import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

import * as Types from './operations'

const defaultOptions = {} as const

export const ActivateSavedFilterDocument = gql`
  mutation ActivateSavedFilter($id: ID!) {
    updateSavedFilter(input: { context: INCIDENT, id: $id, isActive: true }) {
      savedFilter {
        id
        isActive
      }
    }
  }
`
export type ActivateSavedFilterMutationFn = Apollo.MutationFunction<
  Types.ActivateSavedFilterMutation,
  Types.ActivateSavedFilterMutationVariables
>

/**
 * __useActivateSavedFilterMutation__
 *
 * To run a mutation, you first call `useActivateSavedFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateSavedFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateSavedFilterMutation, { data, loading, error }] = useActivateSavedFilterMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActivateSavedFilterMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.ActivateSavedFilterMutation,
    Types.ActivateSavedFilterMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.ActivateSavedFilterMutation,
    Types.ActivateSavedFilterMutationVariables
  >(ActivateSavedFilterDocument, options)
}
export type ActivateSavedFilterMutationHookResult = ReturnType<
  typeof useActivateSavedFilterMutation
>
export type ActivateSavedFilterMutationResult =
  Apollo.MutationResult<Types.ActivateSavedFilterMutation>
export type ActivateSavedFilterMutationOptions = Apollo.BaseMutationOptions<
  Types.ActivateSavedFilterMutation,
  Types.ActivateSavedFilterMutationVariables
>
export const AddTagsToDeviceDocument = gql`
  mutation AddTagsToDevice($input: AddTagsToDeviceInput!) {
    addTagsToDevice(input: $input) {
      device {
        id
        tags {
          edges {
            node {
              id
              name
              enabled
              archived
            }
          }
        }
      }
    }
  }
`
export type AddTagsToDeviceMutationFn = Apollo.MutationFunction<
  Types.AddTagsToDeviceMutation,
  Types.AddTagsToDeviceMutationVariables
>

/**
 * __useAddTagsToDeviceMutation__
 *
 * To run a mutation, you first call `useAddTagsToDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTagsToDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTagsToDeviceMutation, { data, loading, error }] = useAddTagsToDeviceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddTagsToDeviceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.AddTagsToDeviceMutation,
    Types.AddTagsToDeviceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.AddTagsToDeviceMutation,
    Types.AddTagsToDeviceMutationVariables
  >(AddTagsToDeviceDocument, options)
}
export type AddTagsToDeviceMutationHookResult = ReturnType<
  typeof useAddTagsToDeviceMutation
>
export type AddTagsToDeviceMutationResult =
  Apollo.MutationResult<Types.AddTagsToDeviceMutation>
export type AddTagsToDeviceMutationOptions = Apollo.BaseMutationOptions<
  Types.AddTagsToDeviceMutation,
  Types.AddTagsToDeviceMutationVariables
>
export const ArchiveCustomFormDocument = gql`
  mutation ArchiveCustomForm($input: ArchiveCustomFormInput!) {
    archiveCustomForm(input: $input) {
      customForm {
        id
        status
      }
    }
  }
`
export type ArchiveCustomFormMutationFn = Apollo.MutationFunction<
  Types.ArchiveCustomFormMutation,
  Types.ArchiveCustomFormMutationVariables
>

/**
 * __useArchiveCustomFormMutation__
 *
 * To run a mutation, you first call `useArchiveCustomFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveCustomFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveCustomFormMutation, { data, loading, error }] = useArchiveCustomFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveCustomFormMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.ArchiveCustomFormMutation,
    Types.ArchiveCustomFormMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.ArchiveCustomFormMutation,
    Types.ArchiveCustomFormMutationVariables
  >(ArchiveCustomFormDocument, options)
}
export type ArchiveCustomFormMutationHookResult = ReturnType<
  typeof useArchiveCustomFormMutation
>
export type ArchiveCustomFormMutationResult =
  Apollo.MutationResult<Types.ArchiveCustomFormMutation>
export type ArchiveCustomFormMutationOptions = Apollo.BaseMutationOptions<
  Types.ArchiveCustomFormMutation,
  Types.ArchiveCustomFormMutationVariables
>
export const ArchiveFloorDocument = gql`
  mutation ArchiveFloor($input: ArchiveFloorInput!) {
    archiveFloor(input: $input) {
      floor {
        id
      }
    }
  }
`
export type ArchiveFloorMutationFn = Apollo.MutationFunction<
  Types.ArchiveFloorMutation,
  Types.ArchiveFloorMutationVariables
>

/**
 * __useArchiveFloorMutation__
 *
 * To run a mutation, you first call `useArchiveFloorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveFloorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveFloorMutation, { data, loading, error }] = useArchiveFloorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveFloorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.ArchiveFloorMutation,
    Types.ArchiveFloorMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.ArchiveFloorMutation,
    Types.ArchiveFloorMutationVariables
  >(ArchiveFloorDocument, options)
}
export type ArchiveFloorMutationHookResult = ReturnType<
  typeof useArchiveFloorMutation
>
export type ArchiveFloorMutationResult =
  Apollo.MutationResult<Types.ArchiveFloorMutation>
export type ArchiveFloorMutationOptions = Apollo.BaseMutationOptions<
  Types.ArchiveFloorMutation,
  Types.ArchiveFloorMutationVariables
>
export const ArchiveIncidentWorkflowDocument = gql`
  mutation ArchiveIncidentWorkflow($input: ArchiveIncidentWorkflowInput!) {
    archiveIncidentWorkflow(input: $input) {
      __typename
    }
  }
`
export type ArchiveIncidentWorkflowMutationFn = Apollo.MutationFunction<
  Types.ArchiveIncidentWorkflowMutation,
  Types.ArchiveIncidentWorkflowMutationVariables
>

/**
 * __useArchiveIncidentWorkflowMutation__
 *
 * To run a mutation, you first call `useArchiveIncidentWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveIncidentWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveIncidentWorkflowMutation, { data, loading, error }] = useArchiveIncidentWorkflowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveIncidentWorkflowMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.ArchiveIncidentWorkflowMutation,
    Types.ArchiveIncidentWorkflowMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.ArchiveIncidentWorkflowMutation,
    Types.ArchiveIncidentWorkflowMutationVariables
  >(ArchiveIncidentWorkflowDocument, options)
}
export type ArchiveIncidentWorkflowMutationHookResult = ReturnType<
  typeof useArchiveIncidentWorkflowMutation
>
export type ArchiveIncidentWorkflowMutationResult =
  Apollo.MutationResult<Types.ArchiveIncidentWorkflowMutation>
export type ArchiveIncidentWorkflowMutationOptions = Apollo.BaseMutationOptions<
  Types.ArchiveIncidentWorkflowMutation,
  Types.ArchiveIncidentWorkflowMutationVariables
>
export const ArchiveRuleDocument = gql`
  mutation ArchiveRule($input: ArchiveRuleInput!) {
    archiveRule(input: $input) {
      rule {
        id
      }
    }
  }
`
export type ArchiveRuleMutationFn = Apollo.MutationFunction<
  Types.ArchiveRuleMutation,
  Types.ArchiveRuleMutationVariables
>

/**
 * __useArchiveRuleMutation__
 *
 * To run a mutation, you first call `useArchiveRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveRuleMutation, { data, loading, error }] = useArchiveRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveRuleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.ArchiveRuleMutation,
    Types.ArchiveRuleMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.ArchiveRuleMutation,
    Types.ArchiveRuleMutationVariables
  >(ArchiveRuleDocument, options)
}
export type ArchiveRuleMutationHookResult = ReturnType<
  typeof useArchiveRuleMutation
>
export type ArchiveRuleMutationResult =
  Apollo.MutationResult<Types.ArchiveRuleMutation>
export type ArchiveRuleMutationOptions = Apollo.BaseMutationOptions<
  Types.ArchiveRuleMutation,
  Types.ArchiveRuleMutationVariables
>
export const AssociateEmailRecipientsDocument = gql`
  mutation AssociateEmailRecipients($input: AssociateEmailRecipientsInput!) {
    associateEmailRecipients(input: $input) {
      emailRecipients {
        id
      }
    }
  }
`
export type AssociateEmailRecipientsMutationFn = Apollo.MutationFunction<
  Types.AssociateEmailRecipientsMutation,
  Types.AssociateEmailRecipientsMutationVariables
>

/**
 * __useAssociateEmailRecipientsMutation__
 *
 * To run a mutation, you first call `useAssociateEmailRecipientsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssociateEmailRecipientsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [associateEmailRecipientsMutation, { data, loading, error }] = useAssociateEmailRecipientsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssociateEmailRecipientsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.AssociateEmailRecipientsMutation,
    Types.AssociateEmailRecipientsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.AssociateEmailRecipientsMutation,
    Types.AssociateEmailRecipientsMutationVariables
  >(AssociateEmailRecipientsDocument, options)
}
export type AssociateEmailRecipientsMutationHookResult = ReturnType<
  typeof useAssociateEmailRecipientsMutation
>
export type AssociateEmailRecipientsMutationResult =
  Apollo.MutationResult<Types.AssociateEmailRecipientsMutation>
export type AssociateEmailRecipientsMutationOptions =
  Apollo.BaseMutationOptions<
    Types.AssociateEmailRecipientsMutation,
    Types.AssociateEmailRecipientsMutationVariables
  >
export const AssociateSingleIncidentToMultipleCasesDocument = gql`
  mutation AssociateSingleIncidentToMultipleCases(
    $input: AssociateIncidentToCasesInput!
  ) {
    associateSingleIncidentToMultipleCases(input: $input) {
      incident {
        id
      }
    }
  }
`
export type AssociateSingleIncidentToMultipleCasesMutationFn =
  Apollo.MutationFunction<
    Types.AssociateSingleIncidentToMultipleCasesMutation,
    Types.AssociateSingleIncidentToMultipleCasesMutationVariables
  >

/**
 * __useAssociateSingleIncidentToMultipleCasesMutation__
 *
 * To run a mutation, you first call `useAssociateSingleIncidentToMultipleCasesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssociateSingleIncidentToMultipleCasesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [associateSingleIncidentToMultipleCasesMutation, { data, loading, error }] = useAssociateSingleIncidentToMultipleCasesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssociateSingleIncidentToMultipleCasesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.AssociateSingleIncidentToMultipleCasesMutation,
    Types.AssociateSingleIncidentToMultipleCasesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.AssociateSingleIncidentToMultipleCasesMutation,
    Types.AssociateSingleIncidentToMultipleCasesMutationVariables
  >(AssociateSingleIncidentToMultipleCasesDocument, options)
}
export type AssociateSingleIncidentToMultipleCasesMutationHookResult =
  ReturnType<typeof useAssociateSingleIncidentToMultipleCasesMutation>
export type AssociateSingleIncidentToMultipleCasesMutationResult =
  Apollo.MutationResult<Types.AssociateSingleIncidentToMultipleCasesMutation>
export type AssociateSingleIncidentToMultipleCasesMutationOptions =
  Apollo.BaseMutationOptions<
    Types.AssociateSingleIncidentToMultipleCasesMutation,
    Types.AssociateSingleIncidentToMultipleCasesMutationVariables
  >
export const AssociateMultipleIncidentsToSingleCaseDocument = gql`
  mutation AssociateMultipleIncidentsToSingleCase(
    $input: AssociateIncidentsToCaseInput!
  ) {
    associateMultipleIncidentsToSingleCase(input: $input) {
      case {
        id
        name
      }
    }
  }
`
export type AssociateMultipleIncidentsToSingleCaseMutationFn =
  Apollo.MutationFunction<
    Types.AssociateMultipleIncidentsToSingleCaseMutation,
    Types.AssociateMultipleIncidentsToSingleCaseMutationVariables
  >

/**
 * __useAssociateMultipleIncidentsToSingleCaseMutation__
 *
 * To run a mutation, you first call `useAssociateMultipleIncidentsToSingleCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssociateMultipleIncidentsToSingleCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [associateMultipleIncidentsToSingleCaseMutation, { data, loading, error }] = useAssociateMultipleIncidentsToSingleCaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssociateMultipleIncidentsToSingleCaseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.AssociateMultipleIncidentsToSingleCaseMutation,
    Types.AssociateMultipleIncidentsToSingleCaseMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.AssociateMultipleIncidentsToSingleCaseMutation,
    Types.AssociateMultipleIncidentsToSingleCaseMutationVariables
  >(AssociateMultipleIncidentsToSingleCaseDocument, options)
}
export type AssociateMultipleIncidentsToSingleCaseMutationHookResult =
  ReturnType<typeof useAssociateMultipleIncidentsToSingleCaseMutation>
export type AssociateMultipleIncidentsToSingleCaseMutationResult =
  Apollo.MutationResult<Types.AssociateMultipleIncidentsToSingleCaseMutation>
export type AssociateMultipleIncidentsToSingleCaseMutationOptions =
  Apollo.BaseMutationOptions<
    Types.AssociateMultipleIncidentsToSingleCaseMutation,
    Types.AssociateMultipleIncidentsToSingleCaseMutationVariables
  >
export const AssociatePersonOfInterestToCaseDocument = gql`
  mutation AssociatePersonOfInterestToCase(
    $input: AssociatePersonOfInterestInput!
  ) {
    associatePersonOfInterestToCase(input: $input) {
      case {
        id
      }
    }
  }
`
export type AssociatePersonOfInterestToCaseMutationFn = Apollo.MutationFunction<
  Types.AssociatePersonOfInterestToCaseMutation,
  Types.AssociatePersonOfInterestToCaseMutationVariables
>

/**
 * __useAssociatePersonOfInterestToCaseMutation__
 *
 * To run a mutation, you first call `useAssociatePersonOfInterestToCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssociatePersonOfInterestToCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [associatePersonOfInterestToCaseMutation, { data, loading, error }] = useAssociatePersonOfInterestToCaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssociatePersonOfInterestToCaseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.AssociatePersonOfInterestToCaseMutation,
    Types.AssociatePersonOfInterestToCaseMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.AssociatePersonOfInterestToCaseMutation,
    Types.AssociatePersonOfInterestToCaseMutationVariables
  >(AssociatePersonOfInterestToCaseDocument, options)
}
export type AssociatePersonOfInterestToCaseMutationHookResult = ReturnType<
  typeof useAssociatePersonOfInterestToCaseMutation
>
export type AssociatePersonOfInterestToCaseMutationResult =
  Apollo.MutationResult<Types.AssociatePersonOfInterestToCaseMutation>
export type AssociatePersonOfInterestToCaseMutationOptions =
  Apollo.BaseMutationOptions<
    Types.AssociatePersonOfInterestToCaseMutation,
    Types.AssociatePersonOfInterestToCaseMutationVariables
  >
export const BulkResolveStaleIncidentsDocument = gql`
  mutation BulkResolveStaleIncidents($input: BulkResolveStaleIncidentsInput!) {
    bulkResolveStaleIncidents(input: $input) {
      resolvedIncidentActions {
        id
      }
      skipped {
        incidentId
        reason
      }
    }
  }
`
export type BulkResolveStaleIncidentsMutationFn = Apollo.MutationFunction<
  Types.BulkResolveStaleIncidentsMutation,
  Types.BulkResolveStaleIncidentsMutationVariables
>

/**
 * __useBulkResolveStaleIncidentsMutation__
 *
 * To run a mutation, you first call `useBulkResolveStaleIncidentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkResolveStaleIncidentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkResolveStaleIncidentsMutation, { data, loading, error }] = useBulkResolveStaleIncidentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkResolveStaleIncidentsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.BulkResolveStaleIncidentsMutation,
    Types.BulkResolveStaleIncidentsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.BulkResolveStaleIncidentsMutation,
    Types.BulkResolveStaleIncidentsMutationVariables
  >(BulkResolveStaleIncidentsDocument, options)
}
export type BulkResolveStaleIncidentsMutationHookResult = ReturnType<
  typeof useBulkResolveStaleIncidentsMutation
>
export type BulkResolveStaleIncidentsMutationResult =
  Apollo.MutationResult<Types.BulkResolveStaleIncidentsMutation>
export type BulkResolveStaleIncidentsMutationOptions =
  Apollo.BaseMutationOptions<
    Types.BulkResolveStaleIncidentsMutation,
    Types.BulkResolveStaleIncidentsMutationVariables
  >
export const CreateAiOperatorFeedbackDocument = gql`
  mutation CreateAiOperatorFeedback($input: CreateAiOperatorFeedbackInput!) {
    createAiOperatorFeedback(input: $input) {
      aiOperatorFeedback {
        id
        isPositive
        message
      }
    }
  }
`
export type CreateAiOperatorFeedbackMutationFn = Apollo.MutationFunction<
  Types.CreateAiOperatorFeedbackMutation,
  Types.CreateAiOperatorFeedbackMutationVariables
>

/**
 * __useCreateAiOperatorFeedbackMutation__
 *
 * To run a mutation, you first call `useCreateAiOperatorFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAiOperatorFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAiOperatorFeedbackMutation, { data, loading, error }] = useCreateAiOperatorFeedbackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAiOperatorFeedbackMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateAiOperatorFeedbackMutation,
    Types.CreateAiOperatorFeedbackMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreateAiOperatorFeedbackMutation,
    Types.CreateAiOperatorFeedbackMutationVariables
  >(CreateAiOperatorFeedbackDocument, options)
}
export type CreateAiOperatorFeedbackMutationHookResult = ReturnType<
  typeof useCreateAiOperatorFeedbackMutation
>
export type CreateAiOperatorFeedbackMutationResult =
  Apollo.MutationResult<Types.CreateAiOperatorFeedbackMutation>
export type CreateAiOperatorFeedbackMutationOptions =
  Apollo.BaseMutationOptions<
    Types.CreateAiOperatorFeedbackMutation,
    Types.CreateAiOperatorFeedbackMutationVariables
  >
export const CreateAiOperatorHumanLabelDocument = gql`
  mutation CreateAiOperatorHumanLabel(
    $input: CreateAiOperatorHumanLabelInput!
  ) {
    createAiOperatorHumanLabel(input: $input) {
      aiOperatorHumanLabel {
        id
      }
    }
  }
`
export type CreateAiOperatorHumanLabelMutationFn = Apollo.MutationFunction<
  Types.CreateAiOperatorHumanLabelMutation,
  Types.CreateAiOperatorHumanLabelMutationVariables
>

/**
 * __useCreateAiOperatorHumanLabelMutation__
 *
 * To run a mutation, you first call `useCreateAiOperatorHumanLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAiOperatorHumanLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAiOperatorHumanLabelMutation, { data, loading, error }] = useCreateAiOperatorHumanLabelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAiOperatorHumanLabelMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateAiOperatorHumanLabelMutation,
    Types.CreateAiOperatorHumanLabelMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreateAiOperatorHumanLabelMutation,
    Types.CreateAiOperatorHumanLabelMutationVariables
  >(CreateAiOperatorHumanLabelDocument, options)
}
export type CreateAiOperatorHumanLabelMutationHookResult = ReturnType<
  typeof useCreateAiOperatorHumanLabelMutation
>
export type CreateAiOperatorHumanLabelMutationResult =
  Apollo.MutationResult<Types.CreateAiOperatorHumanLabelMutation>
export type CreateAiOperatorHumanLabelMutationOptions =
  Apollo.BaseMutationOptions<
    Types.CreateAiOperatorHumanLabelMutation,
    Types.CreateAiOperatorHumanLabelMutationVariables
  >
export const CreateAlarmDocument = gql`
  mutation CreateAlarm($alarmInput: CreateAlarmInput!) {
    createAlarm(input: $alarmInput) {
      alarm {
        id
      }
    }
  }
`
export type CreateAlarmMutationFn = Apollo.MutationFunction<
  Types.CreateAlarmMutation,
  Types.CreateAlarmMutationVariables
>

/**
 * __useCreateAlarmMutation__
 *
 * To run a mutation, you first call `useCreateAlarmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAlarmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAlarmMutation, { data, loading, error }] = useCreateAlarmMutation({
 *   variables: {
 *      alarmInput: // value for 'alarmInput'
 *   },
 * });
 */
export function useCreateAlarmMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateAlarmMutation,
    Types.CreateAlarmMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreateAlarmMutation,
    Types.CreateAlarmMutationVariables
  >(CreateAlarmDocument, options)
}
export type CreateAlarmMutationHookResult = ReturnType<
  typeof useCreateAlarmMutation
>
export type CreateAlarmMutationResult =
  Apollo.MutationResult<Types.CreateAlarmMutation>
export type CreateAlarmMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateAlarmMutation,
  Types.CreateAlarmMutationVariables
>
export const CreateAudioClipDocument = gql`
  mutation CreateAudioClip($input: CreateAudioClipInput!) {
    createAudioClip(input: $input) {
      audioClip {
        id
        creator {
          id
          firstName
          lastName
          roleName
        }
        createdAt
        endTime
        incident {
          id
          name
        }
        incidentId
        startTime
        updatedAt
        url
      }
    }
  }
`
export type CreateAudioClipMutationFn = Apollo.MutationFunction<
  Types.CreateAudioClipMutation,
  Types.CreateAudioClipMutationVariables
>

/**
 * __useCreateAudioClipMutation__
 *
 * To run a mutation, you first call `useCreateAudioClipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAudioClipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAudioClipMutation, { data, loading, error }] = useCreateAudioClipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAudioClipMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateAudioClipMutation,
    Types.CreateAudioClipMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreateAudioClipMutation,
    Types.CreateAudioClipMutationVariables
  >(CreateAudioClipDocument, options)
}
export type CreateAudioClipMutationHookResult = ReturnType<
  typeof useCreateAudioClipMutation
>
export type CreateAudioClipMutationResult =
  Apollo.MutationResult<Types.CreateAudioClipMutation>
export type CreateAudioClipMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateAudioClipMutation,
  Types.CreateAudioClipMutationVariables
>
export const CreateAudioMessageDocument = gql`
  mutation CreateAudioMessage($input: CreateAudioMessageInput!) {
    createAudioMessage(input: $input) {
      audioMessage {
        id
        createdAt
        creator {
          id
          firstName
          lastName
          roleName
        }
        audioClip {
          id
          url
        }
      }
    }
  }
`
export type CreateAudioMessageMutationFn = Apollo.MutationFunction<
  Types.CreateAudioMessageMutation,
  Types.CreateAudioMessageMutationVariables
>

/**
 * __useCreateAudioMessageMutation__
 *
 * To run a mutation, you first call `useCreateAudioMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAudioMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAudioMessageMutation, { data, loading, error }] = useCreateAudioMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAudioMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateAudioMessageMutation,
    Types.CreateAudioMessageMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreateAudioMessageMutation,
    Types.CreateAudioMessageMutationVariables
  >(CreateAudioMessageDocument, options)
}
export type CreateAudioMessageMutationHookResult = ReturnType<
  typeof useCreateAudioMessageMutation
>
export type CreateAudioMessageMutationResult =
  Apollo.MutationResult<Types.CreateAudioMessageMutation>
export type CreateAudioMessageMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateAudioMessageMutation,
  Types.CreateAudioMessageMutationVariables
>
export const CreateBulkIncidentActionDocument = gql`
  mutation CreateBulkIncidentAction($input: CreateBulkIncidentActionInput!) {
    createBulkIncidentAction(input: $input) {
      incidentActions {
        id
      }
    }
  }
`
export type CreateBulkIncidentActionMutationFn = Apollo.MutationFunction<
  Types.CreateBulkIncidentActionMutation,
  Types.CreateBulkIncidentActionMutationVariables
>

/**
 * __useCreateBulkIncidentActionMutation__
 *
 * To run a mutation, you first call `useCreateBulkIncidentActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBulkIncidentActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBulkIncidentActionMutation, { data, loading, error }] = useCreateBulkIncidentActionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBulkIncidentActionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateBulkIncidentActionMutation,
    Types.CreateBulkIncidentActionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreateBulkIncidentActionMutation,
    Types.CreateBulkIncidentActionMutationVariables
  >(CreateBulkIncidentActionDocument, options)
}
export type CreateBulkIncidentActionMutationHookResult = ReturnType<
  typeof useCreateBulkIncidentActionMutation
>
export type CreateBulkIncidentActionMutationResult =
  Apollo.MutationResult<Types.CreateBulkIncidentActionMutation>
export type CreateBulkIncidentActionMutationOptions =
  Apollo.BaseMutationOptions<
    Types.CreateBulkIncidentActionMutation,
    Types.CreateBulkIncidentActionMutationVariables
  >
export const CreateCameraDocument = gql`
  mutation CreateCamera($cameraInput: CreateCameraInput!) {
    createCamera(input: $cameraInput) {
      camera {
        id
      }
    }
  }
`
export type CreateCameraMutationFn = Apollo.MutationFunction<
  Types.CreateCameraMutation,
  Types.CreateCameraMutationVariables
>

/**
 * __useCreateCameraMutation__
 *
 * To run a mutation, you first call `useCreateCameraMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCameraMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCameraMutation, { data, loading, error }] = useCreateCameraMutation({
 *   variables: {
 *      cameraInput: // value for 'cameraInput'
 *   },
 * });
 */
export function useCreateCameraMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateCameraMutation,
    Types.CreateCameraMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreateCameraMutation,
    Types.CreateCameraMutationVariables
  >(CreateCameraDocument, options)
}
export type CreateCameraMutationHookResult = ReturnType<
  typeof useCreateCameraMutation
>
export type CreateCameraMutationResult =
  Apollo.MutationResult<Types.CreateCameraMutation>
export type CreateCameraMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateCameraMutation,
  Types.CreateCameraMutationVariables
>
export const CreateCaseDocument = gql`
  mutation CreateCase($input: CreateCaseInput!) {
    createCase(input: $input) {
      case {
        createdAt
        createdBy
        description
        detailedReport
        displayId
        id
        name
        ownerId
        status
        updatedAt
        updatedBy
        facilities {
          address
          archived
          createdAt
          defaultFloorId
          guardCount
          id
          latitude
          longitude
          name
        }
      }
    }
  }
`
export type CreateCaseMutationFn = Apollo.MutationFunction<
  Types.CreateCaseMutation,
  Types.CreateCaseMutationVariables
>

/**
 * __useCreateCaseMutation__
 *
 * To run a mutation, you first call `useCreateCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCaseMutation, { data, loading, error }] = useCreateCaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCaseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateCaseMutation,
    Types.CreateCaseMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreateCaseMutation,
    Types.CreateCaseMutationVariables
  >(CreateCaseDocument, options)
}
export type CreateCaseMutationHookResult = ReturnType<
  typeof useCreateCaseMutation
>
export type CreateCaseMutationResult =
  Apollo.MutationResult<Types.CreateCaseMutation>
export type CreateCaseMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateCaseMutation,
  Types.CreateCaseMutationVariables
>
export const CreateCaseCommentDocument = gql`
  mutation CreateCaseComment($input: CreateCaseCommentInput!) {
    createCaseComment(input: $input) {
      caseComment {
        caseId
        createdAt
        createdBy
        id
        message
        updatedAt
        updatedBy
      }
    }
  }
`
export type CreateCaseCommentMutationFn = Apollo.MutationFunction<
  Types.CreateCaseCommentMutation,
  Types.CreateCaseCommentMutationVariables
>

/**
 * __useCreateCaseCommentMutation__
 *
 * To run a mutation, you first call `useCreateCaseCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCaseCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCaseCommentMutation, { data, loading, error }] = useCreateCaseCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCaseCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateCaseCommentMutation,
    Types.CreateCaseCommentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreateCaseCommentMutation,
    Types.CreateCaseCommentMutationVariables
  >(CreateCaseCommentDocument, options)
}
export type CreateCaseCommentMutationHookResult = ReturnType<
  typeof useCreateCaseCommentMutation
>
export type CreateCaseCommentMutationResult =
  Apollo.MutationResult<Types.CreateCaseCommentMutation>
export type CreateCaseCommentMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateCaseCommentMutation,
  Types.CreateCaseCommentMutationVariables
>
export const CreateCheckpointDocument = gql`
  mutation CreateCheckpoint($input: CreateDeviceInput!) {
    createCheckpoint(input: $input) {
      device {
        id
      }
    }
  }
`
export type CreateCheckpointMutationFn = Apollo.MutationFunction<
  Types.CreateCheckpointMutation,
  Types.CreateCheckpointMutationVariables
>

/**
 * __useCreateCheckpointMutation__
 *
 * To run a mutation, you first call `useCreateCheckpointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCheckpointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCheckpointMutation, { data, loading, error }] = useCreateCheckpointMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCheckpointMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateCheckpointMutation,
    Types.CreateCheckpointMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreateCheckpointMutation,
    Types.CreateCheckpointMutationVariables
  >(CreateCheckpointDocument, options)
}
export type CreateCheckpointMutationHookResult = ReturnType<
  typeof useCreateCheckpointMutation
>
export type CreateCheckpointMutationResult =
  Apollo.MutationResult<Types.CreateCheckpointMutation>
export type CreateCheckpointMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateCheckpointMutation,
  Types.CreateCheckpointMutationVariables
>
export const CreateCheckpointTaskDocument = gql`
  mutation CreateCheckpointTask($input: CreateCheckpointTaskInput!) {
    createCheckpointTask(input: $input) {
      checkpointTask {
        id
      }
    }
  }
`
export type CreateCheckpointTaskMutationFn = Apollo.MutationFunction<
  Types.CreateCheckpointTaskMutation,
  Types.CreateCheckpointTaskMutationVariables
>

/**
 * __useCreateCheckpointTaskMutation__
 *
 * To run a mutation, you first call `useCreateCheckpointTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCheckpointTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCheckpointTaskMutation, { data, loading, error }] = useCreateCheckpointTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCheckpointTaskMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateCheckpointTaskMutation,
    Types.CreateCheckpointTaskMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreateCheckpointTaskMutation,
    Types.CreateCheckpointTaskMutationVariables
  >(CreateCheckpointTaskDocument, options)
}
export type CreateCheckpointTaskMutationHookResult = ReturnType<
  typeof useCreateCheckpointTaskMutation
>
export type CreateCheckpointTaskMutationResult =
  Apollo.MutationResult<Types.CreateCheckpointTaskMutation>
export type CreateCheckpointTaskMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateCheckpointTaskMutation,
  Types.CreateCheckpointTaskMutationVariables
>
export const CreateCustomFormDocument = gql`
  mutation CreateCustomForm($input: CreateCustomFormInput!) {
    createCustomForm(input: $input) {
      customForm {
        id
        name
        description
        status
        version
        createdAt
        updatedAt
        sections {
          id
          name
          order
          questions {
            id
          }
        }
      }
    }
  }
`
export type CreateCustomFormMutationFn = Apollo.MutationFunction<
  Types.CreateCustomFormMutation,
  Types.CreateCustomFormMutationVariables
>

/**
 * __useCreateCustomFormMutation__
 *
 * To run a mutation, you first call `useCreateCustomFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomFormMutation, { data, loading, error }] = useCreateCustomFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomFormMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateCustomFormMutation,
    Types.CreateCustomFormMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreateCustomFormMutation,
    Types.CreateCustomFormMutationVariables
  >(CreateCustomFormDocument, options)
}
export type CreateCustomFormMutationHookResult = ReturnType<
  typeof useCreateCustomFormMutation
>
export type CreateCustomFormMutationResult =
  Apollo.MutationResult<Types.CreateCustomFormMutation>
export type CreateCustomFormMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateCustomFormMutation,
  Types.CreateCustomFormMutationVariables
>
export const CreateCustomFormQuestionDocument = gql`
  mutation CreateCustomFormQuestion($input: CreateCustomFormQuestionInput!) {
    createCustomFormQuestion(input: $input) {
      question {
        id
        label
        helpText
        answerType
        required
        order
        defaultValue
        options {
          id
          label
          order
        }
      }
    }
  }
`
export type CreateCustomFormQuestionMutationFn = Apollo.MutationFunction<
  Types.CreateCustomFormQuestionMutation,
  Types.CreateCustomFormQuestionMutationVariables
>

/**
 * __useCreateCustomFormQuestionMutation__
 *
 * To run a mutation, you first call `useCreateCustomFormQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomFormQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomFormQuestionMutation, { data, loading, error }] = useCreateCustomFormQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomFormQuestionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateCustomFormQuestionMutation,
    Types.CreateCustomFormQuestionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreateCustomFormQuestionMutation,
    Types.CreateCustomFormQuestionMutationVariables
  >(CreateCustomFormQuestionDocument, options)
}
export type CreateCustomFormQuestionMutationHookResult = ReturnType<
  typeof useCreateCustomFormQuestionMutation
>
export type CreateCustomFormQuestionMutationResult =
  Apollo.MutationResult<Types.CreateCustomFormQuestionMutation>
export type CreateCustomFormQuestionMutationOptions =
  Apollo.BaseMutationOptions<
    Types.CreateCustomFormQuestionMutation,
    Types.CreateCustomFormQuestionMutationVariables
  >
export const CreateCustomFormSectionDocument = gql`
  mutation CreateCustomFormSection($input: CreateCustomFormSectionInput!) {
    createCustomFormSection(input: $input) {
      section {
        id
        name
        description
        order
      }
    }
  }
`
export type CreateCustomFormSectionMutationFn = Apollo.MutationFunction<
  Types.CreateCustomFormSectionMutation,
  Types.CreateCustomFormSectionMutationVariables
>

/**
 * __useCreateCustomFormSectionMutation__
 *
 * To run a mutation, you first call `useCreateCustomFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomFormSectionMutation, { data, loading, error }] = useCreateCustomFormSectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomFormSectionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateCustomFormSectionMutation,
    Types.CreateCustomFormSectionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreateCustomFormSectionMutation,
    Types.CreateCustomFormSectionMutationVariables
  >(CreateCustomFormSectionDocument, options)
}
export type CreateCustomFormSectionMutationHookResult = ReturnType<
  typeof useCreateCustomFormSectionMutation
>
export type CreateCustomFormSectionMutationResult =
  Apollo.MutationResult<Types.CreateCustomFormSectionMutation>
export type CreateCustomFormSectionMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateCustomFormSectionMutation,
  Types.CreateCustomFormSectionMutationVariables
>
export const CreateCustomerSecretProviderDocument = gql`
  mutation CreateCustomerSecretProvider(
    $input: CreateCustomerSecretProviderInput!
  ) {
    createCustomerSecretProvider(input: $input) {
      customerSecretProvider {
        id
        providerAccountId
        providerName
        providerRegion
        providerType
        secretNamespace
        kmsKeyId
        kmsRegion
        kmsAlias
        organizationId
        createdAt
        updatedAt
      }
    }
  }
`
export type CreateCustomerSecretProviderMutationFn = Apollo.MutationFunction<
  Types.CreateCustomerSecretProviderMutation,
  Types.CreateCustomerSecretProviderMutationVariables
>

/**
 * __useCreateCustomerSecretProviderMutation__
 *
 * To run a mutation, you first call `useCreateCustomerSecretProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerSecretProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerSecretProviderMutation, { data, loading, error }] = useCreateCustomerSecretProviderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomerSecretProviderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateCustomerSecretProviderMutation,
    Types.CreateCustomerSecretProviderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreateCustomerSecretProviderMutation,
    Types.CreateCustomerSecretProviderMutationVariables
  >(CreateCustomerSecretProviderDocument, options)
}
export type CreateCustomerSecretProviderMutationHookResult = ReturnType<
  typeof useCreateCustomerSecretProviderMutation
>
export type CreateCustomerSecretProviderMutationResult =
  Apollo.MutationResult<Types.CreateCustomerSecretProviderMutation>
export type CreateCustomerSecretProviderMutationOptions =
  Apollo.BaseMutationOptions<
    Types.CreateCustomerSecretProviderMutation,
    Types.CreateCustomerSecretProviderMutationVariables
  >
export const CreateDatabaseResetDocument = gql`
  mutation CreateDatabaseReset {
    createDatabaseReset {
      createdAt
      createdBy
    }
  }
`
export type CreateDatabaseResetMutationFn = Apollo.MutationFunction<
  Types.CreateDatabaseResetMutation,
  Types.CreateDatabaseResetMutationVariables
>

/**
 * __useCreateDatabaseResetMutation__
 *
 * To run a mutation, you first call `useCreateDatabaseResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDatabaseResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDatabaseResetMutation, { data, loading, error }] = useCreateDatabaseResetMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateDatabaseResetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateDatabaseResetMutation,
    Types.CreateDatabaseResetMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreateDatabaseResetMutation,
    Types.CreateDatabaseResetMutationVariables
  >(CreateDatabaseResetDocument, options)
}
export type CreateDatabaseResetMutationHookResult = ReturnType<
  typeof useCreateDatabaseResetMutation
>
export type CreateDatabaseResetMutationResult =
  Apollo.MutationResult<Types.CreateDatabaseResetMutation>
export type CreateDatabaseResetMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateDatabaseResetMutation,
  Types.CreateDatabaseResetMutationVariables
>
export const CreateDeviceDocument = gql`
  mutation CreateDevice($input: CreateDeviceInput!) {
    createDevice(input: $input) {
      device {
        id
      }
    }
  }
`
export type CreateDeviceMutationFn = Apollo.MutationFunction<
  Types.CreateDeviceMutation,
  Types.CreateDeviceMutationVariables
>

/**
 * __useCreateDeviceMutation__
 *
 * To run a mutation, you first call `useCreateDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDeviceMutation, { data, loading, error }] = useCreateDeviceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDeviceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateDeviceMutation,
    Types.CreateDeviceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreateDeviceMutation,
    Types.CreateDeviceMutationVariables
  >(CreateDeviceDocument, options)
}
export type CreateDeviceMutationHookResult = ReturnType<
  typeof useCreateDeviceMutation
>
export type CreateDeviceMutationResult =
  Apollo.MutationResult<Types.CreateDeviceMutation>
export type CreateDeviceMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateDeviceMutation,
  Types.CreateDeviceMutationVariables
>
export const CreateDeviceNoteDocument = gql`
  mutation CreateDeviceNote($input: CreateDeviceNoteInput!) {
    createDeviceNote(input: $input) {
      deviceNote {
        id
      }
    }
  }
`
export type CreateDeviceNoteMutationFn = Apollo.MutationFunction<
  Types.CreateDeviceNoteMutation,
  Types.CreateDeviceNoteMutationVariables
>

/**
 * __useCreateDeviceNoteMutation__
 *
 * To run a mutation, you first call `useCreateDeviceNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDeviceNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDeviceNoteMutation, { data, loading, error }] = useCreateDeviceNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDeviceNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateDeviceNoteMutation,
    Types.CreateDeviceNoteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreateDeviceNoteMutation,
    Types.CreateDeviceNoteMutationVariables
  >(CreateDeviceNoteDocument, options)
}
export type CreateDeviceNoteMutationHookResult = ReturnType<
  typeof useCreateDeviceNoteMutation
>
export type CreateDeviceNoteMutationResult =
  Apollo.MutationResult<Types.CreateDeviceNoteMutation>
export type CreateDeviceNoteMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateDeviceNoteMutation,
  Types.CreateDeviceNoteMutationVariables
>
export const CreateDevicesDocument = gql`
  mutation CreateDevices($input: CreateDevicesInput!) {
    createDevices(input: $input) {
      device {
        id
      }
    }
  }
`
export type CreateDevicesMutationFn = Apollo.MutationFunction<
  Types.CreateDevicesMutation,
  Types.CreateDevicesMutationVariables
>

/**
 * __useCreateDevicesMutation__
 *
 * To run a mutation, you first call `useCreateDevicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDevicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDevicesMutation, { data, loading, error }] = useCreateDevicesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDevicesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateDevicesMutation,
    Types.CreateDevicesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreateDevicesMutation,
    Types.CreateDevicesMutationVariables
  >(CreateDevicesDocument, options)
}
export type CreateDevicesMutationHookResult = ReturnType<
  typeof useCreateDevicesMutation
>
export type CreateDevicesMutationResult =
  Apollo.MutationResult<Types.CreateDevicesMutation>
export type CreateDevicesMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateDevicesMutation,
  Types.CreateDevicesMutationVariables
>
export const CreateDoorDocument = gql`
  mutation CreateDoor($doorInput: CreateDoorInput!) {
    createDoor(input: $doorInput) {
      door {
        id
      }
    }
  }
`
export type CreateDoorMutationFn = Apollo.MutationFunction<
  Types.CreateDoorMutation,
  Types.CreateDoorMutationVariables
>

/**
 * __useCreateDoorMutation__
 *
 * To run a mutation, you first call `useCreateDoorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDoorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDoorMutation, { data, loading, error }] = useCreateDoorMutation({
 *   variables: {
 *      doorInput: // value for 'doorInput'
 *   },
 * });
 */
export function useCreateDoorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateDoorMutation,
    Types.CreateDoorMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreateDoorMutation,
    Types.CreateDoorMutationVariables
  >(CreateDoorDocument, options)
}
export type CreateDoorMutationHookResult = ReturnType<
  typeof useCreateDoorMutation
>
export type CreateDoorMutationResult =
  Apollo.MutationResult<Types.CreateDoorMutation>
export type CreateDoorMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateDoorMutation,
  Types.CreateDoorMutationVariables
>
export const CreateEdgeDeviceDocument = gql`
  mutation CreateEdgeDevice($input: CreateEdgeDeviceInput!) {
    createEdgeDevice(input: $input) {
      edgeDevice {
        id
        name
      }
    }
  }
`
export type CreateEdgeDeviceMutationFn = Apollo.MutationFunction<
  Types.CreateEdgeDeviceMutation,
  Types.CreateEdgeDeviceMutationVariables
>

/**
 * __useCreateEdgeDeviceMutation__
 *
 * To run a mutation, you first call `useCreateEdgeDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEdgeDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEdgeDeviceMutation, { data, loading, error }] = useCreateEdgeDeviceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEdgeDeviceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateEdgeDeviceMutation,
    Types.CreateEdgeDeviceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreateEdgeDeviceMutation,
    Types.CreateEdgeDeviceMutationVariables
  >(CreateEdgeDeviceDocument, options)
}
export type CreateEdgeDeviceMutationHookResult = ReturnType<
  typeof useCreateEdgeDeviceMutation
>
export type CreateEdgeDeviceMutationResult =
  Apollo.MutationResult<Types.CreateEdgeDeviceMutation>
export type CreateEdgeDeviceMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateEdgeDeviceMutation,
  Types.CreateEdgeDeviceMutationVariables
>
export const CreateEmergencyCallDocument = gql`
  mutation CreateEmergencyCall($input: CreateEmergencyCallInput!) {
    createEmergencyCall(input: $input) {
      emergencyCall {
        id
      }
    }
  }
`
export type CreateEmergencyCallMutationFn = Apollo.MutationFunction<
  Types.CreateEmergencyCallMutation,
  Types.CreateEmergencyCallMutationVariables
>

/**
 * __useCreateEmergencyCallMutation__
 *
 * To run a mutation, you first call `useCreateEmergencyCallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmergencyCallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmergencyCallMutation, { data, loading, error }] = useCreateEmergencyCallMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEmergencyCallMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateEmergencyCallMutation,
    Types.CreateEmergencyCallMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreateEmergencyCallMutation,
    Types.CreateEmergencyCallMutationVariables
  >(CreateEmergencyCallDocument, options)
}
export type CreateEmergencyCallMutationHookResult = ReturnType<
  typeof useCreateEmergencyCallMutation
>
export type CreateEmergencyCallMutationResult =
  Apollo.MutationResult<Types.CreateEmergencyCallMutation>
export type CreateEmergencyCallMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateEmergencyCallMutation,
  Types.CreateEmergencyCallMutationVariables
>
export const CreateExternalAccountDocument = gql`
  mutation CreateExternalAccount($input: CreateExternalAccountInput!) {
    createExternalAccount(input: $input) {
      externalAccount {
        accountId
        accountName
        defaultAccount
        externalSystemType
        id
      }
    }
  }
`
export type CreateExternalAccountMutationFn = Apollo.MutationFunction<
  Types.CreateExternalAccountMutation,
  Types.CreateExternalAccountMutationVariables
>

/**
 * __useCreateExternalAccountMutation__
 *
 * To run a mutation, you first call `useCreateExternalAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExternalAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExternalAccountMutation, { data, loading, error }] = useCreateExternalAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateExternalAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateExternalAccountMutation,
    Types.CreateExternalAccountMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreateExternalAccountMutation,
    Types.CreateExternalAccountMutationVariables
  >(CreateExternalAccountDocument, options)
}
export type CreateExternalAccountMutationHookResult = ReturnType<
  typeof useCreateExternalAccountMutation
>
export type CreateExternalAccountMutationResult =
  Apollo.MutationResult<Types.CreateExternalAccountMutation>
export type CreateExternalAccountMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateExternalAccountMutation,
  Types.CreateExternalAccountMutationVariables
>
export const CreateExternalAccountApiKeyDocument = gql`
  mutation CreateExternalAccountApiKey(
    $input: CreateExternalAccountApiKeyInput!
  ) {
    createExternalAccountApiKey(input: $input) {
      externalAccountApiKey {
        id
        secretName
      }
    }
  }
`
export type CreateExternalAccountApiKeyMutationFn = Apollo.MutationFunction<
  Types.CreateExternalAccountApiKeyMutation,
  Types.CreateExternalAccountApiKeyMutationVariables
>

/**
 * __useCreateExternalAccountApiKeyMutation__
 *
 * To run a mutation, you first call `useCreateExternalAccountApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExternalAccountApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExternalAccountApiKeyMutation, { data, loading, error }] = useCreateExternalAccountApiKeyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateExternalAccountApiKeyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateExternalAccountApiKeyMutation,
    Types.CreateExternalAccountApiKeyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreateExternalAccountApiKeyMutation,
    Types.CreateExternalAccountApiKeyMutationVariables
  >(CreateExternalAccountApiKeyDocument, options)
}
export type CreateExternalAccountApiKeyMutationHookResult = ReturnType<
  typeof useCreateExternalAccountApiKeyMutation
>
export type CreateExternalAccountApiKeyMutationResult =
  Apollo.MutationResult<Types.CreateExternalAccountApiKeyMutation>
export type CreateExternalAccountApiKeyMutationOptions =
  Apollo.BaseMutationOptions<
    Types.CreateExternalAccountApiKeyMutation,
    Types.CreateExternalAccountApiKeyMutationVariables
  >
export const CreateExternalAccountPropertiesDocument = gql`
  mutation CreateExternalAccountProperties(
    $input: CreateExternalAccountPropertiesInput!
  ) {
    createExternalAccountProperties(input: $input) {
      externalAccountProperties {
        createdAt
        data
        externalAccountId
        id
        updatedAt
      }
    }
  }
`
export type CreateExternalAccountPropertiesMutationFn = Apollo.MutationFunction<
  Types.CreateExternalAccountPropertiesMutation,
  Types.CreateExternalAccountPropertiesMutationVariables
>

/**
 * __useCreateExternalAccountPropertiesMutation__
 *
 * To run a mutation, you first call `useCreateExternalAccountPropertiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExternalAccountPropertiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExternalAccountPropertiesMutation, { data, loading, error }] = useCreateExternalAccountPropertiesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateExternalAccountPropertiesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateExternalAccountPropertiesMutation,
    Types.CreateExternalAccountPropertiesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreateExternalAccountPropertiesMutation,
    Types.CreateExternalAccountPropertiesMutationVariables
  >(CreateExternalAccountPropertiesDocument, options)
}
export type CreateExternalAccountPropertiesMutationHookResult = ReturnType<
  typeof useCreateExternalAccountPropertiesMutation
>
export type CreateExternalAccountPropertiesMutationResult =
  Apollo.MutationResult<Types.CreateExternalAccountPropertiesMutation>
export type CreateExternalAccountPropertiesMutationOptions =
  Apollo.BaseMutationOptions<
    Types.CreateExternalAccountPropertiesMutation,
    Types.CreateExternalAccountPropertiesMutationVariables
  >
export const CreateFacilityDocument = gql`
  mutation CreateFacility($input: CreateFacilityInput!) {
    createFacility(input: $input) {
      facility {
        id
      }
    }
  }
`
export type CreateFacilityMutationFn = Apollo.MutationFunction<
  Types.CreateFacilityMutation,
  Types.CreateFacilityMutationVariables
>

/**
 * __useCreateFacilityMutation__
 *
 * To run a mutation, you first call `useCreateFacilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFacilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFacilityMutation, { data, loading, error }] = useCreateFacilityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFacilityMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateFacilityMutation,
    Types.CreateFacilityMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreateFacilityMutation,
    Types.CreateFacilityMutationVariables
  >(CreateFacilityDocument, options)
}
export type CreateFacilityMutationHookResult = ReturnType<
  typeof useCreateFacilityMutation
>
export type CreateFacilityMutationResult =
  Apollo.MutationResult<Types.CreateFacilityMutation>
export type CreateFacilityMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateFacilityMutation,
  Types.CreateFacilityMutationVariables
>
export const CreateFloorDocument = gql`
  mutation CreateFloor($input: CreateFloorInput!) {
    createFloor(input: $input) {
      floor {
        id
      }
    }
  }
`
export type CreateFloorMutationFn = Apollo.MutationFunction<
  Types.CreateFloorMutation,
  Types.CreateFloorMutationVariables
>

/**
 * __useCreateFloorMutation__
 *
 * To run a mutation, you first call `useCreateFloorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFloorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFloorMutation, { data, loading, error }] = useCreateFloorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFloorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateFloorMutation,
    Types.CreateFloorMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreateFloorMutation,
    Types.CreateFloorMutationVariables
  >(CreateFloorDocument, options)
}
export type CreateFloorMutationHookResult = ReturnType<
  typeof useCreateFloorMutation
>
export type CreateFloorMutationResult =
  Apollo.MutationResult<Types.CreateFloorMutation>
export type CreateFloorMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateFloorMutation,
  Types.CreateFloorMutationVariables
>
export const CreateFloorPlanDocument = gql`
  mutation CreateFloorPlan($input: CreateFloorPlanInput!) {
    createFloorPlan(input: $input) {
      floorPlan {
        id
      }
    }
  }
`
export type CreateFloorPlanMutationFn = Apollo.MutationFunction<
  Types.CreateFloorPlanMutation,
  Types.CreateFloorPlanMutationVariables
>

/**
 * __useCreateFloorPlanMutation__
 *
 * To run a mutation, you first call `useCreateFloorPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFloorPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFloorPlanMutation, { data, loading, error }] = useCreateFloorPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFloorPlanMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateFloorPlanMutation,
    Types.CreateFloorPlanMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreateFloorPlanMutation,
    Types.CreateFloorPlanMutationVariables
  >(CreateFloorPlanDocument, options)
}
export type CreateFloorPlanMutationHookResult = ReturnType<
  typeof useCreateFloorPlanMutation
>
export type CreateFloorPlanMutationResult =
  Apollo.MutationResult<Types.CreateFloorPlanMutation>
export type CreateFloorPlanMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateFloorPlanMutation,
  Types.CreateFloorPlanMutationVariables
>
export const CreateFormForIncidentCategoryDocument = gql`
  mutation CreateFormForIncidentCategory(
    $input: CreateFormForIncidentCategoryInput!
  ) {
    createFormForIncidentCategory(input: $input) {
      incidentCategory {
        id
        name
        customForm {
          id
          name
          status
        }
      }
    }
  }
`
export type CreateFormForIncidentCategoryMutationFn = Apollo.MutationFunction<
  Types.CreateFormForIncidentCategoryMutation,
  Types.CreateFormForIncidentCategoryMutationVariables
>

/**
 * __useCreateFormForIncidentCategoryMutation__
 *
 * To run a mutation, you first call `useCreateFormForIncidentCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFormForIncidentCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFormForIncidentCategoryMutation, { data, loading, error }] = useCreateFormForIncidentCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFormForIncidentCategoryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateFormForIncidentCategoryMutation,
    Types.CreateFormForIncidentCategoryMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreateFormForIncidentCategoryMutation,
    Types.CreateFormForIncidentCategoryMutationVariables
  >(CreateFormForIncidentCategoryDocument, options)
}
export type CreateFormForIncidentCategoryMutationHookResult = ReturnType<
  typeof useCreateFormForIncidentCategoryMutation
>
export type CreateFormForIncidentCategoryMutationResult =
  Apollo.MutationResult<Types.CreateFormForIncidentCategoryMutation>
export type CreateFormForIncidentCategoryMutationOptions =
  Apollo.BaseMutationOptions<
    Types.CreateFormForIncidentCategoryMutation,
    Types.CreateFormForIncidentCategoryMutationVariables
  >
export const CreateGridAnalysisJobDocument = gql`
  mutation CreateGridAnalysisJob($input: CreateGridAnalysisJobInput!) {
    createGridAnalysisJob(input: $input) {
      gridAnalysisJob {
        id
        status
      }
    }
  }
`
export type CreateGridAnalysisJobMutationFn = Apollo.MutationFunction<
  Types.CreateGridAnalysisJobMutation,
  Types.CreateGridAnalysisJobMutationVariables
>

/**
 * __useCreateGridAnalysisJobMutation__
 *
 * To run a mutation, you first call `useCreateGridAnalysisJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGridAnalysisJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGridAnalysisJobMutation, { data, loading, error }] = useCreateGridAnalysisJobMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGridAnalysisJobMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateGridAnalysisJobMutation,
    Types.CreateGridAnalysisJobMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreateGridAnalysisJobMutation,
    Types.CreateGridAnalysisJobMutationVariables
  >(CreateGridAnalysisJobDocument, options)
}
export type CreateGridAnalysisJobMutationHookResult = ReturnType<
  typeof useCreateGridAnalysisJobMutation
>
export type CreateGridAnalysisJobMutationResult =
  Apollo.MutationResult<Types.CreateGridAnalysisJobMutation>
export type CreateGridAnalysisJobMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateGridAnalysisJobMutation,
  Types.CreateGridAnalysisJobMutationVariables
>
export const CreateIncidentDocument = gql`
  mutation CreateIncident($input: CreateIncidentInput!) {
    createIncident(input: $input) {
      incident {
        id
        displayId
      }
    }
  }
`
export type CreateIncidentMutationFn = Apollo.MutationFunction<
  Types.CreateIncidentMutation,
  Types.CreateIncidentMutationVariables
>

/**
 * __useCreateIncidentMutation__
 *
 * To run a mutation, you first call `useCreateIncidentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIncidentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIncidentMutation, { data, loading, error }] = useCreateIncidentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIncidentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateIncidentMutation,
    Types.CreateIncidentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreateIncidentMutation,
    Types.CreateIncidentMutationVariables
  >(CreateIncidentDocument, options)
}
export type CreateIncidentMutationHookResult = ReturnType<
  typeof useCreateIncidentMutation
>
export type CreateIncidentMutationResult =
  Apollo.MutationResult<Types.CreateIncidentMutation>
export type CreateIncidentMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateIncidentMutation,
  Types.CreateIncidentMutationVariables
>
export const CreateIncidentActionDocument = gql`
  mutation CreateIncidentAction($input: CreateIncidentActionInput!) {
    createIncidentAction(input: $input) {
      incidentAction {
        id
        type
        audioMessageId
        history {
          incidentActionType
          oldValue
          newValue
        }
      }
    }
  }
`
export type CreateIncidentActionMutationFn = Apollo.MutationFunction<
  Types.CreateIncidentActionMutation,
  Types.CreateIncidentActionMutationVariables
>

/**
 * __useCreateIncidentActionMutation__
 *
 * To run a mutation, you first call `useCreateIncidentActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIncidentActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIncidentActionMutation, { data, loading, error }] = useCreateIncidentActionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIncidentActionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateIncidentActionMutation,
    Types.CreateIncidentActionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreateIncidentActionMutation,
    Types.CreateIncidentActionMutationVariables
  >(CreateIncidentActionDocument, options)
}
export type CreateIncidentActionMutationHookResult = ReturnType<
  typeof useCreateIncidentActionMutation
>
export type CreateIncidentActionMutationResult =
  Apollo.MutationResult<Types.CreateIncidentActionMutation>
export type CreateIncidentActionMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateIncidentActionMutation,
  Types.CreateIncidentActionMutationVariables
>
export const CreateIncidentCategoryWhitelistDocument = gql`
  mutation CreateIncidentCategoryWhitelist(
    $input: CreateIncidentCategoryWhitelistInput!
  ) {
    createIncidentCategoryWhitelist(input: $input) {
      edges {
        node {
          id
        }
      }
    }
  }
`
export type CreateIncidentCategoryWhitelistMutationFn = Apollo.MutationFunction<
  Types.CreateIncidentCategoryWhitelistMutation,
  Types.CreateIncidentCategoryWhitelistMutationVariables
>

/**
 * __useCreateIncidentCategoryWhitelistMutation__
 *
 * To run a mutation, you first call `useCreateIncidentCategoryWhitelistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIncidentCategoryWhitelistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIncidentCategoryWhitelistMutation, { data, loading, error }] = useCreateIncidentCategoryWhitelistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIncidentCategoryWhitelistMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateIncidentCategoryWhitelistMutation,
    Types.CreateIncidentCategoryWhitelistMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreateIncidentCategoryWhitelistMutation,
    Types.CreateIncidentCategoryWhitelistMutationVariables
  >(CreateIncidentCategoryWhitelistDocument, options)
}
export type CreateIncidentCategoryWhitelistMutationHookResult = ReturnType<
  typeof useCreateIncidentCategoryWhitelistMutation
>
export type CreateIncidentCategoryWhitelistMutationResult =
  Apollo.MutationResult<Types.CreateIncidentCategoryWhitelistMutation>
export type CreateIncidentCategoryWhitelistMutationOptions =
  Apollo.BaseMutationOptions<
    Types.CreateIncidentCategoryWhitelistMutation,
    Types.CreateIncidentCategoryWhitelistMutationVariables
  >
export const CreateIncidentNoteDocument = gql`
  mutation CreateIncidentNote($input: CreateIncidentNoteInput!) {
    createIncidentNote(input: $input) {
      incidentNote {
        id
        message
      }
    }
  }
`
export type CreateIncidentNoteMutationFn = Apollo.MutationFunction<
  Types.CreateIncidentNoteMutation,
  Types.CreateIncidentNoteMutationVariables
>

/**
 * __useCreateIncidentNoteMutation__
 *
 * To run a mutation, you first call `useCreateIncidentNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIncidentNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIncidentNoteMutation, { data, loading, error }] = useCreateIncidentNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIncidentNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateIncidentNoteMutation,
    Types.CreateIncidentNoteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreateIncidentNoteMutation,
    Types.CreateIncidentNoteMutationVariables
  >(CreateIncidentNoteDocument, options)
}
export type CreateIncidentNoteMutationHookResult = ReturnType<
  typeof useCreateIncidentNoteMutation
>
export type CreateIncidentNoteMutationResult =
  Apollo.MutationResult<Types.CreateIncidentNoteMutation>
export type CreateIncidentNoteMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateIncidentNoteMutation,
  Types.CreateIncidentNoteMutationVariables
>
export const CreateIncidentNoteMediaDocument = gql`
  mutation CreateIncidentNoteMedia($input: CreateIncidentNoteMediaInput!) {
    createIncidentNoteMedia(input: $input) {
      incidentNoteId
      media {
        id
        url
        name
        mimeType
      }
    }
  }
`
export type CreateIncidentNoteMediaMutationFn = Apollo.MutationFunction<
  Types.CreateIncidentNoteMediaMutation,
  Types.CreateIncidentNoteMediaMutationVariables
>

/**
 * __useCreateIncidentNoteMediaMutation__
 *
 * To run a mutation, you first call `useCreateIncidentNoteMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIncidentNoteMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIncidentNoteMediaMutation, { data, loading, error }] = useCreateIncidentNoteMediaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIncidentNoteMediaMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateIncidentNoteMediaMutation,
    Types.CreateIncidentNoteMediaMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreateIncidentNoteMediaMutation,
    Types.CreateIncidentNoteMediaMutationVariables
  >(CreateIncidentNoteMediaDocument, options)
}
export type CreateIncidentNoteMediaMutationHookResult = ReturnType<
  typeof useCreateIncidentNoteMediaMutation
>
export type CreateIncidentNoteMediaMutationResult =
  Apollo.MutationResult<Types.CreateIncidentNoteMediaMutation>
export type CreateIncidentNoteMediaMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateIncidentNoteMediaMutation,
  Types.CreateIncidentNoteMediaMutationVariables
>
export const CreateIncidentTypeDefinitionDocument = gql`
  mutation CreateIncidentTypeDefinition(
    $input: CreateIncidentTypeDefinitionInput!
  ) {
    createIncidentTypeDefinition(input: $input) {
      incidentTypeDefinition {
        id
        displayName
      }
    }
  }
`
export type CreateIncidentTypeDefinitionMutationFn = Apollo.MutationFunction<
  Types.CreateIncidentTypeDefinitionMutation,
  Types.CreateIncidentTypeDefinitionMutationVariables
>

/**
 * __useCreateIncidentTypeDefinitionMutation__
 *
 * To run a mutation, you first call `useCreateIncidentTypeDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIncidentTypeDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIncidentTypeDefinitionMutation, { data, loading, error }] = useCreateIncidentTypeDefinitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIncidentTypeDefinitionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateIncidentTypeDefinitionMutation,
    Types.CreateIncidentTypeDefinitionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreateIncidentTypeDefinitionMutation,
    Types.CreateIncidentTypeDefinitionMutationVariables
  >(CreateIncidentTypeDefinitionDocument, options)
}
export type CreateIncidentTypeDefinitionMutationHookResult = ReturnType<
  typeof useCreateIncidentTypeDefinitionMutation
>
export type CreateIncidentTypeDefinitionMutationResult =
  Apollo.MutationResult<Types.CreateIncidentTypeDefinitionMutation>
export type CreateIncidentTypeDefinitionMutationOptions =
  Apollo.BaseMutationOptions<
    Types.CreateIncidentTypeDefinitionMutation,
    Types.CreateIncidentTypeDefinitionMutationVariables
  >
export const CreateIncidentWorkflowDocument = gql`
  mutation CreateIncidentWorkflow($input: CreateIncidentWorkflowInput!) {
    createIncidentWorkflow(input: $input) {
      workflow {
        workflowId
        name
        state
      }
    }
  }
`
export type CreateIncidentWorkflowMutationFn = Apollo.MutationFunction<
  Types.CreateIncidentWorkflowMutation,
  Types.CreateIncidentWorkflowMutationVariables
>

/**
 * __useCreateIncidentWorkflowMutation__
 *
 * To run a mutation, you first call `useCreateIncidentWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIncidentWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIncidentWorkflowMutation, { data, loading, error }] = useCreateIncidentWorkflowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIncidentWorkflowMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateIncidentWorkflowMutation,
    Types.CreateIncidentWorkflowMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreateIncidentWorkflowMutation,
    Types.CreateIncidentWorkflowMutationVariables
  >(CreateIncidentWorkflowDocument, options)
}
export type CreateIncidentWorkflowMutationHookResult = ReturnType<
  typeof useCreateIncidentWorkflowMutation
>
export type CreateIncidentWorkflowMutationResult =
  Apollo.MutationResult<Types.CreateIncidentWorkflowMutation>
export type CreateIncidentWorkflowMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateIncidentWorkflowMutation,
  Types.CreateIncidentWorkflowMutationVariables
>
export const CreateLlmIncidentsDocument = gql`
  mutation CreateLlmIncidents {
    createLlmIncidents(input: {}) {
      incidents {
        id
      }
    }
  }
`
export type CreateLlmIncidentsMutationFn = Apollo.MutationFunction<
  Types.CreateLlmIncidentsMutation,
  Types.CreateLlmIncidentsMutationVariables
>

/**
 * __useCreateLlmIncidentsMutation__
 *
 * To run a mutation, you first call `useCreateLlmIncidentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLlmIncidentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLlmIncidentsMutation, { data, loading, error }] = useCreateLlmIncidentsMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateLlmIncidentsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateLlmIncidentsMutation,
    Types.CreateLlmIncidentsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreateLlmIncidentsMutation,
    Types.CreateLlmIncidentsMutationVariables
  >(CreateLlmIncidentsDocument, options)
}
export type CreateLlmIncidentsMutationHookResult = ReturnType<
  typeof useCreateLlmIncidentsMutation
>
export type CreateLlmIncidentsMutationResult =
  Apollo.MutationResult<Types.CreateLlmIncidentsMutation>
export type CreateLlmIncidentsMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateLlmIncidentsMutation,
  Types.CreateLlmIncidentsMutationVariables
>
export const CreateManualIncidentCategoryDocument = gql`
  mutation CreateManualIncidentCategory(
    $input: CreateManualIncidentCategoryInput!
  ) {
    createManualIncidentCategory(input: $input) {
      manualIncidentCategory {
        id
        name
      }
    }
  }
`
export type CreateManualIncidentCategoryMutationFn = Apollo.MutationFunction<
  Types.CreateManualIncidentCategoryMutation,
  Types.CreateManualIncidentCategoryMutationVariables
>

/**
 * __useCreateManualIncidentCategoryMutation__
 *
 * To run a mutation, you first call `useCreateManualIncidentCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateManualIncidentCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createManualIncidentCategoryMutation, { data, loading, error }] = useCreateManualIncidentCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateManualIncidentCategoryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateManualIncidentCategoryMutation,
    Types.CreateManualIncidentCategoryMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreateManualIncidentCategoryMutation,
    Types.CreateManualIncidentCategoryMutationVariables
  >(CreateManualIncidentCategoryDocument, options)
}
export type CreateManualIncidentCategoryMutationHookResult = ReturnType<
  typeof useCreateManualIncidentCategoryMutation
>
export type CreateManualIncidentCategoryMutationResult =
  Apollo.MutationResult<Types.CreateManualIncidentCategoryMutation>
export type CreateManualIncidentCategoryMutationOptions =
  Apollo.BaseMutationOptions<
    Types.CreateManualIncidentCategoryMutation,
    Types.CreateManualIncidentCategoryMutationVariables
  >
export const CreatePacsSourceInstanceDocument = gql`
  mutation createPacsSourceInstance($input: CreatePacsSourceInstanceInput!) {
    createPacsSourceInstance(input: $input) {
      pacsSourceInstance {
        id
      }
    }
  }
`
export type CreatePacsSourceInstanceMutationFn = Apollo.MutationFunction<
  Types.CreatePacsSourceInstanceMutation,
  Types.CreatePacsSourceInstanceMutationVariables
>

/**
 * __useCreatePacsSourceInstanceMutation__
 *
 * To run a mutation, you first call `useCreatePacsSourceInstanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePacsSourceInstanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPacsSourceInstanceMutation, { data, loading, error }] = useCreatePacsSourceInstanceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePacsSourceInstanceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreatePacsSourceInstanceMutation,
    Types.CreatePacsSourceInstanceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreatePacsSourceInstanceMutation,
    Types.CreatePacsSourceInstanceMutationVariables
  >(CreatePacsSourceInstanceDocument, options)
}
export type CreatePacsSourceInstanceMutationHookResult = ReturnType<
  typeof useCreatePacsSourceInstanceMutation
>
export type CreatePacsSourceInstanceMutationResult =
  Apollo.MutationResult<Types.CreatePacsSourceInstanceMutation>
export type CreatePacsSourceInstanceMutationOptions =
  Apollo.BaseMutationOptions<
    Types.CreatePacsSourceInstanceMutation,
    Types.CreatePacsSourceInstanceMutationVariables
  >
export const CreatePersonOfInterestDocument = gql`
  mutation CreatePersonOfInterest($input: CreatePersonOfInterestInput!) {
    createPersonOfInterest(input: $input) {
      personOfInterest {
        id
      }
    }
  }
`
export type CreatePersonOfInterestMutationFn = Apollo.MutationFunction<
  Types.CreatePersonOfInterestMutation,
  Types.CreatePersonOfInterestMutationVariables
>

/**
 * __useCreatePersonOfInterestMutation__
 *
 * To run a mutation, you first call `useCreatePersonOfInterestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePersonOfInterestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPersonOfInterestMutation, { data, loading, error }] = useCreatePersonOfInterestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePersonOfInterestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreatePersonOfInterestMutation,
    Types.CreatePersonOfInterestMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreatePersonOfInterestMutation,
    Types.CreatePersonOfInterestMutationVariables
  >(CreatePersonOfInterestDocument, options)
}
export type CreatePersonOfInterestMutationHookResult = ReturnType<
  typeof useCreatePersonOfInterestMutation
>
export type CreatePersonOfInterestMutationResult =
  Apollo.MutationResult<Types.CreatePersonOfInterestMutation>
export type CreatePersonOfInterestMutationOptions = Apollo.BaseMutationOptions<
  Types.CreatePersonOfInterestMutation,
  Types.CreatePersonOfInterestMutationVariables
>
export const CreateProductMessageDocument = gql`
  mutation CreateProductMessage($input: CreateProductMessageInput!) {
    createProductMessage(input: $input) {
      productMessage {
        id
        message
        messageType
        startDateTime
        endDateTime
      }
    }
  }
`
export type CreateProductMessageMutationFn = Apollo.MutationFunction<
  Types.CreateProductMessageMutation,
  Types.CreateProductMessageMutationVariables
>

/**
 * __useCreateProductMessageMutation__
 *
 * To run a mutation, you first call `useCreateProductMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductMessageMutation, { data, loading, error }] = useCreateProductMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProductMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateProductMessageMutation,
    Types.CreateProductMessageMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreateProductMessageMutation,
    Types.CreateProductMessageMutationVariables
  >(CreateProductMessageDocument, options)
}
export type CreateProductMessageMutationHookResult = ReturnType<
  typeof useCreateProductMessageMutation
>
export type CreateProductMessageMutationResult =
  Apollo.MutationResult<Types.CreateProductMessageMutation>
export type CreateProductMessageMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateProductMessageMutation,
  Types.CreateProductMessageMutationVariables
>
export const CreateProgramRecommendationDocument = gql`
  mutation CreateProgramRecommendation(
    $input: CreateProgramRecommendationInput!
  ) {
    createProgramRecommendation(input: $input) {
      programRecommendation {
        id
        title
        description
        category
        owner
        status
        estimatedImpact
        internalNote
        createdAt
        isArchived
      }
    }
  }
`
export type CreateProgramRecommendationMutationFn = Apollo.MutationFunction<
  Types.CreateProgramRecommendationMutation,
  Types.CreateProgramRecommendationMutationVariables
>

/**
 * __useCreateProgramRecommendationMutation__
 *
 * To run a mutation, you first call `useCreateProgramRecommendationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProgramRecommendationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProgramRecommendationMutation, { data, loading, error }] = useCreateProgramRecommendationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProgramRecommendationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateProgramRecommendationMutation,
    Types.CreateProgramRecommendationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreateProgramRecommendationMutation,
    Types.CreateProgramRecommendationMutationVariables
  >(CreateProgramRecommendationDocument, options)
}
export type CreateProgramRecommendationMutationHookResult = ReturnType<
  typeof useCreateProgramRecommendationMutation
>
export type CreateProgramRecommendationMutationResult =
  Apollo.MutationResult<Types.CreateProgramRecommendationMutation>
export type CreateProgramRecommendationMutationOptions =
  Apollo.BaseMutationOptions<
    Types.CreateProgramRecommendationMutation,
    Types.CreateProgramRecommendationMutationVariables
  >
export const CreateQuickReportDocument = gql`
  mutation CreateQuickReport($input: CreateQuickReportInput!) {
    createQuickReport(input: $input) {
      quickReport {
        id
        logoAssetId
      }
    }
  }
`
export type CreateQuickReportMutationFn = Apollo.MutationFunction<
  Types.CreateQuickReportMutation,
  Types.CreateQuickReportMutationVariables
>

/**
 * __useCreateQuickReportMutation__
 *
 * To run a mutation, you first call `useCreateQuickReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuickReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuickReportMutation, { data, loading, error }] = useCreateQuickReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateQuickReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateQuickReportMutation,
    Types.CreateQuickReportMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreateQuickReportMutation,
    Types.CreateQuickReportMutationVariables
  >(CreateQuickReportDocument, options)
}
export type CreateQuickReportMutationHookResult = ReturnType<
  typeof useCreateQuickReportMutation
>
export type CreateQuickReportMutationResult =
  Apollo.MutationResult<Types.CreateQuickReportMutation>
export type CreateQuickReportMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateQuickReportMutation,
  Types.CreateQuickReportMutationVariables
>
export const CreateRuleDocument = gql`
  mutation CreateRule($input: CreateRuleInput!) {
    createRule(input: $input) {
      rule {
        id
      }
    }
  }
`
export type CreateRuleMutationFn = Apollo.MutationFunction<
  Types.CreateRuleMutation,
  Types.CreateRuleMutationVariables
>

/**
 * __useCreateRuleMutation__
 *
 * To run a mutation, you first call `useCreateRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRuleMutation, { data, loading, error }] = useCreateRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRuleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateRuleMutation,
    Types.CreateRuleMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreateRuleMutation,
    Types.CreateRuleMutationVariables
  >(CreateRuleDocument, options)
}
export type CreateRuleMutationHookResult = ReturnType<
  typeof useCreateRuleMutation
>
export type CreateRuleMutationResult =
  Apollo.MutationResult<Types.CreateRuleMutation>
export type CreateRuleMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateRuleMutation,
  Types.CreateRuleMutationVariables
>
export const CreateSavedFilterDocument = gql`
  mutation CreateSavedFilter($input: CreateSavedFilterInput!) {
    createSavedFilter(input: $input) {
      savedFilter {
        id
      }
    }
  }
`
export type CreateSavedFilterMutationFn = Apollo.MutationFunction<
  Types.CreateSavedFilterMutation,
  Types.CreateSavedFilterMutationVariables
>

/**
 * __useCreateSavedFilterMutation__
 *
 * To run a mutation, you first call `useCreateSavedFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSavedFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSavedFilterMutation, { data, loading, error }] = useCreateSavedFilterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSavedFilterMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateSavedFilterMutation,
    Types.CreateSavedFilterMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreateSavedFilterMutation,
    Types.CreateSavedFilterMutationVariables
  >(CreateSavedFilterDocument, options)
}
export type CreateSavedFilterMutationHookResult = ReturnType<
  typeof useCreateSavedFilterMutation
>
export type CreateSavedFilterMutationResult =
  Apollo.MutationResult<Types.CreateSavedFilterMutation>
export type CreateSavedFilterMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateSavedFilterMutation,
  Types.CreateSavedFilterMutationVariables
>
export const CreateStandardOperatingProcedureDocument = gql`
  mutation CreateStandardOperatingProcedure(
    $input: CreateStandardOperatingProcedureInput!
  ) {
    createStandardOperatingProcedure(input: $input) {
      standardOperatingProcedure {
        id
        name
        externalId
        url
      }
    }
  }
`
export type CreateStandardOperatingProcedureMutationFn =
  Apollo.MutationFunction<
    Types.CreateStandardOperatingProcedureMutation,
    Types.CreateStandardOperatingProcedureMutationVariables
  >

/**
 * __useCreateStandardOperatingProcedureMutation__
 *
 * To run a mutation, you first call `useCreateStandardOperatingProcedureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStandardOperatingProcedureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStandardOperatingProcedureMutation, { data, loading, error }] = useCreateStandardOperatingProcedureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStandardOperatingProcedureMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateStandardOperatingProcedureMutation,
    Types.CreateStandardOperatingProcedureMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreateStandardOperatingProcedureMutation,
    Types.CreateStandardOperatingProcedureMutationVariables
  >(CreateStandardOperatingProcedureDocument, options)
}
export type CreateStandardOperatingProcedureMutationHookResult = ReturnType<
  typeof useCreateStandardOperatingProcedureMutation
>
export type CreateStandardOperatingProcedureMutationResult =
  Apollo.MutationResult<Types.CreateStandardOperatingProcedureMutation>
export type CreateStandardOperatingProcedureMutationOptions =
  Apollo.BaseMutationOptions<
    Types.CreateStandardOperatingProcedureMutation,
    Types.CreateStandardOperatingProcedureMutationVariables
  >
export const CreateTagDocument = gql`
  mutation createTag($input: CreateTagInput!) {
    createTag(input: $input) {
      tag {
        id
        name
      }
    }
  }
`
export type CreateTagMutationFn = Apollo.MutationFunction<
  Types.CreateTagMutation,
  Types.CreateTagMutationVariables
>

/**
 * __useCreateTagMutation__
 *
 * To run a mutation, you first call `useCreateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTagMutation, { data, loading, error }] = useCreateTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTagMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateTagMutation,
    Types.CreateTagMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreateTagMutation,
    Types.CreateTagMutationVariables
  >(CreateTagDocument, options)
}
export type CreateTagMutationHookResult = ReturnType<
  typeof useCreateTagMutation
>
export type CreateTagMutationResult =
  Apollo.MutationResult<Types.CreateTagMutation>
export type CreateTagMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateTagMutation,
  Types.CreateTagMutationVariables
>
export const CreateTagAndAddToDeviceDocument = gql`
  mutation CreateTagAndAddToDevice($input: CreateTagAndAddToDeviceInput!) {
    createTagAndAddToDevice(input: $input) {
      device {
        id
        tags {
          edges {
            node {
              id
              name
              enabled
              archived
            }
          }
        }
      }
    }
  }
`
export type CreateTagAndAddToDeviceMutationFn = Apollo.MutationFunction<
  Types.CreateTagAndAddToDeviceMutation,
  Types.CreateTagAndAddToDeviceMutationVariables
>

/**
 * __useCreateTagAndAddToDeviceMutation__
 *
 * To run a mutation, you first call `useCreateTagAndAddToDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTagAndAddToDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTagAndAddToDeviceMutation, { data, loading, error }] = useCreateTagAndAddToDeviceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTagAndAddToDeviceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateTagAndAddToDeviceMutation,
    Types.CreateTagAndAddToDeviceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreateTagAndAddToDeviceMutation,
    Types.CreateTagAndAddToDeviceMutationVariables
  >(CreateTagAndAddToDeviceDocument, options)
}
export type CreateTagAndAddToDeviceMutationHookResult = ReturnType<
  typeof useCreateTagAndAddToDeviceMutation
>
export type CreateTagAndAddToDeviceMutationResult =
  Apollo.MutationResult<Types.CreateTagAndAddToDeviceMutation>
export type CreateTagAndAddToDeviceMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateTagAndAddToDeviceMutation,
  Types.CreateTagAndAddToDeviceMutationVariables
>
export const CreateTailgateConnDocument = gql`
  mutation CreateTailgateConn($input: CreateTailgateConnInput!) {
    createTailgateConn(input: $input) {
      tailgateConn {
        id
        cameras {
          edges {
            node {
              id
            }
          }
        }
        door {
          id
        }
      }
    }
  }
`
export type CreateTailgateConnMutationFn = Apollo.MutationFunction<
  Types.CreateTailgateConnMutation,
  Types.CreateTailgateConnMutationVariables
>

/**
 * __useCreateTailgateConnMutation__
 *
 * To run a mutation, you first call `useCreateTailgateConnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTailgateConnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTailgateConnMutation, { data, loading, error }] = useCreateTailgateConnMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTailgateConnMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateTailgateConnMutation,
    Types.CreateTailgateConnMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreateTailgateConnMutation,
    Types.CreateTailgateConnMutationVariables
  >(CreateTailgateConnDocument, options)
}
export type CreateTailgateConnMutationHookResult = ReturnType<
  typeof useCreateTailgateConnMutation
>
export type CreateTailgateConnMutationResult =
  Apollo.MutationResult<Types.CreateTailgateConnMutation>
export type CreateTailgateConnMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateTailgateConnMutation,
  Types.CreateTailgateConnMutationVariables
>
export const CreateTechnicianDocument = gql`
  mutation CreateTechnician($input: CreateTechnicianInput!) {
    createTechnician(input: $input) {
      technician {
        id
        email
        firstName
        lastName
        facilities {
          name
        }
        deviceTypes
      }
    }
  }
`
export type CreateTechnicianMutationFn = Apollo.MutationFunction<
  Types.CreateTechnicianMutation,
  Types.CreateTechnicianMutationVariables
>

/**
 * __useCreateTechnicianMutation__
 *
 * To run a mutation, you first call `useCreateTechnicianMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTechnicianMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTechnicianMutation, { data, loading, error }] = useCreateTechnicianMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTechnicianMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateTechnicianMutation,
    Types.CreateTechnicianMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreateTechnicianMutation,
    Types.CreateTechnicianMutationVariables
  >(CreateTechnicianDocument, options)
}
export type CreateTechnicianMutationHookResult = ReturnType<
  typeof useCreateTechnicianMutation
>
export type CreateTechnicianMutationResult =
  Apollo.MutationResult<Types.CreateTechnicianMutation>
export type CreateTechnicianMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateTechnicianMutation,
  Types.CreateTechnicianMutationVariables
>
export const CreateTourPlanDocument = gql`
  mutation CreateTourPlan($input: CreateTourPlanInput!) {
    createTourPlan(input: $input) {
      tourPlan {
        id
      }
    }
  }
`
export type CreateTourPlanMutationFn = Apollo.MutationFunction<
  Types.CreateTourPlanMutation,
  Types.CreateTourPlanMutationVariables
>

/**
 * __useCreateTourPlanMutation__
 *
 * To run a mutation, you first call `useCreateTourPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTourPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTourPlanMutation, { data, loading, error }] = useCreateTourPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTourPlanMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateTourPlanMutation,
    Types.CreateTourPlanMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreateTourPlanMutation,
    Types.CreateTourPlanMutationVariables
  >(CreateTourPlanDocument, options)
}
export type CreateTourPlanMutationHookResult = ReturnType<
  typeof useCreateTourPlanMutation
>
export type CreateTourPlanMutationResult =
  Apollo.MutationResult<Types.CreateTourPlanMutation>
export type CreateTourPlanMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateTourPlanMutation,
  Types.CreateTourPlanMutationVariables
>
export const CreateUserDocument = gql`
  mutation CreateUser($input: CreateUserInput!) {
    createUser(input: $input) {
      user {
        designatedFacilityId
        email
        firstName
        lastName
        roleName
      }
    }
  }
`
export type CreateUserMutationFn = Apollo.MutationFunction<
  Types.CreateUserMutation,
  Types.CreateUserMutationVariables
>

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateUserMutation,
    Types.CreateUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreateUserMutation,
    Types.CreateUserMutationVariables
  >(CreateUserDocument, options)
}
export type CreateUserMutationHookResult = ReturnType<
  typeof useCreateUserMutation
>
export type CreateUserMutationResult =
  Apollo.MutationResult<Types.CreateUserMutation>
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateUserMutation,
  Types.CreateUserMutationVariables
>
export const CreateUserFeedbackDocument = gql`
  mutation CreateUserFeedback($input: CreateUserFeedbackInput!) {
    createUserFeedback(input: $input) {
      userFeedback {
        id
        message
        createdAt
      }
    }
  }
`
export type CreateUserFeedbackMutationFn = Apollo.MutationFunction<
  Types.CreateUserFeedbackMutation,
  Types.CreateUserFeedbackMutationVariables
>

/**
 * __useCreateUserFeedbackMutation__
 *
 * To run a mutation, you first call `useCreateUserFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserFeedbackMutation, { data, loading, error }] = useCreateUserFeedbackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserFeedbackMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateUserFeedbackMutation,
    Types.CreateUserFeedbackMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreateUserFeedbackMutation,
    Types.CreateUserFeedbackMutationVariables
  >(CreateUserFeedbackDocument, options)
}
export type CreateUserFeedbackMutationHookResult = ReturnType<
  typeof useCreateUserFeedbackMutation
>
export type CreateUserFeedbackMutationResult =
  Apollo.MutationResult<Types.CreateUserFeedbackMutation>
export type CreateUserFeedbackMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateUserFeedbackMutation,
  Types.CreateUserFeedbackMutationVariables
>
export const CreateWorkflowActionDocument = gql`
  mutation CreateWorkflowAction($input: CreateWorkflowActionInput!) {
    createWorkflowAction(input: $input) {
      id
      workflowId
      currentWorkflowStep
      workflowStatus
      workflowEndTime
    }
  }
`
export type CreateWorkflowActionMutationFn = Apollo.MutationFunction<
  Types.CreateWorkflowActionMutation,
  Types.CreateWorkflowActionMutationVariables
>

/**
 * __useCreateWorkflowActionMutation__
 *
 * To run a mutation, you first call `useCreateWorkflowActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkflowActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkflowActionMutation, { data, loading, error }] = useCreateWorkflowActionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWorkflowActionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateWorkflowActionMutation,
    Types.CreateWorkflowActionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.CreateWorkflowActionMutation,
    Types.CreateWorkflowActionMutationVariables
  >(CreateWorkflowActionDocument, options)
}
export type CreateWorkflowActionMutationHookResult = ReturnType<
  typeof useCreateWorkflowActionMutation
>
export type CreateWorkflowActionMutationResult =
  Apollo.MutationResult<Types.CreateWorkflowActionMutation>
export type CreateWorkflowActionMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateWorkflowActionMutation,
  Types.CreateWorkflowActionMutationVariables
>
export const DeactivateSavedFilterDocument = gql`
  mutation DeactivateSavedFilter($id: ID!) {
    updateSavedFilter(input: { context: INCIDENT, id: $id, isActive: false }) {
      savedFilter {
        id
        isActive
      }
    }
  }
`
export type DeactivateSavedFilterMutationFn = Apollo.MutationFunction<
  Types.DeactivateSavedFilterMutation,
  Types.DeactivateSavedFilterMutationVariables
>

/**
 * __useDeactivateSavedFilterMutation__
 *
 * To run a mutation, you first call `useDeactivateSavedFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateSavedFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateSavedFilterMutation, { data, loading, error }] = useDeactivateSavedFilterMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeactivateSavedFilterMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.DeactivateSavedFilterMutation,
    Types.DeactivateSavedFilterMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.DeactivateSavedFilterMutation,
    Types.DeactivateSavedFilterMutationVariables
  >(DeactivateSavedFilterDocument, options)
}
export type DeactivateSavedFilterMutationHookResult = ReturnType<
  typeof useDeactivateSavedFilterMutation
>
export type DeactivateSavedFilterMutationResult =
  Apollo.MutationResult<Types.DeactivateSavedFilterMutation>
export type DeactivateSavedFilterMutationOptions = Apollo.BaseMutationOptions<
  Types.DeactivateSavedFilterMutation,
  Types.DeactivateSavedFilterMutationVariables
>
export const DeleteAiOperatorDeviceConfigurationDocument = gql`
  mutation DeleteAiOperatorDeviceConfiguration(
    $input: DeleteAiOperatorDeviceConfigurationInput!
  ) {
    deleteAiOperatorDeviceConfiguration(input: $input) {
      deviceId
    }
  }
`
export type DeleteAiOperatorDeviceConfigurationMutationFn =
  Apollo.MutationFunction<
    Types.DeleteAiOperatorDeviceConfigurationMutation,
    Types.DeleteAiOperatorDeviceConfigurationMutationVariables
  >

/**
 * __useDeleteAiOperatorDeviceConfigurationMutation__
 *
 * To run a mutation, you first call `useDeleteAiOperatorDeviceConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAiOperatorDeviceConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAiOperatorDeviceConfigurationMutation, { data, loading, error }] = useDeleteAiOperatorDeviceConfigurationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAiOperatorDeviceConfigurationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.DeleteAiOperatorDeviceConfigurationMutation,
    Types.DeleteAiOperatorDeviceConfigurationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.DeleteAiOperatorDeviceConfigurationMutation,
    Types.DeleteAiOperatorDeviceConfigurationMutationVariables
  >(DeleteAiOperatorDeviceConfigurationDocument, options)
}
export type DeleteAiOperatorDeviceConfigurationMutationHookResult = ReturnType<
  typeof useDeleteAiOperatorDeviceConfigurationMutation
>
export type DeleteAiOperatorDeviceConfigurationMutationResult =
  Apollo.MutationResult<Types.DeleteAiOperatorDeviceConfigurationMutation>
export type DeleteAiOperatorDeviceConfigurationMutationOptions =
  Apollo.BaseMutationOptions<
    Types.DeleteAiOperatorDeviceConfigurationMutation,
    Types.DeleteAiOperatorDeviceConfigurationMutationVariables
  >
export const DeleteCheckpointTaskDocument = gql`
  mutation DeleteCheckpointTask($input: DeleteCheckpointTaskInput!) {
    deleteCheckpointTask(input: $input) {
      checkpointTaskId
    }
  }
`
export type DeleteCheckpointTaskMutationFn = Apollo.MutationFunction<
  Types.DeleteCheckpointTaskMutation,
  Types.DeleteCheckpointTaskMutationVariables
>

/**
 * __useDeleteCheckpointTaskMutation__
 *
 * To run a mutation, you first call `useDeleteCheckpointTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCheckpointTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCheckpointTaskMutation, { data, loading, error }] = useDeleteCheckpointTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCheckpointTaskMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.DeleteCheckpointTaskMutation,
    Types.DeleteCheckpointTaskMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.DeleteCheckpointTaskMutation,
    Types.DeleteCheckpointTaskMutationVariables
  >(DeleteCheckpointTaskDocument, options)
}
export type DeleteCheckpointTaskMutationHookResult = ReturnType<
  typeof useDeleteCheckpointTaskMutation
>
export type DeleteCheckpointTaskMutationResult =
  Apollo.MutationResult<Types.DeleteCheckpointTaskMutation>
export type DeleteCheckpointTaskMutationOptions = Apollo.BaseMutationOptions<
  Types.DeleteCheckpointTaskMutation,
  Types.DeleteCheckpointTaskMutationVariables
>
export const DeleteCustomFormQuestionDocument = gql`
  mutation DeleteCustomFormQuestion($input: DeleteCustomFormQuestionInput!) {
    deleteCustomFormQuestion(input: $input) {
      success
    }
  }
`
export type DeleteCustomFormQuestionMutationFn = Apollo.MutationFunction<
  Types.DeleteCustomFormQuestionMutation,
  Types.DeleteCustomFormQuestionMutationVariables
>

/**
 * __useDeleteCustomFormQuestionMutation__
 *
 * To run a mutation, you first call `useDeleteCustomFormQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomFormQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomFormQuestionMutation, { data, loading, error }] = useDeleteCustomFormQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCustomFormQuestionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.DeleteCustomFormQuestionMutation,
    Types.DeleteCustomFormQuestionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.DeleteCustomFormQuestionMutation,
    Types.DeleteCustomFormQuestionMutationVariables
  >(DeleteCustomFormQuestionDocument, options)
}
export type DeleteCustomFormQuestionMutationHookResult = ReturnType<
  typeof useDeleteCustomFormQuestionMutation
>
export type DeleteCustomFormQuestionMutationResult =
  Apollo.MutationResult<Types.DeleteCustomFormQuestionMutation>
export type DeleteCustomFormQuestionMutationOptions =
  Apollo.BaseMutationOptions<
    Types.DeleteCustomFormQuestionMutation,
    Types.DeleteCustomFormQuestionMutationVariables
  >
export const DeleteCustomFormSectionDocument = gql`
  mutation DeleteCustomFormSection($input: DeleteCustomFormSectionInput!) {
    deleteCustomFormSection(input: $input) {
      success
    }
  }
`
export type DeleteCustomFormSectionMutationFn = Apollo.MutationFunction<
  Types.DeleteCustomFormSectionMutation,
  Types.DeleteCustomFormSectionMutationVariables
>

/**
 * __useDeleteCustomFormSectionMutation__
 *
 * To run a mutation, you first call `useDeleteCustomFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomFormSectionMutation, { data, loading, error }] = useDeleteCustomFormSectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCustomFormSectionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.DeleteCustomFormSectionMutation,
    Types.DeleteCustomFormSectionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.DeleteCustomFormSectionMutation,
    Types.DeleteCustomFormSectionMutationVariables
  >(DeleteCustomFormSectionDocument, options)
}
export type DeleteCustomFormSectionMutationHookResult = ReturnType<
  typeof useDeleteCustomFormSectionMutation
>
export type DeleteCustomFormSectionMutationResult =
  Apollo.MutationResult<Types.DeleteCustomFormSectionMutation>
export type DeleteCustomFormSectionMutationOptions = Apollo.BaseMutationOptions<
  Types.DeleteCustomFormSectionMutation,
  Types.DeleteCustomFormSectionMutationVariables
>
export const DeleteCustomerSecretProviderDocument = gql`
  mutation DeleteCustomerSecretProvider($id: ID!) {
    deleteCustomerSecretProvider(id: $id) {
      id
    }
  }
`
export type DeleteCustomerSecretProviderMutationFn = Apollo.MutationFunction<
  Types.DeleteCustomerSecretProviderMutation,
  Types.DeleteCustomerSecretProviderMutationVariables
>

/**
 * __useDeleteCustomerSecretProviderMutation__
 *
 * To run a mutation, you first call `useDeleteCustomerSecretProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomerSecretProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomerSecretProviderMutation, { data, loading, error }] = useDeleteCustomerSecretProviderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCustomerSecretProviderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.DeleteCustomerSecretProviderMutation,
    Types.DeleteCustomerSecretProviderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.DeleteCustomerSecretProviderMutation,
    Types.DeleteCustomerSecretProviderMutationVariables
  >(DeleteCustomerSecretProviderDocument, options)
}
export type DeleteCustomerSecretProviderMutationHookResult = ReturnType<
  typeof useDeleteCustomerSecretProviderMutation
>
export type DeleteCustomerSecretProviderMutationResult =
  Apollo.MutationResult<Types.DeleteCustomerSecretProviderMutation>
export type DeleteCustomerSecretProviderMutationOptions =
  Apollo.BaseMutationOptions<
    Types.DeleteCustomerSecretProviderMutation,
    Types.DeleteCustomerSecretProviderMutationVariables
  >
export const DeleteDeviceDocument = gql`
  mutation DeleteDevice($input: DeleteDeviceInput!) {
    deleteDevice(input: $input) {
      id
    }
  }
`
export type DeleteDeviceMutationFn = Apollo.MutationFunction<
  Types.DeleteDeviceMutation,
  Types.DeleteDeviceMutationVariables
>

/**
 * __useDeleteDeviceMutation__
 *
 * To run a mutation, you first call `useDeleteDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDeviceMutation, { data, loading, error }] = useDeleteDeviceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteDeviceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.DeleteDeviceMutation,
    Types.DeleteDeviceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.DeleteDeviceMutation,
    Types.DeleteDeviceMutationVariables
  >(DeleteDeviceDocument, options)
}
export type DeleteDeviceMutationHookResult = ReturnType<
  typeof useDeleteDeviceMutation
>
export type DeleteDeviceMutationResult =
  Apollo.MutationResult<Types.DeleteDeviceMutation>
export type DeleteDeviceMutationOptions = Apollo.BaseMutationOptions<
  Types.DeleteDeviceMutation,
  Types.DeleteDeviceMutationVariables
>
export const DeleteFacilityDocument = gql`
  mutation DeleteFacility($input: DeleteFacilityInput!) {
    deleteFacility(input: $input) {
      id
    }
  }
`
export type DeleteFacilityMutationFn = Apollo.MutationFunction<
  Types.DeleteFacilityMutation,
  Types.DeleteFacilityMutationVariables
>

/**
 * __useDeleteFacilityMutation__
 *
 * To run a mutation, you first call `useDeleteFacilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFacilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFacilityMutation, { data, loading, error }] = useDeleteFacilityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteFacilityMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.DeleteFacilityMutation,
    Types.DeleteFacilityMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.DeleteFacilityMutation,
    Types.DeleteFacilityMutationVariables
  >(DeleteFacilityDocument, options)
}
export type DeleteFacilityMutationHookResult = ReturnType<
  typeof useDeleteFacilityMutation
>
export type DeleteFacilityMutationResult =
  Apollo.MutationResult<Types.DeleteFacilityMutation>
export type DeleteFacilityMutationOptions = Apollo.BaseMutationOptions<
  Types.DeleteFacilityMutation,
  Types.DeleteFacilityMutationVariables
>
export const DeleteFloorPlanDocument = gql`
  mutation DeleteFloorPlan($input: DeleteFloorPlanInput!) {
    deleteFloorPlan(input: $input) {
      id
    }
  }
`
export type DeleteFloorPlanMutationFn = Apollo.MutationFunction<
  Types.DeleteFloorPlanMutation,
  Types.DeleteFloorPlanMutationVariables
>

/**
 * __useDeleteFloorPlanMutation__
 *
 * To run a mutation, you first call `useDeleteFloorPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFloorPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFloorPlanMutation, { data, loading, error }] = useDeleteFloorPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteFloorPlanMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.DeleteFloorPlanMutation,
    Types.DeleteFloorPlanMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.DeleteFloorPlanMutation,
    Types.DeleteFloorPlanMutationVariables
  >(DeleteFloorPlanDocument, options)
}
export type DeleteFloorPlanMutationHookResult = ReturnType<
  typeof useDeleteFloorPlanMutation
>
export type DeleteFloorPlanMutationResult =
  Apollo.MutationResult<Types.DeleteFloorPlanMutation>
export type DeleteFloorPlanMutationOptions = Apollo.BaseMutationOptions<
  Types.DeleteFloorPlanMutation,
  Types.DeleteFloorPlanMutationVariables
>
export const DeleteIncidentTypeDefinitionDocument = gql`
  mutation DeleteIncidentTypeDefinition($id: ID!) {
    deleteIncidentTypeDefinition(id: $id) {
      id
    }
  }
`
export type DeleteIncidentTypeDefinitionMutationFn = Apollo.MutationFunction<
  Types.DeleteIncidentTypeDefinitionMutation,
  Types.DeleteIncidentTypeDefinitionMutationVariables
>

/**
 * __useDeleteIncidentTypeDefinitionMutation__
 *
 * To run a mutation, you first call `useDeleteIncidentTypeDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIncidentTypeDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIncidentTypeDefinitionMutation, { data, loading, error }] = useDeleteIncidentTypeDefinitionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteIncidentTypeDefinitionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.DeleteIncidentTypeDefinitionMutation,
    Types.DeleteIncidentTypeDefinitionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.DeleteIncidentTypeDefinitionMutation,
    Types.DeleteIncidentTypeDefinitionMutationVariables
  >(DeleteIncidentTypeDefinitionDocument, options)
}
export type DeleteIncidentTypeDefinitionMutationHookResult = ReturnType<
  typeof useDeleteIncidentTypeDefinitionMutation
>
export type DeleteIncidentTypeDefinitionMutationResult =
  Apollo.MutationResult<Types.DeleteIncidentTypeDefinitionMutation>
export type DeleteIncidentTypeDefinitionMutationOptions =
  Apollo.BaseMutationOptions<
    Types.DeleteIncidentTypeDefinitionMutation,
    Types.DeleteIncidentTypeDefinitionMutationVariables
  >
export const DeleteManualIncidentCategoryDocument = gql`
  mutation deleteManualIncidentCategory(
    $input: DeleteManualIncidentCategoryInput!
  ) {
    deleteManualIncidentCategory(input: $input) {
      id
    }
  }
`
export type DeleteManualIncidentCategoryMutationFn = Apollo.MutationFunction<
  Types.DeleteManualIncidentCategoryMutation,
  Types.DeleteManualIncidentCategoryMutationVariables
>

/**
 * __useDeleteManualIncidentCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteManualIncidentCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteManualIncidentCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteManualIncidentCategoryMutation, { data, loading, error }] = useDeleteManualIncidentCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteManualIncidentCategoryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.DeleteManualIncidentCategoryMutation,
    Types.DeleteManualIncidentCategoryMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.DeleteManualIncidentCategoryMutation,
    Types.DeleteManualIncidentCategoryMutationVariables
  >(DeleteManualIncidentCategoryDocument, options)
}
export type DeleteManualIncidentCategoryMutationHookResult = ReturnType<
  typeof useDeleteManualIncidentCategoryMutation
>
export type DeleteManualIncidentCategoryMutationResult =
  Apollo.MutationResult<Types.DeleteManualIncidentCategoryMutation>
export type DeleteManualIncidentCategoryMutationOptions =
  Apollo.BaseMutationOptions<
    Types.DeleteManualIncidentCategoryMutation,
    Types.DeleteManualIncidentCategoryMutationVariables
  >
export const DeleteProductMessageDocument = gql`
  mutation DeleteProductMessage($input: DeleteProductMessageInput!) {
    deleteProductMessage(input: $input) {
      id
    }
  }
`
export type DeleteProductMessageMutationFn = Apollo.MutationFunction<
  Types.DeleteProductMessageMutation,
  Types.DeleteProductMessageMutationVariables
>

/**
 * __useDeleteProductMessageMutation__
 *
 * To run a mutation, you first call `useDeleteProductMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductMessageMutation, { data, loading, error }] = useDeleteProductMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteProductMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.DeleteProductMessageMutation,
    Types.DeleteProductMessageMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.DeleteProductMessageMutation,
    Types.DeleteProductMessageMutationVariables
  >(DeleteProductMessageDocument, options)
}
export type DeleteProductMessageMutationHookResult = ReturnType<
  typeof useDeleteProductMessageMutation
>
export type DeleteProductMessageMutationResult =
  Apollo.MutationResult<Types.DeleteProductMessageMutation>
export type DeleteProductMessageMutationOptions = Apollo.BaseMutationOptions<
  Types.DeleteProductMessageMutation,
  Types.DeleteProductMessageMutationVariables
>
export const DeleteSavedFilterDocument = gql`
  mutation DeleteSavedFilter($input: DeleteSavedFilterInput!) {
    deleteSavedFilter(input: $input) {
      id
    }
  }
`
export type DeleteSavedFilterMutationFn = Apollo.MutationFunction<
  Types.DeleteSavedFilterMutation,
  Types.DeleteSavedFilterMutationVariables
>

/**
 * __useDeleteSavedFilterMutation__
 *
 * To run a mutation, you first call `useDeleteSavedFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSavedFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSavedFilterMutation, { data, loading, error }] = useDeleteSavedFilterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSavedFilterMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.DeleteSavedFilterMutation,
    Types.DeleteSavedFilterMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.DeleteSavedFilterMutation,
    Types.DeleteSavedFilterMutationVariables
  >(DeleteSavedFilterDocument, options)
}
export type DeleteSavedFilterMutationHookResult = ReturnType<
  typeof useDeleteSavedFilterMutation
>
export type DeleteSavedFilterMutationResult =
  Apollo.MutationResult<Types.DeleteSavedFilterMutation>
export type DeleteSavedFilterMutationOptions = Apollo.BaseMutationOptions<
  Types.DeleteSavedFilterMutation,
  Types.DeleteSavedFilterMutationVariables
>
export const DeleteStandardOperatingProcedureDocument = gql`
  mutation DeleteStandardOperatingProcedure(
    $input: DeleteStandardOperatingProcedureInput!
  ) {
    deleteStandardOperatingProcedure(input: $input) {
      id
    }
  }
`
export type DeleteStandardOperatingProcedureMutationFn =
  Apollo.MutationFunction<
    Types.DeleteStandardOperatingProcedureMutation,
    Types.DeleteStandardOperatingProcedureMutationVariables
  >

/**
 * __useDeleteStandardOperatingProcedureMutation__
 *
 * To run a mutation, you first call `useDeleteStandardOperatingProcedureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStandardOperatingProcedureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStandardOperatingProcedureMutation, { data, loading, error }] = useDeleteStandardOperatingProcedureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteStandardOperatingProcedureMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.DeleteStandardOperatingProcedureMutation,
    Types.DeleteStandardOperatingProcedureMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.DeleteStandardOperatingProcedureMutation,
    Types.DeleteStandardOperatingProcedureMutationVariables
  >(DeleteStandardOperatingProcedureDocument, options)
}
export type DeleteStandardOperatingProcedureMutationHookResult = ReturnType<
  typeof useDeleteStandardOperatingProcedureMutation
>
export type DeleteStandardOperatingProcedureMutationResult =
  Apollo.MutationResult<Types.DeleteStandardOperatingProcedureMutation>
export type DeleteStandardOperatingProcedureMutationOptions =
  Apollo.BaseMutationOptions<
    Types.DeleteStandardOperatingProcedureMutation,
    Types.DeleteStandardOperatingProcedureMutationVariables
  >
export const DeleteTailgateGridDocument = gql`
  mutation DeleteTailgateGrid($input: DeleteTailgateGridInput!) {
    deleteTailgateGrid(input: $input) {
      camera {
        id
      }
      door {
        id
      }
    }
  }
`
export type DeleteTailgateGridMutationFn = Apollo.MutationFunction<
  Types.DeleteTailgateGridMutation,
  Types.DeleteTailgateGridMutationVariables
>

/**
 * __useDeleteTailgateGridMutation__
 *
 * To run a mutation, you first call `useDeleteTailgateGridMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTailgateGridMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTailgateGridMutation, { data, loading, error }] = useDeleteTailgateGridMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTailgateGridMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.DeleteTailgateGridMutation,
    Types.DeleteTailgateGridMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.DeleteTailgateGridMutation,
    Types.DeleteTailgateGridMutationVariables
  >(DeleteTailgateGridDocument, options)
}
export type DeleteTailgateGridMutationHookResult = ReturnType<
  typeof useDeleteTailgateGridMutation
>
export type DeleteTailgateGridMutationResult =
  Apollo.MutationResult<Types.DeleteTailgateGridMutation>
export type DeleteTailgateGridMutationOptions = Apollo.BaseMutationOptions<
  Types.DeleteTailgateGridMutation,
  Types.DeleteTailgateGridMutationVariables
>
export const DeleteTechnicianDocument = gql`
  mutation DeleteTechnician($input: DeleteTechnicianInput!) {
    deleteTechnician(input: $input) {
      id
    }
  }
`
export type DeleteTechnicianMutationFn = Apollo.MutationFunction<
  Types.DeleteTechnicianMutation,
  Types.DeleteTechnicianMutationVariables
>

/**
 * __useDeleteTechnicianMutation__
 *
 * To run a mutation, you first call `useDeleteTechnicianMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTechnicianMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTechnicianMutation, { data, loading, error }] = useDeleteTechnicianMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTechnicianMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.DeleteTechnicianMutation,
    Types.DeleteTechnicianMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.DeleteTechnicianMutation,
    Types.DeleteTechnicianMutationVariables
  >(DeleteTechnicianDocument, options)
}
export type DeleteTechnicianMutationHookResult = ReturnType<
  typeof useDeleteTechnicianMutation
>
export type DeleteTechnicianMutationResult =
  Apollo.MutationResult<Types.DeleteTechnicianMutation>
export type DeleteTechnicianMutationOptions = Apollo.BaseMutationOptions<
  Types.DeleteTechnicianMutation,
  Types.DeleteTechnicianMutationVariables
>
export const DeleteTourPlanDocument = gql`
  mutation DeleteTourPlan($input: DeleteTourPlanInput!) {
    deleteTourPlan(input: $input) {
      id
    }
  }
`
export type DeleteTourPlanMutationFn = Apollo.MutationFunction<
  Types.DeleteTourPlanMutation,
  Types.DeleteTourPlanMutationVariables
>

/**
 * __useDeleteTourPlanMutation__
 *
 * To run a mutation, you first call `useDeleteTourPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTourPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTourPlanMutation, { data, loading, error }] = useDeleteTourPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTourPlanMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.DeleteTourPlanMutation,
    Types.DeleteTourPlanMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.DeleteTourPlanMutation,
    Types.DeleteTourPlanMutationVariables
  >(DeleteTourPlanDocument, options)
}
export type DeleteTourPlanMutationHookResult = ReturnType<
  typeof useDeleteTourPlanMutation
>
export type DeleteTourPlanMutationResult =
  Apollo.MutationResult<Types.DeleteTourPlanMutation>
export type DeleteTourPlanMutationOptions = Apollo.BaseMutationOptions<
  Types.DeleteTourPlanMutation,
  Types.DeleteTourPlanMutationVariables
>
export const DeleteUserDocument = gql`
  mutation DeleteUser($input: DeleteUserInput!) {
    deleteUser(input: $input) {
      id
    }
  }
`
export type DeleteUserMutationFn = Apollo.MutationFunction<
  Types.DeleteUserMutation,
  Types.DeleteUserMutationVariables
>

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.DeleteUserMutation,
    Types.DeleteUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.DeleteUserMutation,
    Types.DeleteUserMutationVariables
  >(DeleteUserDocument, options)
}
export type DeleteUserMutationHookResult = ReturnType<
  typeof useDeleteUserMutation
>
export type DeleteUserMutationResult =
  Apollo.MutationResult<Types.DeleteUserMutation>
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<
  Types.DeleteUserMutation,
  Types.DeleteUserMutationVariables
>
export const DisassociateMultipleIncidentsFromSingleCaseDocument = gql`
  mutation DisassociateMultipleIncidentsFromSingleCase(
    $input: DisassociateIncidentsFromCaseInput!
  ) {
    disassociateMultipleIncidentsFromSingleCase(input: $input) {
      case {
        id
        name
      }
    }
  }
`
export type DisassociateMultipleIncidentsFromSingleCaseMutationFn =
  Apollo.MutationFunction<
    Types.DisassociateMultipleIncidentsFromSingleCaseMutation,
    Types.DisassociateMultipleIncidentsFromSingleCaseMutationVariables
  >

/**
 * __useDisassociateMultipleIncidentsFromSingleCaseMutation__
 *
 * To run a mutation, you first call `useDisassociateMultipleIncidentsFromSingleCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisassociateMultipleIncidentsFromSingleCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disassociateMultipleIncidentsFromSingleCaseMutation, { data, loading, error }] = useDisassociateMultipleIncidentsFromSingleCaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDisassociateMultipleIncidentsFromSingleCaseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.DisassociateMultipleIncidentsFromSingleCaseMutation,
    Types.DisassociateMultipleIncidentsFromSingleCaseMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.DisassociateMultipleIncidentsFromSingleCaseMutation,
    Types.DisassociateMultipleIncidentsFromSingleCaseMutationVariables
  >(DisassociateMultipleIncidentsFromSingleCaseDocument, options)
}
export type DisassociateMultipleIncidentsFromSingleCaseMutationHookResult =
  ReturnType<typeof useDisassociateMultipleIncidentsFromSingleCaseMutation>
export type DisassociateMultipleIncidentsFromSingleCaseMutationResult =
  Apollo.MutationResult<Types.DisassociateMultipleIncidentsFromSingleCaseMutation>
export type DisassociateMultipleIncidentsFromSingleCaseMutationOptions =
  Apollo.BaseMutationOptions<
    Types.DisassociateMultipleIncidentsFromSingleCaseMutation,
    Types.DisassociateMultipleIncidentsFromSingleCaseMutationVariables
  >
export const DisassociatePersonOfInterestFromCaseDocument = gql`
  mutation DisassociatePersonOfInterestFromCase(
    $input: DisassociatePersonOfInterestInput!
  ) {
    disassociatePersonOfInterestFromCase(input: $input) {
      case {
        id
      }
    }
  }
`
export type DisassociatePersonOfInterestFromCaseMutationFn =
  Apollo.MutationFunction<
    Types.DisassociatePersonOfInterestFromCaseMutation,
    Types.DisassociatePersonOfInterestFromCaseMutationVariables
  >

/**
 * __useDisassociatePersonOfInterestFromCaseMutation__
 *
 * To run a mutation, you first call `useDisassociatePersonOfInterestFromCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisassociatePersonOfInterestFromCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disassociatePersonOfInterestFromCaseMutation, { data, loading, error }] = useDisassociatePersonOfInterestFromCaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDisassociatePersonOfInterestFromCaseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.DisassociatePersonOfInterestFromCaseMutation,
    Types.DisassociatePersonOfInterestFromCaseMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.DisassociatePersonOfInterestFromCaseMutation,
    Types.DisassociatePersonOfInterestFromCaseMutationVariables
  >(DisassociatePersonOfInterestFromCaseDocument, options)
}
export type DisassociatePersonOfInterestFromCaseMutationHookResult = ReturnType<
  typeof useDisassociatePersonOfInterestFromCaseMutation
>
export type DisassociatePersonOfInterestFromCaseMutationResult =
  Apollo.MutationResult<Types.DisassociatePersonOfInterestFromCaseMutation>
export type DisassociatePersonOfInterestFromCaseMutationOptions =
  Apollo.BaseMutationOptions<
    Types.DisassociatePersonOfInterestFromCaseMutation,
    Types.DisassociatePersonOfInterestFromCaseMutationVariables
  >
export const EmbedQuickSightContentDocument = gql`
  mutation EmbedQuickSightContent($input: EmbedQuickSightContentInput) {
    embedQuickSightContent(input: $input) {
      embeddedQuickSightContent {
        expiryTime
        sessionLifetimeInMinutes
        url
      }
    }
  }
`
export type EmbedQuickSightContentMutationFn = Apollo.MutationFunction<
  Types.EmbedQuickSightContentMutation,
  Types.EmbedQuickSightContentMutationVariables
>

/**
 * __useEmbedQuickSightContentMutation__
 *
 * To run a mutation, you first call `useEmbedQuickSightContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmbedQuickSightContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [embedQuickSightContentMutation, { data, loading, error }] = useEmbedQuickSightContentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEmbedQuickSightContentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.EmbedQuickSightContentMutation,
    Types.EmbedQuickSightContentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.EmbedQuickSightContentMutation,
    Types.EmbedQuickSightContentMutationVariables
  >(EmbedQuickSightContentDocument, options)
}
export type EmbedQuickSightContentMutationHookResult = ReturnType<
  typeof useEmbedQuickSightContentMutation
>
export type EmbedQuickSightContentMutationResult =
  Apollo.MutationResult<Types.EmbedQuickSightContentMutation>
export type EmbedQuickSightContentMutationOptions = Apollo.BaseMutationOptions<
  Types.EmbedQuickSightContentMutation,
  Types.EmbedQuickSightContentMutationVariables
>
export const EnableManualIncidentCategoriesForQuickReportDocument = gql`
  mutation EnableManualIncidentCategoriesForQuickReport(
    $input: EnableManualIncidentCategoriesForQuickReportInput!
  ) {
    enableManualIncidentCategoriesForQuickReport(input: $input) {
      totalCount
    }
  }
`
export type EnableManualIncidentCategoriesForQuickReportMutationFn =
  Apollo.MutationFunction<
    Types.EnableManualIncidentCategoriesForQuickReportMutation,
    Types.EnableManualIncidentCategoriesForQuickReportMutationVariables
  >

/**
 * __useEnableManualIncidentCategoriesForQuickReportMutation__
 *
 * To run a mutation, you first call `useEnableManualIncidentCategoriesForQuickReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableManualIncidentCategoriesForQuickReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableManualIncidentCategoriesForQuickReportMutation, { data, loading, error }] = useEnableManualIncidentCategoriesForQuickReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEnableManualIncidentCategoriesForQuickReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.EnableManualIncidentCategoriesForQuickReportMutation,
    Types.EnableManualIncidentCategoriesForQuickReportMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.EnableManualIncidentCategoriesForQuickReportMutation,
    Types.EnableManualIncidentCategoriesForQuickReportMutationVariables
  >(EnableManualIncidentCategoriesForQuickReportDocument, options)
}
export type EnableManualIncidentCategoriesForQuickReportMutationHookResult =
  ReturnType<typeof useEnableManualIncidentCategoriesForQuickReportMutation>
export type EnableManualIncidentCategoriesForQuickReportMutationResult =
  Apollo.MutationResult<Types.EnableManualIncidentCategoriesForQuickReportMutation>
export type EnableManualIncidentCategoriesForQuickReportMutationOptions =
  Apollo.BaseMutationOptions<
    Types.EnableManualIncidentCategoriesForQuickReportMutation,
    Types.EnableManualIncidentCategoriesForQuickReportMutationVariables
  >
export const GenerateFileUploadUrlDocument = gql`
  mutation GenerateFileUploadUrl($input: GenerateFileUploadUrlInput!) {
    generateFileUploadUrl(input: $input) {
      fileId
      url
      __typename
    }
  }
`
export type GenerateFileUploadUrlMutationFn = Apollo.MutationFunction<
  Types.GenerateFileUploadUrlMutation,
  Types.GenerateFileUploadUrlMutationVariables
>

/**
 * __useGenerateFileUploadUrlMutation__
 *
 * To run a mutation, you first call `useGenerateFileUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateFileUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateFileUploadUrlMutation, { data, loading, error }] = useGenerateFileUploadUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateFileUploadUrlMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.GenerateFileUploadUrlMutation,
    Types.GenerateFileUploadUrlMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.GenerateFileUploadUrlMutation,
    Types.GenerateFileUploadUrlMutationVariables
  >(GenerateFileUploadUrlDocument, options)
}
export type GenerateFileUploadUrlMutationHookResult = ReturnType<
  typeof useGenerateFileUploadUrlMutation
>
export type GenerateFileUploadUrlMutationResult =
  Apollo.MutationResult<Types.GenerateFileUploadUrlMutation>
export type GenerateFileUploadUrlMutationOptions = Apollo.BaseMutationOptions<
  Types.GenerateFileUploadUrlMutation,
  Types.GenerateFileUploadUrlMutationVariables
>
export const GenerateIncidentSummaryDocument = gql`
  mutation GenerateIncidentSummary($input: GenerateIncidentSummaryInput!) {
    generateIncidentSummary(input: $input) {
      overview {
        incidentCount
        narrative
        dateRange {
          from
          to
        }
        severityBreakdown {
          critical
          urgent
          moderate
          low
          informational
        }
        statusBreakdown {
          active
          inProgress
          resolved
        }
        topDevices
        topFacilities
      }
      categoryBreakdown {
        category
        count
        narrative
        percentage
      }
      incidents {
        incidentId
        displayId
        assignedCategory
        summary
      }
      patterns {
        description
        incidentIds
      }
    }
  }
`
export type GenerateIncidentSummaryMutationFn = Apollo.MutationFunction<
  Types.GenerateIncidentSummaryMutation,
  Types.GenerateIncidentSummaryMutationVariables
>

/**
 * __useGenerateIncidentSummaryMutation__
 *
 * To run a mutation, you first call `useGenerateIncidentSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateIncidentSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateIncidentSummaryMutation, { data, loading, error }] = useGenerateIncidentSummaryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateIncidentSummaryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.GenerateIncidentSummaryMutation,
    Types.GenerateIncidentSummaryMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.GenerateIncidentSummaryMutation,
    Types.GenerateIncidentSummaryMutationVariables
  >(GenerateIncidentSummaryDocument, options)
}
export type GenerateIncidentSummaryMutationHookResult = ReturnType<
  typeof useGenerateIncidentSummaryMutation
>
export type GenerateIncidentSummaryMutationResult =
  Apollo.MutationResult<Types.GenerateIncidentSummaryMutation>
export type GenerateIncidentSummaryMutationOptions = Apollo.BaseMutationOptions<
  Types.GenerateIncidentSummaryMutation,
  Types.GenerateIncidentSummaryMutationVariables
>
export const InviteUserDocument = gql`
  mutation InviteUser($input: InviteUserInput!) {
    inviteUser(input: $input) {
      user {
        id
        email
        firstName
        lastName
        roles
        roleName
        designatedFacilityId
      }
    }
  }
`
export type InviteUserMutationFn = Apollo.MutationFunction<
  Types.InviteUserMutation,
  Types.InviteUserMutationVariables
>

/**
 * __useInviteUserMutation__
 *
 * To run a mutation, you first call `useInviteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteUserMutation, { data, loading, error }] = useInviteUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.InviteUserMutation,
    Types.InviteUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.InviteUserMutation,
    Types.InviteUserMutationVariables
  >(InviteUserDocument, options)
}
export type InviteUserMutationHookResult = ReturnType<
  typeof useInviteUserMutation
>
export type InviteUserMutationResult =
  Apollo.MutationResult<Types.InviteUserMutation>
export type InviteUserMutationOptions = Apollo.BaseMutationOptions<
  Types.InviteUserMutation,
  Types.InviteUserMutationVariables
>
export const LinkCustomerSecretProviderDocument = gql`
  mutation LinkCustomerSecretProvider(
    $input: LinkCustomerSecretProviderInput!
  ) {
    linkCustomerSecretProvider(input: $input) {
      customerSecretProviderLink {
        id
        customerSecretProviderId
        entityType
        entityId
        createdAt
        entity {
          ... on PacsSourceInstance {
            id
            customerSecretProvider {
              secretArn
            }
          }
          ... on ExternalAccountApiKey {
            id
            customerSecretProvider {
              secretArn
            }
          }
          ... on Camera {
            id
            customerSecretProvider {
              secretArn
            }
          }
        }
      }
    }
  }
`
export type LinkCustomerSecretProviderMutationFn = Apollo.MutationFunction<
  Types.LinkCustomerSecretProviderMutation,
  Types.LinkCustomerSecretProviderMutationVariables
>

/**
 * __useLinkCustomerSecretProviderMutation__
 *
 * To run a mutation, you first call `useLinkCustomerSecretProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkCustomerSecretProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkCustomerSecretProviderMutation, { data, loading, error }] = useLinkCustomerSecretProviderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinkCustomerSecretProviderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.LinkCustomerSecretProviderMutation,
    Types.LinkCustomerSecretProviderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.LinkCustomerSecretProviderMutation,
    Types.LinkCustomerSecretProviderMutationVariables
  >(LinkCustomerSecretProviderDocument, options)
}
export type LinkCustomerSecretProviderMutationHookResult = ReturnType<
  typeof useLinkCustomerSecretProviderMutation
>
export type LinkCustomerSecretProviderMutationResult =
  Apollo.MutationResult<Types.LinkCustomerSecretProviderMutation>
export type LinkCustomerSecretProviderMutationOptions =
  Apollo.BaseMutationOptions<
    Types.LinkCustomerSecretProviderMutation,
    Types.LinkCustomerSecretProviderMutationVariables
  >
export const MarkFtuCompletedDocument = gql`
  mutation MarkFtuCompleted($input: MarkFtuCompletedInput!) {
    markFtuCompleted(input: $input) {
      userSetting {
        completedFtus
      }
    }
  }
`
export type MarkFtuCompletedMutationFn = Apollo.MutationFunction<
  Types.MarkFtuCompletedMutation,
  Types.MarkFtuCompletedMutationVariables
>

/**
 * __useMarkFtuCompletedMutation__
 *
 * To run a mutation, you first call `useMarkFtuCompletedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkFtuCompletedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markFtuCompletedMutation, { data, loading, error }] = useMarkFtuCompletedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkFtuCompletedMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.MarkFtuCompletedMutation,
    Types.MarkFtuCompletedMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.MarkFtuCompletedMutation,
    Types.MarkFtuCompletedMutationVariables
  >(MarkFtuCompletedDocument, options)
}
export type MarkFtuCompletedMutationHookResult = ReturnType<
  typeof useMarkFtuCompletedMutation
>
export type MarkFtuCompletedMutationResult =
  Apollo.MutationResult<Types.MarkFtuCompletedMutation>
export type MarkFtuCompletedMutationOptions = Apollo.BaseMutationOptions<
  Types.MarkFtuCompletedMutation,
  Types.MarkFtuCompletedMutationVariables
>
export const ModifyTailgateConnDocument = gql`
  mutation ModifyTailgateConn($input: ModifyTailgateConnInput!) {
    modifyTailgateConn(input: $input) {
      tailgateConn {
        id
        cameras {
          edges {
            node {
              id
            }
          }
        }
        door {
          id
        }
      }
    }
  }
`
export type ModifyTailgateConnMutationFn = Apollo.MutationFunction<
  Types.ModifyTailgateConnMutation,
  Types.ModifyTailgateConnMutationVariables
>

/**
 * __useModifyTailgateConnMutation__
 *
 * To run a mutation, you first call `useModifyTailgateConnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModifyTailgateConnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modifyTailgateConnMutation, { data, loading, error }] = useModifyTailgateConnMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useModifyTailgateConnMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.ModifyTailgateConnMutation,
    Types.ModifyTailgateConnMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.ModifyTailgateConnMutation,
    Types.ModifyTailgateConnMutationVariables
  >(ModifyTailgateConnDocument, options)
}
export type ModifyTailgateConnMutationHookResult = ReturnType<
  typeof useModifyTailgateConnMutation
>
export type ModifyTailgateConnMutationResult =
  Apollo.MutationResult<Types.ModifyTailgateConnMutation>
export type ModifyTailgateConnMutationOptions = Apollo.BaseMutationOptions<
  Types.ModifyTailgateConnMutation,
  Types.ModifyTailgateConnMutationVariables
>
export const OffboardUserDocument = gql`
  mutation OffboardUser($input: OffboardUserInput!) {
    offboardUser(input: $input) {
      id
    }
  }
`
export type OffboardUserMutationFn = Apollo.MutationFunction<
  Types.OffboardUserMutation,
  Types.OffboardUserMutationVariables
>

/**
 * __useOffboardUserMutation__
 *
 * To run a mutation, you first call `useOffboardUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOffboardUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [offboardUserMutation, { data, loading, error }] = useOffboardUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOffboardUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.OffboardUserMutation,
    Types.OffboardUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.OffboardUserMutation,
    Types.OffboardUserMutationVariables
  >(OffboardUserDocument, options)
}
export type OffboardUserMutationHookResult = ReturnType<
  typeof useOffboardUserMutation
>
export type OffboardUserMutationResult =
  Apollo.MutationResult<Types.OffboardUserMutation>
export type OffboardUserMutationOptions = Apollo.BaseMutationOptions<
  Types.OffboardUserMutation,
  Types.OffboardUserMutationVariables
>
export const PublishCustomFormDocument = gql`
  mutation PublishCustomForm($input: PublishCustomFormInput!) {
    publishCustomForm(input: $input) {
      customForm {
        id
        status
        version
        publishedAt
      }
    }
  }
`
export type PublishCustomFormMutationFn = Apollo.MutationFunction<
  Types.PublishCustomFormMutation,
  Types.PublishCustomFormMutationVariables
>

/**
 * __usePublishCustomFormMutation__
 *
 * To run a mutation, you first call `usePublishCustomFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishCustomFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishCustomFormMutation, { data, loading, error }] = usePublishCustomFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublishCustomFormMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.PublishCustomFormMutation,
    Types.PublishCustomFormMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.PublishCustomFormMutation,
    Types.PublishCustomFormMutationVariables
  >(PublishCustomFormDocument, options)
}
export type PublishCustomFormMutationHookResult = ReturnType<
  typeof usePublishCustomFormMutation
>
export type PublishCustomFormMutationResult =
  Apollo.MutationResult<Types.PublishCustomFormMutation>
export type PublishCustomFormMutationOptions = Apollo.BaseMutationOptions<
  Types.PublishCustomFormMutation,
  Types.PublishCustomFormMutationVariables
>
export const RefreshQuickReportCodeDocument = gql`
  mutation RefreshQuickReportCode {
    refreshQuickReportCode {
      quickReportCode {
        id
      }
    }
  }
`
export type RefreshQuickReportCodeMutationFn = Apollo.MutationFunction<
  Types.RefreshQuickReportCodeMutation,
  Types.RefreshQuickReportCodeMutationVariables
>

/**
 * __useRefreshQuickReportCodeMutation__
 *
 * To run a mutation, you first call `useRefreshQuickReportCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshQuickReportCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshQuickReportCodeMutation, { data, loading, error }] = useRefreshQuickReportCodeMutation({
 *   variables: {
 *   },
 * });
 */
export function useRefreshQuickReportCodeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.RefreshQuickReportCodeMutation,
    Types.RefreshQuickReportCodeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.RefreshQuickReportCodeMutation,
    Types.RefreshQuickReportCodeMutationVariables
  >(RefreshQuickReportCodeDocument, options)
}
export type RefreshQuickReportCodeMutationHookResult = ReturnType<
  typeof useRefreshQuickReportCodeMutation
>
export type RefreshQuickReportCodeMutationResult =
  Apollo.MutationResult<Types.RefreshQuickReportCodeMutation>
export type RefreshQuickReportCodeMutationOptions = Apollo.BaseMutationOptions<
  Types.RefreshQuickReportCodeMutation,
  Types.RefreshQuickReportCodeMutationVariables
>
export const RemoveTagsFromDeviceDocument = gql`
  mutation RemoveTagsFromDevice($input: RemoveTagsFromDeviceInput!) {
    removeTagsFromDevice(input: $input) {
      device {
        id
        tags {
          edges {
            node {
              id
              name
              enabled
              archived
            }
          }
        }
      }
    }
  }
`
export type RemoveTagsFromDeviceMutationFn = Apollo.MutationFunction<
  Types.RemoveTagsFromDeviceMutation,
  Types.RemoveTagsFromDeviceMutationVariables
>

/**
 * __useRemoveTagsFromDeviceMutation__
 *
 * To run a mutation, you first call `useRemoveTagsFromDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTagsFromDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTagsFromDeviceMutation, { data, loading, error }] = useRemoveTagsFromDeviceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveTagsFromDeviceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.RemoveTagsFromDeviceMutation,
    Types.RemoveTagsFromDeviceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.RemoveTagsFromDeviceMutation,
    Types.RemoveTagsFromDeviceMutationVariables
  >(RemoveTagsFromDeviceDocument, options)
}
export type RemoveTagsFromDeviceMutationHookResult = ReturnType<
  typeof useRemoveTagsFromDeviceMutation
>
export type RemoveTagsFromDeviceMutationResult =
  Apollo.MutationResult<Types.RemoveTagsFromDeviceMutation>
export type RemoveTagsFromDeviceMutationOptions = Apollo.BaseMutationOptions<
  Types.RemoveTagsFromDeviceMutation,
  Types.RemoveTagsFromDeviceMutationVariables
>
export const ReorderFloorsDocument = gql`
  mutation ReorderFloors($input: ReorderFloorsInput!) {
    reorderFloors(input: $input) {
      floors {
        id
        name
        displayOrder
      }
    }
  }
`
export type ReorderFloorsMutationFn = Apollo.MutationFunction<
  Types.ReorderFloorsMutation,
  Types.ReorderFloorsMutationVariables
>

/**
 * __useReorderFloorsMutation__
 *
 * To run a mutation, you first call `useReorderFloorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderFloorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderFloorsMutation, { data, loading, error }] = useReorderFloorsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReorderFloorsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.ReorderFloorsMutation,
    Types.ReorderFloorsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.ReorderFloorsMutation,
    Types.ReorderFloorsMutationVariables
  >(ReorderFloorsDocument, options)
}
export type ReorderFloorsMutationHookResult = ReturnType<
  typeof useReorderFloorsMutation
>
export type ReorderFloorsMutationResult =
  Apollo.MutationResult<Types.ReorderFloorsMutation>
export type ReorderFloorsMutationOptions = Apollo.BaseMutationOptions<
  Types.ReorderFloorsMutation,
  Types.ReorderFloorsMutationVariables
>
export const ResendUserInviteDocument = gql`
  mutation ResendUserInvite($input: ResendUserInviteInput!) {
    resendUserInvite(input: $input) {
      user {
        id
        email
        lastInviteSentAt
      }
    }
  }
`
export type ResendUserInviteMutationFn = Apollo.MutationFunction<
  Types.ResendUserInviteMutation,
  Types.ResendUserInviteMutationVariables
>

/**
 * __useResendUserInviteMutation__
 *
 * To run a mutation, you first call `useResendUserInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendUserInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendUserInviteMutation, { data, loading, error }] = useResendUserInviteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResendUserInviteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.ResendUserInviteMutation,
    Types.ResendUserInviteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.ResendUserInviteMutation,
    Types.ResendUserInviteMutationVariables
  >(ResendUserInviteDocument, options)
}
export type ResendUserInviteMutationHookResult = ReturnType<
  typeof useResendUserInviteMutation
>
export type ResendUserInviteMutationResult =
  Apollo.MutationResult<Types.ResendUserInviteMutation>
export type ResendUserInviteMutationOptions = Apollo.BaseMutationOptions<
  Types.ResendUserInviteMutation,
  Types.ResendUserInviteMutationVariables
>
export const RestartEdgeDeviceDocument = gql`
  mutation RestartEdgeDevice($input: RestartEdgeDeviceInput!) {
    restartEdgeDevice(input: $input) {
      isRestartRequested
    }
  }
`
export type RestartEdgeDeviceMutationFn = Apollo.MutationFunction<
  Types.RestartEdgeDeviceMutation,
  Types.RestartEdgeDeviceMutationVariables
>

/**
 * __useRestartEdgeDeviceMutation__
 *
 * To run a mutation, you first call `useRestartEdgeDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestartEdgeDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restartEdgeDeviceMutation, { data, loading, error }] = useRestartEdgeDeviceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestartEdgeDeviceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.RestartEdgeDeviceMutation,
    Types.RestartEdgeDeviceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.RestartEdgeDeviceMutation,
    Types.RestartEdgeDeviceMutationVariables
  >(RestartEdgeDeviceDocument, options)
}
export type RestartEdgeDeviceMutationHookResult = ReturnType<
  typeof useRestartEdgeDeviceMutation
>
export type RestartEdgeDeviceMutationResult =
  Apollo.MutationResult<Types.RestartEdgeDeviceMutation>
export type RestartEdgeDeviceMutationOptions = Apollo.BaseMutationOptions<
  Types.RestartEdgeDeviceMutation,
  Types.RestartEdgeDeviceMutationVariables
>
export const SetCameraCredsDocument = gql`
  mutation SetCameraCreds($id: ID!, $username: String, $password: String) {
    updateCamera(
      input: {
        id: $id
        requiresAuthentication: true
        rtspUsername: $username
        rtspPassword: $password
      }
    ) {
      camera {
        id
        requiresAuthentication
      }
    }
  }
`
export type SetCameraCredsMutationFn = Apollo.MutationFunction<
  Types.SetCameraCredsMutation,
  Types.SetCameraCredsMutationVariables
>

/**
 * __useSetCameraCredsMutation__
 *
 * To run a mutation, you first call `useSetCameraCredsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCameraCredsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCameraCredsMutation, { data, loading, error }] = useSetCameraCredsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      username: // value for 'username'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useSetCameraCredsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.SetCameraCredsMutation,
    Types.SetCameraCredsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.SetCameraCredsMutation,
    Types.SetCameraCredsMutationVariables
  >(SetCameraCredsDocument, options)
}
export type SetCameraCredsMutationHookResult = ReturnType<
  typeof useSetCameraCredsMutation
>
export type SetCameraCredsMutationResult =
  Apollo.MutationResult<Types.SetCameraCredsMutation>
export type SetCameraCredsMutationOptions = Apollo.BaseMutationOptions<
  Types.SetCameraCredsMutation,
  Types.SetCameraCredsMutationVariables
>
export const TransitionProgramRecommendationDocument = gql`
  mutation TransitionProgramRecommendation(
    $input: TransitionProgramRecommendationInput!
  ) {
    transitionProgramRecommendation(input: $input) {
      programRecommendation {
        id
        title
        description
        category
        owner
        status
        estimatedImpact
        actualImpact
        internalNote
        createdAt
        updatedAt
        isArchived
        publishedById
        publishedBy {
          id
          firstName
          lastName
        }
        actions {
          id
          actionType
          note
          performedAt
          performedById
        }
      }
    }
  }
`
export type TransitionProgramRecommendationMutationFn = Apollo.MutationFunction<
  Types.TransitionProgramRecommendationMutation,
  Types.TransitionProgramRecommendationMutationVariables
>

/**
 * __useTransitionProgramRecommendationMutation__
 *
 * To run a mutation, you first call `useTransitionProgramRecommendationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransitionProgramRecommendationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transitionProgramRecommendationMutation, { data, loading, error }] = useTransitionProgramRecommendationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTransitionProgramRecommendationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.TransitionProgramRecommendationMutation,
    Types.TransitionProgramRecommendationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.TransitionProgramRecommendationMutation,
    Types.TransitionProgramRecommendationMutationVariables
  >(TransitionProgramRecommendationDocument, options)
}
export type TransitionProgramRecommendationMutationHookResult = ReturnType<
  typeof useTransitionProgramRecommendationMutation
>
export type TransitionProgramRecommendationMutationResult =
  Apollo.MutationResult<Types.TransitionProgramRecommendationMutation>
export type TransitionProgramRecommendationMutationOptions =
  Apollo.BaseMutationOptions<
    Types.TransitionProgramRecommendationMutation,
    Types.TransitionProgramRecommendationMutationVariables
  >
export const UnarchiveFloorDocument = gql`
  mutation UnarchiveFloor($input: UnarchiveFloorInput!) {
    unarchiveFloor(input: $input) {
      floor {
        id
      }
    }
  }
`
export type UnarchiveFloorMutationFn = Apollo.MutationFunction<
  Types.UnarchiveFloorMutation,
  Types.UnarchiveFloorMutationVariables
>

/**
 * __useUnarchiveFloorMutation__
 *
 * To run a mutation, you first call `useUnarchiveFloorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveFloorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveFloorMutation, { data, loading, error }] = useUnarchiveFloorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnarchiveFloorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UnarchiveFloorMutation,
    Types.UnarchiveFloorMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.UnarchiveFloorMutation,
    Types.UnarchiveFloorMutationVariables
  >(UnarchiveFloorDocument, options)
}
export type UnarchiveFloorMutationHookResult = ReturnType<
  typeof useUnarchiveFloorMutation
>
export type UnarchiveFloorMutationResult =
  Apollo.MutationResult<Types.UnarchiveFloorMutation>
export type UnarchiveFloorMutationOptions = Apollo.BaseMutationOptions<
  Types.UnarchiveFloorMutation,
  Types.UnarchiveFloorMutationVariables
>
export const UnlinkCustomerSecretProviderDocument = gql`
  mutation UnlinkCustomerSecretProvider(
    $input: UnlinkCustomerSecretProviderInput!
  ) {
    unlinkCustomerSecretProvider(input: $input) {
      id
    }
  }
`
export type UnlinkCustomerSecretProviderMutationFn = Apollo.MutationFunction<
  Types.UnlinkCustomerSecretProviderMutation,
  Types.UnlinkCustomerSecretProviderMutationVariables
>

/**
 * __useUnlinkCustomerSecretProviderMutation__
 *
 * To run a mutation, you first call `useUnlinkCustomerSecretProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkCustomerSecretProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkCustomerSecretProviderMutation, { data, loading, error }] = useUnlinkCustomerSecretProviderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnlinkCustomerSecretProviderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UnlinkCustomerSecretProviderMutation,
    Types.UnlinkCustomerSecretProviderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.UnlinkCustomerSecretProviderMutation,
    Types.UnlinkCustomerSecretProviderMutationVariables
  >(UnlinkCustomerSecretProviderDocument, options)
}
export type UnlinkCustomerSecretProviderMutationHookResult = ReturnType<
  typeof useUnlinkCustomerSecretProviderMutation
>
export type UnlinkCustomerSecretProviderMutationResult =
  Apollo.MutationResult<Types.UnlinkCustomerSecretProviderMutation>
export type UnlinkCustomerSecretProviderMutationOptions =
  Apollo.BaseMutationOptions<
    Types.UnlinkCustomerSecretProviderMutation,
    Types.UnlinkCustomerSecretProviderMutationVariables
  >
export const UnpublishCustomFormDocument = gql`
  mutation UnpublishCustomForm($input: UnpublishCustomFormInput!) {
    unpublishCustomForm(input: $input) {
      customForm {
        id
        status
      }
    }
  }
`
export type UnpublishCustomFormMutationFn = Apollo.MutationFunction<
  Types.UnpublishCustomFormMutation,
  Types.UnpublishCustomFormMutationVariables
>

/**
 * __useUnpublishCustomFormMutation__
 *
 * To run a mutation, you first call `useUnpublishCustomFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpublishCustomFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpublishCustomFormMutation, { data, loading, error }] = useUnpublishCustomFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnpublishCustomFormMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UnpublishCustomFormMutation,
    Types.UnpublishCustomFormMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.UnpublishCustomFormMutation,
    Types.UnpublishCustomFormMutationVariables
  >(UnpublishCustomFormDocument, options)
}
export type UnpublishCustomFormMutationHookResult = ReturnType<
  typeof useUnpublishCustomFormMutation
>
export type UnpublishCustomFormMutationResult =
  Apollo.MutationResult<Types.UnpublishCustomFormMutation>
export type UnpublishCustomFormMutationOptions = Apollo.BaseMutationOptions<
  Types.UnpublishCustomFormMutation,
  Types.UnpublishCustomFormMutationVariables
>
export const UpdateAiOperatorLimitDocument = gql`
  mutation UpdateAiOperatorLimit($input: UpdateAiOperatorLimitInput!) {
    updateAiOperatorLimit(input: $input) {
      aiOperatorSettings {
        id
        monthlyIncidentLimit
      }
    }
  }
`
export type UpdateAiOperatorLimitMutationFn = Apollo.MutationFunction<
  Types.UpdateAiOperatorLimitMutation,
  Types.UpdateAiOperatorLimitMutationVariables
>

/**
 * __useUpdateAiOperatorLimitMutation__
 *
 * To run a mutation, you first call `useUpdateAiOperatorLimitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAiOperatorLimitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAiOperatorLimitMutation, { data, loading, error }] = useUpdateAiOperatorLimitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAiOperatorLimitMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateAiOperatorLimitMutation,
    Types.UpdateAiOperatorLimitMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.UpdateAiOperatorLimitMutation,
    Types.UpdateAiOperatorLimitMutationVariables
  >(UpdateAiOperatorLimitDocument, options)
}
export type UpdateAiOperatorLimitMutationHookResult = ReturnType<
  typeof useUpdateAiOperatorLimitMutation
>
export type UpdateAiOperatorLimitMutationResult =
  Apollo.MutationResult<Types.UpdateAiOperatorLimitMutation>
export type UpdateAiOperatorLimitMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateAiOperatorLimitMutation,
  Types.UpdateAiOperatorLimitMutationVariables
>
export const UpdateAiOperatorResponseRulesDocument = gql`
  mutation UpdateAiOperatorResponseRules(
    $input: UpdateAiOperatorResponseRulesInput
  ) {
    updateAiOperatorResponseRules(input: $input) {
      rule {
        id
      }
    }
  }
`
export type UpdateAiOperatorResponseRulesMutationFn = Apollo.MutationFunction<
  Types.UpdateAiOperatorResponseRulesMutation,
  Types.UpdateAiOperatorResponseRulesMutationVariables
>

/**
 * __useUpdateAiOperatorResponseRulesMutation__
 *
 * To run a mutation, you first call `useUpdateAiOperatorResponseRulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAiOperatorResponseRulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAiOperatorResponseRulesMutation, { data, loading, error }] = useUpdateAiOperatorResponseRulesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAiOperatorResponseRulesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateAiOperatorResponseRulesMutation,
    Types.UpdateAiOperatorResponseRulesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.UpdateAiOperatorResponseRulesMutation,
    Types.UpdateAiOperatorResponseRulesMutationVariables
  >(UpdateAiOperatorResponseRulesDocument, options)
}
export type UpdateAiOperatorResponseRulesMutationHookResult = ReturnType<
  typeof useUpdateAiOperatorResponseRulesMutation
>
export type UpdateAiOperatorResponseRulesMutationResult =
  Apollo.MutationResult<Types.UpdateAiOperatorResponseRulesMutation>
export type UpdateAiOperatorResponseRulesMutationOptions =
  Apollo.BaseMutationOptions<
    Types.UpdateAiOperatorResponseRulesMutation,
    Types.UpdateAiOperatorResponseRulesMutationVariables
  >
export const UpdateAiOperatorThresholdsDocument = gql`
  mutation UpdateAiOperatorThresholds(
    $input: UpdateAiOperatorThresholdsInput!
  ) {
    updateAiOperatorThresholds(input: $input) {
      aiOperatorSettings {
        id
        accessGrantedTimeThresholdDefault
        doorCloseTimeThresholdDefault
        doorForcedBounceTimeThresholdDefault
      }
    }
  }
`
export type UpdateAiOperatorThresholdsMutationFn = Apollo.MutationFunction<
  Types.UpdateAiOperatorThresholdsMutation,
  Types.UpdateAiOperatorThresholdsMutationVariables
>

/**
 * __useUpdateAiOperatorThresholdsMutation__
 *
 * To run a mutation, you first call `useUpdateAiOperatorThresholdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAiOperatorThresholdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAiOperatorThresholdsMutation, { data, loading, error }] = useUpdateAiOperatorThresholdsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAiOperatorThresholdsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateAiOperatorThresholdsMutation,
    Types.UpdateAiOperatorThresholdsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.UpdateAiOperatorThresholdsMutation,
    Types.UpdateAiOperatorThresholdsMutationVariables
  >(UpdateAiOperatorThresholdsDocument, options)
}
export type UpdateAiOperatorThresholdsMutationHookResult = ReturnType<
  typeof useUpdateAiOperatorThresholdsMutation
>
export type UpdateAiOperatorThresholdsMutationResult =
  Apollo.MutationResult<Types.UpdateAiOperatorThresholdsMutation>
export type UpdateAiOperatorThresholdsMutationOptions =
  Apollo.BaseMutationOptions<
    Types.UpdateAiOperatorThresholdsMutation,
    Types.UpdateAiOperatorThresholdsMutationVariables
  >
export const UpdateAlarmDocument = gql`
  mutation UpdateAlarm($input: UpdateAlarmInput!) {
    updateAlarm(input: $input) {
      alarm {
        id
        externalId
        alarmTypeId
      }
    }
  }
`
export type UpdateAlarmMutationFn = Apollo.MutationFunction<
  Types.UpdateAlarmMutation,
  Types.UpdateAlarmMutationVariables
>

/**
 * __useUpdateAlarmMutation__
 *
 * To run a mutation, you first call `useUpdateAlarmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAlarmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAlarmMutation, { data, loading, error }] = useUpdateAlarmMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAlarmMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateAlarmMutation,
    Types.UpdateAlarmMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.UpdateAlarmMutation,
    Types.UpdateAlarmMutationVariables
  >(UpdateAlarmDocument, options)
}
export type UpdateAlarmMutationHookResult = ReturnType<
  typeof useUpdateAlarmMutation
>
export type UpdateAlarmMutationResult =
  Apollo.MutationResult<Types.UpdateAlarmMutation>
export type UpdateAlarmMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateAlarmMutation,
  Types.UpdateAlarmMutationVariables
>
export const UpdateCameraDocument = gql`
  mutation UpdateCamera($input: UpdateCameraInput!) {
    updateCamera(input: $input) {
      camera {
        id
        externalId
      }
    }
  }
`
export type UpdateCameraMutationFn = Apollo.MutationFunction<
  Types.UpdateCameraMutation,
  Types.UpdateCameraMutationVariables
>

/**
 * __useUpdateCameraMutation__
 *
 * To run a mutation, you first call `useUpdateCameraMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCameraMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCameraMutation, { data, loading, error }] = useUpdateCameraMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCameraMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateCameraMutation,
    Types.UpdateCameraMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.UpdateCameraMutation,
    Types.UpdateCameraMutationVariables
  >(UpdateCameraDocument, options)
}
export type UpdateCameraMutationHookResult = ReturnType<
  typeof useUpdateCameraMutation
>
export type UpdateCameraMutationResult =
  Apollo.MutationResult<Types.UpdateCameraMutation>
export type UpdateCameraMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateCameraMutation,
  Types.UpdateCameraMutationVariables
>
export const UpdateCaseDocument = gql`
  mutation UpdateCase($input: UpdateCaseInput!) {
    updateCase(input: $input) {
      case {
        description
        detailedReport
        id
        status
      }
    }
  }
`
export type UpdateCaseMutationFn = Apollo.MutationFunction<
  Types.UpdateCaseMutation,
  Types.UpdateCaseMutationVariables
>

/**
 * __useUpdateCaseMutation__
 *
 * To run a mutation, you first call `useUpdateCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCaseMutation, { data, loading, error }] = useUpdateCaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCaseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateCaseMutation,
    Types.UpdateCaseMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.UpdateCaseMutation,
    Types.UpdateCaseMutationVariables
  >(UpdateCaseDocument, options)
}
export type UpdateCaseMutationHookResult = ReturnType<
  typeof useUpdateCaseMutation
>
export type UpdateCaseMutationResult =
  Apollo.MutationResult<Types.UpdateCaseMutation>
export type UpdateCaseMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateCaseMutation,
  Types.UpdateCaseMutationVariables
>
export const UpdateCaseDetailsDocument = gql`
  mutation UpdateCaseDetails(
    $caseId: ID!
    $caseName: String!
    $caseFacilityIds: [ID!]!
    $caseOwnerId: ID!
    $status: CaseStatus!
  ) {
    updateCase(
      input: { id: $caseId, name: $caseName, facilityIds: $caseFacilityIds }
    ) {
      case {
        id
        name
        ownerId
      }
    }
    updateCaseOwner(input: { caseId: $caseId, ownerId: $caseOwnerId }) {
      case {
        id
        ownerId
      }
    }
    updateCaseStatus(input: { caseId: $caseId, newStatus: $status }) {
      case {
        id
        status
      }
    }
  }
`
export type UpdateCaseDetailsMutationFn = Apollo.MutationFunction<
  Types.UpdateCaseDetailsMutation,
  Types.UpdateCaseDetailsMutationVariables
>

/**
 * __useUpdateCaseDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateCaseDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCaseDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCaseDetailsMutation, { data, loading, error }] = useUpdateCaseDetailsMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      caseName: // value for 'caseName'
 *      caseFacilityIds: // value for 'caseFacilityIds'
 *      caseOwnerId: // value for 'caseOwnerId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateCaseDetailsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateCaseDetailsMutation,
    Types.UpdateCaseDetailsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.UpdateCaseDetailsMutation,
    Types.UpdateCaseDetailsMutationVariables
  >(UpdateCaseDetailsDocument, options)
}
export type UpdateCaseDetailsMutationHookResult = ReturnType<
  typeof useUpdateCaseDetailsMutation
>
export type UpdateCaseDetailsMutationResult =
  Apollo.MutationResult<Types.UpdateCaseDetailsMutation>
export type UpdateCaseDetailsMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateCaseDetailsMutation,
  Types.UpdateCaseDetailsMutationVariables
>
export const UpdateCheckpointDocument = gql`
  mutation UpdateCheckpoint($input: UpdateCheckpointInput!) {
    updateCheckpoint(input: $input) {
      id
    }
  }
`
export type UpdateCheckpointMutationFn = Apollo.MutationFunction<
  Types.UpdateCheckpointMutation,
  Types.UpdateCheckpointMutationVariables
>

/**
 * __useUpdateCheckpointMutation__
 *
 * To run a mutation, you first call `useUpdateCheckpointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCheckpointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCheckpointMutation, { data, loading, error }] = useUpdateCheckpointMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCheckpointMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateCheckpointMutation,
    Types.UpdateCheckpointMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.UpdateCheckpointMutation,
    Types.UpdateCheckpointMutationVariables
  >(UpdateCheckpointDocument, options)
}
export type UpdateCheckpointMutationHookResult = ReturnType<
  typeof useUpdateCheckpointMutation
>
export type UpdateCheckpointMutationResult =
  Apollo.MutationResult<Types.UpdateCheckpointMutation>
export type UpdateCheckpointMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateCheckpointMutation,
  Types.UpdateCheckpointMutationVariables
>
export const UpdateCheckpointTaskDocument = gql`
  mutation UpdateCheckpointTask($input: UpdateCheckpointTaskInput!) {
    updateCheckpointTask(input: $input) {
      checkpointTask {
        id
      }
    }
  }
`
export type UpdateCheckpointTaskMutationFn = Apollo.MutationFunction<
  Types.UpdateCheckpointTaskMutation,
  Types.UpdateCheckpointTaskMutationVariables
>

/**
 * __useUpdateCheckpointTaskMutation__
 *
 * To run a mutation, you first call `useUpdateCheckpointTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCheckpointTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCheckpointTaskMutation, { data, loading, error }] = useUpdateCheckpointTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCheckpointTaskMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateCheckpointTaskMutation,
    Types.UpdateCheckpointTaskMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.UpdateCheckpointTaskMutation,
    Types.UpdateCheckpointTaskMutationVariables
  >(UpdateCheckpointTaskDocument, options)
}
export type UpdateCheckpointTaskMutationHookResult = ReturnType<
  typeof useUpdateCheckpointTaskMutation
>
export type UpdateCheckpointTaskMutationResult =
  Apollo.MutationResult<Types.UpdateCheckpointTaskMutation>
export type UpdateCheckpointTaskMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateCheckpointTaskMutation,
  Types.UpdateCheckpointTaskMutationVariables
>
export const UpdateCustomFormDocument = gql`
  mutation UpdateCustomForm($input: UpdateCustomFormInput!) {
    updateCustomForm(input: $input) {
      customForm {
        id
        name
        description
        updatedAt
      }
    }
  }
`
export type UpdateCustomFormMutationFn = Apollo.MutationFunction<
  Types.UpdateCustomFormMutation,
  Types.UpdateCustomFormMutationVariables
>

/**
 * __useUpdateCustomFormMutation__
 *
 * To run a mutation, you first call `useUpdateCustomFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomFormMutation, { data, loading, error }] = useUpdateCustomFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomFormMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateCustomFormMutation,
    Types.UpdateCustomFormMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.UpdateCustomFormMutation,
    Types.UpdateCustomFormMutationVariables
  >(UpdateCustomFormDocument, options)
}
export type UpdateCustomFormMutationHookResult = ReturnType<
  typeof useUpdateCustomFormMutation
>
export type UpdateCustomFormMutationResult =
  Apollo.MutationResult<Types.UpdateCustomFormMutation>
export type UpdateCustomFormMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateCustomFormMutation,
  Types.UpdateCustomFormMutationVariables
>
export const UpdateCustomFormQuestionDocument = gql`
  mutation UpdateCustomFormQuestion($input: UpdateCustomFormQuestionInput!) {
    updateCustomFormQuestion(input: $input) {
      question {
        id
        label
        helpText
        answerType
        required
        order
        defaultValue
        visibleWhen {
          anyOf {
            allOf {
              questionId
              operator
              value
            }
          }
        }
        options {
          id
          label
          order
        }
      }
    }
  }
`
export type UpdateCustomFormQuestionMutationFn = Apollo.MutationFunction<
  Types.UpdateCustomFormQuestionMutation,
  Types.UpdateCustomFormQuestionMutationVariables
>

/**
 * __useUpdateCustomFormQuestionMutation__
 *
 * To run a mutation, you first call `useUpdateCustomFormQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomFormQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomFormQuestionMutation, { data, loading, error }] = useUpdateCustomFormQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomFormQuestionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateCustomFormQuestionMutation,
    Types.UpdateCustomFormQuestionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.UpdateCustomFormQuestionMutation,
    Types.UpdateCustomFormQuestionMutationVariables
  >(UpdateCustomFormQuestionDocument, options)
}
export type UpdateCustomFormQuestionMutationHookResult = ReturnType<
  typeof useUpdateCustomFormQuestionMutation
>
export type UpdateCustomFormQuestionMutationResult =
  Apollo.MutationResult<Types.UpdateCustomFormQuestionMutation>
export type UpdateCustomFormQuestionMutationOptions =
  Apollo.BaseMutationOptions<
    Types.UpdateCustomFormQuestionMutation,
    Types.UpdateCustomFormQuestionMutationVariables
  >
export const UpdateCustomFormSectionDocument = gql`
  mutation UpdateCustomFormSection($input: UpdateCustomFormSectionInput!) {
    updateCustomFormSection(input: $input) {
      section {
        id
        name
        description
        order
      }
    }
  }
`
export type UpdateCustomFormSectionMutationFn = Apollo.MutationFunction<
  Types.UpdateCustomFormSectionMutation,
  Types.UpdateCustomFormSectionMutationVariables
>

/**
 * __useUpdateCustomFormSectionMutation__
 *
 * To run a mutation, you first call `useUpdateCustomFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomFormSectionMutation, { data, loading, error }] = useUpdateCustomFormSectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomFormSectionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateCustomFormSectionMutation,
    Types.UpdateCustomFormSectionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.UpdateCustomFormSectionMutation,
    Types.UpdateCustomFormSectionMutationVariables
  >(UpdateCustomFormSectionDocument, options)
}
export type UpdateCustomFormSectionMutationHookResult = ReturnType<
  typeof useUpdateCustomFormSectionMutation
>
export type UpdateCustomFormSectionMutationResult =
  Apollo.MutationResult<Types.UpdateCustomFormSectionMutation>
export type UpdateCustomFormSectionMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateCustomFormSectionMutation,
  Types.UpdateCustomFormSectionMutationVariables
>
export const UpdateCustomerSecretProviderDocument = gql`
  mutation UpdateCustomerSecretProvider(
    $input: UpdateCustomerSecretProviderInput!
  ) {
    updateCustomerSecretProvider(input: $input) {
      customerSecretProvider {
        id
        providerName
        providerAccountId
        providerRegion
        providerType
        secretNamespace
        kmsKeyId
        kmsRegion
        kmsAlias
        updatedAt
      }
    }
  }
`
export type UpdateCustomerSecretProviderMutationFn = Apollo.MutationFunction<
  Types.UpdateCustomerSecretProviderMutation,
  Types.UpdateCustomerSecretProviderMutationVariables
>

/**
 * __useUpdateCustomerSecretProviderMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerSecretProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerSecretProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerSecretProviderMutation, { data, loading, error }] = useUpdateCustomerSecretProviderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomerSecretProviderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateCustomerSecretProviderMutation,
    Types.UpdateCustomerSecretProviderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.UpdateCustomerSecretProviderMutation,
    Types.UpdateCustomerSecretProviderMutationVariables
  >(UpdateCustomerSecretProviderDocument, options)
}
export type UpdateCustomerSecretProviderMutationHookResult = ReturnType<
  typeof useUpdateCustomerSecretProviderMutation
>
export type UpdateCustomerSecretProviderMutationResult =
  Apollo.MutationResult<Types.UpdateCustomerSecretProviderMutation>
export type UpdateCustomerSecretProviderMutationOptions =
  Apollo.BaseMutationOptions<
    Types.UpdateCustomerSecretProviderMutation,
    Types.UpdateCustomerSecretProviderMutationVariables
  >
export const UpdateDeviceDocument = gql`
  mutation UpdateDevice($input: UpdateDeviceInput!) {
    updateDevice(input: $input) {
      device {
        id
      }
    }
  }
`
export type UpdateDeviceMutationFn = Apollo.MutationFunction<
  Types.UpdateDeviceMutation,
  Types.UpdateDeviceMutationVariables
>

/**
 * __useUpdateDeviceMutation__
 *
 * To run a mutation, you first call `useUpdateDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeviceMutation, { data, loading, error }] = useUpdateDeviceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDeviceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateDeviceMutation,
    Types.UpdateDeviceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.UpdateDeviceMutation,
    Types.UpdateDeviceMutationVariables
  >(UpdateDeviceDocument, options)
}
export type UpdateDeviceMutationHookResult = ReturnType<
  typeof useUpdateDeviceMutation
>
export type UpdateDeviceMutationResult =
  Apollo.MutationResult<Types.UpdateDeviceMutation>
export type UpdateDeviceMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateDeviceMutation,
  Types.UpdateDeviceMutationVariables
>
export const UpdateDoorDocument = gql`
  mutation UpdateDoor($input: UpdateDoorInput!) {
    updateDoor(input: $input) {
      door {
        id
        externalId
      }
    }
  }
`
export type UpdateDoorMutationFn = Apollo.MutationFunction<
  Types.UpdateDoorMutation,
  Types.UpdateDoorMutationVariables
>

/**
 * __useUpdateDoorMutation__
 *
 * To run a mutation, you first call `useUpdateDoorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDoorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDoorMutation, { data, loading, error }] = useUpdateDoorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDoorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateDoorMutation,
    Types.UpdateDoorMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.UpdateDoorMutation,
    Types.UpdateDoorMutationVariables
  >(UpdateDoorDocument, options)
}
export type UpdateDoorMutationHookResult = ReturnType<
  typeof useUpdateDoorMutation
>
export type UpdateDoorMutationResult =
  Apollo.MutationResult<Types.UpdateDoorMutation>
export type UpdateDoorMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateDoorMutation,
  Types.UpdateDoorMutationVariables
>
export const UpdateEdgeDeviceDocument = gql`
  mutation UpdateEdgeDevice($input: UpdateEdgeDeviceInput!) {
    updateEdgeDevice(input: $input) {
      edgeDevice {
        id
        name
      }
    }
  }
`
export type UpdateEdgeDeviceMutationFn = Apollo.MutationFunction<
  Types.UpdateEdgeDeviceMutation,
  Types.UpdateEdgeDeviceMutationVariables
>

/**
 * __useUpdateEdgeDeviceMutation__
 *
 * To run a mutation, you first call `useUpdateEdgeDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEdgeDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEdgeDeviceMutation, { data, loading, error }] = useUpdateEdgeDeviceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEdgeDeviceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateEdgeDeviceMutation,
    Types.UpdateEdgeDeviceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.UpdateEdgeDeviceMutation,
    Types.UpdateEdgeDeviceMutationVariables
  >(UpdateEdgeDeviceDocument, options)
}
export type UpdateEdgeDeviceMutationHookResult = ReturnType<
  typeof useUpdateEdgeDeviceMutation
>
export type UpdateEdgeDeviceMutationResult =
  Apollo.MutationResult<Types.UpdateEdgeDeviceMutation>
export type UpdateEdgeDeviceMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateEdgeDeviceMutation,
  Types.UpdateEdgeDeviceMutationVariables
>
export const UpdateEmergencyCallDocument = gql`
  mutation UpdateEmergencyCall($input: UpdateEmergencyCallInput!) {
    updateEmergencyCall(input: $input) {
      emergencyCall {
        id
      }
    }
  }
`
export type UpdateEmergencyCallMutationFn = Apollo.MutationFunction<
  Types.UpdateEmergencyCallMutation,
  Types.UpdateEmergencyCallMutationVariables
>

/**
 * __useUpdateEmergencyCallMutation__
 *
 * To run a mutation, you first call `useUpdateEmergencyCallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmergencyCallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmergencyCallMutation, { data, loading, error }] = useUpdateEmergencyCallMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEmergencyCallMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateEmergencyCallMutation,
    Types.UpdateEmergencyCallMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.UpdateEmergencyCallMutation,
    Types.UpdateEmergencyCallMutationVariables
  >(UpdateEmergencyCallDocument, options)
}
export type UpdateEmergencyCallMutationHookResult = ReturnType<
  typeof useUpdateEmergencyCallMutation
>
export type UpdateEmergencyCallMutationResult =
  Apollo.MutationResult<Types.UpdateEmergencyCallMutation>
export type UpdateEmergencyCallMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateEmergencyCallMutation,
  Types.UpdateEmergencyCallMutationVariables
>
export const UpdateExternalAccountDocument = gql`
  mutation updateExternalAccount($input: UpdateExternalAccountInput!) {
    updateExternalAccount(input: $input) {
      externalAccount {
        accountId
        accountName
        defaultAccount
        externalSystemType
        id
      }
    }
  }
`
export type UpdateExternalAccountMutationFn = Apollo.MutationFunction<
  Types.UpdateExternalAccountMutation,
  Types.UpdateExternalAccountMutationVariables
>

/**
 * __useUpdateExternalAccountMutation__
 *
 * To run a mutation, you first call `useUpdateExternalAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExternalAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExternalAccountMutation, { data, loading, error }] = useUpdateExternalAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateExternalAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateExternalAccountMutation,
    Types.UpdateExternalAccountMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.UpdateExternalAccountMutation,
    Types.UpdateExternalAccountMutationVariables
  >(UpdateExternalAccountDocument, options)
}
export type UpdateExternalAccountMutationHookResult = ReturnType<
  typeof useUpdateExternalAccountMutation
>
export type UpdateExternalAccountMutationResult =
  Apollo.MutationResult<Types.UpdateExternalAccountMutation>
export type UpdateExternalAccountMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateExternalAccountMutation,
  Types.UpdateExternalAccountMutationVariables
>
export const UpdateExternalAccountApiKeyDocument = gql`
  mutation UpdateExternalAccountApiKey(
    $input: UpdateExternalAccountApiKeyInput!
  ) {
    updateExternalAccountApiKey(input: $input) {
      externalAccountApiKey {
        id
        secretName
        permissionName
      }
    }
  }
`
export type UpdateExternalAccountApiKeyMutationFn = Apollo.MutationFunction<
  Types.UpdateExternalAccountApiKeyMutation,
  Types.UpdateExternalAccountApiKeyMutationVariables
>

/**
 * __useUpdateExternalAccountApiKeyMutation__
 *
 * To run a mutation, you first call `useUpdateExternalAccountApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExternalAccountApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExternalAccountApiKeyMutation, { data, loading, error }] = useUpdateExternalAccountApiKeyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateExternalAccountApiKeyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateExternalAccountApiKeyMutation,
    Types.UpdateExternalAccountApiKeyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.UpdateExternalAccountApiKeyMutation,
    Types.UpdateExternalAccountApiKeyMutationVariables
  >(UpdateExternalAccountApiKeyDocument, options)
}
export type UpdateExternalAccountApiKeyMutationHookResult = ReturnType<
  typeof useUpdateExternalAccountApiKeyMutation
>
export type UpdateExternalAccountApiKeyMutationResult =
  Apollo.MutationResult<Types.UpdateExternalAccountApiKeyMutation>
export type UpdateExternalAccountApiKeyMutationOptions =
  Apollo.BaseMutationOptions<
    Types.UpdateExternalAccountApiKeyMutation,
    Types.UpdateExternalAccountApiKeyMutationVariables
  >
export const UpdateExternalAccountPropertiesDocument = gql`
  mutation UpdateExternalAccountProperties(
    $input: UpdateExternalAccountPropertiesInput!
  ) {
    updateExternalAccountProperties(input: $input) {
      externalAccountProperties {
        createdAt
        data
        externalAccountId
        id
        updatedAt
      }
    }
  }
`
export type UpdateExternalAccountPropertiesMutationFn = Apollo.MutationFunction<
  Types.UpdateExternalAccountPropertiesMutation,
  Types.UpdateExternalAccountPropertiesMutationVariables
>

/**
 * __useUpdateExternalAccountPropertiesMutation__
 *
 * To run a mutation, you first call `useUpdateExternalAccountPropertiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExternalAccountPropertiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExternalAccountPropertiesMutation, { data, loading, error }] = useUpdateExternalAccountPropertiesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateExternalAccountPropertiesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateExternalAccountPropertiesMutation,
    Types.UpdateExternalAccountPropertiesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.UpdateExternalAccountPropertiesMutation,
    Types.UpdateExternalAccountPropertiesMutationVariables
  >(UpdateExternalAccountPropertiesDocument, options)
}
export type UpdateExternalAccountPropertiesMutationHookResult = ReturnType<
  typeof useUpdateExternalAccountPropertiesMutation
>
export type UpdateExternalAccountPropertiesMutationResult =
  Apollo.MutationResult<Types.UpdateExternalAccountPropertiesMutation>
export type UpdateExternalAccountPropertiesMutationOptions =
  Apollo.BaseMutationOptions<
    Types.UpdateExternalAccountPropertiesMutation,
    Types.UpdateExternalAccountPropertiesMutationVariables
  >
export const UpdateFacilityDocument = gql`
  mutation UpdateFacility($input: UpdateFacilityInput!) {
    updateFacility(input: $input) {
      facility {
        id
        name
        shortName
        address
        longitude
        latitude
        emergencyNumber
      }
    }
  }
`
export type UpdateFacilityMutationFn = Apollo.MutationFunction<
  Types.UpdateFacilityMutation,
  Types.UpdateFacilityMutationVariables
>

/**
 * __useUpdateFacilityMutation__
 *
 * To run a mutation, you first call `useUpdateFacilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFacilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFacilityMutation, { data, loading, error }] = useUpdateFacilityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFacilityMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateFacilityMutation,
    Types.UpdateFacilityMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.UpdateFacilityMutation,
    Types.UpdateFacilityMutationVariables
  >(UpdateFacilityDocument, options)
}
export type UpdateFacilityMutationHookResult = ReturnType<
  typeof useUpdateFacilityMutation
>
export type UpdateFacilityMutationResult =
  Apollo.MutationResult<Types.UpdateFacilityMutation>
export type UpdateFacilityMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateFacilityMutation,
  Types.UpdateFacilityMutationVariables
>
export const UpdateFloorDocument = gql`
  mutation UpdateFloor($input: UpdateFloorInput!) {
    updateFloor(input: $input) {
      floor {
        id
      }
    }
  }
`
export type UpdateFloorMutationFn = Apollo.MutationFunction<
  Types.UpdateFloorMutation,
  Types.UpdateFloorMutationVariables
>

/**
 * __useUpdateFloorMutation__
 *
 * To run a mutation, you first call `useUpdateFloorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFloorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFloorMutation, { data, loading, error }] = useUpdateFloorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFloorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateFloorMutation,
    Types.UpdateFloorMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.UpdateFloorMutation,
    Types.UpdateFloorMutationVariables
  >(UpdateFloorDocument, options)
}
export type UpdateFloorMutationHookResult = ReturnType<
  typeof useUpdateFloorMutation
>
export type UpdateFloorMutationResult =
  Apollo.MutationResult<Types.UpdateFloorMutation>
export type UpdateFloorMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateFloorMutation,
  Types.UpdateFloorMutationVariables
>
export const UpdateIncidentDocument = gql`
  mutation UpdateIncident($input: UpdateIncidentInput!) {
    updateIncident(input: $input) {
      incident {
        id
        priority
      }
    }
  }
`
export type UpdateIncidentMutationFn = Apollo.MutationFunction<
  Types.UpdateIncidentMutation,
  Types.UpdateIncidentMutationVariables
>

/**
 * __useUpdateIncidentMutation__
 *
 * To run a mutation, you first call `useUpdateIncidentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIncidentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIncidentMutation, { data, loading, error }] = useUpdateIncidentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateIncidentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateIncidentMutation,
    Types.UpdateIncidentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.UpdateIncidentMutation,
    Types.UpdateIncidentMutationVariables
  >(UpdateIncidentDocument, options)
}
export type UpdateIncidentMutationHookResult = ReturnType<
  typeof useUpdateIncidentMutation
>
export type UpdateIncidentMutationResult =
  Apollo.MutationResult<Types.UpdateIncidentMutation>
export type UpdateIncidentMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateIncidentMutation,
  Types.UpdateIncidentMutationVariables
>
export const UpdateIncidentTypeDefinitionDocument = gql`
  mutation UpdateIncidentTypeDefinition(
    $input: UpdateIncidentTypeDefinitionInput!
  ) {
    updateIncidentTypeDefinition(input: $input) {
      incidentTypeDefinition {
        id
        defaultPriority
      }
    }
  }
`
export type UpdateIncidentTypeDefinitionMutationFn = Apollo.MutationFunction<
  Types.UpdateIncidentTypeDefinitionMutation,
  Types.UpdateIncidentTypeDefinitionMutationVariables
>

/**
 * __useUpdateIncidentTypeDefinitionMutation__
 *
 * To run a mutation, you first call `useUpdateIncidentTypeDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIncidentTypeDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIncidentTypeDefinitionMutation, { data, loading, error }] = useUpdateIncidentTypeDefinitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateIncidentTypeDefinitionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateIncidentTypeDefinitionMutation,
    Types.UpdateIncidentTypeDefinitionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.UpdateIncidentTypeDefinitionMutation,
    Types.UpdateIncidentTypeDefinitionMutationVariables
  >(UpdateIncidentTypeDefinitionDocument, options)
}
export type UpdateIncidentTypeDefinitionMutationHookResult = ReturnType<
  typeof useUpdateIncidentTypeDefinitionMutation
>
export type UpdateIncidentTypeDefinitionMutationResult =
  Apollo.MutationResult<Types.UpdateIncidentTypeDefinitionMutation>
export type UpdateIncidentTypeDefinitionMutationOptions =
  Apollo.BaseMutationOptions<
    Types.UpdateIncidentTypeDefinitionMutation,
    Types.UpdateIncidentTypeDefinitionMutationVariables
  >
export const UpdateIncidentWorkflowDocument = gql`
  mutation UpdateIncidentWorkflow($input: UpdateIncidentWorkflowInput!) {
    updateIncidentWorkflow(input: $input) {
      workflow {
        versionId
        workflowId
        name
        state
      }
    }
  }
`
export type UpdateIncidentWorkflowMutationFn = Apollo.MutationFunction<
  Types.UpdateIncidentWorkflowMutation,
  Types.UpdateIncidentWorkflowMutationVariables
>

/**
 * __useUpdateIncidentWorkflowMutation__
 *
 * To run a mutation, you first call `useUpdateIncidentWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIncidentWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIncidentWorkflowMutation, { data, loading, error }] = useUpdateIncidentWorkflowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateIncidentWorkflowMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateIncidentWorkflowMutation,
    Types.UpdateIncidentWorkflowMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.UpdateIncidentWorkflowMutation,
    Types.UpdateIncidentWorkflowMutationVariables
  >(UpdateIncidentWorkflowDocument, options)
}
export type UpdateIncidentWorkflowMutationHookResult = ReturnType<
  typeof useUpdateIncidentWorkflowMutation
>
export type UpdateIncidentWorkflowMutationResult =
  Apollo.MutationResult<Types.UpdateIncidentWorkflowMutation>
export type UpdateIncidentWorkflowMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateIncidentWorkflowMutation,
  Types.UpdateIncidentWorkflowMutationVariables
>
export const UpdateManualIncidentCategoryDocument = gql`
  mutation updateManualIncidentCategory(
    $input: UpdateManualIncidentCategoryInput!
  ) {
    updateManualIncidentCategory(input: $input) {
      manualIncidentCategory {
        id
        defaultPriority
      }
    }
  }
`
export type UpdateManualIncidentCategoryMutationFn = Apollo.MutationFunction<
  Types.UpdateManualIncidentCategoryMutation,
  Types.UpdateManualIncidentCategoryMutationVariables
>

/**
 * __useUpdateManualIncidentCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateManualIncidentCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateManualIncidentCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateManualIncidentCategoryMutation, { data, loading, error }] = useUpdateManualIncidentCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateManualIncidentCategoryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateManualIncidentCategoryMutation,
    Types.UpdateManualIncidentCategoryMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.UpdateManualIncidentCategoryMutation,
    Types.UpdateManualIncidentCategoryMutationVariables
  >(UpdateManualIncidentCategoryDocument, options)
}
export type UpdateManualIncidentCategoryMutationHookResult = ReturnType<
  typeof useUpdateManualIncidentCategoryMutation
>
export type UpdateManualIncidentCategoryMutationResult =
  Apollo.MutationResult<Types.UpdateManualIncidentCategoryMutation>
export type UpdateManualIncidentCategoryMutationOptions =
  Apollo.BaseMutationOptions<
    Types.UpdateManualIncidentCategoryMutation,
    Types.UpdateManualIncidentCategoryMutationVariables
  >
export const UpdateMySettingDocument = gql`
  mutation UpdateMySetting($input: UpdateUserSettingInput!) {
    updateMySetting(input: $input) {
      userSetting {
        audibleAlertsEnabled
        completedFtus
      }
    }
  }
`
export type UpdateMySettingMutationFn = Apollo.MutationFunction<
  Types.UpdateMySettingMutation,
  Types.UpdateMySettingMutationVariables
>

/**
 * __useUpdateMySettingMutation__
 *
 * To run a mutation, you first call `useUpdateMySettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMySettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMySettingMutation, { data, loading, error }] = useUpdateMySettingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMySettingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateMySettingMutation,
    Types.UpdateMySettingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.UpdateMySettingMutation,
    Types.UpdateMySettingMutationVariables
  >(UpdateMySettingDocument, options)
}
export type UpdateMySettingMutationHookResult = ReturnType<
  typeof useUpdateMySettingMutation
>
export type UpdateMySettingMutationResult =
  Apollo.MutationResult<Types.UpdateMySettingMutation>
export type UpdateMySettingMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateMySettingMutation,
  Types.UpdateMySettingMutationVariables
>
export const UpdateOrganizationSettingsDocument = gql`
  mutation UpdateOrganizationSettings(
    $input: UpdateOrganizationSettingsInput!
  ) {
    updateOrganizationSettings(input: $input) {
      organizationSettings {
        id
        minimumCameraOfflineDuration
        cameraOfflineDurationUnit
      }
    }
  }
`
export type UpdateOrganizationSettingsMutationFn = Apollo.MutationFunction<
  Types.UpdateOrganizationSettingsMutation,
  Types.UpdateOrganizationSettingsMutationVariables
>

/**
 * __useUpdateOrganizationSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationSettingsMutation, { data, loading, error }] = useUpdateOrganizationSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationSettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateOrganizationSettingsMutation,
    Types.UpdateOrganizationSettingsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.UpdateOrganizationSettingsMutation,
    Types.UpdateOrganizationSettingsMutationVariables
  >(UpdateOrganizationSettingsDocument, options)
}
export type UpdateOrganizationSettingsMutationHookResult = ReturnType<
  typeof useUpdateOrganizationSettingsMutation
>
export type UpdateOrganizationSettingsMutationResult =
  Apollo.MutationResult<Types.UpdateOrganizationSettingsMutation>
export type UpdateOrganizationSettingsMutationOptions =
  Apollo.BaseMutationOptions<
    Types.UpdateOrganizationSettingsMutation,
    Types.UpdateOrganizationSettingsMutationVariables
  >
export const UpdatePacsSourceInstanceDocument = gql`
  mutation UpdatePacsSourceInstance($input: UpdatePacsSourceInstanceInput!) {
    updatePacsSourceInstance(input: $input) {
      pacsSourceInstance {
        id
      }
    }
  }
`
export type UpdatePacsSourceInstanceMutationFn = Apollo.MutationFunction<
  Types.UpdatePacsSourceInstanceMutation,
  Types.UpdatePacsSourceInstanceMutationVariables
>

/**
 * __useUpdatePacsSourceInstanceMutation__
 *
 * To run a mutation, you first call `useUpdatePacsSourceInstanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePacsSourceInstanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePacsSourceInstanceMutation, { data, loading, error }] = useUpdatePacsSourceInstanceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePacsSourceInstanceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdatePacsSourceInstanceMutation,
    Types.UpdatePacsSourceInstanceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.UpdatePacsSourceInstanceMutation,
    Types.UpdatePacsSourceInstanceMutationVariables
  >(UpdatePacsSourceInstanceDocument, options)
}
export type UpdatePacsSourceInstanceMutationHookResult = ReturnType<
  typeof useUpdatePacsSourceInstanceMutation
>
export type UpdatePacsSourceInstanceMutationResult =
  Apollo.MutationResult<Types.UpdatePacsSourceInstanceMutation>
export type UpdatePacsSourceInstanceMutationOptions =
  Apollo.BaseMutationOptions<
    Types.UpdatePacsSourceInstanceMutation,
    Types.UpdatePacsSourceInstanceMutationVariables
  >
export const UpdatePersonOfInterestDocument = gql`
  mutation UpdatePersonOfInterest($input: UpdatePersonOfInterestInput!) {
    updatePersonOfInterest(input: $input) {
      personOfInterest {
        id
      }
    }
  }
`
export type UpdatePersonOfInterestMutationFn = Apollo.MutationFunction<
  Types.UpdatePersonOfInterestMutation,
  Types.UpdatePersonOfInterestMutationVariables
>

/**
 * __useUpdatePersonOfInterestMutation__
 *
 * To run a mutation, you first call `useUpdatePersonOfInterestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonOfInterestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonOfInterestMutation, { data, loading, error }] = useUpdatePersonOfInterestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePersonOfInterestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdatePersonOfInterestMutation,
    Types.UpdatePersonOfInterestMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.UpdatePersonOfInterestMutation,
    Types.UpdatePersonOfInterestMutationVariables
  >(UpdatePersonOfInterestDocument, options)
}
export type UpdatePersonOfInterestMutationHookResult = ReturnType<
  typeof useUpdatePersonOfInterestMutation
>
export type UpdatePersonOfInterestMutationResult =
  Apollo.MutationResult<Types.UpdatePersonOfInterestMutation>
export type UpdatePersonOfInterestMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdatePersonOfInterestMutation,
  Types.UpdatePersonOfInterestMutationVariables
>
export const UpdatePersonOfInterestRoleDocument = gql`
  mutation UpdatePersonOfInterestRole(
    $input: UpdatePersonOfInterestRoleInput!
  ) {
    updatePersonOfInterestRole(input: $input) {
      case {
        id
      }
    }
  }
`
export type UpdatePersonOfInterestRoleMutationFn = Apollo.MutationFunction<
  Types.UpdatePersonOfInterestRoleMutation,
  Types.UpdatePersonOfInterestRoleMutationVariables
>

/**
 * __useUpdatePersonOfInterestRoleMutation__
 *
 * To run a mutation, you first call `useUpdatePersonOfInterestRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonOfInterestRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonOfInterestRoleMutation, { data, loading, error }] = useUpdatePersonOfInterestRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePersonOfInterestRoleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdatePersonOfInterestRoleMutation,
    Types.UpdatePersonOfInterestRoleMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.UpdatePersonOfInterestRoleMutation,
    Types.UpdatePersonOfInterestRoleMutationVariables
  >(UpdatePersonOfInterestRoleDocument, options)
}
export type UpdatePersonOfInterestRoleMutationHookResult = ReturnType<
  typeof useUpdatePersonOfInterestRoleMutation
>
export type UpdatePersonOfInterestRoleMutationResult =
  Apollo.MutationResult<Types.UpdatePersonOfInterestRoleMutation>
export type UpdatePersonOfInterestRoleMutationOptions =
  Apollo.BaseMutationOptions<
    Types.UpdatePersonOfInterestRoleMutation,
    Types.UpdatePersonOfInterestRoleMutationVariables
  >
export const UpdateProgramRecommendationDocument = gql`
  mutation UpdateProgramRecommendation(
    $input: UpdateProgramRecommendationInput!
  ) {
    updateProgramRecommendation(input: $input) {
      programRecommendation {
        id
        estimatedImpact
        actualImpact
        internalNote
        updatedAt
      }
    }
  }
`
export type UpdateProgramRecommendationMutationFn = Apollo.MutationFunction<
  Types.UpdateProgramRecommendationMutation,
  Types.UpdateProgramRecommendationMutationVariables
>

/**
 * __useUpdateProgramRecommendationMutation__
 *
 * To run a mutation, you first call `useUpdateProgramRecommendationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProgramRecommendationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProgramRecommendationMutation, { data, loading, error }] = useUpdateProgramRecommendationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProgramRecommendationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateProgramRecommendationMutation,
    Types.UpdateProgramRecommendationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.UpdateProgramRecommendationMutation,
    Types.UpdateProgramRecommendationMutationVariables
  >(UpdateProgramRecommendationDocument, options)
}
export type UpdateProgramRecommendationMutationHookResult = ReturnType<
  typeof useUpdateProgramRecommendationMutation
>
export type UpdateProgramRecommendationMutationResult =
  Apollo.MutationResult<Types.UpdateProgramRecommendationMutation>
export type UpdateProgramRecommendationMutationOptions =
  Apollo.BaseMutationOptions<
    Types.UpdateProgramRecommendationMutation,
    Types.UpdateProgramRecommendationMutationVariables
  >
export const UpdateQuickReportDocument = gql`
  mutation UpdateQuickReport($input: UpdateQuickReportInput!) {
    updateQuickReport(input: $input) {
      quickReport {
        id
        reportType
      }
    }
  }
`
export type UpdateQuickReportMutationFn = Apollo.MutationFunction<
  Types.UpdateQuickReportMutation,
  Types.UpdateQuickReportMutationVariables
>

/**
 * __useUpdateQuickReportMutation__
 *
 * To run a mutation, you first call `useUpdateQuickReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuickReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuickReportMutation, { data, loading, error }] = useUpdateQuickReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuickReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateQuickReportMutation,
    Types.UpdateQuickReportMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.UpdateQuickReportMutation,
    Types.UpdateQuickReportMutationVariables
  >(UpdateQuickReportDocument, options)
}
export type UpdateQuickReportMutationHookResult = ReturnType<
  typeof useUpdateQuickReportMutation
>
export type UpdateQuickReportMutationResult =
  Apollo.MutationResult<Types.UpdateQuickReportMutation>
export type UpdateQuickReportMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateQuickReportMutation,
  Types.UpdateQuickReportMutationVariables
>
export const UpdateRuleDocument = gql`
  mutation UpdateRule($input: UpdateRuleInput!) {
    updateRule(input: $input) {
      rule {
        id
        action
        allDayOverride
        createdAt
        creator {
          id
          firstName
          lastName
        }
        day
        endDate
        endTimeOfDay
        incidentTypeDefinitions {
          id
        }
        lastMatched
        manualIncidentCategoryIds
        name
        repeatInterval
        repeatIntervalNum
        ruleEventType
        ruleLogics {
          edges {
            node {
              id
              value
              entity
            }
          }
        }
        startTime
        status
        triggerType
        updatedAt
        updatedBy {
          id
          firstName
          lastName
        }
      }
    }
  }
`
export type UpdateRuleMutationFn = Apollo.MutationFunction<
  Types.UpdateRuleMutation,
  Types.UpdateRuleMutationVariables
>

/**
 * __useUpdateRuleMutation__
 *
 * To run a mutation, you first call `useUpdateRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRuleMutation, { data, loading, error }] = useUpdateRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRuleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateRuleMutation,
    Types.UpdateRuleMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.UpdateRuleMutation,
    Types.UpdateRuleMutationVariables
  >(UpdateRuleDocument, options)
}
export type UpdateRuleMutationHookResult = ReturnType<
  typeof useUpdateRuleMutation
>
export type UpdateRuleMutationResult =
  Apollo.MutationResult<Types.UpdateRuleMutation>
export type UpdateRuleMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateRuleMutation,
  Types.UpdateRuleMutationVariables
>
export const UpdateSavedFilterDocument = gql`
  mutation UpdateSavedFilter($input: UpdateSavedFilterInput!) {
    updateSavedFilter(input: $input) {
      savedFilter {
        id
      }
    }
  }
`
export type UpdateSavedFilterMutationFn = Apollo.MutationFunction<
  Types.UpdateSavedFilterMutation,
  Types.UpdateSavedFilterMutationVariables
>

/**
 * __useUpdateSavedFilterMutation__
 *
 * To run a mutation, you first call `useUpdateSavedFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSavedFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSavedFilterMutation, { data, loading, error }] = useUpdateSavedFilterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSavedFilterMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateSavedFilterMutation,
    Types.UpdateSavedFilterMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.UpdateSavedFilterMutation,
    Types.UpdateSavedFilterMutationVariables
  >(UpdateSavedFilterDocument, options)
}
export type UpdateSavedFilterMutationHookResult = ReturnType<
  typeof useUpdateSavedFilterMutation
>
export type UpdateSavedFilterMutationResult =
  Apollo.MutationResult<Types.UpdateSavedFilterMutation>
export type UpdateSavedFilterMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateSavedFilterMutation,
  Types.UpdateSavedFilterMutationVariables
>
export const UpdateStandardOperatingProcedureDocument = gql`
  mutation UpdateStandardOperatingProcedure(
    $input: UpdateStandardOperatingProcedureInput!
  ) {
    updateStandardOperatingProcedure(input: $input) {
      standardOperatingProcedure {
        id
      }
    }
  }
`
export type UpdateStandardOperatingProcedureMutationFn =
  Apollo.MutationFunction<
    Types.UpdateStandardOperatingProcedureMutation,
    Types.UpdateStandardOperatingProcedureMutationVariables
  >

/**
 * __useUpdateStandardOperatingProcedureMutation__
 *
 * To run a mutation, you first call `useUpdateStandardOperatingProcedureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStandardOperatingProcedureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStandardOperatingProcedureMutation, { data, loading, error }] = useUpdateStandardOperatingProcedureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStandardOperatingProcedureMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateStandardOperatingProcedureMutation,
    Types.UpdateStandardOperatingProcedureMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.UpdateStandardOperatingProcedureMutation,
    Types.UpdateStandardOperatingProcedureMutationVariables
  >(UpdateStandardOperatingProcedureDocument, options)
}
export type UpdateStandardOperatingProcedureMutationHookResult = ReturnType<
  typeof useUpdateStandardOperatingProcedureMutation
>
export type UpdateStandardOperatingProcedureMutationResult =
  Apollo.MutationResult<Types.UpdateStandardOperatingProcedureMutation>
export type UpdateStandardOperatingProcedureMutationOptions =
  Apollo.BaseMutationOptions<
    Types.UpdateStandardOperatingProcedureMutation,
    Types.UpdateStandardOperatingProcedureMutationVariables
  >
export const UpdateTagDocument = gql`
  mutation updateTag($input: UpdateTagInput!) {
    updateTag(input: $input) {
      tag {
        id
        name
      }
    }
  }
`
export type UpdateTagMutationFn = Apollo.MutationFunction<
  Types.UpdateTagMutation,
  Types.UpdateTagMutationVariables
>

/**
 * __useUpdateTagMutation__
 *
 * To run a mutation, you first call `useUpdateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTagMutation, { data, loading, error }] = useUpdateTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTagMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateTagMutation,
    Types.UpdateTagMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.UpdateTagMutation,
    Types.UpdateTagMutationVariables
  >(UpdateTagDocument, options)
}
export type UpdateTagMutationHookResult = ReturnType<
  typeof useUpdateTagMutation
>
export type UpdateTagMutationResult =
  Apollo.MutationResult<Types.UpdateTagMutation>
export type UpdateTagMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateTagMutation,
  Types.UpdateTagMutationVariables
>
export const UpdateTailgateEnabledDocument = gql`
  mutation UpdateTailgateEnabled($input: UpdateTailgateEnabledInput!) {
    updateTailgateEnabled(input: $input) {
      isTailgateEnabled
    }
  }
`
export type UpdateTailgateEnabledMutationFn = Apollo.MutationFunction<
  Types.UpdateTailgateEnabledMutation,
  Types.UpdateTailgateEnabledMutationVariables
>

/**
 * __useUpdateTailgateEnabledMutation__
 *
 * To run a mutation, you first call `useUpdateTailgateEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTailgateEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTailgateEnabledMutation, { data, loading, error }] = useUpdateTailgateEnabledMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTailgateEnabledMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateTailgateEnabledMutation,
    Types.UpdateTailgateEnabledMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.UpdateTailgateEnabledMutation,
    Types.UpdateTailgateEnabledMutationVariables
  >(UpdateTailgateEnabledDocument, options)
}
export type UpdateTailgateEnabledMutationHookResult = ReturnType<
  typeof useUpdateTailgateEnabledMutation
>
export type UpdateTailgateEnabledMutationResult =
  Apollo.MutationResult<Types.UpdateTailgateEnabledMutation>
export type UpdateTailgateEnabledMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateTailgateEnabledMutation,
  Types.UpdateTailgateEnabledMutationVariables
>
export const UpdateTailgateGridDocument = gql`
  mutation UpdateTailgateGrid(
    $updateTailgateGridInput: UpdateTailgateGridInput!
    $updateCameraInput: UpdateCameraInput!
  ) {
    updateTailgateGrid(input: $updateTailgateGridInput) {
      camera {
        id
      }
      door {
        id
      }
    }
    updateCamera(input: $updateCameraInput) {
      camera {
        id
      }
    }
  }
`
export type UpdateTailgateGridMutationFn = Apollo.MutationFunction<
  Types.UpdateTailgateGridMutation,
  Types.UpdateTailgateGridMutationVariables
>

/**
 * __useUpdateTailgateGridMutation__
 *
 * To run a mutation, you first call `useUpdateTailgateGridMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTailgateGridMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTailgateGridMutation, { data, loading, error }] = useUpdateTailgateGridMutation({
 *   variables: {
 *      updateTailgateGridInput: // value for 'updateTailgateGridInput'
 *      updateCameraInput: // value for 'updateCameraInput'
 *   },
 * });
 */
export function useUpdateTailgateGridMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateTailgateGridMutation,
    Types.UpdateTailgateGridMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.UpdateTailgateGridMutation,
    Types.UpdateTailgateGridMutationVariables
  >(UpdateTailgateGridDocument, options)
}
export type UpdateTailgateGridMutationHookResult = ReturnType<
  typeof useUpdateTailgateGridMutation
>
export type UpdateTailgateGridMutationResult =
  Apollo.MutationResult<Types.UpdateTailgateGridMutation>
export type UpdateTailgateGridMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateTailgateGridMutation,
  Types.UpdateTailgateGridMutationVariables
>
export const UpdateTechnicianDocument = gql`
  mutation UpdateTechnician($input: UpdateTechnicianInput!) {
    updateTechnician(input: $input) {
      technician {
        id
        email
        firstName
        lastName
        facilities {
          id
          name
        }
        deviceTypes
      }
    }
  }
`
export type UpdateTechnicianMutationFn = Apollo.MutationFunction<
  Types.UpdateTechnicianMutation,
  Types.UpdateTechnicianMutationVariables
>

/**
 * __useUpdateTechnicianMutation__
 *
 * To run a mutation, you first call `useUpdateTechnicianMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTechnicianMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTechnicianMutation, { data, loading, error }] = useUpdateTechnicianMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTechnicianMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateTechnicianMutation,
    Types.UpdateTechnicianMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.UpdateTechnicianMutation,
    Types.UpdateTechnicianMutationVariables
  >(UpdateTechnicianDocument, options)
}
export type UpdateTechnicianMutationHookResult = ReturnType<
  typeof useUpdateTechnicianMutation
>
export type UpdateTechnicianMutationResult =
  Apollo.MutationResult<Types.UpdateTechnicianMutation>
export type UpdateTechnicianMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateTechnicianMutation,
  Types.UpdateTechnicianMutationVariables
>
export const UpdateTourPlanDocument = gql`
  mutation UpdateTourPlan($input: UpdateTourPlanInput!) {
    updateTourPlan(input: $input) {
      tourPlan {
        id
      }
    }
  }
`
export type UpdateTourPlanMutationFn = Apollo.MutationFunction<
  Types.UpdateTourPlanMutation,
  Types.UpdateTourPlanMutationVariables
>

/**
 * __useUpdateTourPlanMutation__
 *
 * To run a mutation, you first call `useUpdateTourPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTourPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTourPlanMutation, { data, loading, error }] = useUpdateTourPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTourPlanMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateTourPlanMutation,
    Types.UpdateTourPlanMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.UpdateTourPlanMutation,
    Types.UpdateTourPlanMutationVariables
  >(UpdateTourPlanDocument, options)
}
export type UpdateTourPlanMutationHookResult = ReturnType<
  typeof useUpdateTourPlanMutation
>
export type UpdateTourPlanMutationResult =
  Apollo.MutationResult<Types.UpdateTourPlanMutation>
export type UpdateTourPlanMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateTourPlanMutation,
  Types.UpdateTourPlanMutationVariables
>
export const UpdateUserDocument = gql`
  mutation UpdateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      user {
        id
        designatedFacilityId
        email
        firstName
        lastName
        roleName
      }
    }
  }
`
export type UpdateUserMutationFn = Apollo.MutationFunction<
  Types.UpdateUserMutation,
  Types.UpdateUserMutationVariables
>

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateUserMutation,
    Types.UpdateUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.UpdateUserMutation,
    Types.UpdateUserMutationVariables
  >(UpdateUserDocument, options)
}
export type UpdateUserMutationHookResult = ReturnType<
  typeof useUpdateUserMutation
>
export type UpdateUserMutationResult =
  Apollo.MutationResult<Types.UpdateUserMutation>
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateUserMutation,
  Types.UpdateUserMutationVariables
>
export const UpdateUserRolesDocument = gql`
  mutation UpdateUserRoles($input: UpdateUserRolesInput!) {
    updateUserRoles(input: $input) {
      user {
        id
        email
        roleName
      }
    }
  }
`
export type UpdateUserRolesMutationFn = Apollo.MutationFunction<
  Types.UpdateUserRolesMutation,
  Types.UpdateUserRolesMutationVariables
>

/**
 * __useUpdateUserRolesMutation__
 *
 * To run a mutation, you first call `useUpdateUserRolesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserRolesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserRolesMutation, { data, loading, error }] = useUpdateUserRolesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserRolesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateUserRolesMutation,
    Types.UpdateUserRolesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.UpdateUserRolesMutation,
    Types.UpdateUserRolesMutationVariables
  >(UpdateUserRolesDocument, options)
}
export type UpdateUserRolesMutationHookResult = ReturnType<
  typeof useUpdateUserRolesMutation
>
export type UpdateUserRolesMutationResult =
  Apollo.MutationResult<Types.UpdateUserRolesMutation>
export type UpdateUserRolesMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateUserRolesMutation,
  Types.UpdateUserRolesMutationVariables
>
export const UpsertAiOperatorDeviceConfigurationDocument = gql`
  mutation UpsertAiOperatorDeviceConfiguration(
    $input: UpsertAiOperatorDeviceConfigurationInput!
  ) {
    upsertAiOperatorDeviceConfiguration(input: $input) {
      aiOperatorDeviceConfiguration {
        id
        deviceId
        accessGrantedTimeThreshold
        doorCloseTimeThreshold
        doorForcedBounceTimeThreshold
        isDefault
      }
    }
  }
`
export type UpsertAiOperatorDeviceConfigurationMutationFn =
  Apollo.MutationFunction<
    Types.UpsertAiOperatorDeviceConfigurationMutation,
    Types.UpsertAiOperatorDeviceConfigurationMutationVariables
  >

/**
 * __useUpsertAiOperatorDeviceConfigurationMutation__
 *
 * To run a mutation, you first call `useUpsertAiOperatorDeviceConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertAiOperatorDeviceConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertAiOperatorDeviceConfigurationMutation, { data, loading, error }] = useUpsertAiOperatorDeviceConfigurationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertAiOperatorDeviceConfigurationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpsertAiOperatorDeviceConfigurationMutation,
    Types.UpsertAiOperatorDeviceConfigurationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    Types.UpsertAiOperatorDeviceConfigurationMutation,
    Types.UpsertAiOperatorDeviceConfigurationMutationVariables
  >(UpsertAiOperatorDeviceConfigurationDocument, options)
}
export type UpsertAiOperatorDeviceConfigurationMutationHookResult = ReturnType<
  typeof useUpsertAiOperatorDeviceConfigurationMutation
>
export type UpsertAiOperatorDeviceConfigurationMutationResult =
  Apollo.MutationResult<Types.UpsertAiOperatorDeviceConfigurationMutation>
export type UpsertAiOperatorDeviceConfigurationMutationOptions =
  Apollo.BaseMutationOptions<
    Types.UpsertAiOperatorDeviceConfigurationMutation,
    Types.UpsertAiOperatorDeviceConfigurationMutationVariables
  >
export const ManualIncidentCategoriesDocument = gql`
  query ManualIncidentCategories($input: ManualIncidentCategoryFilterInput) {
    manualIncidentCategories(input: $input) {
      totalCount
      edges {
        node {
          id
          name
          isQuickReportCategory
          defaultPriority
          creatorId
        }
      }
    }
  }
`

/**
 * __useManualIncidentCategoriesQuery__
 *
 * To run a query within a React component, call `useManualIncidentCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useManualIncidentCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManualIncidentCategoriesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useManualIncidentCategoriesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.ManualIncidentCategoriesQuery,
    Types.ManualIncidentCategoriesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.ManualIncidentCategoriesQuery,
    Types.ManualIncidentCategoriesQueryVariables
  >(ManualIncidentCategoriesDocument, options)
}
export function useManualIncidentCategoriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.ManualIncidentCategoriesQuery,
    Types.ManualIncidentCategoriesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.ManualIncidentCategoriesQuery,
    Types.ManualIncidentCategoriesQueryVariables
  >(ManualIncidentCategoriesDocument, options)
}
export type ManualIncidentCategoriesQueryHookResult = ReturnType<
  typeof useManualIncidentCategoriesQuery
>
export type ManualIncidentCategoriesLazyQueryHookResult = ReturnType<
  typeof useManualIncidentCategoriesLazyQuery
>
export type ManualIncidentCategoriesQueryResult = Apollo.QueryResult<
  Types.ManualIncidentCategoriesQuery,
  Types.ManualIncidentCategoriesQueryVariables
>
export const ActiveIncidentsFilterDocument = gql`
  query ActiveIncidentsFilter {
    activeFilter(context: INCIDENT) {
      id
      name
      filterCriteria {
        incident {
          aiOperatorStateIn
          createdAtGte
          createdAtGteInterval
          createdAtLte
          deviceIdIn
          facilityIdIn
          floorIdIn
          hasVideoClip
          mutedStatus
          priorityIn {
            value
          }
          statusIn
          OR {
            sourceIn
            deviceTypeIn
          }
          AND {
            OR {
              typeIn
              manualIncidentCategoryIdIn
            }
          }
        }
      }
    }
  }
`

/**
 * __useActiveIncidentsFilterQuery__
 *
 * To run a query within a React component, call `useActiveIncidentsFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveIncidentsFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveIncidentsFilterQuery({
 *   variables: {
 *   },
 * });
 */
export function useActiveIncidentsFilterQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.ActiveIncidentsFilterQuery,
    Types.ActiveIncidentsFilterQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.ActiveIncidentsFilterQuery,
    Types.ActiveIncidentsFilterQueryVariables
  >(ActiveIncidentsFilterDocument, options)
}
export function useActiveIncidentsFilterLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.ActiveIncidentsFilterQuery,
    Types.ActiveIncidentsFilterQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.ActiveIncidentsFilterQuery,
    Types.ActiveIncidentsFilterQueryVariables
  >(ActiveIncidentsFilterDocument, options)
}
export type ActiveIncidentsFilterQueryHookResult = ReturnType<
  typeof useActiveIncidentsFilterQuery
>
export type ActiveIncidentsFilterLazyQueryHookResult = ReturnType<
  typeof useActiveIncidentsFilterLazyQuery
>
export type ActiveIncidentsFilterQueryResult = Apollo.QueryResult<
  Types.ActiveIncidentsFilterQuery,
  Types.ActiveIncidentsFilterQueryVariables
>
export const AiOperatorDeviceConfigurationDocument = gql`
  query AiOperatorDeviceConfiguration($deviceId: ID!) {
    aiOperatorDeviceConfiguration(deviceId: $deviceId) {
      id
      deviceId
      accessGrantedTimeThreshold
      doorCloseTimeThreshold
      doorForcedBounceTimeThreshold
      isDefault
    }
  }
`

/**
 * __useAiOperatorDeviceConfigurationQuery__
 *
 * To run a query within a React component, call `useAiOperatorDeviceConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiOperatorDeviceConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiOperatorDeviceConfigurationQuery({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *   },
 * });
 */
export function useAiOperatorDeviceConfigurationQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.AiOperatorDeviceConfigurationQuery,
    Types.AiOperatorDeviceConfigurationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.AiOperatorDeviceConfigurationQuery,
    Types.AiOperatorDeviceConfigurationQueryVariables
  >(AiOperatorDeviceConfigurationDocument, options)
}
export function useAiOperatorDeviceConfigurationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.AiOperatorDeviceConfigurationQuery,
    Types.AiOperatorDeviceConfigurationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.AiOperatorDeviceConfigurationQuery,
    Types.AiOperatorDeviceConfigurationQueryVariables
  >(AiOperatorDeviceConfigurationDocument, options)
}
export type AiOperatorDeviceConfigurationQueryHookResult = ReturnType<
  typeof useAiOperatorDeviceConfigurationQuery
>
export type AiOperatorDeviceConfigurationLazyQueryHookResult = ReturnType<
  typeof useAiOperatorDeviceConfigurationLazyQuery
>
export type AiOperatorDeviceConfigurationQueryResult = Apollo.QueryResult<
  Types.AiOperatorDeviceConfigurationQuery,
  Types.AiOperatorDeviceConfigurationQueryVariables
>
export const AiOperatorFieldsDocument = gql`
  query AiOperatorFields($filter: AiOperatorFieldFilterInput) {
    aiOperatorFields(filter: $filter) {
      totalCount
      edges {
        node {
          description
          id
          sourceType
        }
      }
    }
  }
`

/**
 * __useAiOperatorFieldsQuery__
 *
 * To run a query within a React component, call `useAiOperatorFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiOperatorFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiOperatorFieldsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAiOperatorFieldsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.AiOperatorFieldsQuery,
    Types.AiOperatorFieldsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.AiOperatorFieldsQuery,
    Types.AiOperatorFieldsQueryVariables
  >(AiOperatorFieldsDocument, options)
}
export function useAiOperatorFieldsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.AiOperatorFieldsQuery,
    Types.AiOperatorFieldsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.AiOperatorFieldsQuery,
    Types.AiOperatorFieldsQueryVariables
  >(AiOperatorFieldsDocument, options)
}
export type AiOperatorFieldsQueryHookResult = ReturnType<
  typeof useAiOperatorFieldsQuery
>
export type AiOperatorFieldsLazyQueryHookResult = ReturnType<
  typeof useAiOperatorFieldsLazyQuery
>
export type AiOperatorFieldsQueryResult = Apollo.QueryResult<
  Types.AiOperatorFieldsQuery,
  Types.AiOperatorFieldsQueryVariables
>
export const AiOperatorReportDocument = gql`
  query AiOperatorReport($input: AiOperatorReportInput!) {
    aiOperatorReport(input: $input)
  }
`

/**
 * __useAiOperatorReportQuery__
 *
 * To run a query within a React component, call `useAiOperatorReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiOperatorReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiOperatorReportQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAiOperatorReportQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.AiOperatorReportQuery,
    Types.AiOperatorReportQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.AiOperatorReportQuery,
    Types.AiOperatorReportQueryVariables
  >(AiOperatorReportDocument, options)
}
export function useAiOperatorReportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.AiOperatorReportQuery,
    Types.AiOperatorReportQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.AiOperatorReportQuery,
    Types.AiOperatorReportQueryVariables
  >(AiOperatorReportDocument, options)
}
export type AiOperatorReportQueryHookResult = ReturnType<
  typeof useAiOperatorReportQuery
>
export type AiOperatorReportLazyQueryHookResult = ReturnType<
  typeof useAiOperatorReportLazyQuery
>
export type AiOperatorReportQueryResult = Apollo.QueryResult<
  Types.AiOperatorReportQuery,
  Types.AiOperatorReportQueryVariables
>
export const AiOperatorRuleEvaluationsDocument = gql`
  query AiOperatorRuleEvaluations(
    $filter: AiOperatorRuleEvaluationFilterInput
  ) {
    aiOperatorRuleEvaluations(filter: $filter) {
      edges {
        node {
          id
          incident {
            id
            displayId
            createdAt
            video {
              url
            }
            devices {
              id
              name
              type
            }
          }
          responseRule {
            id
            field {
              id
              humanInstructions
            }
          }
        }
      }
    }
  }
`

/**
 * __useAiOperatorRuleEvaluationsQuery__
 *
 * To run a query within a React component, call `useAiOperatorRuleEvaluationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiOperatorRuleEvaluationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiOperatorRuleEvaluationsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAiOperatorRuleEvaluationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.AiOperatorRuleEvaluationsQuery,
    Types.AiOperatorRuleEvaluationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.AiOperatorRuleEvaluationsQuery,
    Types.AiOperatorRuleEvaluationsQueryVariables
  >(AiOperatorRuleEvaluationsDocument, options)
}
export function useAiOperatorRuleEvaluationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.AiOperatorRuleEvaluationsQuery,
    Types.AiOperatorRuleEvaluationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.AiOperatorRuleEvaluationsQuery,
    Types.AiOperatorRuleEvaluationsQueryVariables
  >(AiOperatorRuleEvaluationsDocument, options)
}
export type AiOperatorRuleEvaluationsQueryHookResult = ReturnType<
  typeof useAiOperatorRuleEvaluationsQuery
>
export type AiOperatorRuleEvaluationsLazyQueryHookResult = ReturnType<
  typeof useAiOperatorRuleEvaluationsLazyQuery
>
export type AiOperatorRuleEvaluationsQueryResult = Apollo.QueryResult<
  Types.AiOperatorRuleEvaluationsQuery,
  Types.AiOperatorRuleEvaluationsQueryVariables
>
export const AiOperatorRuleEvaluationsCountDocument = gql`
  query AiOperatorRuleEvaluationsCount(
    $filter: AiOperatorRuleEvaluationFilterInput
  ) {
    aiOperatorRuleEvaluations(filter: $filter) {
      totalCount
    }
  }
`

/**
 * __useAiOperatorRuleEvaluationsCountQuery__
 *
 * To run a query within a React component, call `useAiOperatorRuleEvaluationsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiOperatorRuleEvaluationsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiOperatorRuleEvaluationsCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAiOperatorRuleEvaluationsCountQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.AiOperatorRuleEvaluationsCountQuery,
    Types.AiOperatorRuleEvaluationsCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.AiOperatorRuleEvaluationsCountQuery,
    Types.AiOperatorRuleEvaluationsCountQueryVariables
  >(AiOperatorRuleEvaluationsCountDocument, options)
}
export function useAiOperatorRuleEvaluationsCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.AiOperatorRuleEvaluationsCountQuery,
    Types.AiOperatorRuleEvaluationsCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.AiOperatorRuleEvaluationsCountQuery,
    Types.AiOperatorRuleEvaluationsCountQueryVariables
  >(AiOperatorRuleEvaluationsCountDocument, options)
}
export type AiOperatorRuleEvaluationsCountQueryHookResult = ReturnType<
  typeof useAiOperatorRuleEvaluationsCountQuery
>
export type AiOperatorRuleEvaluationsCountLazyQueryHookResult = ReturnType<
  typeof useAiOperatorRuleEvaluationsCountLazyQuery
>
export type AiOperatorRuleEvaluationsCountQueryResult = Apollo.QueryResult<
  Types.AiOperatorRuleEvaluationsCountQuery,
  Types.AiOperatorRuleEvaluationsCountQueryVariables
>
export const AiOperatorSettingsHistoryDocument = gql`
  query AiOperatorSettingsHistory(
    $filter: AiOperatorSettingsHistoryFilterInput
    $page: Int
    $pageSize: Int
  ) {
    aiOperatorSettingsHistory(
      page: $page
      pageSize: $pageSize
      filter: $filter
    ) {
      totalCount
      edges {
        id
        oldValue
        newValue
        userId
        createdAt
        settingKey
      }
    }
  }
`

/**
 * __useAiOperatorSettingsHistoryQuery__
 *
 * To run a query within a React component, call `useAiOperatorSettingsHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiOperatorSettingsHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiOperatorSettingsHistoryQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useAiOperatorSettingsHistoryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.AiOperatorSettingsHistoryQuery,
    Types.AiOperatorSettingsHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.AiOperatorSettingsHistoryQuery,
    Types.AiOperatorSettingsHistoryQueryVariables
  >(AiOperatorSettingsHistoryDocument, options)
}
export function useAiOperatorSettingsHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.AiOperatorSettingsHistoryQuery,
    Types.AiOperatorSettingsHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.AiOperatorSettingsHistoryQuery,
    Types.AiOperatorSettingsHistoryQueryVariables
  >(AiOperatorSettingsHistoryDocument, options)
}
export type AiOperatorSettingsHistoryQueryHookResult = ReturnType<
  typeof useAiOperatorSettingsHistoryQuery
>
export type AiOperatorSettingsHistoryLazyQueryHookResult = ReturnType<
  typeof useAiOperatorSettingsHistoryLazyQuery
>
export type AiOperatorSettingsHistoryQueryResult = Apollo.QueryResult<
  Types.AiOperatorSettingsHistoryQuery,
  Types.AiOperatorSettingsHistoryQueryVariables
>
export const AllPersonsOfInterestDocument = gql`
  query allPersonsOfInterest(
    $filter: PersonOfInterestFilterInput
    $pageIndex: Int
    $pageSize: Int
  ) {
    personsOfInterest(filter: $filter, first: $pageIndex, last: $pageSize) {
      totalCount
      edges {
        node {
          id
          firstName
          lastName
          email
          createdAt
          companyAffiliation
          cases {
            edges {
              node {
                caseRole
                customCaseRoleDescription
                case {
                  name
                  id
                }
              }
            }
          }
        }
      }
    }
  }
`

/**
 * __useAllPersonsOfInterestQuery__
 *
 * To run a query within a React component, call `useAllPersonsOfInterestQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPersonsOfInterestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPersonsOfInterestQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pageIndex: // value for 'pageIndex'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useAllPersonsOfInterestQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.AllPersonsOfInterestQuery,
    Types.AllPersonsOfInterestQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.AllPersonsOfInterestQuery,
    Types.AllPersonsOfInterestQueryVariables
  >(AllPersonsOfInterestDocument, options)
}
export function useAllPersonsOfInterestLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.AllPersonsOfInterestQuery,
    Types.AllPersonsOfInterestQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.AllPersonsOfInterestQuery,
    Types.AllPersonsOfInterestQueryVariables
  >(AllPersonsOfInterestDocument, options)
}
export type AllPersonsOfInterestQueryHookResult = ReturnType<
  typeof useAllPersonsOfInterestQuery
>
export type AllPersonsOfInterestLazyQueryHookResult = ReturnType<
  typeof useAllPersonsOfInterestLazyQuery
>
export type AllPersonsOfInterestQueryResult = Apollo.QueryResult<
  Types.AllPersonsOfInterestQuery,
  Types.AllPersonsOfInterestQueryVariables
>
export const AssociatedDevicesDocument = gql`
  query AssociatedDevices($id: ID!) {
    device(id: $id) {
      id
      type
      tailgateConns {
        edges {
          node {
            id
            door {
              id
              name
              type
            }
            cameras {
              edges {
                node {
                  id
                  name
                  type
                  camera {
                    tailgateGrids {
                      door {
                        id
                      }
                      isTailgateEnabled
                      inBox {
                        topLeft {
                          x
                          y
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`

/**
 * __useAssociatedDevicesQuery__
 *
 * To run a query within a React component, call `useAssociatedDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssociatedDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssociatedDevicesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAssociatedDevicesQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.AssociatedDevicesQuery,
    Types.AssociatedDevicesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.AssociatedDevicesQuery,
    Types.AssociatedDevicesQueryVariables
  >(AssociatedDevicesDocument, options)
}
export function useAssociatedDevicesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.AssociatedDevicesQuery,
    Types.AssociatedDevicesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.AssociatedDevicesQuery,
    Types.AssociatedDevicesQueryVariables
  >(AssociatedDevicesDocument, options)
}
export type AssociatedDevicesQueryHookResult = ReturnType<
  typeof useAssociatedDevicesQuery
>
export type AssociatedDevicesLazyQueryHookResult = ReturnType<
  typeof useAssociatedDevicesLazyQuery
>
export type AssociatedDevicesQueryResult = Apollo.QueryResult<
  Types.AssociatedDevicesQuery,
  Types.AssociatedDevicesQueryVariables
>
export const CameraFeedDocument = gql`
  query CameraFeed($deviceId: ID!) {
    streamingUrlWrapper(deviceId: $deviceId) {
      url
      expiryTime
      ... on StreamingUrlWrapperLiveKit {
        token
      }
    }
  }
`

/**
 * __useCameraFeedQuery__
 *
 * To run a query within a React component, call `useCameraFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useCameraFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCameraFeedQuery({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *   },
 * });
 */
export function useCameraFeedQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.CameraFeedQuery,
    Types.CameraFeedQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<Types.CameraFeedQuery, Types.CameraFeedQueryVariables>(
    CameraFeedDocument,
    options
  )
}
export function useCameraFeedLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.CameraFeedQuery,
    Types.CameraFeedQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.CameraFeedQuery,
    Types.CameraFeedQueryVariables
  >(CameraFeedDocument, options)
}
export type CameraFeedQueryHookResult = ReturnType<typeof useCameraFeedQuery>
export type CameraFeedLazyQueryHookResult = ReturnType<
  typeof useCameraFeedLazyQuery
>
export type CameraFeedQueryResult = Apollo.QueryResult<
  Types.CameraFeedQuery,
  Types.CameraFeedQueryVariables
>
export const CaseDocument = gql`
  query Case($id: ID!) {
    case(id: $id) {
      createdAt
      description
      detailedReport
      displayId
      id
      name
      status
      facilities {
        id
        name
        shortName
        archived
      }
      owner {
        firstName
        lastName
        roleName
        id
      }
      incidents {
        edges {
          node {
            id
            displayId
            createdAt
            name
            status
            facility {
              id
              name
            }
            floor {
              id
              name
            }
          }
        }
      }
      actions {
        edges {
          node {
            id
            type
            comment {
              message
            }
            createdAt
            creator {
              id
              firstName
              lastName
              roleName
            }
            personOfInterestRoleUpdateDetail {
              newRole
              personOfInterest {
                firstName
                id
                lastName
              }
            }
            referenceId
          }
        }
      }
    }
  }
`

/**
 * __useCaseQuery__
 *
 * To run a query within a React component, call `useCaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useCaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCaseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCaseQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.CaseQuery,
    Types.CaseQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<Types.CaseQuery, Types.CaseQueryVariables>(
    CaseDocument,
    options
  )
}
export function useCaseLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.CaseQuery,
    Types.CaseQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<Types.CaseQuery, Types.CaseQueryVariables>(
    CaseDocument,
    options
  )
}
export type CaseQueryHookResult = ReturnType<typeof useCaseQuery>
export type CaseLazyQueryHookResult = ReturnType<typeof useCaseLazyQuery>
export type CaseQueryResult = Apollo.QueryResult<
  Types.CaseQuery,
  Types.CaseQueryVariables
>
export const CaseIncidentsDocument = gql`
  query CaseIncidents($id: ID!, $pageIndex: Int, $pageSize: Int) {
    case(id: $id) {
      id
      incidents(first: $pageIndex, last: $pageSize) {
        edges {
          node {
            id
            displayId
            createdAt
            name
            status
            facility {
              id
              name
            }
            floor {
              id
              name
            }
          }
        }
        totalCount
      }
    }
  }
`

/**
 * __useCaseIncidentsQuery__
 *
 * To run a query within a React component, call `useCaseIncidentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCaseIncidentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCaseIncidentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      pageIndex: // value for 'pageIndex'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useCaseIncidentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.CaseIncidentsQuery,
    Types.CaseIncidentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.CaseIncidentsQuery,
    Types.CaseIncidentsQueryVariables
  >(CaseIncidentsDocument, options)
}
export function useCaseIncidentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.CaseIncidentsQuery,
    Types.CaseIncidentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.CaseIncidentsQuery,
    Types.CaseIncidentsQueryVariables
  >(CaseIncidentsDocument, options)
}
export type CaseIncidentsQueryHookResult = ReturnType<
  typeof useCaseIncidentsQuery
>
export type CaseIncidentsLazyQueryHookResult = ReturnType<
  typeof useCaseIncidentsLazyQuery
>
export type CaseIncidentsQueryResult = Apollo.QueryResult<
  Types.CaseIncidentsQuery,
  Types.CaseIncidentsQueryVariables
>
export const CaseIncidentsVideosDocument = gql`
  query CaseIncidentsVideos($id: ID!) {
    case(id: $id) {
      id
      incidents {
        edges {
          node {
            id
            displayId
            createdAt
            type
            video {
              expiryTime
              url
            }
          }
        }
      }
    }
  }
`

/**
 * __useCaseIncidentsVideosQuery__
 *
 * To run a query within a React component, call `useCaseIncidentsVideosQuery` and pass it any options that fit your needs.
 * When your component renders, `useCaseIncidentsVideosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCaseIncidentsVideosQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCaseIncidentsVideosQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.CaseIncidentsVideosQuery,
    Types.CaseIncidentsVideosQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.CaseIncidentsVideosQuery,
    Types.CaseIncidentsVideosQueryVariables
  >(CaseIncidentsVideosDocument, options)
}
export function useCaseIncidentsVideosLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.CaseIncidentsVideosQuery,
    Types.CaseIncidentsVideosQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.CaseIncidentsVideosQuery,
    Types.CaseIncidentsVideosQueryVariables
  >(CaseIncidentsVideosDocument, options)
}
export type CaseIncidentsVideosQueryHookResult = ReturnType<
  typeof useCaseIncidentsVideosQuery
>
export type CaseIncidentsVideosLazyQueryHookResult = ReturnType<
  typeof useCaseIncidentsVideosLazyQuery
>
export type CaseIncidentsVideosQueryResult = Apollo.QueryResult<
  Types.CaseIncidentsVideosQuery,
  Types.CaseIncidentsVideosQueryVariables
>
export const CaseReportEnrichmentDocument = gql`
  query CaseReportEnrichment($incidentIds: [ID!]) {
    incidents(filter: { idIn: $incidentIds }) {
      edges {
        node {
          id
          displayId
        }
      }
    }
    users {
      edges {
        node {
          id
          firstName
          lastName
          roleName
        }
      }
    }
  }
`

/**
 * __useCaseReportEnrichmentQuery__
 *
 * To run a query within a React component, call `useCaseReportEnrichmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useCaseReportEnrichmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCaseReportEnrichmentQuery({
 *   variables: {
 *      incidentIds: // value for 'incidentIds'
 *   },
 * });
 */
export function useCaseReportEnrichmentQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.CaseReportEnrichmentQuery,
    Types.CaseReportEnrichmentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.CaseReportEnrichmentQuery,
    Types.CaseReportEnrichmentQueryVariables
  >(CaseReportEnrichmentDocument, options)
}
export function useCaseReportEnrichmentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.CaseReportEnrichmentQuery,
    Types.CaseReportEnrichmentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.CaseReportEnrichmentQuery,
    Types.CaseReportEnrichmentQueryVariables
  >(CaseReportEnrichmentDocument, options)
}
export type CaseReportEnrichmentQueryHookResult = ReturnType<
  typeof useCaseReportEnrichmentQuery
>
export type CaseReportEnrichmentLazyQueryHookResult = ReturnType<
  typeof useCaseReportEnrichmentLazyQuery
>
export type CaseReportEnrichmentQueryResult = Apollo.QueryResult<
  Types.CaseReportEnrichmentQuery,
  Types.CaseReportEnrichmentQueryVariables
>
export const CaseWithDisplayIdDocument = gql`
  query CaseWithDisplayId($displayId: String) {
    cases(filter: { displayId: $displayId }) {
      edges {
        node {
          id
        }
      }
    }
  }
`

/**
 * __useCaseWithDisplayIdQuery__
 *
 * To run a query within a React component, call `useCaseWithDisplayIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCaseWithDisplayIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCaseWithDisplayIdQuery({
 *   variables: {
 *      displayId: // value for 'displayId'
 *   },
 * });
 */
export function useCaseWithDisplayIdQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.CaseWithDisplayIdQuery,
    Types.CaseWithDisplayIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.CaseWithDisplayIdQuery,
    Types.CaseWithDisplayIdQueryVariables
  >(CaseWithDisplayIdDocument, options)
}
export function useCaseWithDisplayIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.CaseWithDisplayIdQuery,
    Types.CaseWithDisplayIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.CaseWithDisplayIdQuery,
    Types.CaseWithDisplayIdQueryVariables
  >(CaseWithDisplayIdDocument, options)
}
export type CaseWithDisplayIdQueryHookResult = ReturnType<
  typeof useCaseWithDisplayIdQuery
>
export type CaseWithDisplayIdLazyQueryHookResult = ReturnType<
  typeof useCaseWithDisplayIdLazyQuery
>
export type CaseWithDisplayIdQueryResult = Apollo.QueryResult<
  Types.CaseWithDisplayIdQuery,
  Types.CaseWithDisplayIdQueryVariables
>
export const CasesDocument = gql`
  query Cases($filter: CaseFilterInput, $first: Int, $last: Int) {
    cases(filter: $filter, first: $first, last: $last) {
      totalCount
      edges {
        cursor
        node {
          displayId
          id
          name
          status
          createdAt
          owner {
            firstName
            id
            lastName
          }
        }
      }
    }
  }
`

/**
 * __useCasesQuery__
 *
 * To run a query within a React component, call `useCasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCasesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useCasesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.CasesQuery,
    Types.CasesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<Types.CasesQuery, Types.CasesQueryVariables>(
    CasesDocument,
    options
  )
}
export function useCasesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.CasesQuery,
    Types.CasesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<Types.CasesQuery, Types.CasesQueryVariables>(
    CasesDocument,
    options
  )
}
export type CasesQueryHookResult = ReturnType<typeof useCasesQuery>
export type CasesLazyQueryHookResult = ReturnType<typeof useCasesLazyQuery>
export type CasesQueryResult = Apollo.QueryResult<
  Types.CasesQuery,
  Types.CasesQueryVariables
>
export const CheckpointTasksDocument = gql`
  query CheckpointTasks($checkpointId: ID!) {
    checkpointTasks(checkpointId: $checkpointId) {
      edges {
        node {
          id
          description
          isRequired
        }
      }
    }
  }
`

/**
 * __useCheckpointTasksQuery__
 *
 * To run a query within a React component, call `useCheckpointTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckpointTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckpointTasksQuery({
 *   variables: {
 *      checkpointId: // value for 'checkpointId'
 *   },
 * });
 */
export function useCheckpointTasksQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.CheckpointTasksQuery,
    Types.CheckpointTasksQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.CheckpointTasksQuery,
    Types.CheckpointTasksQueryVariables
  >(CheckpointTasksDocument, options)
}
export function useCheckpointTasksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.CheckpointTasksQuery,
    Types.CheckpointTasksQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.CheckpointTasksQuery,
    Types.CheckpointTasksQueryVariables
  >(CheckpointTasksDocument, options)
}
export type CheckpointTasksQueryHookResult = ReturnType<
  typeof useCheckpointTasksQuery
>
export type CheckpointTasksLazyQueryHookResult = ReturnType<
  typeof useCheckpointTasksLazyQuery
>
export type CheckpointTasksQueryResult = Apollo.QueryResult<
  Types.CheckpointTasksQuery,
  Types.CheckpointTasksQueryVariables
>
export const CurrentMonthAiOperatorUsageDocument = gql`
  query CurrentMonthAiOperatorUsage {
    aiOperatorProcessedIncidentCount
  }
`

/**
 * __useCurrentMonthAiOperatorUsageQuery__
 *
 * To run a query within a React component, call `useCurrentMonthAiOperatorUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentMonthAiOperatorUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentMonthAiOperatorUsageQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentMonthAiOperatorUsageQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.CurrentMonthAiOperatorUsageQuery,
    Types.CurrentMonthAiOperatorUsageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.CurrentMonthAiOperatorUsageQuery,
    Types.CurrentMonthAiOperatorUsageQueryVariables
  >(CurrentMonthAiOperatorUsageDocument, options)
}
export function useCurrentMonthAiOperatorUsageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.CurrentMonthAiOperatorUsageQuery,
    Types.CurrentMonthAiOperatorUsageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.CurrentMonthAiOperatorUsageQuery,
    Types.CurrentMonthAiOperatorUsageQueryVariables
  >(CurrentMonthAiOperatorUsageDocument, options)
}
export type CurrentMonthAiOperatorUsageQueryHookResult = ReturnType<
  typeof useCurrentMonthAiOperatorUsageQuery
>
export type CurrentMonthAiOperatorUsageLazyQueryHookResult = ReturnType<
  typeof useCurrentMonthAiOperatorUsageLazyQuery
>
export type CurrentMonthAiOperatorUsageQueryResult = Apollo.QueryResult<
  Types.CurrentMonthAiOperatorUsageQuery,
  Types.CurrentMonthAiOperatorUsageQueryVariables
>
export const CustomFormDocument = gql`
  query CustomForm($id: ID!) {
    customForm(id: $id) {
      id
      name
      description
      status
      version
      publishedAt
      createdAt
      updatedAt
      sections {
        id
        name
        description
        order
        questions {
          id
          label
          helpText
          answerType
          required
          order
          defaultValue
          visibleWhen {
            anyOf {
              allOf {
                questionId
                operator
                value
              }
            }
          }
          options {
            id
            label
            order
          }
        }
      }
    }
  }
`

/**
 * __useCustomFormQuery__
 *
 * To run a query within a React component, call `useCustomFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomFormQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.CustomFormQuery,
    Types.CustomFormQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<Types.CustomFormQuery, Types.CustomFormQueryVariables>(
    CustomFormDocument,
    options
  )
}
export function useCustomFormLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.CustomFormQuery,
    Types.CustomFormQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.CustomFormQuery,
    Types.CustomFormQueryVariables
  >(CustomFormDocument, options)
}
export type CustomFormQueryHookResult = ReturnType<typeof useCustomFormQuery>
export type CustomFormLazyQueryHookResult = ReturnType<
  typeof useCustomFormLazyQuery
>
export type CustomFormQueryResult = Apollo.QueryResult<
  Types.CustomFormQuery,
  Types.CustomFormQueryVariables
>
export const CustomFormsDocument = gql`
  query CustomForms($status: CustomFormStatus) {
    customForms(status: $status) {
      edges {
        node {
          id
          name
          description
          status
          version
          createdAt
          updatedAt
        }
      }
      totalCount
    }
  }
`

/**
 * __useCustomFormsQuery__
 *
 * To run a query within a React component, call `useCustomFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomFormsQuery({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useCustomFormsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.CustomFormsQuery,
    Types.CustomFormsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.CustomFormsQuery,
    Types.CustomFormsQueryVariables
  >(CustomFormsDocument, options)
}
export function useCustomFormsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.CustomFormsQuery,
    Types.CustomFormsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.CustomFormsQuery,
    Types.CustomFormsQueryVariables
  >(CustomFormsDocument, options)
}
export type CustomFormsQueryHookResult = ReturnType<typeof useCustomFormsQuery>
export type CustomFormsLazyQueryHookResult = ReturnType<
  typeof useCustomFormsLazyQuery
>
export type CustomFormsQueryResult = Apollo.QueryResult<
  Types.CustomFormsQuery,
  Types.CustomFormsQueryVariables
>
export const AverageGuardAcknowledgmentTimeKpiDocument = gql`
  query AverageGuardAcknowledgmentTimeKPI($guards: [ID!], $hours: Int!) {
    kpi {
      averageGuardAcknowledgmentTime(guards: $guards, hours: $hours) {
        current
        past
      }
    }
  }
`

/**
 * __useAverageGuardAcknowledgmentTimeKpiQuery__
 *
 * To run a query within a React component, call `useAverageGuardAcknowledgmentTimeKpiQuery` and pass it any options that fit your needs.
 * When your component renders, `useAverageGuardAcknowledgmentTimeKpiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAverageGuardAcknowledgmentTimeKpiQuery({
 *   variables: {
 *      guards: // value for 'guards'
 *      hours: // value for 'hours'
 *   },
 * });
 */
export function useAverageGuardAcknowledgmentTimeKpiQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.AverageGuardAcknowledgmentTimeKpiQuery,
    Types.AverageGuardAcknowledgmentTimeKpiQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.AverageGuardAcknowledgmentTimeKpiQuery,
    Types.AverageGuardAcknowledgmentTimeKpiQueryVariables
  >(AverageGuardAcknowledgmentTimeKpiDocument, options)
}
export function useAverageGuardAcknowledgmentTimeKpiLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.AverageGuardAcknowledgmentTimeKpiQuery,
    Types.AverageGuardAcknowledgmentTimeKpiQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.AverageGuardAcknowledgmentTimeKpiQuery,
    Types.AverageGuardAcknowledgmentTimeKpiQueryVariables
  >(AverageGuardAcknowledgmentTimeKpiDocument, options)
}
export type AverageGuardAcknowledgmentTimeKpiQueryHookResult = ReturnType<
  typeof useAverageGuardAcknowledgmentTimeKpiQuery
>
export type AverageGuardAcknowledgmentTimeKpiLazyQueryHookResult = ReturnType<
  typeof useAverageGuardAcknowledgmentTimeKpiLazyQuery
>
export type AverageGuardAcknowledgmentTimeKpiQueryResult = Apollo.QueryResult<
  Types.AverageGuardAcknowledgmentTimeKpiQuery,
  Types.AverageGuardAcknowledgmentTimeKpiQueryVariables
>
export const AverageGuardTimeOnSceneKpiDocument = gql`
  query AverageGuardTimeOnSceneKPI($guards: [ID!], $hours: Int!) {
    kpi {
      averageGuardOnScene(guards: $guards, hours: $hours) {
        current
        past
      }
    }
  }
`

/**
 * __useAverageGuardTimeOnSceneKpiQuery__
 *
 * To run a query within a React component, call `useAverageGuardTimeOnSceneKpiQuery` and pass it any options that fit your needs.
 * When your component renders, `useAverageGuardTimeOnSceneKpiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAverageGuardTimeOnSceneKpiQuery({
 *   variables: {
 *      guards: // value for 'guards'
 *      hours: // value for 'hours'
 *   },
 * });
 */
export function useAverageGuardTimeOnSceneKpiQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.AverageGuardTimeOnSceneKpiQuery,
    Types.AverageGuardTimeOnSceneKpiQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.AverageGuardTimeOnSceneKpiQuery,
    Types.AverageGuardTimeOnSceneKpiQueryVariables
  >(AverageGuardTimeOnSceneKpiDocument, options)
}
export function useAverageGuardTimeOnSceneKpiLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.AverageGuardTimeOnSceneKpiQuery,
    Types.AverageGuardTimeOnSceneKpiQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.AverageGuardTimeOnSceneKpiQuery,
    Types.AverageGuardTimeOnSceneKpiQueryVariables
  >(AverageGuardTimeOnSceneKpiDocument, options)
}
export type AverageGuardTimeOnSceneKpiQueryHookResult = ReturnType<
  typeof useAverageGuardTimeOnSceneKpiQuery
>
export type AverageGuardTimeOnSceneKpiLazyQueryHookResult = ReturnType<
  typeof useAverageGuardTimeOnSceneKpiLazyQuery
>
export type AverageGuardTimeOnSceneKpiQueryResult = Apollo.QueryResult<
  Types.AverageGuardTimeOnSceneKpiQuery,
  Types.AverageGuardTimeOnSceneKpiQueryVariables
>
export const AverageGuardTimeToClearKpiDocument = gql`
  query AverageGuardTimeToClearKPI($guards: [ID!], $hours: Int!) {
    kpi {
      averageGuardToClear(guards: $guards, hours: $hours) {
        current
        past
      }
    }
  }
`

/**
 * __useAverageGuardTimeToClearKpiQuery__
 *
 * To run a query within a React component, call `useAverageGuardTimeToClearKpiQuery` and pass it any options that fit your needs.
 * When your component renders, `useAverageGuardTimeToClearKpiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAverageGuardTimeToClearKpiQuery({
 *   variables: {
 *      guards: // value for 'guards'
 *      hours: // value for 'hours'
 *   },
 * });
 */
export function useAverageGuardTimeToClearKpiQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.AverageGuardTimeToClearKpiQuery,
    Types.AverageGuardTimeToClearKpiQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.AverageGuardTimeToClearKpiQuery,
    Types.AverageGuardTimeToClearKpiQueryVariables
  >(AverageGuardTimeToClearKpiDocument, options)
}
export function useAverageGuardTimeToClearKpiLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.AverageGuardTimeToClearKpiQuery,
    Types.AverageGuardTimeToClearKpiQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.AverageGuardTimeToClearKpiQuery,
    Types.AverageGuardTimeToClearKpiQueryVariables
  >(AverageGuardTimeToClearKpiDocument, options)
}
export type AverageGuardTimeToClearKpiQueryHookResult = ReturnType<
  typeof useAverageGuardTimeToClearKpiQuery
>
export type AverageGuardTimeToClearKpiLazyQueryHookResult = ReturnType<
  typeof useAverageGuardTimeToClearKpiLazyQuery
>
export type AverageGuardTimeToClearKpiQueryResult = Apollo.QueryResult<
  Types.AverageGuardTimeToClearKpiQuery,
  Types.AverageGuardTimeToClearKpiQueryVariables
>
export const AverageOperatorTimeToAcknowledgeKpiDocument = gql`
  query AverageOperatorTimeToAcknowledgeKPI($owners: [ID!], $hours: Int!) {
    kpi {
      averageOperatorTimeToAcknowledge(owners: $owners, hours: $hours) {
        current
        past
      }
    }
  }
`

/**
 * __useAverageOperatorTimeToAcknowledgeKpiQuery__
 *
 * To run a query within a React component, call `useAverageOperatorTimeToAcknowledgeKpiQuery` and pass it any options that fit your needs.
 * When your component renders, `useAverageOperatorTimeToAcknowledgeKpiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAverageOperatorTimeToAcknowledgeKpiQuery({
 *   variables: {
 *      owners: // value for 'owners'
 *      hours: // value for 'hours'
 *   },
 * });
 */
export function useAverageOperatorTimeToAcknowledgeKpiQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.AverageOperatorTimeToAcknowledgeKpiQuery,
    Types.AverageOperatorTimeToAcknowledgeKpiQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.AverageOperatorTimeToAcknowledgeKpiQuery,
    Types.AverageOperatorTimeToAcknowledgeKpiQueryVariables
  >(AverageOperatorTimeToAcknowledgeKpiDocument, options)
}
export function useAverageOperatorTimeToAcknowledgeKpiLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.AverageOperatorTimeToAcknowledgeKpiQuery,
    Types.AverageOperatorTimeToAcknowledgeKpiQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.AverageOperatorTimeToAcknowledgeKpiQuery,
    Types.AverageOperatorTimeToAcknowledgeKpiQueryVariables
  >(AverageOperatorTimeToAcknowledgeKpiDocument, options)
}
export type AverageOperatorTimeToAcknowledgeKpiQueryHookResult = ReturnType<
  typeof useAverageOperatorTimeToAcknowledgeKpiQuery
>
export type AverageOperatorTimeToAcknowledgeKpiLazyQueryHookResult = ReturnType<
  typeof useAverageOperatorTimeToAcknowledgeKpiLazyQuery
>
export type AverageOperatorTimeToAcknowledgeKpiQueryResult = Apollo.QueryResult<
  Types.AverageOperatorTimeToAcknowledgeKpiQuery,
  Types.AverageOperatorTimeToAcknowledgeKpiQueryVariables
>
export const AverageOperatorTimeToResolveKpiDocument = gql`
  query AverageOperatorTimeToResolveKPI($owners: [ID!], $hours: Int!) {
    kpi {
      averageOperatorTimeToResolve(owners: $owners, hours: $hours) {
        current
        past
      }
    }
  }
`

/**
 * __useAverageOperatorTimeToResolveKpiQuery__
 *
 * To run a query within a React component, call `useAverageOperatorTimeToResolveKpiQuery` and pass it any options that fit your needs.
 * When your component renders, `useAverageOperatorTimeToResolveKpiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAverageOperatorTimeToResolveKpiQuery({
 *   variables: {
 *      owners: // value for 'owners'
 *      hours: // value for 'hours'
 *   },
 * });
 */
export function useAverageOperatorTimeToResolveKpiQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.AverageOperatorTimeToResolveKpiQuery,
    Types.AverageOperatorTimeToResolveKpiQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.AverageOperatorTimeToResolveKpiQuery,
    Types.AverageOperatorTimeToResolveKpiQueryVariables
  >(AverageOperatorTimeToResolveKpiDocument, options)
}
export function useAverageOperatorTimeToResolveKpiLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.AverageOperatorTimeToResolveKpiQuery,
    Types.AverageOperatorTimeToResolveKpiQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.AverageOperatorTimeToResolveKpiQuery,
    Types.AverageOperatorTimeToResolveKpiQueryVariables
  >(AverageOperatorTimeToResolveKpiDocument, options)
}
export type AverageOperatorTimeToResolveKpiQueryHookResult = ReturnType<
  typeof useAverageOperatorTimeToResolveKpiQuery
>
export type AverageOperatorTimeToResolveKpiLazyQueryHookResult = ReturnType<
  typeof useAverageOperatorTimeToResolveKpiLazyQuery
>
export type AverageOperatorTimeToResolveKpiQueryResult = Apollo.QueryResult<
  Types.AverageOperatorTimeToResolveKpiQuery,
  Types.AverageOperatorTimeToResolveKpiQueryVariables
>
export const EnrolledDevicesKpiDocument = gql`
  query EnrolledDevicesKPI($deviceType: DeviceType, $hours: Int!) {
    kpi {
      totalEnrolledDevices(type: $deviceType, hours: $hours)
    }
  }
`

/**
 * __useEnrolledDevicesKpiQuery__
 *
 * To run a query within a React component, call `useEnrolledDevicesKpiQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnrolledDevicesKpiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrolledDevicesKpiQuery({
 *   variables: {
 *      deviceType: // value for 'deviceType'
 *      hours: // value for 'hours'
 *   },
 * });
 */
export function useEnrolledDevicesKpiQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.EnrolledDevicesKpiQuery,
    Types.EnrolledDevicesKpiQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.EnrolledDevicesKpiQuery,
    Types.EnrolledDevicesKpiQueryVariables
  >(EnrolledDevicesKpiDocument, options)
}
export function useEnrolledDevicesKpiLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.EnrolledDevicesKpiQuery,
    Types.EnrolledDevicesKpiQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.EnrolledDevicesKpiQuery,
    Types.EnrolledDevicesKpiQueryVariables
  >(EnrolledDevicesKpiDocument, options)
}
export type EnrolledDevicesKpiQueryHookResult = ReturnType<
  typeof useEnrolledDevicesKpiQuery
>
export type EnrolledDevicesKpiLazyQueryHookResult = ReturnType<
  typeof useEnrolledDevicesKpiLazyQuery
>
export type EnrolledDevicesKpiQueryResult = Apollo.QueryResult<
  Types.EnrolledDevicesKpiQuery,
  Types.EnrolledDevicesKpiQueryVariables
>
export const IncidentResolutionRateKpiDocument = gql`
  query IncidentResolutionRateKPI($hours: Int!) {
    kpi {
      incidentResolutionRate(hours: $hours)
    }
  }
`

/**
 * __useIncidentResolutionRateKpiQuery__
 *
 * To run a query within a React component, call `useIncidentResolutionRateKpiQuery` and pass it any options that fit your needs.
 * When your component renders, `useIncidentResolutionRateKpiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIncidentResolutionRateKpiQuery({
 *   variables: {
 *      hours: // value for 'hours'
 *   },
 * });
 */
export function useIncidentResolutionRateKpiQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.IncidentResolutionRateKpiQuery,
    Types.IncidentResolutionRateKpiQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.IncidentResolutionRateKpiQuery,
    Types.IncidentResolutionRateKpiQueryVariables
  >(IncidentResolutionRateKpiDocument, options)
}
export function useIncidentResolutionRateKpiLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.IncidentResolutionRateKpiQuery,
    Types.IncidentResolutionRateKpiQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.IncidentResolutionRateKpiQuery,
    Types.IncidentResolutionRateKpiQueryVariables
  >(IncidentResolutionRateKpiDocument, options)
}
export type IncidentResolutionRateKpiQueryHookResult = ReturnType<
  typeof useIncidentResolutionRateKpiQuery
>
export type IncidentResolutionRateKpiLazyQueryHookResult = ReturnType<
  typeof useIncidentResolutionRateKpiLazyQuery
>
export type IncidentResolutionRateKpiQueryResult = Apollo.QueryResult<
  Types.IncidentResolutionRateKpiQuery,
  Types.IncidentResolutionRateKpiQueryVariables
>
export const MedianOperatorTimeToAcknowledgeDocument = gql`
  query MedianOperatorTimeToAcknowledge($owners: [ID!], $hours: Int!) {
    kpi {
      medianOperatorTimeToAcknowledge(owners: $owners, hours: $hours) {
        current
        past
      }
    }
  }
`

/**
 * __useMedianOperatorTimeToAcknowledgeQuery__
 *
 * To run a query within a React component, call `useMedianOperatorTimeToAcknowledgeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedianOperatorTimeToAcknowledgeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedianOperatorTimeToAcknowledgeQuery({
 *   variables: {
 *      owners: // value for 'owners'
 *      hours: // value for 'hours'
 *   },
 * });
 */
export function useMedianOperatorTimeToAcknowledgeQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.MedianOperatorTimeToAcknowledgeQuery,
    Types.MedianOperatorTimeToAcknowledgeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.MedianOperatorTimeToAcknowledgeQuery,
    Types.MedianOperatorTimeToAcknowledgeQueryVariables
  >(MedianOperatorTimeToAcknowledgeDocument, options)
}
export function useMedianOperatorTimeToAcknowledgeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.MedianOperatorTimeToAcknowledgeQuery,
    Types.MedianOperatorTimeToAcknowledgeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.MedianOperatorTimeToAcknowledgeQuery,
    Types.MedianOperatorTimeToAcknowledgeQueryVariables
  >(MedianOperatorTimeToAcknowledgeDocument, options)
}
export type MedianOperatorTimeToAcknowledgeQueryHookResult = ReturnType<
  typeof useMedianOperatorTimeToAcknowledgeQuery
>
export type MedianOperatorTimeToAcknowledgeLazyQueryHookResult = ReturnType<
  typeof useMedianOperatorTimeToAcknowledgeLazyQuery
>
export type MedianOperatorTimeToAcknowledgeQueryResult = Apollo.QueryResult<
  Types.MedianOperatorTimeToAcknowledgeQuery,
  Types.MedianOperatorTimeToAcknowledgeQueryVariables
>
export const MedianOperatorTimeToResolveDocument = gql`
  query MedianOperatorTimeToResolve($owners: [ID!], $hours: Int!) {
    kpi {
      medianOperatorTimeToResolve(owners: $owners, hours: $hours) {
        current
        past
      }
    }
  }
`

/**
 * __useMedianOperatorTimeToResolveQuery__
 *
 * To run a query within a React component, call `useMedianOperatorTimeToResolveQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedianOperatorTimeToResolveQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedianOperatorTimeToResolveQuery({
 *   variables: {
 *      owners: // value for 'owners'
 *      hours: // value for 'hours'
 *   },
 * });
 */
export function useMedianOperatorTimeToResolveQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.MedianOperatorTimeToResolveQuery,
    Types.MedianOperatorTimeToResolveQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.MedianOperatorTimeToResolveQuery,
    Types.MedianOperatorTimeToResolveQueryVariables
  >(MedianOperatorTimeToResolveDocument, options)
}
export function useMedianOperatorTimeToResolveLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.MedianOperatorTimeToResolveQuery,
    Types.MedianOperatorTimeToResolveQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.MedianOperatorTimeToResolveQuery,
    Types.MedianOperatorTimeToResolveQueryVariables
  >(MedianOperatorTimeToResolveDocument, options)
}
export type MedianOperatorTimeToResolveQueryHookResult = ReturnType<
  typeof useMedianOperatorTimeToResolveQuery
>
export type MedianOperatorTimeToResolveLazyQueryHookResult = ReturnType<
  typeof useMedianOperatorTimeToResolveLazyQuery
>
export type MedianOperatorTimeToResolveQueryResult = Apollo.QueryResult<
  Types.MedianOperatorTimeToResolveQuery,
  Types.MedianOperatorTimeToResolveQueryVariables
>
export const OutstandingIncidentsDocument = gql`
  query OutstandingIncidents(
    $pastHour: String!
    $first: Int
    $last: Int
    $facilityIdIn: [ID!]
    $typeIn: [IncidentType!]
    $incidentTypeDefinitionIdIn: [ID!]
    $guardIdIn: [ID!]
    $ownerIdIn: [ID!]
    $deviceTypesContain: DeviceType
    $orderBy: [IncidentOrderInput]
  ) {
    outstandingIncidents(
      filter: {
        statusNotIn: RESOLVED
        actionTypeIn: [ACKNOWLEDGEMENT_BY_GUARD, ACKNOWLEDGEMENT_BY_OPERATOR]
        actionUpdatedAtLte: $pastHour
        facilityIdIn: $facilityIdIn
        typeIn: $typeIn
        incidentTypeDefinitionIdIn: $incidentTypeDefinitionIdIn
        guardIdIn: $guardIdIn
        ownerIdIn: $ownerIdIn
        deviceTypesContain: $deviceTypesContain
      }
      first: $first
      last: $last
      orderBy: $orderBy
    ) {
      totalCount
      edges {
        node {
          id
          createdAt
          updatedAt
          name
          status
          real
          description
          type
          manualIncidentCategoryId
          incidentType {
            manual
            slug
          }
          createdAt
          displayId
          guard {
            id
            firstName
            lastName
            avatar {
              ... on UrlContent {
                minExpiryTime
                url
              }
            }
          }
          owner {
            id
            firstName
            lastName
            avatar {
              ... on UrlContent {
                minExpiryTime
                url
              }
            }
          }
          devices {
            id
            name
            type
            facility {
              id
              name
              shortName
            }
            floor {
              id
              name
            }
          }
          facility {
            id
            name
            shortName
          }
          floor {
            id
            name
          }
          actions {
            type
            createdAt
          }
        }
      }
    }
  }
`

/**
 * __useOutstandingIncidentsQuery__
 *
 * To run a query within a React component, call `useOutstandingIncidentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOutstandingIncidentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOutstandingIncidentsQuery({
 *   variables: {
 *      pastHour: // value for 'pastHour'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      facilityIdIn: // value for 'facilityIdIn'
 *      typeIn: // value for 'typeIn'
 *      incidentTypeDefinitionIdIn: // value for 'incidentTypeDefinitionIdIn'
 *      guardIdIn: // value for 'guardIdIn'
 *      ownerIdIn: // value for 'ownerIdIn'
 *      deviceTypesContain: // value for 'deviceTypesContain'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useOutstandingIncidentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.OutstandingIncidentsQuery,
    Types.OutstandingIncidentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.OutstandingIncidentsQuery,
    Types.OutstandingIncidentsQueryVariables
  >(OutstandingIncidentsDocument, options)
}
export function useOutstandingIncidentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.OutstandingIncidentsQuery,
    Types.OutstandingIncidentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.OutstandingIncidentsQuery,
    Types.OutstandingIncidentsQueryVariables
  >(OutstandingIncidentsDocument, options)
}
export type OutstandingIncidentsQueryHookResult = ReturnType<
  typeof useOutstandingIncidentsQuery
>
export type OutstandingIncidentsLazyQueryHookResult = ReturnType<
  typeof useOutstandingIncidentsLazyQuery
>
export type OutstandingIncidentsQueryResult = Apollo.QueryResult<
  Types.OutstandingIncidentsQuery,
  Types.OutstandingIncidentsQueryVariables
>
export const OutstandingIncidentsGuardsDocument = gql`
  query OutstandingIncidentsGuards {
    guards: users(filter: { roleName: "GUARD" }) {
      edges {
        node {
          id
          firstName
          lastName
        }
      }
    }
  }
`

/**
 * __useOutstandingIncidentsGuardsQuery__
 *
 * To run a query within a React component, call `useOutstandingIncidentsGuardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOutstandingIncidentsGuardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOutstandingIncidentsGuardsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOutstandingIncidentsGuardsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.OutstandingIncidentsGuardsQuery,
    Types.OutstandingIncidentsGuardsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.OutstandingIncidentsGuardsQuery,
    Types.OutstandingIncidentsGuardsQueryVariables
  >(OutstandingIncidentsGuardsDocument, options)
}
export function useOutstandingIncidentsGuardsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.OutstandingIncidentsGuardsQuery,
    Types.OutstandingIncidentsGuardsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.OutstandingIncidentsGuardsQuery,
    Types.OutstandingIncidentsGuardsQueryVariables
  >(OutstandingIncidentsGuardsDocument, options)
}
export type OutstandingIncidentsGuardsQueryHookResult = ReturnType<
  typeof useOutstandingIncidentsGuardsQuery
>
export type OutstandingIncidentsGuardsLazyQueryHookResult = ReturnType<
  typeof useOutstandingIncidentsGuardsLazyQuery
>
export type OutstandingIncidentsGuardsQueryResult = Apollo.QueryResult<
  Types.OutstandingIncidentsGuardsQuery,
  Types.OutstandingIncidentsGuardsQueryVariables
>
export const OutstandingIncidentsOperatorsDocument = gql`
  query OutstandingIncidentsOperators {
    operators: users(filter: { roleName: "OPERATOR" }) {
      edges {
        node {
          id
          firstName
          lastName
        }
      }
    }
  }
`

/**
 * __useOutstandingIncidentsOperatorsQuery__
 *
 * To run a query within a React component, call `useOutstandingIncidentsOperatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOutstandingIncidentsOperatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOutstandingIncidentsOperatorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOutstandingIncidentsOperatorsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.OutstandingIncidentsOperatorsQuery,
    Types.OutstandingIncidentsOperatorsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.OutstandingIncidentsOperatorsQuery,
    Types.OutstandingIncidentsOperatorsQueryVariables
  >(OutstandingIncidentsOperatorsDocument, options)
}
export function useOutstandingIncidentsOperatorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.OutstandingIncidentsOperatorsQuery,
    Types.OutstandingIncidentsOperatorsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.OutstandingIncidentsOperatorsQuery,
    Types.OutstandingIncidentsOperatorsQueryVariables
  >(OutstandingIncidentsOperatorsDocument, options)
}
export type OutstandingIncidentsOperatorsQueryHookResult = ReturnType<
  typeof useOutstandingIncidentsOperatorsQuery
>
export type OutstandingIncidentsOperatorsLazyQueryHookResult = ReturnType<
  typeof useOutstandingIncidentsOperatorsLazyQuery
>
export type OutstandingIncidentsOperatorsQueryResult = Apollo.QueryResult<
  Types.OutstandingIncidentsOperatorsQuery,
  Types.OutstandingIncidentsOperatorsQueryVariables
>
export const OutstandingIncidentsTotalCountDocument = gql`
  query OutstandingIncidentsTotalCount($pastHour: String!) {
    outstandingIncidents(
      filter: {
        statusNotIn: RESOLVED
        actionTypeIn: [ACKNOWLEDGEMENT_BY_GUARD, ACKNOWLEDGEMENT_BY_OPERATOR]
        actionUpdatedAtLte: $pastHour
      }
    ) {
      totalCount
    }
  }
`

/**
 * __useOutstandingIncidentsTotalCountQuery__
 *
 * To run a query within a React component, call `useOutstandingIncidentsTotalCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useOutstandingIncidentsTotalCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOutstandingIncidentsTotalCountQuery({
 *   variables: {
 *      pastHour: // value for 'pastHour'
 *   },
 * });
 */
export function useOutstandingIncidentsTotalCountQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.OutstandingIncidentsTotalCountQuery,
    Types.OutstandingIncidentsTotalCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.OutstandingIncidentsTotalCountQuery,
    Types.OutstandingIncidentsTotalCountQueryVariables
  >(OutstandingIncidentsTotalCountDocument, options)
}
export function useOutstandingIncidentsTotalCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.OutstandingIncidentsTotalCountQuery,
    Types.OutstandingIncidentsTotalCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.OutstandingIncidentsTotalCountQuery,
    Types.OutstandingIncidentsTotalCountQueryVariables
  >(OutstandingIncidentsTotalCountDocument, options)
}
export type OutstandingIncidentsTotalCountQueryHookResult = ReturnType<
  typeof useOutstandingIncidentsTotalCountQuery
>
export type OutstandingIncidentsTotalCountLazyQueryHookResult = ReturnType<
  typeof useOutstandingIncidentsTotalCountLazyQuery
>
export type OutstandingIncidentsTotalCountQueryResult = Apollo.QueryResult<
  Types.OutstandingIncidentsTotalCountQuery,
  Types.OutstandingIncidentsTotalCountQueryVariables
>
export const TotalActiveIncidentsKpiDocument = gql`
  query TotalActiveIncidentsKPI($hours: Int!) {
    kpi {
      totalActiveIncidents(hours: $hours) {
        past
        current
      }
    }
  }
`

/**
 * __useTotalActiveIncidentsKpiQuery__
 *
 * To run a query within a React component, call `useTotalActiveIncidentsKpiQuery` and pass it any options that fit your needs.
 * When your component renders, `useTotalActiveIncidentsKpiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTotalActiveIncidentsKpiQuery({
 *   variables: {
 *      hours: // value for 'hours'
 *   },
 * });
 */
export function useTotalActiveIncidentsKpiQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.TotalActiveIncidentsKpiQuery,
    Types.TotalActiveIncidentsKpiQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.TotalActiveIncidentsKpiQuery,
    Types.TotalActiveIncidentsKpiQueryVariables
  >(TotalActiveIncidentsKpiDocument, options)
}
export function useTotalActiveIncidentsKpiLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.TotalActiveIncidentsKpiQuery,
    Types.TotalActiveIncidentsKpiQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.TotalActiveIncidentsKpiQuery,
    Types.TotalActiveIncidentsKpiQueryVariables
  >(TotalActiveIncidentsKpiDocument, options)
}
export type TotalActiveIncidentsKpiQueryHookResult = ReturnType<
  typeof useTotalActiveIncidentsKpiQuery
>
export type TotalActiveIncidentsKpiLazyQueryHookResult = ReturnType<
  typeof useTotalActiveIncidentsKpiLazyQuery
>
export type TotalActiveIncidentsKpiQueryResult = Apollo.QueryResult<
  Types.TotalActiveIncidentsKpiQuery,
  Types.TotalActiveIncidentsKpiQueryVariables
>
export const TotalIncidentsKpiDocument = gql`
  query TotalIncidentsKPI($hours: Int!) {
    kpi {
      totalIncidents(hours: $hours) {
        current
        past
      }
    }
  }
`

/**
 * __useTotalIncidentsKpiQuery__
 *
 * To run a query within a React component, call `useTotalIncidentsKpiQuery` and pass it any options that fit your needs.
 * When your component renders, `useTotalIncidentsKpiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTotalIncidentsKpiQuery({
 *   variables: {
 *      hours: // value for 'hours'
 *   },
 * });
 */
export function useTotalIncidentsKpiQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.TotalIncidentsKpiQuery,
    Types.TotalIncidentsKpiQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.TotalIncidentsKpiQuery,
    Types.TotalIncidentsKpiQueryVariables
  >(TotalIncidentsKpiDocument, options)
}
export function useTotalIncidentsKpiLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.TotalIncidentsKpiQuery,
    Types.TotalIncidentsKpiQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.TotalIncidentsKpiQuery,
    Types.TotalIncidentsKpiQueryVariables
  >(TotalIncidentsKpiDocument, options)
}
export type TotalIncidentsKpiQueryHookResult = ReturnType<
  typeof useTotalIncidentsKpiQuery
>
export type TotalIncidentsKpiLazyQueryHookResult = ReturnType<
  typeof useTotalIncidentsKpiLazyQuery
>
export type TotalIncidentsKpiQueryResult = Apollo.QueryResult<
  Types.TotalIncidentsKpiQuery,
  Types.TotalIncidentsKpiQueryVariables
>
export const TotalIncidentsCountByFacilityDocument = gql`
  query TotalIncidentsCountByFacility($hours: Int!) {
    kpi {
      countIncidentsByFacility(hours: $hours) {
        count
        label
      }
    }
  }
`

/**
 * __useTotalIncidentsCountByFacilityQuery__
 *
 * To run a query within a React component, call `useTotalIncidentsCountByFacilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useTotalIncidentsCountByFacilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTotalIncidentsCountByFacilityQuery({
 *   variables: {
 *      hours: // value for 'hours'
 *   },
 * });
 */
export function useTotalIncidentsCountByFacilityQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.TotalIncidentsCountByFacilityQuery,
    Types.TotalIncidentsCountByFacilityQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.TotalIncidentsCountByFacilityQuery,
    Types.TotalIncidentsCountByFacilityQueryVariables
  >(TotalIncidentsCountByFacilityDocument, options)
}
export function useTotalIncidentsCountByFacilityLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.TotalIncidentsCountByFacilityQuery,
    Types.TotalIncidentsCountByFacilityQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.TotalIncidentsCountByFacilityQuery,
    Types.TotalIncidentsCountByFacilityQueryVariables
  >(TotalIncidentsCountByFacilityDocument, options)
}
export type TotalIncidentsCountByFacilityQueryHookResult = ReturnType<
  typeof useTotalIncidentsCountByFacilityQuery
>
export type TotalIncidentsCountByFacilityLazyQueryHookResult = ReturnType<
  typeof useTotalIncidentsCountByFacilityLazyQuery
>
export type TotalIncidentsCountByFacilityQueryResult = Apollo.QueryResult<
  Types.TotalIncidentsCountByFacilityQuery,
  Types.TotalIncidentsCountByFacilityQueryVariables
>
export const DefaultAiOperatorModelDocument = gql`
  query DefaultAiOperatorModel {
    defaultAiOperatorModel {
      aiOperatorModel {
        id
        canonicalName
        provider
      }
    }
  }
`

/**
 * __useDefaultAiOperatorModelQuery__
 *
 * To run a query within a React component, call `useDefaultAiOperatorModelQuery` and pass it any options that fit your needs.
 * When your component renders, `useDefaultAiOperatorModelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDefaultAiOperatorModelQuery({
 *   variables: {
 *   },
 * });
 */
export function useDefaultAiOperatorModelQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.DefaultAiOperatorModelQuery,
    Types.DefaultAiOperatorModelQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.DefaultAiOperatorModelQuery,
    Types.DefaultAiOperatorModelQueryVariables
  >(DefaultAiOperatorModelDocument, options)
}
export function useDefaultAiOperatorModelLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.DefaultAiOperatorModelQuery,
    Types.DefaultAiOperatorModelQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.DefaultAiOperatorModelQuery,
    Types.DefaultAiOperatorModelQueryVariables
  >(DefaultAiOperatorModelDocument, options)
}
export type DefaultAiOperatorModelQueryHookResult = ReturnType<
  typeof useDefaultAiOperatorModelQuery
>
export type DefaultAiOperatorModelLazyQueryHookResult = ReturnType<
  typeof useDefaultAiOperatorModelLazyQuery
>
export type DefaultAiOperatorModelQueryResult = Apollo.QueryResult<
  Types.DefaultAiOperatorModelQuery,
  Types.DefaultAiOperatorModelQueryVariables
>
export const DeviceDocument = gql`
  query Device($id: ID!) {
    device(id: $id) {
      id
      name
      status
      type
      modelName
      manufacturerName
      macAddress
      floor {
        id
        name
      }
      facility {
        id
        name
        shortName
        longitude
        latitude
        address
      }
      thumbnail {
        ... on UrlContent {
          url
        }
      }
      camera {
        streamingType
      }
      tailgateConns {
        edges {
          node {
            id
            cameras {
              edges {
                node {
                  id
                }
              }
            }
          }
        }
      }
      tags {
        edges {
          node {
            id
            name
            enabled
            archived
          }
        }
      }
    }
  }
`

/**
 * __useDeviceQuery__
 *
 * To run a query within a React component, call `useDeviceQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeviceQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.DeviceQuery,
    Types.DeviceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<Types.DeviceQuery, Types.DeviceQueryVariables>(
    DeviceDocument,
    options
  )
}
export function useDeviceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.DeviceQuery,
    Types.DeviceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<Types.DeviceQuery, Types.DeviceQueryVariables>(
    DeviceDocument,
    options
  )
}
export type DeviceQueryHookResult = ReturnType<typeof useDeviceQuery>
export type DeviceLazyQueryHookResult = ReturnType<typeof useDeviceLazyQuery>
export type DeviceQueryResult = Apollo.QueryResult<
  Types.DeviceQuery,
  Types.DeviceQueryVariables
>
export const DeviceAssocationOptionsDocument = gql`
  query DeviceAssocationOptions($filter: DeviceFilterInput, $id: ID!) {
    devices(filter: $filter) {
      totalCount
      edges {
        node {
          id
          name
          type
          isPlaced
          tailgateConns {
            edges {
              node {
                id
                door {
                  id
                  name
                  type
                }
                cameras {
                  edges {
                    node {
                      id
                      name
                      type
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    device(id: $id) {
      id
      name
      tailgateConns {
        edges {
          node {
            id
            door {
              id
              name
              type
            }
            cameras {
              edges {
                node {
                  id
                  name
                  type
                }
              }
            }
          }
        }
      }
    }
  }
`

/**
 * __useDeviceAssocationOptionsQuery__
 *
 * To run a query within a React component, call `useDeviceAssocationOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceAssocationOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceAssocationOptionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeviceAssocationOptionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.DeviceAssocationOptionsQuery,
    Types.DeviceAssocationOptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.DeviceAssocationOptionsQuery,
    Types.DeviceAssocationOptionsQueryVariables
  >(DeviceAssocationOptionsDocument, options)
}
export function useDeviceAssocationOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.DeviceAssocationOptionsQuery,
    Types.DeviceAssocationOptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.DeviceAssocationOptionsQuery,
    Types.DeviceAssocationOptionsQueryVariables
  >(DeviceAssocationOptionsDocument, options)
}
export type DeviceAssocationOptionsQueryHookResult = ReturnType<
  typeof useDeviceAssocationOptionsQuery
>
export type DeviceAssocationOptionsLazyQueryHookResult = ReturnType<
  typeof useDeviceAssocationOptionsLazyQuery
>
export type DeviceAssocationOptionsQueryResult = Apollo.QueryResult<
  Types.DeviceAssocationOptionsQuery,
  Types.DeviceAssocationOptionsQueryVariables
>
export const DeviceAssociationCountsDocument = gql`
  query DeviceAssociationCounts($filter: DeviceFilterInput) {
    devices(filter: $filter) {
      edges {
        node {
          id
          tailgateConns {
            totalCount
          }
        }
      }
    }
  }
`

/**
 * __useDeviceAssociationCountsQuery__
 *
 * To run a query within a React component, call `useDeviceAssociationCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceAssociationCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceAssociationCountsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeviceAssociationCountsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.DeviceAssociationCountsQuery,
    Types.DeviceAssociationCountsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.DeviceAssociationCountsQuery,
    Types.DeviceAssociationCountsQueryVariables
  >(DeviceAssociationCountsDocument, options)
}
export function useDeviceAssociationCountsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.DeviceAssociationCountsQuery,
    Types.DeviceAssociationCountsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.DeviceAssociationCountsQuery,
    Types.DeviceAssociationCountsQueryVariables
  >(DeviceAssociationCountsDocument, options)
}
export type DeviceAssociationCountsQueryHookResult = ReturnType<
  typeof useDeviceAssociationCountsQuery
>
export type DeviceAssociationCountsLazyQueryHookResult = ReturnType<
  typeof useDeviceAssociationCountsLazyQuery
>
export type DeviceAssociationCountsQueryResult = Apollo.QueryResult<
  Types.DeviceAssociationCountsQuery,
  Types.DeviceAssociationCountsQueryVariables
>
export const DeviceCameraEditDocument = gql`
  query DeviceCameraEdit($id: ID!) {
    device(id: $id) {
      id
      type
      name
      macAddress
      modelName
      manufacturerName
      x
      y
      floor {
        id
        name
      }
      camera {
        id
        externalId
        rtspIp
        rtspPort
        rtspPath
        rtspUsername
        rtspPassword
        streamingProtocol
        streamingType
        customerSecretProvider {
          secretArn
          node {
            id
            providerName
          }
        }
        externalAccount {
          id
          accountId
        }
        requiresAuthentication
      }
    }
  }
`

/**
 * __useDeviceCameraEditQuery__
 *
 * To run a query within a React component, call `useDeviceCameraEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceCameraEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceCameraEditQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeviceCameraEditQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.DeviceCameraEditQuery,
    Types.DeviceCameraEditQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.DeviceCameraEditQuery,
    Types.DeviceCameraEditQueryVariables
  >(DeviceCameraEditDocument, options)
}
export function useDeviceCameraEditLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.DeviceCameraEditQuery,
    Types.DeviceCameraEditQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.DeviceCameraEditQuery,
    Types.DeviceCameraEditQueryVariables
  >(DeviceCameraEditDocument, options)
}
export type DeviceCameraEditQueryHookResult = ReturnType<
  typeof useDeviceCameraEditQuery
>
export type DeviceCameraEditLazyQueryHookResult = ReturnType<
  typeof useDeviceCameraEditLazyQuery
>
export type DeviceCameraEditQueryResult = Apollo.QueryResult<
  Types.DeviceCameraEditQuery,
  Types.DeviceCameraEditQueryVariables
>
export const DeviceEditDocument = gql`
  query DeviceEdit($id: ID!) {
    device(id: $id) {
      id
      type
      name
      macAddress
      modelName
      manufacturerName
      x
      y
      floor {
        id
        name
      }
      door {
        id
        externalId
      }
      camera {
        id
        externalId
      }
      alarm {
        id
        externalId
        alarmType {
          id
        }
      }
    }
  }
`

/**
 * __useDeviceEditQuery__
 *
 * To run a query within a React component, call `useDeviceEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceEditQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeviceEditQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.DeviceEditQuery,
    Types.DeviceEditQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<Types.DeviceEditQuery, Types.DeviceEditQueryVariables>(
    DeviceEditDocument,
    options
  )
}
export function useDeviceEditLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.DeviceEditQuery,
    Types.DeviceEditQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.DeviceEditQuery,
    Types.DeviceEditQueryVariables
  >(DeviceEditDocument, options)
}
export type DeviceEditQueryHookResult = ReturnType<typeof useDeviceEditQuery>
export type DeviceEditLazyQueryHookResult = ReturnType<
  typeof useDeviceEditLazyQuery
>
export type DeviceEditQueryResult = Apollo.QueryResult<
  Types.DeviceEditQuery,
  Types.DeviceEditQueryVariables
>
export const DeviceFeedDetailsDocument = gql`
  query DeviceFeedDetails($id: ID!) {
    device(id: $id) {
      id
      type
      camera {
        streamingType
      }
      tailgateConns {
        edges {
          node {
            id
            cameras {
              edges {
                node {
                  id
                }
              }
            }
          }
        }
      }
    }
  }
`

/**
 * __useDeviceFeedDetailsQuery__
 *
 * To run a query within a React component, call `useDeviceFeedDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceFeedDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceFeedDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeviceFeedDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.DeviceFeedDetailsQuery,
    Types.DeviceFeedDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.DeviceFeedDetailsQuery,
    Types.DeviceFeedDetailsQueryVariables
  >(DeviceFeedDetailsDocument, options)
}
export function useDeviceFeedDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.DeviceFeedDetailsQuery,
    Types.DeviceFeedDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.DeviceFeedDetailsQuery,
    Types.DeviceFeedDetailsQueryVariables
  >(DeviceFeedDetailsDocument, options)
}
export type DeviceFeedDetailsQueryHookResult = ReturnType<
  typeof useDeviceFeedDetailsQuery
>
export type DeviceFeedDetailsLazyQueryHookResult = ReturnType<
  typeof useDeviceFeedDetailsLazyQuery
>
export type DeviceFeedDetailsQueryResult = Apollo.QueryResult<
  Types.DeviceFeedDetailsQuery,
  Types.DeviceFeedDetailsQueryVariables
>
export const DeviceIncidentsDocument = gql`
  query DeviceIncidents($filter: IncidentFilterInput) {
    incidents(
      filter: $filter
      last: 100
      orderBy: [{ direction: DESC, field: CREATED_AT }]
    ) {
      edges {
        node {
          id
          createdAt
          status
          name
          description
          priority
          displayId
          facility {
            name
          }
        }
      }
    }
  }
`

/**
 * __useDeviceIncidentsQuery__
 *
 * To run a query within a React component, call `useDeviceIncidentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceIncidentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceIncidentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeviceIncidentsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.DeviceIncidentsQuery,
    Types.DeviceIncidentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.DeviceIncidentsQuery,
    Types.DeviceIncidentsQueryVariables
  >(DeviceIncidentsDocument, options)
}
export function useDeviceIncidentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.DeviceIncidentsQuery,
    Types.DeviceIncidentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.DeviceIncidentsQuery,
    Types.DeviceIncidentsQueryVariables
  >(DeviceIncidentsDocument, options)
}
export type DeviceIncidentsQueryHookResult = ReturnType<
  typeof useDeviceIncidentsQuery
>
export type DeviceIncidentsLazyQueryHookResult = ReturnType<
  typeof useDeviceIncidentsLazyQuery
>
export type DeviceIncidentsQueryResult = Apollo.QueryResult<
  Types.DeviceIncidentsQuery,
  Types.DeviceIncidentsQueryVariables
>
export const DeviceLogItemsDocument = gql`
  query DeviceLogItems($deviceId: ID!) {
    deviceLogItems(
      deviceId: $deviceId
      orderBy: [{ field: CREATED_AT, direction: DESC }]
    ) {
      edges {
        node {
          id
          type
          message
          createdAt
          user {
            firstName
            lastName
            roleName
          }
          ... on DeviceConfigurationHistory {
            title
          }
        }
      }
    }
  }
`

/**
 * __useDeviceLogItemsQuery__
 *
 * To run a query within a React component, call `useDeviceLogItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceLogItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceLogItemsQuery({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *   },
 * });
 */
export function useDeviceLogItemsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.DeviceLogItemsQuery,
    Types.DeviceLogItemsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.DeviceLogItemsQuery,
    Types.DeviceLogItemsQueryVariables
  >(DeviceLogItemsDocument, options)
}
export function useDeviceLogItemsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.DeviceLogItemsQuery,
    Types.DeviceLogItemsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.DeviceLogItemsQuery,
    Types.DeviceLogItemsQueryVariables
  >(DeviceLogItemsDocument, options)
}
export type DeviceLogItemsQueryHookResult = ReturnType<
  typeof useDeviceLogItemsQuery
>
export type DeviceLogItemsLazyQueryHookResult = ReturnType<
  typeof useDeviceLogItemsLazyQuery
>
export type DeviceLogItemsQueryResult = Apollo.QueryResult<
  Types.DeviceLogItemsQuery,
  Types.DeviceLogItemsQueryVariables
>
export const DeviceMetaDataDocument = gql`
  query DeviceMetaData($id: ID!) {
    device(id: $id) {
      type
      createdAt
      updatedAt
      isPlaced
      camera {
        streamingResolutionWidth
        streamingResolutionHeight
        createdAt
        updatedAt
      }
      door {
        externalId
        createdAt
        updatedAt
      }
      edgeDevice {
        id
        name
      }
      tailgateConns {
        edges {
          node {
            id
            cameras {
              edges {
                node {
                  id
                  name
                }
              }
            }
            door {
              id
              name
            }
            createdAt
            updatedAt
          }
        }
      }
    }
  }
`

/**
 * __useDeviceMetaDataQuery__
 *
 * To run a query within a React component, call `useDeviceMetaDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceMetaDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceMetaDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeviceMetaDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.DeviceMetaDataQuery,
    Types.DeviceMetaDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.DeviceMetaDataQuery,
    Types.DeviceMetaDataQueryVariables
  >(DeviceMetaDataDocument, options)
}
export function useDeviceMetaDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.DeviceMetaDataQuery,
    Types.DeviceMetaDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.DeviceMetaDataQuery,
    Types.DeviceMetaDataQueryVariables
  >(DeviceMetaDataDocument, options)
}
export type DeviceMetaDataQueryHookResult = ReturnType<
  typeof useDeviceMetaDataQuery
>
export type DeviceMetaDataLazyQueryHookResult = ReturnType<
  typeof useDeviceMetaDataLazyQuery
>
export type DeviceMetaDataQueryResult = Apollo.QueryResult<
  Types.DeviceMetaDataQuery,
  Types.DeviceMetaDataQueryVariables
>
export const DevicePopoverDetailsDocument = gql`
  query DevicePopoverDetails($id: ID!) {
    device(id: $id) {
      id
      status
      floor {
        id
        name
      }
      camera {
        streamingType
      }
      facility {
        id
        address
      }
    }
  }
`

/**
 * __useDevicePopoverDetailsQuery__
 *
 * To run a query within a React component, call `useDevicePopoverDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevicePopoverDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevicePopoverDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDevicePopoverDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.DevicePopoverDetailsQuery,
    Types.DevicePopoverDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.DevicePopoverDetailsQuery,
    Types.DevicePopoverDetailsQueryVariables
  >(DevicePopoverDetailsDocument, options)
}
export function useDevicePopoverDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.DevicePopoverDetailsQuery,
    Types.DevicePopoverDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.DevicePopoverDetailsQuery,
    Types.DevicePopoverDetailsQueryVariables
  >(DevicePopoverDetailsDocument, options)
}
export type DevicePopoverDetailsQueryHookResult = ReturnType<
  typeof useDevicePopoverDetailsQuery
>
export type DevicePopoverDetailsLazyQueryHookResult = ReturnType<
  typeof useDevicePopoverDetailsLazyQuery
>
export type DevicePopoverDetailsQueryResult = Apollo.QueryResult<
  Types.DevicePopoverDetailsQuery,
  Types.DevicePopoverDetailsQueryVariables
>
export const DevicesDocument = gql`
  query Devices(
    $filter: DeviceFilterInput
    $first: Int
    $last: Int
    $orderBy: [DeviceOrderInput]
  ) {
    devices(filter: $filter, first: $first, last: $last, orderBy: $orderBy) {
      totalCount
      edges {
        node {
          id
          name
          status
          type
          floor {
            id
            name
          }
          facility {
            id
            name
            shortName
          }
          incidents(filter: { statusIn: [IN_PROGRESS, ACTIVE] }) {
            totalCount
          }
          tags {
            edges {
              node {
                id
                name
                enabled
                archived
              }
            }
          }
        }
      }
    }
  }
`

/**
 * __useDevicesQuery__
 *
 * To run a query within a React component, call `useDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevicesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useDevicesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.DevicesQuery,
    Types.DevicesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<Types.DevicesQuery, Types.DevicesQueryVariables>(
    DevicesDocument,
    options
  )
}
export function useDevicesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.DevicesQuery,
    Types.DevicesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<Types.DevicesQuery, Types.DevicesQueryVariables>(
    DevicesDocument,
    options
  )
}
export type DevicesQueryHookResult = ReturnType<typeof useDevicesQuery>
export type DevicesLazyQueryHookResult = ReturnType<typeof useDevicesLazyQuery>
export type DevicesQueryResult = Apollo.QueryResult<
  Types.DevicesQuery,
  Types.DevicesQueryVariables
>
export const DevicesAlarmDocument = gql`
  query DevicesAlarm($filter: DeviceFilterInput) {
    devices(filter: $filter) {
      edges {
        node {
          id
          name
          facility {
            id
            name
          }
        }
      }
    }
  }
`

/**
 * __useDevicesAlarmQuery__
 *
 * To run a query within a React component, call `useDevicesAlarmQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevicesAlarmQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevicesAlarmQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDevicesAlarmQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.DevicesAlarmQuery,
    Types.DevicesAlarmQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.DevicesAlarmQuery,
    Types.DevicesAlarmQueryVariables
  >(DevicesAlarmDocument, options)
}
export function useDevicesAlarmLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.DevicesAlarmQuery,
    Types.DevicesAlarmQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.DevicesAlarmQuery,
    Types.DevicesAlarmQueryVariables
  >(DevicesAlarmDocument, options)
}
export type DevicesAlarmQueryHookResult = ReturnType<
  typeof useDevicesAlarmQuery
>
export type DevicesAlarmLazyQueryHookResult = ReturnType<
  typeof useDevicesAlarmLazyQuery
>
export type DevicesAlarmQueryResult = Apollo.QueryResult<
  Types.DevicesAlarmQuery,
  Types.DevicesAlarmQueryVariables
>
export const DevicesCameraDocument = gql`
  query DevicesCamera($filter: DeviceFilterInput) {
    devices(filter: $filter, orderBy: [{ field: NAME, direction: ASC }]) {
      edges {
        node {
          id
          name
          facility {
            id
            name
          }
          camera {
            id
            streamingType
          }
        }
      }
    }
  }
`

/**
 * __useDevicesCameraQuery__
 *
 * To run a query within a React component, call `useDevicesCameraQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevicesCameraQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevicesCameraQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDevicesCameraQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.DevicesCameraQuery,
    Types.DevicesCameraQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.DevicesCameraQuery,
    Types.DevicesCameraQueryVariables
  >(DevicesCameraDocument, options)
}
export function useDevicesCameraLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.DevicesCameraQuery,
    Types.DevicesCameraQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.DevicesCameraQuery,
    Types.DevicesCameraQueryVariables
  >(DevicesCameraDocument, options)
}
export type DevicesCameraQueryHookResult = ReturnType<
  typeof useDevicesCameraQuery
>
export type DevicesCameraLazyQueryHookResult = ReturnType<
  typeof useDevicesCameraLazyQuery
>
export type DevicesCameraQueryResult = Apollo.QueryResult<
  Types.DevicesCameraQuery,
  Types.DevicesCameraQueryVariables
>
export const DevicesDoorDocument = gql`
  query DevicesDoor($filter: DeviceFilterInput) {
    devices(filter: $filter) {
      edges {
        node {
          id
          name
          facility {
            id
            name
          }
        }
      }
    }
  }
`

/**
 * __useDevicesDoorQuery__
 *
 * To run a query within a React component, call `useDevicesDoorQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevicesDoorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevicesDoorQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDevicesDoorQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.DevicesDoorQuery,
    Types.DevicesDoorQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.DevicesDoorQuery,
    Types.DevicesDoorQueryVariables
  >(DevicesDoorDocument, options)
}
export function useDevicesDoorLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.DevicesDoorQuery,
    Types.DevicesDoorQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.DevicesDoorQuery,
    Types.DevicesDoorQueryVariables
  >(DevicesDoorDocument, options)
}
export type DevicesDoorQueryHookResult = ReturnType<typeof useDevicesDoorQuery>
export type DevicesDoorLazyQueryHookResult = ReturnType<
  typeof useDevicesDoorLazyQuery
>
export type DevicesDoorQueryResult = Apollo.QueryResult<
  Types.DevicesDoorQuery,
  Types.DevicesDoorQueryVariables
>
export const DevicesFormOptionsDocument = gql`
  query DevicesFormOptions($filter: DeviceFilterInput) {
    devices(filter: $filter) {
      edges {
        node {
          id
          name
          facility {
            name
          }
        }
      }
    }
  }
`

/**
 * __useDevicesFormOptionsQuery__
 *
 * To run a query within a React component, call `useDevicesFormOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevicesFormOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevicesFormOptionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDevicesFormOptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.DevicesFormOptionsQuery,
    Types.DevicesFormOptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.DevicesFormOptionsQuery,
    Types.DevicesFormOptionsQueryVariables
  >(DevicesFormOptionsDocument, options)
}
export function useDevicesFormOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.DevicesFormOptionsQuery,
    Types.DevicesFormOptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.DevicesFormOptionsQuery,
    Types.DevicesFormOptionsQueryVariables
  >(DevicesFormOptionsDocument, options)
}
export type DevicesFormOptionsQueryHookResult = ReturnType<
  typeof useDevicesFormOptionsQuery
>
export type DevicesFormOptionsLazyQueryHookResult = ReturnType<
  typeof useDevicesFormOptionsLazyQuery
>
export type DevicesFormOptionsQueryResult = Apollo.QueryResult<
  Types.DevicesFormOptionsQuery,
  Types.DevicesFormOptionsQueryVariables
>
export const DevicesUnpairedDocument = gql`
  query DevicesUnpaired {
    devices(filter: { type: CAMERA, hasEdgeDevice: false }) {
      edges {
        node {
          id
          name
          facility {
            id
            name
            shortName
          }
          floor {
            id
            name
          }
        }
      }
    }
  }
`

/**
 * __useDevicesUnpairedQuery__
 *
 * To run a query within a React component, call `useDevicesUnpairedQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevicesUnpairedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevicesUnpairedQuery({
 *   variables: {
 *   },
 * });
 */
export function useDevicesUnpairedQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.DevicesUnpairedQuery,
    Types.DevicesUnpairedQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.DevicesUnpairedQuery,
    Types.DevicesUnpairedQueryVariables
  >(DevicesUnpairedDocument, options)
}
export function useDevicesUnpairedLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.DevicesUnpairedQuery,
    Types.DevicesUnpairedQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.DevicesUnpairedQuery,
    Types.DevicesUnpairedQueryVariables
  >(DevicesUnpairedDocument, options)
}
export type DevicesUnpairedQueryHookResult = ReturnType<
  typeof useDevicesUnpairedQuery
>
export type DevicesUnpairedLazyQueryHookResult = ReturnType<
  typeof useDevicesUnpairedLazyQuery
>
export type DevicesUnpairedQueryResult = Apollo.QueryResult<
  Types.DevicesUnpairedQuery,
  Types.DevicesUnpairedQueryVariables
>
export const DevicesWithFacilitiesDocument = gql`
  query DevicesWithFacilities(
    $filter: DeviceFilterInput
    $first: Int
    $last: Int
    $orderBy: [DeviceOrderInput]
  ) {
    devices(filter: $filter, first: $first, last: $last, orderBy: $orderBy) {
      edges {
        node {
          id
          name
          status
          type
          facility {
            id
            name
            shortName
            archived
          }
        }
      }
    }
  }
`

/**
 * __useDevicesWithFacilitiesQuery__
 *
 * To run a query within a React component, call `useDevicesWithFacilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevicesWithFacilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevicesWithFacilitiesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useDevicesWithFacilitiesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.DevicesWithFacilitiesQuery,
    Types.DevicesWithFacilitiesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.DevicesWithFacilitiesQuery,
    Types.DevicesWithFacilitiesQueryVariables
  >(DevicesWithFacilitiesDocument, options)
}
export function useDevicesWithFacilitiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.DevicesWithFacilitiesQuery,
    Types.DevicesWithFacilitiesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.DevicesWithFacilitiesQuery,
    Types.DevicesWithFacilitiesQueryVariables
  >(DevicesWithFacilitiesDocument, options)
}
export type DevicesWithFacilitiesQueryHookResult = ReturnType<
  typeof useDevicesWithFacilitiesQuery
>
export type DevicesWithFacilitiesLazyQueryHookResult = ReturnType<
  typeof useDevicesWithFacilitiesLazyQuery
>
export type DevicesWithFacilitiesQueryResult = Apollo.QueryResult<
  Types.DevicesWithFacilitiesQuery,
  Types.DevicesWithFacilitiesQueryVariables
>
export const DevicesWithTailgateConfiguredDocument = gql`
  query DevicesWithTailgateConfigured($filter: DeviceFilterInput) {
    devices(filter: $filter) {
      edges {
        node {
          id
          name
          floor {
            id
          }
          door {
            id
            tailgateGrids {
              inBox {
                topLeft {
                  x
                }
              }
            }
          }
        }
      }
    }
  }
`

/**
 * __useDevicesWithTailgateConfiguredQuery__
 *
 * To run a query within a React component, call `useDevicesWithTailgateConfiguredQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevicesWithTailgateConfiguredQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevicesWithTailgateConfiguredQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDevicesWithTailgateConfiguredQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.DevicesWithTailgateConfiguredQuery,
    Types.DevicesWithTailgateConfiguredQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.DevicesWithTailgateConfiguredQuery,
    Types.DevicesWithTailgateConfiguredQueryVariables
  >(DevicesWithTailgateConfiguredDocument, options)
}
export function useDevicesWithTailgateConfiguredLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.DevicesWithTailgateConfiguredQuery,
    Types.DevicesWithTailgateConfiguredQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.DevicesWithTailgateConfiguredQuery,
    Types.DevicesWithTailgateConfiguredQueryVariables
  >(DevicesWithTailgateConfiguredDocument, options)
}
export type DevicesWithTailgateConfiguredQueryHookResult = ReturnType<
  typeof useDevicesWithTailgateConfiguredQuery
>
export type DevicesWithTailgateConfiguredLazyQueryHookResult = ReturnType<
  typeof useDevicesWithTailgateConfiguredLazyQuery
>
export type DevicesWithTailgateConfiguredQueryResult = Apollo.QueryResult<
  Types.DevicesWithTailgateConfiguredQuery,
  Types.DevicesWithTailgateConfiguredQueryVariables
>
export const DoorTailgateGridsEnabledDocument = gql`
  query DoorTailgateGridsEnabled($id: ID!) {
    device(id: $id) {
      id
      door {
        tailgateGrids {
          isTailgateEnabled
          camera {
            id
            name
          }
          inBox {
            topLeft {
              x
            }
          }
        }
      }
    }
  }
`

/**
 * __useDoorTailgateGridsEnabledQuery__
 *
 * To run a query within a React component, call `useDoorTailgateGridsEnabledQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoorTailgateGridsEnabledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoorTailgateGridsEnabledQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDoorTailgateGridsEnabledQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.DoorTailgateGridsEnabledQuery,
    Types.DoorTailgateGridsEnabledQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.DoorTailgateGridsEnabledQuery,
    Types.DoorTailgateGridsEnabledQueryVariables
  >(DoorTailgateGridsEnabledDocument, options)
}
export function useDoorTailgateGridsEnabledLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.DoorTailgateGridsEnabledQuery,
    Types.DoorTailgateGridsEnabledQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.DoorTailgateGridsEnabledQuery,
    Types.DoorTailgateGridsEnabledQueryVariables
  >(DoorTailgateGridsEnabledDocument, options)
}
export type DoorTailgateGridsEnabledQueryHookResult = ReturnType<
  typeof useDoorTailgateGridsEnabledQuery
>
export type DoorTailgateGridsEnabledLazyQueryHookResult = ReturnType<
  typeof useDoorTailgateGridsEnabledLazyQuery
>
export type DoorTailgateGridsEnabledQueryResult = Apollo.QueryResult<
  Types.DoorTailgateGridsEnabledQuery,
  Types.DoorTailgateGridsEnabledQueryVariables
>
export const EdgeDeviceDocument = gql`
  query EdgeDevice($id: ID!) {
    edgeDevice(id: $id) {
      id
      name
      devices {
        edges {
          node {
            id
            name
            archived
            facility {
              id
              name
            }
            floor {
              id
              name
            }
          }
        }
      }
    }
  }
`

/**
 * __useEdgeDeviceQuery__
 *
 * To run a query within a React component, call `useEdgeDeviceQuery` and pass it any options that fit your needs.
 * When your component renders, `useEdgeDeviceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEdgeDeviceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEdgeDeviceQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.EdgeDeviceQuery,
    Types.EdgeDeviceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<Types.EdgeDeviceQuery, Types.EdgeDeviceQueryVariables>(
    EdgeDeviceDocument,
    options
  )
}
export function useEdgeDeviceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.EdgeDeviceQuery,
    Types.EdgeDeviceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.EdgeDeviceQuery,
    Types.EdgeDeviceQueryVariables
  >(EdgeDeviceDocument, options)
}
export type EdgeDeviceQueryHookResult = ReturnType<typeof useEdgeDeviceQuery>
export type EdgeDeviceLazyQueryHookResult = ReturnType<
  typeof useEdgeDeviceLazyQuery
>
export type EdgeDeviceQueryResult = Apollo.QueryResult<
  Types.EdgeDeviceQuery,
  Types.EdgeDeviceQueryVariables
>
export const EmergencyCallIncidentCategoryDocument = gql`
  query EmergencyCallIncidentCategory {
    emergencyCallIncidentCategory {
      id
      name
      isQuickReportCategory
      creatorId
    }
  }
`

/**
 * __useEmergencyCallIncidentCategoryQuery__
 *
 * To run a query within a React component, call `useEmergencyCallIncidentCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmergencyCallIncidentCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmergencyCallIncidentCategoryQuery({
 *   variables: {
 *   },
 * });
 */
export function useEmergencyCallIncidentCategoryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.EmergencyCallIncidentCategoryQuery,
    Types.EmergencyCallIncidentCategoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.EmergencyCallIncidentCategoryQuery,
    Types.EmergencyCallIncidentCategoryQueryVariables
  >(EmergencyCallIncidentCategoryDocument, options)
}
export function useEmergencyCallIncidentCategoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.EmergencyCallIncidentCategoryQuery,
    Types.EmergencyCallIncidentCategoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.EmergencyCallIncidentCategoryQuery,
    Types.EmergencyCallIncidentCategoryQueryVariables
  >(EmergencyCallIncidentCategoryDocument, options)
}
export type EmergencyCallIncidentCategoryQueryHookResult = ReturnType<
  typeof useEmergencyCallIncidentCategoryQuery
>
export type EmergencyCallIncidentCategoryLazyQueryHookResult = ReturnType<
  typeof useEmergencyCallIncidentCategoryLazyQuery
>
export type EmergencyCallIncidentCategoryQueryResult = Apollo.QueryResult<
  Types.EmergencyCallIncidentCategoryQuery,
  Types.EmergencyCallIncidentCategoryQueryVariables
>
export const EmergencyCallSetupDocument = gql`
  query EmergencyCallSetup($incidentId: ID!) {
    emergencyCallingAccessToken {
      token
    }
    incident(id: $incidentId) {
      facility {
        emergencyCalling {
          outboundPhoneNumber
        }
      }
    }
  }
`

/**
 * __useEmergencyCallSetupQuery__
 *
 * To run a query within a React component, call `useEmergencyCallSetupQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmergencyCallSetupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmergencyCallSetupQuery({
 *   variables: {
 *      incidentId: // value for 'incidentId'
 *   },
 * });
 */
export function useEmergencyCallSetupQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.EmergencyCallSetupQuery,
    Types.EmergencyCallSetupQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.EmergencyCallSetupQuery,
    Types.EmergencyCallSetupQueryVariables
  >(EmergencyCallSetupDocument, options)
}
export function useEmergencyCallSetupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.EmergencyCallSetupQuery,
    Types.EmergencyCallSetupQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.EmergencyCallSetupQuery,
    Types.EmergencyCallSetupQueryVariables
  >(EmergencyCallSetupDocument, options)
}
export type EmergencyCallSetupQueryHookResult = ReturnType<
  typeof useEmergencyCallSetupQuery
>
export type EmergencyCallSetupLazyQueryHookResult = ReturnType<
  typeof useEmergencyCallSetupLazyQuery
>
export type EmergencyCallSetupQueryResult = Apollo.QueryResult<
  Types.EmergencyCallSetupQuery,
  Types.EmergencyCallSetupQueryVariables
>
export const EmergencyCallsDocument = gql`
  query EmergencyCalls(
    $first: Int
    $last: Int
    $filter: EmergencyCallFilterInput
    $orderBy: [EmergencyCallOrderInput]
  ) {
    emergencyCalls(
      first: $first
      last: $last
      filter: $filter
      orderBy: $orderBy
    ) {
      totalCount
      pageInfo {
        page
        pageSize
      }
      edges {
        node {
          id
          createdAt
          callDuration
          callStartTime
          callEndTime
          incidentId
          incident {
            displayId
            facility {
              id
              name
              archived
            }
          }
          user {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
`

/**
 * __useEmergencyCallsQuery__
 *
 * To run a query within a React component, call `useEmergencyCallsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmergencyCallsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmergencyCallsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useEmergencyCallsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.EmergencyCallsQuery,
    Types.EmergencyCallsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.EmergencyCallsQuery,
    Types.EmergencyCallsQueryVariables
  >(EmergencyCallsDocument, options)
}
export function useEmergencyCallsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.EmergencyCallsQuery,
    Types.EmergencyCallsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.EmergencyCallsQuery,
    Types.EmergencyCallsQueryVariables
  >(EmergencyCallsDocument, options)
}
export type EmergencyCallsQueryHookResult = ReturnType<
  typeof useEmergencyCallsQuery
>
export type EmergencyCallsLazyQueryHookResult = ReturnType<
  typeof useEmergencyCallsLazyQuery
>
export type EmergencyCallsQueryResult = Apollo.QueryResult<
  Types.EmergencyCallsQuery,
  Types.EmergencyCallsQueryVariables
>
export const EnabledAiOperatorModelsDocument = gql`
  query EnabledAiOperatorModels {
    enabledAiOperatorModels {
      edges {
        node {
          id
          canonicalName
          provider
        }
      }
    }
  }
`

/**
 * __useEnabledAiOperatorModelsQuery__
 *
 * To run a query within a React component, call `useEnabledAiOperatorModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnabledAiOperatorModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnabledAiOperatorModelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useEnabledAiOperatorModelsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.EnabledAiOperatorModelsQuery,
    Types.EnabledAiOperatorModelsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.EnabledAiOperatorModelsQuery,
    Types.EnabledAiOperatorModelsQueryVariables
  >(EnabledAiOperatorModelsDocument, options)
}
export function useEnabledAiOperatorModelsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.EnabledAiOperatorModelsQuery,
    Types.EnabledAiOperatorModelsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.EnabledAiOperatorModelsQuery,
    Types.EnabledAiOperatorModelsQueryVariables
  >(EnabledAiOperatorModelsDocument, options)
}
export type EnabledAiOperatorModelsQueryHookResult = ReturnType<
  typeof useEnabledAiOperatorModelsQuery
>
export type EnabledAiOperatorModelsLazyQueryHookResult = ReturnType<
  typeof useEnabledAiOperatorModelsLazyQuery
>
export type EnabledAiOperatorModelsQueryResult = Apollo.QueryResult<
  Types.EnabledAiOperatorModelsQuery,
  Types.EnabledAiOperatorModelsQueryVariables
>
export const EventsOnLoadDocument = gql`
  query eventsOnLoad(
    $mainEventTimestamp: String
    $facilityId: ID
    $deviceId: ID
    $firstANDLastCount: Int!
  ) {
    eventsAfter: eventPresentations(
      filter: {
        facilityId: $facilityId
        deviceId: $deviceId
        detectedAtGte: $mainEventTimestamp
      }
      orderBy: [{ direction: DESC, field: DETECTED_AT }]
      last: $firstANDLastCount
    ) {
      edges {
        cursor
        node {
          externalId
          acsEventType
          badgeNumber
          cardHolderName
          createdAt
          detectedAt
          deviceName
          deviceId
          deviceType
          type
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      totalCount
    }
    eventsBefore: eventPresentations(
      filter: {
        facilityId: $facilityId
        deviceId: $deviceId
        detectedAtLt: $mainEventTimestamp
      }
      orderBy: [{ direction: DESC, field: DETECTED_AT }]
      first: $firstANDLastCount
    ) {
      edges {
        cursor
        node {
          externalId
          acsEventType
          badgeNumber
          cardHolderName
          createdAt
          detectedAt
          deviceName
          deviceId
          deviceType
          type
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      totalCount
    }
  }
`

/**
 * __useEventsOnLoadQuery__
 *
 * To run a query within a React component, call `useEventsOnLoadQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsOnLoadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsOnLoadQuery({
 *   variables: {
 *      mainEventTimestamp: // value for 'mainEventTimestamp'
 *      facilityId: // value for 'facilityId'
 *      deviceId: // value for 'deviceId'
 *      firstANDLastCount: // value for 'firstANDLastCount'
 *   },
 * });
 */
export function useEventsOnLoadQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.EventsOnLoadQuery,
    Types.EventsOnLoadQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.EventsOnLoadQuery,
    Types.EventsOnLoadQueryVariables
  >(EventsOnLoadDocument, options)
}
export function useEventsOnLoadLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.EventsOnLoadQuery,
    Types.EventsOnLoadQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.EventsOnLoadQuery,
    Types.EventsOnLoadQueryVariables
  >(EventsOnLoadDocument, options)
}
export type EventsOnLoadQueryHookResult = ReturnType<
  typeof useEventsOnLoadQuery
>
export type EventsOnLoadLazyQueryHookResult = ReturnType<
  typeof useEventsOnLoadLazyQuery
>
export type EventsOnLoadQueryResult = Apollo.QueryResult<
  Types.EventsOnLoadQuery,
  Types.EventsOnLoadQueryVariables
>
export const EventsScrollCursorDocument = gql`
  query EventsScrollCursor(
    $after: String
    $before: String
    $first: Int
    $last: Int
    $detectedAtGte: String
    $detectedAtLt: String
    $facilityId: ID
    $deviceId: ID
  ) {
    eventPresentations(
      filter: {
        facilityId: $facilityId
        deviceId: $deviceId
        detectedAtGte: $detectedAtGte
        detectedAtLt: $detectedAtLt
      }
      orderBy: [{ direction: DESC, field: DETECTED_AT }]
      first: $first
      last: $last
      after: $after
      before: $before
    ) {
      edges {
        cursor
        node {
          externalId
          acsEventType
          badgeNumber
          cardHolderName
          createdAt
          detectedAt
          deviceId
          deviceName
          deviceType
          type
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      totalCount
    }
  }
`

/**
 * __useEventsScrollCursorQuery__
 *
 * To run a query within a React component, call `useEventsScrollCursorQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsScrollCursorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsScrollCursorQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      detectedAtGte: // value for 'detectedAtGte'
 *      detectedAtLt: // value for 'detectedAtLt'
 *      facilityId: // value for 'facilityId'
 *      deviceId: // value for 'deviceId'
 *   },
 * });
 */
export function useEventsScrollCursorQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.EventsScrollCursorQuery,
    Types.EventsScrollCursorQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.EventsScrollCursorQuery,
    Types.EventsScrollCursorQueryVariables
  >(EventsScrollCursorDocument, options)
}
export function useEventsScrollCursorLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.EventsScrollCursorQuery,
    Types.EventsScrollCursorQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.EventsScrollCursorQuery,
    Types.EventsScrollCursorQueryVariables
  >(EventsScrollCursorDocument, options)
}
export type EventsScrollCursorQueryHookResult = ReturnType<
  typeof useEventsScrollCursorQuery
>
export type EventsScrollCursorLazyQueryHookResult = ReturnType<
  typeof useEventsScrollCursorLazyQuery
>
export type EventsScrollCursorQueryResult = Apollo.QueryResult<
  Types.EventsScrollCursorQuery,
  Types.EventsScrollCursorQueryVariables
>
export const ExternalAccountDocument = gql`
  query ExternalAccount($id: ID!) {
    externalAccount(id: $id) {
      accountId
      accountName
      defaultAccount
      externalSystemType
      id
      apiKeys {
        id
        permissionName
        secretName
        customerSecretProvider {
          secretArn
          node {
            id
            providerName
          }
        }
      }
    }
  }
`

/**
 * __useExternalAccountQuery__
 *
 * To run a query within a React component, call `useExternalAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExternalAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExternalAccountQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.ExternalAccountQuery,
    Types.ExternalAccountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.ExternalAccountQuery,
    Types.ExternalAccountQueryVariables
  >(ExternalAccountDocument, options)
}
export function useExternalAccountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.ExternalAccountQuery,
    Types.ExternalAccountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.ExternalAccountQuery,
    Types.ExternalAccountQueryVariables
  >(ExternalAccountDocument, options)
}
export type ExternalAccountQueryHookResult = ReturnType<
  typeof useExternalAccountQuery
>
export type ExternalAccountLazyQueryHookResult = ReturnType<
  typeof useExternalAccountLazyQuery
>
export type ExternalAccountQueryResult = Apollo.QueryResult<
  Types.ExternalAccountQuery,
  Types.ExternalAccountQueryVariables
>
export const ExternalAccountPropertyDefinitionsDocument = gql`
  query ExternalAccountPropertyDefinitions(
    $externalSystemType: ExternalSystemType!
  ) {
    externalAccountPropertyDefinitions(
      externalSystemType: $externalSystemType
    ) {
      allowedValues {
        label
        value
      }
      defaultValue
      description
      key
      valueType
    }
  }
`

/**
 * __useExternalAccountPropertyDefinitionsQuery__
 *
 * To run a query within a React component, call `useExternalAccountPropertyDefinitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalAccountPropertyDefinitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExternalAccountPropertyDefinitionsQuery({
 *   variables: {
 *      externalSystemType: // value for 'externalSystemType'
 *   },
 * });
 */
export function useExternalAccountPropertyDefinitionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.ExternalAccountPropertyDefinitionsQuery,
    Types.ExternalAccountPropertyDefinitionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.ExternalAccountPropertyDefinitionsQuery,
    Types.ExternalAccountPropertyDefinitionsQueryVariables
  >(ExternalAccountPropertyDefinitionsDocument, options)
}
export function useExternalAccountPropertyDefinitionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.ExternalAccountPropertyDefinitionsQuery,
    Types.ExternalAccountPropertyDefinitionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.ExternalAccountPropertyDefinitionsQuery,
    Types.ExternalAccountPropertyDefinitionsQueryVariables
  >(ExternalAccountPropertyDefinitionsDocument, options)
}
export type ExternalAccountPropertyDefinitionsQueryHookResult = ReturnType<
  typeof useExternalAccountPropertyDefinitionsQuery
>
export type ExternalAccountPropertyDefinitionsLazyQueryHookResult = ReturnType<
  typeof useExternalAccountPropertyDefinitionsLazyQuery
>
export type ExternalAccountPropertyDefinitionsQueryResult = Apollo.QueryResult<
  Types.ExternalAccountPropertyDefinitionsQuery,
  Types.ExternalAccountPropertyDefinitionsQueryVariables
>
export const ExternalAccountsDocument = gql`
  query ExternalAccounts {
    externalAccounts {
      edges {
        node {
          accountId
          accountName
          createdAt
          defaultAccount
          externalSystemType
          id
          apiKeys {
            id
            permissionName
            secretName
            customerSecretProvider {
              secretArn
              node {
                id
                providerName
              }
            }
          }
          properties {
            data
            id
          }
        }
      }
    }
  }
`

/**
 * __useExternalAccountsQuery__
 *
 * To run a query within a React component, call `useExternalAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExternalAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useExternalAccountsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.ExternalAccountsQuery,
    Types.ExternalAccountsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.ExternalAccountsQuery,
    Types.ExternalAccountsQueryVariables
  >(ExternalAccountsDocument, options)
}
export function useExternalAccountsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.ExternalAccountsQuery,
    Types.ExternalAccountsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.ExternalAccountsQuery,
    Types.ExternalAccountsQueryVariables
  >(ExternalAccountsDocument, options)
}
export type ExternalAccountsQueryHookResult = ReturnType<
  typeof useExternalAccountsQuery
>
export type ExternalAccountsLazyQueryHookResult = ReturnType<
  typeof useExternalAccountsLazyQuery
>
export type ExternalAccountsQueryResult = Apollo.QueryResult<
  Types.ExternalAccountsQuery,
  Types.ExternalAccountsQueryVariables
>
export const FacilitiesDocument = gql`
  query Facilities($filter: FacilityFilterInput) {
    facilities(filter: $filter) {
      totalCount
      edges {
        node {
          id
          type
          name
          address
          defaultFloorId
          shortName
          latitude
          longitude
          guardCount
          floors(filter: { archived: false }) {
            totalCount
            edges {
              node {
                id
              }
            }
          }
          incidents(filter: { statusIn: [IN_PROGRESS, ACTIVE] }) {
            totalCount
          }
          cameras: devices(filter: { type: CAMERA }) {
            totalCount
          }
          doors: devices(filter: { type: DOOR }) {
            totalCount
          }
          siteSnapshot {
            ... on UrlContent {
              url
            }
          }
        }
      }
    }
  }
`

/**
 * __useFacilitiesQuery__
 *
 * To run a query within a React component, call `useFacilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFacilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFacilitiesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFacilitiesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.FacilitiesQuery,
    Types.FacilitiesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<Types.FacilitiesQuery, Types.FacilitiesQueryVariables>(
    FacilitiesDocument,
    options
  )
}
export function useFacilitiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.FacilitiesQuery,
    Types.FacilitiesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.FacilitiesQuery,
    Types.FacilitiesQueryVariables
  >(FacilitiesDocument, options)
}
export type FacilitiesQueryHookResult = ReturnType<typeof useFacilitiesQuery>
export type FacilitiesLazyQueryHookResult = ReturnType<
  typeof useFacilitiesLazyQuery
>
export type FacilitiesQueryResult = Apollo.QueryResult<
  Types.FacilitiesQuery,
  Types.FacilitiesQueryVariables
>
export const FacilitiesForCsvDocument = gql`
  query FacilitiesForCsv(
    $filter: FacilityFilterInput
    $first: Int
    $last: Int
    $order: [FacilityOrderInput]
  ) {
    facilities(filter: $filter, first: $first, last: $last, orderBy: $order) {
      totalCount
      edges {
        node {
          id
          name
          shortName
          address
          latitude
          longitude
        }
      }
    }
  }
`

/**
 * __useFacilitiesForCsvQuery__
 *
 * To run a query within a React component, call `useFacilitiesForCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useFacilitiesForCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFacilitiesForCsvQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useFacilitiesForCsvQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.FacilitiesForCsvQuery,
    Types.FacilitiesForCsvQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.FacilitiesForCsvQuery,
    Types.FacilitiesForCsvQueryVariables
  >(FacilitiesForCsvDocument, options)
}
export function useFacilitiesForCsvLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.FacilitiesForCsvQuery,
    Types.FacilitiesForCsvQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.FacilitiesForCsvQuery,
    Types.FacilitiesForCsvQueryVariables
  >(FacilitiesForCsvDocument, options)
}
export type FacilitiesForCsvQueryHookResult = ReturnType<
  typeof useFacilitiesForCsvQuery
>
export type FacilitiesForCsvLazyQueryHookResult = ReturnType<
  typeof useFacilitiesForCsvLazyQuery
>
export type FacilitiesForCsvQueryResult = Apollo.QueryResult<
  Types.FacilitiesForCsvQuery,
  Types.FacilitiesForCsvQueryVariables
>
export const FacilitiesWithFloorsDocument = gql`
  query FacilitiesWithFloors {
    facilities {
      edges {
        node {
          id
          name
          floors(filter: { archived: false }) {
            edges {
              node {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`

/**
 * __useFacilitiesWithFloorsQuery__
 *
 * To run a query within a React component, call `useFacilitiesWithFloorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFacilitiesWithFloorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFacilitiesWithFloorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFacilitiesWithFloorsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.FacilitiesWithFloorsQuery,
    Types.FacilitiesWithFloorsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.FacilitiesWithFloorsQuery,
    Types.FacilitiesWithFloorsQueryVariables
  >(FacilitiesWithFloorsDocument, options)
}
export function useFacilitiesWithFloorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.FacilitiesWithFloorsQuery,
    Types.FacilitiesWithFloorsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.FacilitiesWithFloorsQuery,
    Types.FacilitiesWithFloorsQueryVariables
  >(FacilitiesWithFloorsDocument, options)
}
export type FacilitiesWithFloorsQueryHookResult = ReturnType<
  typeof useFacilitiesWithFloorsQuery
>
export type FacilitiesWithFloorsLazyQueryHookResult = ReturnType<
  typeof useFacilitiesWithFloorsLazyQuery
>
export type FacilitiesWithFloorsQueryResult = Apollo.QueryResult<
  Types.FacilitiesWithFloorsQuery,
  Types.FacilitiesWithFloorsQueryVariables
>
export const FacilityDocument = gql`
  query Facility($id: ID!) {
    facility(id: $id) {
      id
      address
      latitude
      longitude
      shortName
      name
      timeZone
      type
      defaultFloorId
      emergencyCalling {
        outboundPhoneNumber
      }
      emergencyNumber
      floors(filter: { archived: false }) {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
`

/**
 * __useFacilityQuery__
 *
 * To run a query within a React component, call `useFacilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useFacilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFacilityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFacilityQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.FacilityQuery,
    Types.FacilityQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<Types.FacilityQuery, Types.FacilityQueryVariables>(
    FacilityDocument,
    options
  )
}
export function useFacilityLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.FacilityQuery,
    Types.FacilityQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<Types.FacilityQuery, Types.FacilityQueryVariables>(
    FacilityDocument,
    options
  )
}
export type FacilityQueryHookResult = ReturnType<typeof useFacilityQuery>
export type FacilityLazyQueryHookResult = ReturnType<
  typeof useFacilityLazyQuery
>
export type FacilityQueryResult = Apollo.QueryResult<
  Types.FacilityQuery,
  Types.FacilityQueryVariables
>
export const FacilityACsDocument = gql`
  query FacilityACs($id: ID!) {
    facilityACs: devices(filter: { type: DOOR, facilityId: $id }) {
      edges {
        node {
          id
          name
          incidents {
            totalCount
          }
          status
          floor {
            name
          }
        }
      }
    }
  }
`

/**
 * __useFacilityACsQuery__
 *
 * To run a query within a React component, call `useFacilityACsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFacilityACsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFacilityACsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFacilityACsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.FacilityACsQuery,
    Types.FacilityACsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.FacilityACsQuery,
    Types.FacilityACsQueryVariables
  >(FacilityACsDocument, options)
}
export function useFacilityACsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.FacilityACsQuery,
    Types.FacilityACsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.FacilityACsQuery,
    Types.FacilityACsQueryVariables
  >(FacilityACsDocument, options)
}
export type FacilityACsQueryHookResult = ReturnType<typeof useFacilityACsQuery>
export type FacilityACsLazyQueryHookResult = ReturnType<
  typeof useFacilityACsLazyQuery
>
export type FacilityACsQueryResult = Apollo.QueryResult<
  Types.FacilityACsQuery,
  Types.FacilityACsQueryVariables
>
export const FacilityAndDeviceNamesDocument = gql`
  query FacilityAndDeviceNames($filter: FacilityFilterInput) {
    facilityNames: facilities(filter: $filter) {
      edges {
        node {
          id
          name
          shortName
          archived
        }
      }
    }
    devices {
      edges {
        node {
          id
          name
          facility {
            id
            name
          }
          floor {
            id
            name
          }
        }
      }
    }
    manualIncidentCategories {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`

/**
 * __useFacilityAndDeviceNamesQuery__
 *
 * To run a query within a React component, call `useFacilityAndDeviceNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFacilityAndDeviceNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFacilityAndDeviceNamesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFacilityAndDeviceNamesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.FacilityAndDeviceNamesQuery,
    Types.FacilityAndDeviceNamesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.FacilityAndDeviceNamesQuery,
    Types.FacilityAndDeviceNamesQueryVariables
  >(FacilityAndDeviceNamesDocument, options)
}
export function useFacilityAndDeviceNamesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.FacilityAndDeviceNamesQuery,
    Types.FacilityAndDeviceNamesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.FacilityAndDeviceNamesQuery,
    Types.FacilityAndDeviceNamesQueryVariables
  >(FacilityAndDeviceNamesDocument, options)
}
export type FacilityAndDeviceNamesQueryHookResult = ReturnType<
  typeof useFacilityAndDeviceNamesQuery
>
export type FacilityAndDeviceNamesLazyQueryHookResult = ReturnType<
  typeof useFacilityAndDeviceNamesLazyQuery
>
export type FacilityAndDeviceNamesQueryResult = Apollo.QueryResult<
  Types.FacilityAndDeviceNamesQuery,
  Types.FacilityAndDeviceNamesQueryVariables
>
export const FacilityArchivedFloorsDocument = gql`
  query FacilityArchivedFloors($facilityId: ID!) {
    facility(id: $facilityId) {
      id
      defaultFloorId
      floors(filter: { archived: true }) {
        edges {
          node {
            id
            name
            displayOrder
            incidents(filter: { statusIn: [IN_PROGRESS, ACTIVE] }) {
              totalCount
            }
          }
        }
      }
    }
  }
`

/**
 * __useFacilityArchivedFloorsQuery__
 *
 * To run a query within a React component, call `useFacilityArchivedFloorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFacilityArchivedFloorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFacilityArchivedFloorsQuery({
 *   variables: {
 *      facilityId: // value for 'facilityId'
 *   },
 * });
 */
export function useFacilityArchivedFloorsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.FacilityArchivedFloorsQuery,
    Types.FacilityArchivedFloorsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.FacilityArchivedFloorsQuery,
    Types.FacilityArchivedFloorsQueryVariables
  >(FacilityArchivedFloorsDocument, options)
}
export function useFacilityArchivedFloorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.FacilityArchivedFloorsQuery,
    Types.FacilityArchivedFloorsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.FacilityArchivedFloorsQuery,
    Types.FacilityArchivedFloorsQueryVariables
  >(FacilityArchivedFloorsDocument, options)
}
export type FacilityArchivedFloorsQueryHookResult = ReturnType<
  typeof useFacilityArchivedFloorsQuery
>
export type FacilityArchivedFloorsLazyQueryHookResult = ReturnType<
  typeof useFacilityArchivedFloorsLazyQuery
>
export type FacilityArchivedFloorsQueryResult = Apollo.QueryResult<
  Types.FacilityArchivedFloorsQuery,
  Types.FacilityArchivedFloorsQueryVariables
>
export const FacilityDevicesByFloorsDocument = gql`
  query FacilityDevicesByFloors(
    $facilityId: ID!
    $floorId: ID!
    $types: [DeviceType!]
    $floorIds: [ID!]
    $nameLike: String
  ) {
    facility(id: $facilityId) {
      id
      name
      floors(filter: { id: $floorId }) {
        edges {
          node {
            id
            name
          }
        }
      }
      devices(
        filter: { typeIn: $types, floorIdIn: $floorIds, nameLike: $nameLike }
        orderBy: [{ direction: ASC, field: NAME }]
      ) {
        edges {
          node {
            id
            name
            createdAt
            macAddress
            type
            x
            y
            status
            fieldOfView
            bearing
            visibilityRange
            floorPlanId
            camera {
              tailgateGrids {
                camera {
                  id
                }
                door {
                  id
                }
                isTailgateEnabled
                inBox {
                  topLeft {
                    x
                    y
                  }
                }
              }
            }
            tailgateConns {
              edges {
                node {
                  id
                  door {
                    id
                  }
                  cameras {
                    edges {
                      node {
                        id
                      }
                    }
                  }
                }
              }
            }
            checkpoint {
              id
              displayId
              isPhotoRequired
            }
            floor {
              id
              name
            }
          }
        }
      }
    }
  }
`

/**
 * __useFacilityDevicesByFloorsQuery__
 *
 * To run a query within a React component, call `useFacilityDevicesByFloorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFacilityDevicesByFloorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFacilityDevicesByFloorsQuery({
 *   variables: {
 *      facilityId: // value for 'facilityId'
 *      floorId: // value for 'floorId'
 *      types: // value for 'types'
 *      floorIds: // value for 'floorIds'
 *      nameLike: // value for 'nameLike'
 *   },
 * });
 */
export function useFacilityDevicesByFloorsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.FacilityDevicesByFloorsQuery,
    Types.FacilityDevicesByFloorsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.FacilityDevicesByFloorsQuery,
    Types.FacilityDevicesByFloorsQueryVariables
  >(FacilityDevicesByFloorsDocument, options)
}
export function useFacilityDevicesByFloorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.FacilityDevicesByFloorsQuery,
    Types.FacilityDevicesByFloorsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.FacilityDevicesByFloorsQuery,
    Types.FacilityDevicesByFloorsQueryVariables
  >(FacilityDevicesByFloorsDocument, options)
}
export type FacilityDevicesByFloorsQueryHookResult = ReturnType<
  typeof useFacilityDevicesByFloorsQuery
>
export type FacilityDevicesByFloorsLazyQueryHookResult = ReturnType<
  typeof useFacilityDevicesByFloorsLazyQuery
>
export type FacilityDevicesByFloorsQueryResult = Apollo.QueryResult<
  Types.FacilityDevicesByFloorsQuery,
  Types.FacilityDevicesByFloorsQueryVariables
>
export const FacilityCamerasDocument = gql`
  query FacilityCameras($id: ID!) {
    facilityCameras: devices(filter: { type: CAMERA, facilityId: $id }) {
      edges {
        node {
          id
          name
          incidents {
            totalCount
          }
          status
          floor {
            name
          }
        }
      }
    }
  }
`

/**
 * __useFacilityCamerasQuery__
 *
 * To run a query within a React component, call `useFacilityCamerasQuery` and pass it any options that fit your needs.
 * When your component renders, `useFacilityCamerasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFacilityCamerasQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFacilityCamerasQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.FacilityCamerasQuery,
    Types.FacilityCamerasQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.FacilityCamerasQuery,
    Types.FacilityCamerasQueryVariables
  >(FacilityCamerasDocument, options)
}
export function useFacilityCamerasLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.FacilityCamerasQuery,
    Types.FacilityCamerasQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.FacilityCamerasQuery,
    Types.FacilityCamerasQueryVariables
  >(FacilityCamerasDocument, options)
}
export type FacilityCamerasQueryHookResult = ReturnType<
  typeof useFacilityCamerasQuery
>
export type FacilityCamerasLazyQueryHookResult = ReturnType<
  typeof useFacilityCamerasLazyQuery
>
export type FacilityCamerasQueryResult = Apollo.QueryResult<
  Types.FacilityCamerasQuery,
  Types.FacilityCamerasQueryVariables
>
export const FacilityDevicesDocument = gql`
  query FacilityDevices($id: ID!) {
    facilityDevices: devices(
      filter: { facilityId: $id, typeIn: [CAMERA, DOOR] }
    ) {
      edges {
        node {
          id
          name
          incidents {
            totalCount
          }
          type
          status
          floor {
            name
          }
        }
      }
    }
  }
`

/**
 * __useFacilityDevicesQuery__
 *
 * To run a query within a React component, call `useFacilityDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFacilityDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFacilityDevicesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFacilityDevicesQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.FacilityDevicesQuery,
    Types.FacilityDevicesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.FacilityDevicesQuery,
    Types.FacilityDevicesQueryVariables
  >(FacilityDevicesDocument, options)
}
export function useFacilityDevicesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.FacilityDevicesQuery,
    Types.FacilityDevicesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.FacilityDevicesQuery,
    Types.FacilityDevicesQueryVariables
  >(FacilityDevicesDocument, options)
}
export type FacilityDevicesQueryHookResult = ReturnType<
  typeof useFacilityDevicesQuery
>
export type FacilityDevicesLazyQueryHookResult = ReturnType<
  typeof useFacilityDevicesLazyQuery
>
export type FacilityDevicesQueryResult = Apollo.QueryResult<
  Types.FacilityDevicesQuery,
  Types.FacilityDevicesQueryVariables
>
export const FacilityEmergencyCallingDocument = gql`
  query FacilityEmergencyCalling($id: ID!) {
    facility(id: $id) {
      emergencyCalling {
        outboundPhoneNumber
      }
      emergencyNumber
    }
  }
`

/**
 * __useFacilityEmergencyCallingQuery__
 *
 * To run a query within a React component, call `useFacilityEmergencyCallingQuery` and pass it any options that fit your needs.
 * When your component renders, `useFacilityEmergencyCallingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFacilityEmergencyCallingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFacilityEmergencyCallingQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.FacilityEmergencyCallingQuery,
    Types.FacilityEmergencyCallingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.FacilityEmergencyCallingQuery,
    Types.FacilityEmergencyCallingQueryVariables
  >(FacilityEmergencyCallingDocument, options)
}
export function useFacilityEmergencyCallingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.FacilityEmergencyCallingQuery,
    Types.FacilityEmergencyCallingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.FacilityEmergencyCallingQuery,
    Types.FacilityEmergencyCallingQueryVariables
  >(FacilityEmergencyCallingDocument, options)
}
export type FacilityEmergencyCallingQueryHookResult = ReturnType<
  typeof useFacilityEmergencyCallingQuery
>
export type FacilityEmergencyCallingLazyQueryHookResult = ReturnType<
  typeof useFacilityEmergencyCallingLazyQuery
>
export type FacilityEmergencyCallingQueryResult = Apollo.QueryResult<
  Types.FacilityEmergencyCallingQuery,
  Types.FacilityEmergencyCallingQueryVariables
>
export const FacilityFloorOptionsDocument = gql`
  query FacilityFloorOptions($id: ID) {
    floors(filter: { facilityId: $id, archived: false }) {
      edges {
        node {
          id
          name
          facility {
            id
            name
          }
        }
      }
    }
  }
`

/**
 * __useFacilityFloorOptionsQuery__
 *
 * To run a query within a React component, call `useFacilityFloorOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFacilityFloorOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFacilityFloorOptionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFacilityFloorOptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.FacilityFloorOptionsQuery,
    Types.FacilityFloorOptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.FacilityFloorOptionsQuery,
    Types.FacilityFloorOptionsQueryVariables
  >(FacilityFloorOptionsDocument, options)
}
export function useFacilityFloorOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.FacilityFloorOptionsQuery,
    Types.FacilityFloorOptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.FacilityFloorOptionsQuery,
    Types.FacilityFloorOptionsQueryVariables
  >(FacilityFloorOptionsDocument, options)
}
export type FacilityFloorOptionsQueryHookResult = ReturnType<
  typeof useFacilityFloorOptionsQuery
>
export type FacilityFloorOptionsLazyQueryHookResult = ReturnType<
  typeof useFacilityFloorOptionsLazyQuery
>
export type FacilityFloorOptionsQueryResult = Apollo.QueryResult<
  Types.FacilityFloorOptionsQuery,
  Types.FacilityFloorOptionsQueryVariables
>
export const FacilityFloorPlanDocument = gql`
  query FacilityFloorPlan($facilityId: ID!, $floorId: ID!) {
    facility(id: $facilityId) {
      id
      floors(filter: { id: $floorId }) {
        edges {
          node {
            id
            floorPlan {
              id
              image {
                ... on UrlContent {
                  url
                }
              }
            }
          }
        }
      }
    }
  }
`

/**
 * __useFacilityFloorPlanQuery__
 *
 * To run a query within a React component, call `useFacilityFloorPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useFacilityFloorPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFacilityFloorPlanQuery({
 *   variables: {
 *      facilityId: // value for 'facilityId'
 *      floorId: // value for 'floorId'
 *   },
 * });
 */
export function useFacilityFloorPlanQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.FacilityFloorPlanQuery,
    Types.FacilityFloorPlanQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.FacilityFloorPlanQuery,
    Types.FacilityFloorPlanQueryVariables
  >(FacilityFloorPlanDocument, options)
}
export function useFacilityFloorPlanLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.FacilityFloorPlanQuery,
    Types.FacilityFloorPlanQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.FacilityFloorPlanQuery,
    Types.FacilityFloorPlanQueryVariables
  >(FacilityFloorPlanDocument, options)
}
export type FacilityFloorPlanQueryHookResult = ReturnType<
  typeof useFacilityFloorPlanQuery
>
export type FacilityFloorPlanLazyQueryHookResult = ReturnType<
  typeof useFacilityFloorPlanLazyQuery
>
export type FacilityFloorPlanQueryResult = Apollo.QueryResult<
  Types.FacilityFloorPlanQuery,
  Types.FacilityFloorPlanQueryVariables
>
export const FacilityFloorsDocument = gql`
  query FacilityFloors($id: ID, $name: String) {
    floors(filter: { facilityId: $id, name: $name, archived: false }) {
      edges {
        node {
          id
          name
          facility {
            id
            name
          }
          incidents(filter: { statusIn: [IN_PROGRESS, ACTIVE] }) {
            totalCount
          }
          cameras: devices(filter: { type: CAMERA }) {
            totalCount
          }
          doors: devices(filter: { type: DOOR }) {
            totalCount
          }
        }
      }
    }
  }
`

/**
 * __useFacilityFloorsQuery__
 *
 * To run a query within a React component, call `useFacilityFloorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFacilityFloorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFacilityFloorsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useFacilityFloorsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.FacilityFloorsQuery,
    Types.FacilityFloorsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.FacilityFloorsQuery,
    Types.FacilityFloorsQueryVariables
  >(FacilityFloorsDocument, options)
}
export function useFacilityFloorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.FacilityFloorsQuery,
    Types.FacilityFloorsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.FacilityFloorsQuery,
    Types.FacilityFloorsQueryVariables
  >(FacilityFloorsDocument, options)
}
export type FacilityFloorsQueryHookResult = ReturnType<
  typeof useFacilityFloorsQuery
>
export type FacilityFloorsLazyQueryHookResult = ReturnType<
  typeof useFacilityFloorsLazyQuery
>
export type FacilityFloorsQueryResult = Apollo.QueryResult<
  Types.FacilityFloorsQuery,
  Types.FacilityFloorsQueryVariables
>
export const FacilityFloorsDrawerDocument = gql`
  query facilityFloorsDrawer($facilityId: ID!) {
    facility(id: $facilityId) {
      id
      name
      address
      defaultFloorId
      floors(filter: { archived: false }) {
        edges {
          node {
            id
            name
            displayOrder
            incidents(filter: { statusIn: [IN_PROGRESS, ACTIVE] }) {
              totalCount
            }
          }
        }
      }
    }
  }
`

/**
 * __useFacilityFloorsDrawerQuery__
 *
 * To run a query within a React component, call `useFacilityFloorsDrawerQuery` and pass it any options that fit your needs.
 * When your component renders, `useFacilityFloorsDrawerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFacilityFloorsDrawerQuery({
 *   variables: {
 *      facilityId: // value for 'facilityId'
 *   },
 * });
 */
export function useFacilityFloorsDrawerQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.FacilityFloorsDrawerQuery,
    Types.FacilityFloorsDrawerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.FacilityFloorsDrawerQuery,
    Types.FacilityFloorsDrawerQueryVariables
  >(FacilityFloorsDrawerDocument, options)
}
export function useFacilityFloorsDrawerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.FacilityFloorsDrawerQuery,
    Types.FacilityFloorsDrawerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.FacilityFloorsDrawerQuery,
    Types.FacilityFloorsDrawerQueryVariables
  >(FacilityFloorsDrawerDocument, options)
}
export type FacilityFloorsDrawerQueryHookResult = ReturnType<
  typeof useFacilityFloorsDrawerQuery
>
export type FacilityFloorsDrawerLazyQueryHookResult = ReturnType<
  typeof useFacilityFloorsDrawerLazyQuery
>
export type FacilityFloorsDrawerQueryResult = Apollo.QueryResult<
  Types.FacilityFloorsDrawerQuery,
  Types.FacilityFloorsDrawerQueryVariables
>
export const FacilityGuardsDocument = gql`
  query FacilityGuards($facilityId: ID!) {
    checkedInUsers(facilityId: $facilityId) {
      edges {
        node {
          id
          firstName
          lastName
          avatar {
            ... on UrlContent {
              url
            }
          }
        }
      }
    }
  }
`

/**
 * __useFacilityGuardsQuery__
 *
 * To run a query within a React component, call `useFacilityGuardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFacilityGuardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFacilityGuardsQuery({
 *   variables: {
 *      facilityId: // value for 'facilityId'
 *   },
 * });
 */
export function useFacilityGuardsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.FacilityGuardsQuery,
    Types.FacilityGuardsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.FacilityGuardsQuery,
    Types.FacilityGuardsQueryVariables
  >(FacilityGuardsDocument, options)
}
export function useFacilityGuardsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.FacilityGuardsQuery,
    Types.FacilityGuardsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.FacilityGuardsQuery,
    Types.FacilityGuardsQueryVariables
  >(FacilityGuardsDocument, options)
}
export type FacilityGuardsQueryHookResult = ReturnType<
  typeof useFacilityGuardsQuery
>
export type FacilityGuardsLazyQueryHookResult = ReturnType<
  typeof useFacilityGuardsLazyQuery
>
export type FacilityGuardsQueryResult = Apollo.QueryResult<
  Types.FacilityGuardsQuery,
  Types.FacilityGuardsQueryVariables
>
export const FacilityIncidentsDocument = gql`
  query FacilityIncidents($id: ID!) {
    facilityIncidents: incidents(
      filter: { facilityId: $id, statusIn: [IN_PROGRESS, ACTIVE] }
      orderBy: [{ direction: DESC, field: CREATED_AT }]
    ) {
      edges {
        node {
          id
          name
          type
          manualIncidentCategory {
            id
            name
          }
          incidentType {
            displayName
            manual
            icon
            slug
          }
          description
          floor {
            name
          }
          createdAt
          devices {
            id
            name
            type
          }
        }
      }
    }
  }
`

/**
 * __useFacilityIncidentsQuery__
 *
 * To run a query within a React component, call `useFacilityIncidentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFacilityIncidentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFacilityIncidentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFacilityIncidentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.FacilityIncidentsQuery,
    Types.FacilityIncidentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.FacilityIncidentsQuery,
    Types.FacilityIncidentsQueryVariables
  >(FacilityIncidentsDocument, options)
}
export function useFacilityIncidentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.FacilityIncidentsQuery,
    Types.FacilityIncidentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.FacilityIncidentsQuery,
    Types.FacilityIncidentsQueryVariables
  >(FacilityIncidentsDocument, options)
}
export type FacilityIncidentsQueryHookResult = ReturnType<
  typeof useFacilityIncidentsQuery
>
export type FacilityIncidentsLazyQueryHookResult = ReturnType<
  typeof useFacilityIncidentsLazyQuery
>
export type FacilityIncidentsQueryResult = Apollo.QueryResult<
  Types.FacilityIncidentsQuery,
  Types.FacilityIncidentsQueryVariables
>
export const FacilityNamesDocument = gql`
  query FacilityNames($filter: FacilityFilterInput) {
    facilityNames: facilities(
      filter: $filter
      last: 100
      orderBy: [{ direction: ASC, field: NAME }]
    ) {
      edges {
        node {
          id
          name
          shortName
          archived
        }
      }
    }
  }
`

/**
 * __useFacilityNamesQuery__
 *
 * To run a query within a React component, call `useFacilityNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFacilityNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFacilityNamesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFacilityNamesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.FacilityNamesQuery,
    Types.FacilityNamesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.FacilityNamesQuery,
    Types.FacilityNamesQueryVariables
  >(FacilityNamesDocument, options)
}
export function useFacilityNamesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.FacilityNamesQuery,
    Types.FacilityNamesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.FacilityNamesQuery,
    Types.FacilityNamesQueryVariables
  >(FacilityNamesDocument, options)
}
export type FacilityNamesQueryHookResult = ReturnType<
  typeof useFacilityNamesQuery
>
export type FacilityNamesLazyQueryHookResult = ReturnType<
  typeof useFacilityNamesLazyQuery
>
export type FacilityNamesQueryResult = Apollo.QueryResult<
  Types.FacilityNamesQuery,
  Types.FacilityNamesQueryVariables
>
export const FacilityNormalTypeNamesDocument = gql`
  query FacilityNormalTypeNames($filter: FacilityFilterInput) {
    facilityNames: facilities(
      filter: $filter
      last: 100
      orderBy: [{ direction: ASC, field: NAME }]
    ) {
      edges {
        node {
          id
          name
          shortName
        }
      }
    }
  }
`

/**
 * __useFacilityNormalTypeNamesQuery__
 *
 * To run a query within a React component, call `useFacilityNormalTypeNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFacilityNormalTypeNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFacilityNormalTypeNamesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFacilityNormalTypeNamesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.FacilityNormalTypeNamesQuery,
    Types.FacilityNormalTypeNamesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.FacilityNormalTypeNamesQuery,
    Types.FacilityNormalTypeNamesQueryVariables
  >(FacilityNormalTypeNamesDocument, options)
}
export function useFacilityNormalTypeNamesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.FacilityNormalTypeNamesQuery,
    Types.FacilityNormalTypeNamesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.FacilityNormalTypeNamesQuery,
    Types.FacilityNormalTypeNamesQueryVariables
  >(FacilityNormalTypeNamesDocument, options)
}
export type FacilityNormalTypeNamesQueryHookResult = ReturnType<
  typeof useFacilityNormalTypeNamesQuery
>
export type FacilityNormalTypeNamesLazyQueryHookResult = ReturnType<
  typeof useFacilityNormalTypeNamesLazyQuery
>
export type FacilityNormalTypeNamesQueryResult = Apollo.QueryResult<
  Types.FacilityNormalTypeNamesQuery,
  Types.FacilityNormalTypeNamesQueryVariables
>
export const FacilitySiteSnapshotDocument = gql`
  query FacilitySiteSnapshot($id: ID!) {
    facility(id: $id) {
      id
      siteSnapshot {
        ... on UrlContent {
          minExpiryTime
          url
        }
      }
    }
  }
`

/**
 * __useFacilitySiteSnapshotQuery__
 *
 * To run a query within a React component, call `useFacilitySiteSnapshotQuery` and pass it any options that fit your needs.
 * When your component renders, `useFacilitySiteSnapshotQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFacilitySiteSnapshotQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFacilitySiteSnapshotQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.FacilitySiteSnapshotQuery,
    Types.FacilitySiteSnapshotQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.FacilitySiteSnapshotQuery,
    Types.FacilitySiteSnapshotQueryVariables
  >(FacilitySiteSnapshotDocument, options)
}
export function useFacilitySiteSnapshotLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.FacilitySiteSnapshotQuery,
    Types.FacilitySiteSnapshotQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.FacilitySiteSnapshotQuery,
    Types.FacilitySiteSnapshotQueryVariables
  >(FacilitySiteSnapshotDocument, options)
}
export type FacilitySiteSnapshotQueryHookResult = ReturnType<
  typeof useFacilitySiteSnapshotQuery
>
export type FacilitySiteSnapshotLazyQueryHookResult = ReturnType<
  typeof useFacilitySiteSnapshotLazyQuery
>
export type FacilitySiteSnapshotQueryResult = Apollo.QueryResult<
  Types.FacilitySiteSnapshotQuery,
  Types.FacilitySiteSnapshotQueryVariables
>
export const FacilitiesTableDocument = gql`
  query FacilitiesTable(
    $filter: FacilityFilterInput
    $first: Int
    $last: Int
    $order: [FacilityOrderInput]
  ) {
    facilities(filter: $filter, first: $first, last: $last, orderBy: $order) {
      totalCount
      edges {
        node {
          id
          type
          name
          address
          shortName
          guardCount
          defaultFloorId
          emergencyNumber
          emergencyCalling {
            id
            outboundPhoneNumber
          }
          floors(filter: { archived: false }) {
            totalCount
            edges {
              node {
                id
              }
            }
          }
          siteSnapshot {
            ... on UrlContent {
              url
            }
          }
        }
      }
    }
  }
`

/**
 * __useFacilitiesTableQuery__
 *
 * To run a query within a React component, call `useFacilitiesTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useFacilitiesTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFacilitiesTableQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useFacilitiesTableQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.FacilitiesTableQuery,
    Types.FacilitiesTableQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.FacilitiesTableQuery,
    Types.FacilitiesTableQueryVariables
  >(FacilitiesTableDocument, options)
}
export function useFacilitiesTableLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.FacilitiesTableQuery,
    Types.FacilitiesTableQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.FacilitiesTableQuery,
    Types.FacilitiesTableQueryVariables
  >(FacilitiesTableDocument, options)
}
export type FacilitiesTableQueryHookResult = ReturnType<
  typeof useFacilitiesTableQuery
>
export type FacilitiesTableLazyQueryHookResult = ReturnType<
  typeof useFacilitiesTableLazyQuery
>
export type FacilitiesTableQueryResult = Apollo.QueryResult<
  Types.FacilitiesTableQuery,
  Types.FacilitiesTableQueryVariables
>
export const FacilityTourPlanCheckPointsDocument = gql`
  query facilityTourPlanCheckPoints($id: ID!) {
    tourPlan(id: $id) {
      id
      name
      checkpoints {
        edges {
          node {
            id
            displayId
            isPhotoRequired
            device {
              id
              type
              name
              x
              y
              createdAt
              floor {
                id
                name
              }
              facility {
                id
                name
              }
              checkpoint {
                id
                displayId
              }
            }
          }
        }
      }
    }
  }
`

/**
 * __useFacilityTourPlanCheckPointsQuery__
 *
 * To run a query within a React component, call `useFacilityTourPlanCheckPointsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFacilityTourPlanCheckPointsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFacilityTourPlanCheckPointsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFacilityTourPlanCheckPointsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.FacilityTourPlanCheckPointsQuery,
    Types.FacilityTourPlanCheckPointsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.FacilityTourPlanCheckPointsQuery,
    Types.FacilityTourPlanCheckPointsQueryVariables
  >(FacilityTourPlanCheckPointsDocument, options)
}
export function useFacilityTourPlanCheckPointsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.FacilityTourPlanCheckPointsQuery,
    Types.FacilityTourPlanCheckPointsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.FacilityTourPlanCheckPointsQuery,
    Types.FacilityTourPlanCheckPointsQueryVariables
  >(FacilityTourPlanCheckPointsDocument, options)
}
export type FacilityTourPlanCheckPointsQueryHookResult = ReturnType<
  typeof useFacilityTourPlanCheckPointsQuery
>
export type FacilityTourPlanCheckPointsLazyQueryHookResult = ReturnType<
  typeof useFacilityTourPlanCheckPointsLazyQuery
>
export type FacilityTourPlanCheckPointsQueryResult = Apollo.QueryResult<
  Types.FacilityTourPlanCheckPointsQuery,
  Types.FacilityTourPlanCheckPointsQueryVariables
>
export const FacilityTourPlansDocument = gql`
  query facilityTourPlans($facilityId: ID) {
    tourPlans(
      filter: { facilityId: $facilityId }
      orderBy: [{ direction: DESC, field: CREATED_AT }]
    ) {
      totalCount
      edges {
        node {
          id
          name
          checkpointIds
        }
      }
    }
  }
`

/**
 * __useFacilityTourPlansQuery__
 *
 * To run a query within a React component, call `useFacilityTourPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useFacilityTourPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFacilityTourPlansQuery({
 *   variables: {
 *      facilityId: // value for 'facilityId'
 *   },
 * });
 */
export function useFacilityTourPlansQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.FacilityTourPlansQuery,
    Types.FacilityTourPlansQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.FacilityTourPlansQuery,
    Types.FacilityTourPlansQueryVariables
  >(FacilityTourPlansDocument, options)
}
export function useFacilityTourPlansLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.FacilityTourPlansQuery,
    Types.FacilityTourPlansQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.FacilityTourPlansQuery,
    Types.FacilityTourPlansQueryVariables
  >(FacilityTourPlansDocument, options)
}
export type FacilityTourPlansQueryHookResult = ReturnType<
  typeof useFacilityTourPlansQuery
>
export type FacilityTourPlansLazyQueryHookResult = ReturnType<
  typeof useFacilityTourPlansLazyQuery
>
export type FacilityTourPlansQueryResult = Apollo.QueryResult<
  Types.FacilityTourPlansQuery,
  Types.FacilityTourPlansQueryVariables
>
export const FacilityTypesDocument = gql`
  query FacilityTypes($filter: FacilityFilterInput) {
    facilities(
      filter: $filter
      last: 100
      orderBy: [{ direction: ASC, field: NAME }]
    ) {
      edges {
        node {
          id
          name
          shortName
          type
          archived
          address
          latitude
          longitude
          timeZone
        }
      }
    }
  }
`

/**
 * __useFacilityTypesQuery__
 *
 * To run a query within a React component, call `useFacilityTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFacilityTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFacilityTypesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFacilityTypesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.FacilityTypesQuery,
    Types.FacilityTypesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.FacilityTypesQuery,
    Types.FacilityTypesQueryVariables
  >(FacilityTypesDocument, options)
}
export function useFacilityTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.FacilityTypesQuery,
    Types.FacilityTypesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.FacilityTypesQuery,
    Types.FacilityTypesQueryVariables
  >(FacilityTypesDocument, options)
}
export type FacilityTypesQueryHookResult = ReturnType<
  typeof useFacilityTypesQuery
>
export type FacilityTypesLazyQueryHookResult = ReturnType<
  typeof useFacilityTypesLazyQuery
>
export type FacilityTypesQueryResult = Apollo.QueryResult<
  Types.FacilityTypesQuery,
  Types.FacilityTypesQueryVariables
>
export const FacilityUnresolvedIncidentsDocument = gql`
  query FacilityUnresolvedIncidents($id: ID!) {
    facility(id: $id) {
      id
      name
      incidents(filter: { statusIn: [IN_PROGRESS, ACTIVE] }) {
        totalCount
      }
    }
  }
`

/**
 * __useFacilityUnresolvedIncidentsQuery__
 *
 * To run a query within a React component, call `useFacilityUnresolvedIncidentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFacilityUnresolvedIncidentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFacilityUnresolvedIncidentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFacilityUnresolvedIncidentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.FacilityUnresolvedIncidentsQuery,
    Types.FacilityUnresolvedIncidentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.FacilityUnresolvedIncidentsQuery,
    Types.FacilityUnresolvedIncidentsQueryVariables
  >(FacilityUnresolvedIncidentsDocument, options)
}
export function useFacilityUnresolvedIncidentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.FacilityUnresolvedIncidentsQuery,
    Types.FacilityUnresolvedIncidentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.FacilityUnresolvedIncidentsQuery,
    Types.FacilityUnresolvedIncidentsQueryVariables
  >(FacilityUnresolvedIncidentsDocument, options)
}
export type FacilityUnresolvedIncidentsQueryHookResult = ReturnType<
  typeof useFacilityUnresolvedIncidentsQuery
>
export type FacilityUnresolvedIncidentsLazyQueryHookResult = ReturnType<
  typeof useFacilityUnresolvedIncidentsLazyQuery
>
export type FacilityUnresolvedIncidentsQueryResult = Apollo.QueryResult<
  Types.FacilityUnresolvedIncidentsQuery,
  Types.FacilityUnresolvedIncidentsQueryVariables
>
export const FeatureFlagsDocument = gql`
  query FeatureFlags {
    featureFlags {
      name
      value
    }
  }
`

/**
 * __useFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFeatureFlagsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.FeatureFlagsQuery,
    Types.FeatureFlagsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.FeatureFlagsQuery,
    Types.FeatureFlagsQueryVariables
  >(FeatureFlagsDocument, options)
}
export function useFeatureFlagsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.FeatureFlagsQuery,
    Types.FeatureFlagsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.FeatureFlagsQuery,
    Types.FeatureFlagsQueryVariables
  >(FeatureFlagsDocument, options)
}
export type FeatureFlagsQueryHookResult = ReturnType<
  typeof useFeatureFlagsQuery
>
export type FeatureFlagsLazyQueryHookResult = ReturnType<
  typeof useFeatureFlagsLazyQuery
>
export type FeatureFlagsQueryResult = Apollo.QueryResult<
  Types.FeatureFlagsQuery,
  Types.FeatureFlagsQueryVariables
>
export const FloorDetailsDocument = gql`
  query FloorDetails($floorId: ID!) {
    floor(id: $floorId) {
      id
      name
      archived
      facility {
        id
        name
        shortName
      }
      floorPlan {
        id
        name
      }
    }
  }
`

/**
 * __useFloorDetailsQuery__
 *
 * To run a query within a React component, call `useFloorDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFloorDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFloorDetailsQuery({
 *   variables: {
 *      floorId: // value for 'floorId'
 *   },
 * });
 */
export function useFloorDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.FloorDetailsQuery,
    Types.FloorDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.FloorDetailsQuery,
    Types.FloorDetailsQueryVariables
  >(FloorDetailsDocument, options)
}
export function useFloorDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.FloorDetailsQuery,
    Types.FloorDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.FloorDetailsQuery,
    Types.FloorDetailsQueryVariables
  >(FloorDetailsDocument, options)
}
export type FloorDetailsQueryHookResult = ReturnType<
  typeof useFloorDetailsQuery
>
export type FloorDetailsLazyQueryHookResult = ReturnType<
  typeof useFloorDetailsLazyQuery
>
export type FloorDetailsQueryResult = Apollo.QueryResult<
  Types.FloorDetailsQuery,
  Types.FloorDetailsQueryVariables
>
export const FloorDevicesCountDocument = gql`
  query FloorDevicesCount($floorId: ID!) {
    floor(id: $floorId) {
      id
      checkpoints: devices(filter: { typeIn: [CHECKPOINT], isPlaced: true }) {
        totalCount
      }
      devices(filter: { typeIn: [CAMERA, DOOR], isPlaced: true }) {
        totalCount
      }
    }
  }
`

/**
 * __useFloorDevicesCountQuery__
 *
 * To run a query within a React component, call `useFloorDevicesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useFloorDevicesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFloorDevicesCountQuery({
 *   variables: {
 *      floorId: // value for 'floorId'
 *   },
 * });
 */
export function useFloorDevicesCountQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.FloorDevicesCountQuery,
    Types.FloorDevicesCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.FloorDevicesCountQuery,
    Types.FloorDevicesCountQueryVariables
  >(FloorDevicesCountDocument, options)
}
export function useFloorDevicesCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.FloorDevicesCountQuery,
    Types.FloorDevicesCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.FloorDevicesCountQuery,
    Types.FloorDevicesCountQueryVariables
  >(FloorDevicesCountDocument, options)
}
export type FloorDevicesCountQueryHookResult = ReturnType<
  typeof useFloorDevicesCountQuery
>
export type FloorDevicesCountLazyQueryHookResult = ReturnType<
  typeof useFloorDevicesCountLazyQuery
>
export type FloorDevicesCountQueryResult = Apollo.QueryResult<
  Types.FloorDevicesCountQuery,
  Types.FloorDevicesCountQueryVariables
>
export const FloorPlanDetailsDocument = gql`
  query floorPlanDetails($floorId: ID!) {
    currentOrganization {
      name
    }
    floor(id: $floorId) {
      id
      facility {
        id
        name
        shortName
      }
      name
    }
  }
`

/**
 * __useFloorPlanDetailsQuery__
 *
 * To run a query within a React component, call `useFloorPlanDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFloorPlanDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFloorPlanDetailsQuery({
 *   variables: {
 *      floorId: // value for 'floorId'
 *   },
 * });
 */
export function useFloorPlanDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.FloorPlanDetailsQuery,
    Types.FloorPlanDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.FloorPlanDetailsQuery,
    Types.FloorPlanDetailsQueryVariables
  >(FloorPlanDetailsDocument, options)
}
export function useFloorPlanDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.FloorPlanDetailsQuery,
    Types.FloorPlanDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.FloorPlanDetailsQuery,
    Types.FloorPlanDetailsQueryVariables
  >(FloorPlanDetailsDocument, options)
}
export type FloorPlanDetailsQueryHookResult = ReturnType<
  typeof useFloorPlanDetailsQuery
>
export type FloorPlanDetailsLazyQueryHookResult = ReturnType<
  typeof useFloorPlanDetailsLazyQuery
>
export type FloorPlanDetailsQueryResult = Apollo.QueryResult<
  Types.FloorPlanDetailsQuery,
  Types.FloorPlanDetailsQueryVariables
>
export const FloorsDocument = gql`
  query Floors {
    floors(filter: { archived: false }) {
      edges {
        node {
          id
          name
          facility {
            id
            name
          }
        }
      }
    }
  }
`

/**
 * __useFloorsQuery__
 *
 * To run a query within a React component, call `useFloorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFloorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFloorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFloorsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.FloorsQuery,
    Types.FloorsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<Types.FloorsQuery, Types.FloorsQueryVariables>(
    FloorsDocument,
    options
  )
}
export function useFloorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.FloorsQuery,
    Types.FloorsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<Types.FloorsQuery, Types.FloorsQueryVariables>(
    FloorsDocument,
    options
  )
}
export type FloorsQueryHookResult = ReturnType<typeof useFloorsQuery>
export type FloorsLazyQueryHookResult = ReturnType<typeof useFloorsLazyQuery>
export type FloorsQueryResult = Apollo.QueryResult<
  Types.FloorsQuery,
  Types.FloorsQueryVariables
>
export const FloorsByFacilityIdsDocument = gql`
  query floorsByFacilityIds($facilityIds: [ID!]) {
    floors(filter: { facilityIdIn: $facilityIds, archived: false }) {
      edges {
        node {
          id
          name
          facility {
            id
            name
          }
        }
      }
    }
  }
`

/**
 * __useFloorsByFacilityIdsQuery__
 *
 * To run a query within a React component, call `useFloorsByFacilityIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFloorsByFacilityIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFloorsByFacilityIdsQuery({
 *   variables: {
 *      facilityIds: // value for 'facilityIds'
 *   },
 * });
 */
export function useFloorsByFacilityIdsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.FloorsByFacilityIdsQuery,
    Types.FloorsByFacilityIdsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.FloorsByFacilityIdsQuery,
    Types.FloorsByFacilityIdsQueryVariables
  >(FloorsByFacilityIdsDocument, options)
}
export function useFloorsByFacilityIdsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.FloorsByFacilityIdsQuery,
    Types.FloorsByFacilityIdsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.FloorsByFacilityIdsQuery,
    Types.FloorsByFacilityIdsQueryVariables
  >(FloorsByFacilityIdsDocument, options)
}
export type FloorsByFacilityIdsQueryHookResult = ReturnType<
  typeof useFloorsByFacilityIdsQuery
>
export type FloorsByFacilityIdsLazyQueryHookResult = ReturnType<
  typeof useFloorsByFacilityIdsLazyQuery
>
export type FloorsByFacilityIdsQueryResult = Apollo.QueryResult<
  Types.FloorsByFacilityIdsQuery,
  Types.FloorsByFacilityIdsQueryVariables
>
export const FloorsFacilityCheckpointsDocument = gql`
  query FloorsFacilityCheckpoints($id: ID!) {
    floors(filter: { facilityId: $id, archived: false }) {
      edges {
        node {
          id
          name
          devices(filter: { typeIn: [CHECKPOINT], yGt: 0, xGt: 0 }) {
            edges {
              node {
                id
                type
                name
                x
                y
                facility {
                  id
                  name
                }
                checkpoint {
                  id
                  displayId
                }
              }
            }
            totalCount
          }
        }
      }
    }
  }
`

/**
 * __useFloorsFacilityCheckpointsQuery__
 *
 * To run a query within a React component, call `useFloorsFacilityCheckpointsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFloorsFacilityCheckpointsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFloorsFacilityCheckpointsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFloorsFacilityCheckpointsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.FloorsFacilityCheckpointsQuery,
    Types.FloorsFacilityCheckpointsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.FloorsFacilityCheckpointsQuery,
    Types.FloorsFacilityCheckpointsQueryVariables
  >(FloorsFacilityCheckpointsDocument, options)
}
export function useFloorsFacilityCheckpointsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.FloorsFacilityCheckpointsQuery,
    Types.FloorsFacilityCheckpointsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.FloorsFacilityCheckpointsQuery,
    Types.FloorsFacilityCheckpointsQueryVariables
  >(FloorsFacilityCheckpointsDocument, options)
}
export type FloorsFacilityCheckpointsQueryHookResult = ReturnType<
  typeof useFloorsFacilityCheckpointsQuery
>
export type FloorsFacilityCheckpointsLazyQueryHookResult = ReturnType<
  typeof useFloorsFacilityCheckpointsLazyQuery
>
export type FloorsFacilityCheckpointsQueryResult = Apollo.QueryResult<
  Types.FloorsFacilityCheckpointsQuery,
  Types.FloorsFacilityCheckpointsQueryVariables
>
export const GatewayDevicesDocument = gql`
  query GatewayDevices(
    $filter: EdgeDeviceFilterInput
    $first: Int
    $last: Int
    $orderBy: [EdgeDeviceOrderInput]
  ) {
    edgeDevices(
      filter: $filter
      first: $first
      last: $last
      orderBy: $orderBy
    ) {
      totalCount
      pageInfo {
        page
        pageSize
      }
      edges {
        node {
          id
          name
          devices {
            totalCount
            edges {
              node {
                id
                name
                archived
                facility {
                  id
                  name
                  archived
                }
              }
            }
          }
        }
      }
    }
  }
`

/**
 * __useGatewayDevicesQuery__
 *
 * To run a query within a React component, call `useGatewayDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGatewayDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGatewayDevicesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGatewayDevicesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.GatewayDevicesQuery,
    Types.GatewayDevicesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.GatewayDevicesQuery,
    Types.GatewayDevicesQueryVariables
  >(GatewayDevicesDocument, options)
}
export function useGatewayDevicesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GatewayDevicesQuery,
    Types.GatewayDevicesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.GatewayDevicesQuery,
    Types.GatewayDevicesQueryVariables
  >(GatewayDevicesDocument, options)
}
export type GatewayDevicesQueryHookResult = ReturnType<
  typeof useGatewayDevicesQuery
>
export type GatewayDevicesLazyQueryHookResult = ReturnType<
  typeof useGatewayDevicesLazyQuery
>
export type GatewayDevicesQueryResult = Apollo.QueryResult<
  Types.GatewayDevicesQuery,
  Types.GatewayDevicesQueryVariables
>
export const GlobalFacilitiesDocument = gql`
  query GlobalFacilities {
    globalFacilities {
      totalCount
      edges {
        node {
          id
          shortName
          defaultFloorId
          lat
          lon
        }
      }
    }
  }
`

/**
 * __useGlobalFacilitiesQuery__
 *
 * To run a query within a React component, call `useGlobalFacilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalFacilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalFacilitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGlobalFacilitiesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.GlobalFacilitiesQuery,
    Types.GlobalFacilitiesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.GlobalFacilitiesQuery,
    Types.GlobalFacilitiesQueryVariables
  >(GlobalFacilitiesDocument, options)
}
export function useGlobalFacilitiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GlobalFacilitiesQuery,
    Types.GlobalFacilitiesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.GlobalFacilitiesQuery,
    Types.GlobalFacilitiesQueryVariables
  >(GlobalFacilitiesDocument, options)
}
export type GlobalFacilitiesQueryHookResult = ReturnType<
  typeof useGlobalFacilitiesQuery
>
export type GlobalFacilitiesLazyQueryHookResult = ReturnType<
  typeof useGlobalFacilitiesLazyQuery
>
export type GlobalFacilitiesQueryResult = Apollo.QueryResult<
  Types.GlobalFacilitiesQuery,
  Types.GlobalFacilitiesQueryVariables
>
export const GlobalIncidentsDocument = gql`
  query GlobalIncidents(
    $filter: IncidentFilterInput
    $first: Int
    $last: Int
    $orderBy: [IncidentOrderInput]
  ) {
    incidents(filter: $filter, first: $first, last: $last, orderBy: $orderBy) {
      edges {
        node {
          id
          name
          real
          createdAt
          status
          type
          manualIncidentCategoryId
          incidentType {
            displayName
            manual
            icon
            slug
          }
          description
          displayId
          devices {
            id
            name
          }
          facility {
            id
            name
            shortName
          }
        }
      }
    }
  }
`

/**
 * __useGlobalIncidentsQuery__
 *
 * To run a query within a React component, call `useGlobalIncidentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalIncidentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalIncidentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGlobalIncidentsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.GlobalIncidentsQuery,
    Types.GlobalIncidentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.GlobalIncidentsQuery,
    Types.GlobalIncidentsQueryVariables
  >(GlobalIncidentsDocument, options)
}
export function useGlobalIncidentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GlobalIncidentsQuery,
    Types.GlobalIncidentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.GlobalIncidentsQuery,
    Types.GlobalIncidentsQueryVariables
  >(GlobalIncidentsDocument, options)
}
export type GlobalIncidentsQueryHookResult = ReturnType<
  typeof useGlobalIncidentsQuery
>
export type GlobalIncidentsLazyQueryHookResult = ReturnType<
  typeof useGlobalIncidentsLazyQuery
>
export type GlobalIncidentsQueryResult = Apollo.QueryResult<
  Types.GlobalIncidentsQuery,
  Types.GlobalIncidentsQueryVariables
>
export const GlobalUnresolvedIncidentsCountDocument = gql`
  query GlobalUnresolvedIncidentsCount {
    globalUnresolvedIncidentsCount: incidents(filter: { status: ACTIVE }) {
      totalCount
    }
  }
`

/**
 * __useGlobalUnresolvedIncidentsCountQuery__
 *
 * To run a query within a React component, call `useGlobalUnresolvedIncidentsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalUnresolvedIncidentsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalUnresolvedIncidentsCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGlobalUnresolvedIncidentsCountQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.GlobalUnresolvedIncidentsCountQuery,
    Types.GlobalUnresolvedIncidentsCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.GlobalUnresolvedIncidentsCountQuery,
    Types.GlobalUnresolvedIncidentsCountQueryVariables
  >(GlobalUnresolvedIncidentsCountDocument, options)
}
export function useGlobalUnresolvedIncidentsCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GlobalUnresolvedIncidentsCountQuery,
    Types.GlobalUnresolvedIncidentsCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.GlobalUnresolvedIncidentsCountQuery,
    Types.GlobalUnresolvedIncidentsCountQueryVariables
  >(GlobalUnresolvedIncidentsCountDocument, options)
}
export type GlobalUnresolvedIncidentsCountQueryHookResult = ReturnType<
  typeof useGlobalUnresolvedIncidentsCountQuery
>
export type GlobalUnresolvedIncidentsCountLazyQueryHookResult = ReturnType<
  typeof useGlobalUnresolvedIncidentsCountLazyQuery
>
export type GlobalUnresolvedIncidentsCountQueryResult = Apollo.QueryResult<
  Types.GlobalUnresolvedIncidentsCountQuery,
  Types.GlobalUnresolvedIncidentsCountQueryVariables
>
export const CountIncidentsByTypeBetweenDatesDocument = gql`
  query CountIncidentsByTypeBetweenDates(
    $startDate: String
    $endDate: String
    $real: Boolean
    $types: [IncidentType]
  ) {
    kpi {
      countIncidentsByTypeBetweenDates(
        startDate: $startDate
        endDate: $endDate
        real: $real
        types: $types
      ) {
        totalCount
        incidentsTypeByDate {
          date
          day
          incidentsTypes {
            count
            type
          }
        }
      }
    }
  }
`

/**
 * __useCountIncidentsByTypeBetweenDatesQuery__
 *
 * To run a query within a React component, call `useCountIncidentsByTypeBetweenDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountIncidentsByTypeBetweenDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountIncidentsByTypeBetweenDatesQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      real: // value for 'real'
 *      types: // value for 'types'
 *   },
 * });
 */
export function useCountIncidentsByTypeBetweenDatesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.CountIncidentsByTypeBetweenDatesQuery,
    Types.CountIncidentsByTypeBetweenDatesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.CountIncidentsByTypeBetweenDatesQuery,
    Types.CountIncidentsByTypeBetweenDatesQueryVariables
  >(CountIncidentsByTypeBetweenDatesDocument, options)
}
export function useCountIncidentsByTypeBetweenDatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.CountIncidentsByTypeBetweenDatesQuery,
    Types.CountIncidentsByTypeBetweenDatesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.CountIncidentsByTypeBetweenDatesQuery,
    Types.CountIncidentsByTypeBetweenDatesQueryVariables
  >(CountIncidentsByTypeBetweenDatesDocument, options)
}
export type CountIncidentsByTypeBetweenDatesQueryHookResult = ReturnType<
  typeof useCountIncidentsByTypeBetweenDatesQuery
>
export type CountIncidentsByTypeBetweenDatesLazyQueryHookResult = ReturnType<
  typeof useCountIncidentsByTypeBetweenDatesLazyQuery
>
export type CountIncidentsByTypeBetweenDatesQueryResult = Apollo.QueryResult<
  Types.CountIncidentsByTypeBetweenDatesQuery,
  Types.CountIncidentsByTypeBetweenDatesQueryVariables
>
export const GridAnalysisJobDocument = gql`
  query GridAnalysisJob($id: ID!) {
    gridAnalysisJob(id: $id) {
      id
      status
      annotatedVideoUrl
      labeledIn
      labeledOut
      transitions {
        personId
        direction
        timestamp
      }
      updatedAt
    }
  }
`

/**
 * __useGridAnalysisJobQuery__
 *
 * To run a query within a React component, call `useGridAnalysisJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGridAnalysisJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGridAnalysisJobQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGridAnalysisJobQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GridAnalysisJobQuery,
    Types.GridAnalysisJobQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.GridAnalysisJobQuery,
    Types.GridAnalysisJobQueryVariables
  >(GridAnalysisJobDocument, options)
}
export function useGridAnalysisJobLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GridAnalysisJobQuery,
    Types.GridAnalysisJobQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.GridAnalysisJobQuery,
    Types.GridAnalysisJobQueryVariables
  >(GridAnalysisJobDocument, options)
}
export type GridAnalysisJobQueryHookResult = ReturnType<
  typeof useGridAnalysisJobQuery
>
export type GridAnalysisJobLazyQueryHookResult = ReturnType<
  typeof useGridAnalysisJobLazyQuery
>
export type GridAnalysisJobQueryResult = Apollo.QueryResult<
  Types.GridAnalysisJobQuery,
  Types.GridAnalysisJobQueryVariables
>
export const GuardTourDocument = gql`
  query GuardTour($id: ID!) {
    guardTour(id: $id) {
      id
      createdAt
      updatedAt
      submittedAt
      status
      tourPlan {
        id
        name
        checkpointIds
        checkpoints {
          edges {
            node {
              id
              displayId
              device {
                id
                type
                name
                x
                y
                floor {
                  id
                  name
                }
                facility {
                  id
                  name
                }
              }
            }
          }
        }
      }
      guard {
        id
        firstName
        lastName
      }
      completedCheckpoints {
        edges {
          node {
            scannedAt
            note
            checkpointPhotoId
            checkpointPhoto {
              ... on UrlContent {
                url
              }
            }
            checkpoint {
              id
            }
            tasks {
              edges {
                node {
                  id
                  description
                  isRequired
                  isCompleted
                  completedAt
                }
              }
            }
          }
        }
      }
    }
  }
`

/**
 * __useGuardTourQuery__
 *
 * To run a query within a React component, call `useGuardTourQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuardTourQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuardTourQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGuardTourQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GuardTourQuery,
    Types.GuardTourQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<Types.GuardTourQuery, Types.GuardTourQueryVariables>(
    GuardTourDocument,
    options
  )
}
export function useGuardTourLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GuardTourQuery,
    Types.GuardTourQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.GuardTourQuery,
    Types.GuardTourQueryVariables
  >(GuardTourDocument, options)
}
export type GuardTourQueryHookResult = ReturnType<typeof useGuardTourQuery>
export type GuardTourLazyQueryHookResult = ReturnType<
  typeof useGuardTourLazyQuery
>
export type GuardTourQueryResult = Apollo.QueryResult<
  Types.GuardTourQuery,
  Types.GuardTourQueryVariables
>
export const GuardToursDocument = gql`
  query GuardTours(
    $pageIndex: Int
    $pageSize: Int
    $filter: GuardTourFilterInput
    $orderBy: [GuardTourOrderInput]
  ) {
    guardTours(
      first: $pageIndex
      last: $pageSize
      filter: $filter
      orderBy: $orderBy
    ) {
      totalCount
      pageInfo {
        page
        pageSize
      }
      edges {
        node {
          id
          updatedAt
          status
          completedCheckpoints {
            edges {
              node {
                checkpoint {
                  id
                }
              }
            }
          }
          tourPlan {
            id
            name
            checkpointIds
            facility {
              id
              name
              address
              archived
            }
          }
          guard {
            firstName
            lastName
          }
        }
      }
    }
  }
`

/**
 * __useGuardToursQuery__
 *
 * To run a query within a React component, call `useGuardToursQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuardToursQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuardToursQuery({
 *   variables: {
 *      pageIndex: // value for 'pageIndex'
 *      pageSize: // value for 'pageSize'
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGuardToursQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.GuardToursQuery,
    Types.GuardToursQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<Types.GuardToursQuery, Types.GuardToursQueryVariables>(
    GuardToursDocument,
    options
  )
}
export function useGuardToursLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GuardToursQuery,
    Types.GuardToursQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.GuardToursQuery,
    Types.GuardToursQueryVariables
  >(GuardToursDocument, options)
}
export type GuardToursQueryHookResult = ReturnType<typeof useGuardToursQuery>
export type GuardToursLazyQueryHookResult = ReturnType<
  typeof useGuardToursLazyQuery
>
export type GuardToursQueryResult = Apollo.QueryResult<
  Types.GuardToursQuery,
  Types.GuardToursQueryVariables
>
export const HivewatchAwsAccountIdDocument = gql`
  query HivewatchAwsAccountId {
    hivewatchAwsAccountId
  }
`

/**
 * __useHivewatchAwsAccountIdQuery__
 *
 * To run a query within a React component, call `useHivewatchAwsAccountIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useHivewatchAwsAccountIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHivewatchAwsAccountIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useHivewatchAwsAccountIdQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.HivewatchAwsAccountIdQuery,
    Types.HivewatchAwsAccountIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.HivewatchAwsAccountIdQuery,
    Types.HivewatchAwsAccountIdQueryVariables
  >(HivewatchAwsAccountIdDocument, options)
}
export function useHivewatchAwsAccountIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.HivewatchAwsAccountIdQuery,
    Types.HivewatchAwsAccountIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.HivewatchAwsAccountIdQuery,
    Types.HivewatchAwsAccountIdQueryVariables
  >(HivewatchAwsAccountIdDocument, options)
}
export type HivewatchAwsAccountIdQueryHookResult = ReturnType<
  typeof useHivewatchAwsAccountIdQuery
>
export type HivewatchAwsAccountIdLazyQueryHookResult = ReturnType<
  typeof useHivewatchAwsAccountIdLazyQuery
>
export type HivewatchAwsAccountIdQueryResult = Apollo.QueryResult<
  Types.HivewatchAwsAccountIdQuery,
  Types.HivewatchAwsAccountIdQueryVariables
>
export const IncidentDocument = gql`
  query Incident($id: ID!) {
    incident(id: $id) {
      actions {
        id
        createdAt
        type
        message
        history {
          incidentActionType
          oldValue
          newValue
        }
        incident {
          devices {
            id
            name
          }
        }
        creator {
          id
          firstName
          lastName
          roleName
          avatar {
            ... on UrlContent {
              minExpiryTime
              url
            }
          }
        }
        deviceRepairOrder {
          technician {
            firstName
            lastName
          }
        }
        resolutionContent {
          plainText
          segments {
            segmentType
            text
            detectedAt
            externalId
          }
        }
        isRuleAction
        ruleId
        emailRecipients {
          id
        }
      }
      address
      audioMessages {
        edges {
          node {
            id
            createdAt
            creator {
              id
              firstName
              lastName
              roleName
              avatar {
                ... on UrlContent {
                  minExpiryTime
                  url
                }
              }
            }
            audioClip {
              id
              url
            }
          }
        }
      }
      createdAt
      creator {
        id
        firstName
        lastName
        roleName
      }
      description
      detectedAt
      devices {
        id
        name
        type
        status
        camera {
          streamingType
        }
        tailgateConns {
          totalCount
        }
        facility {
          id
          name
          shortName
        }
        floor {
          id
          name
        }
      }
      dispatched
      dispatchedGuardIds
      displayId
      eventExternalIds
      events {
        ... on SystemAction {
          systemMessage
          createdAt
        }
        ... on IncidentAction {
          creatorId
          message
          technicianId
          type
        }
      }
      externalDetail: externalIncidentAdditionalDetail {
        additionalContactInformation
        email
        firstName
        lastName
        locationOfConcern
        partiesInvolved
        phoneNumber
        timeReported
      }
      quickReportDetails {
        reportType
        displayAnswers {
          questionId
          label
          displayValue
          answerType
          sectionName
          order
          fileUrls
        }
      }
      facility {
        id
        name
        archived
        type
        timeZone
        shortName
        address
        latitude
        longitude
        emergencyNumber
        emergencyCalling {
          outboundPhoneNumber
        }
        defaultFloorId
        floors(filter: { archived: false }, first: 0, last: 1) {
          edges {
            node {
              id
            }
          }
        }
      }
      floor {
        id
        name
      }
      guard {
        id
        firstName
        lastName
        avatar {
          ... on UrlContent {
            minExpiryTime
            url
          }
        }
      }
      hasVideoClip
      id
      imageUrls
      incidentType {
        displayName
        icon
        manual
        slug
      }
      incidentTypeDefinitionId
      isFlagged
      isSentToOntic
      lastIncidentDispatchType
      latitude
      longitude
      manualIncidentCategory {
        id
        isQuickReportCategory
        name
      }
      name
      notes {
        edges {
          node {
            id
            message
            media {
              id
              url
              name
              mimeType
            }
            createdAt
            creator {
              id
              firstName
              lastName
              roleName
            }
          }
        }
      }
      owner {
        id
        firstName
        lastName
        avatar {
          ... on UrlContent {
            minExpiryTime
            url
          }
        }
      }
      priority
      real
      source
      status
      systemActions {
        systemMessage
      }
      type
      video {
        url
      }
      wasProcessedByAiOperator
      workflowId
      currentWorkflowStep
      workflowStatus
      workflowStartedTime
      workflowEndTime
      pendingWorkflow {
        versionId
        name
        startingStep
      }
    }
  }
`

/**
 * __useIncidentQuery__
 *
 * To run a query within a React component, call `useIncidentQuery` and pass it any options that fit your needs.
 * When your component renders, `useIncidentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIncidentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIncidentQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.IncidentQuery,
    Types.IncidentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<Types.IncidentQuery, Types.IncidentQueryVariables>(
    IncidentDocument,
    options
  )
}
export function useIncidentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.IncidentQuery,
    Types.IncidentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<Types.IncidentQuery, Types.IncidentQueryVariables>(
    IncidentDocument,
    options
  )
}
export type IncidentQueryHookResult = ReturnType<typeof useIncidentQuery>
export type IncidentLazyQueryHookResult = ReturnType<
  typeof useIncidentLazyQuery
>
export type IncidentQueryResult = Apollo.QueryResult<
  Types.IncidentQuery,
  Types.IncidentQueryVariables
>
export const IncidentAioEvalResultsDocument = gql`
  query IncidentAioEvalResults($incidentId: ID!) {
    incident(id: $incidentId) {
      id
      aiOperatorRuleEvaluations {
        id
        createdAt
        description
        evalIsTrue
        evalPayload
        wasDryRun
        processingTimeSeconds
        responseRule {
          id
          field {
            id
            description
          }
        }
        model {
          id
          canonicalName
        }
      }
    }
  }
`

/**
 * __useIncidentAioEvalResultsQuery__
 *
 * To run a query within a React component, call `useIncidentAioEvalResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIncidentAioEvalResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIncidentAioEvalResultsQuery({
 *   variables: {
 *      incidentId: // value for 'incidentId'
 *   },
 * });
 */
export function useIncidentAioEvalResultsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.IncidentAioEvalResultsQuery,
    Types.IncidentAioEvalResultsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.IncidentAioEvalResultsQuery,
    Types.IncidentAioEvalResultsQueryVariables
  >(IncidentAioEvalResultsDocument, options)
}
export function useIncidentAioEvalResultsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.IncidentAioEvalResultsQuery,
    Types.IncidentAioEvalResultsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.IncidentAioEvalResultsQuery,
    Types.IncidentAioEvalResultsQueryVariables
  >(IncidentAioEvalResultsDocument, options)
}
export type IncidentAioEvalResultsQueryHookResult = ReturnType<
  typeof useIncidentAioEvalResultsQuery
>
export type IncidentAioEvalResultsLazyQueryHookResult = ReturnType<
  typeof useIncidentAioEvalResultsLazyQuery
>
export type IncidentAioEvalResultsQueryResult = Apollo.QueryResult<
  Types.IncidentAioEvalResultsQuery,
  Types.IncidentAioEvalResultsQueryVariables
>
export const IncidentExtendedClipStatusDocument = gql`
  query IncidentExtendedClipStatus($id: ID!) {
    incident(id: $id) {
      id
      clips {
        totalCount
      }
    }
  }
`

/**
 * __useIncidentExtendedClipStatusQuery__
 *
 * To run a query within a React component, call `useIncidentExtendedClipStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useIncidentExtendedClipStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIncidentExtendedClipStatusQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIncidentExtendedClipStatusQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.IncidentExtendedClipStatusQuery,
    Types.IncidentExtendedClipStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.IncidentExtendedClipStatusQuery,
    Types.IncidentExtendedClipStatusQueryVariables
  >(IncidentExtendedClipStatusDocument, options)
}
export function useIncidentExtendedClipStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.IncidentExtendedClipStatusQuery,
    Types.IncidentExtendedClipStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.IncidentExtendedClipStatusQuery,
    Types.IncidentExtendedClipStatusQueryVariables
  >(IncidentExtendedClipStatusDocument, options)
}
export type IncidentExtendedClipStatusQueryHookResult = ReturnType<
  typeof useIncidentExtendedClipStatusQuery
>
export type IncidentExtendedClipStatusLazyQueryHookResult = ReturnType<
  typeof useIncidentExtendedClipStatusLazyQuery
>
export type IncidentExtendedClipStatusQueryResult = Apollo.QueryResult<
  Types.IncidentExtendedClipStatusQuery,
  Types.IncidentExtendedClipStatusQueryVariables
>
export const IncidentFeedItemsDocument = gql`
  query IncidentFeedItems($id: ID!) {
    incidentFeedItems: incident(id: $id) {
      audioMessages {
        totalCount
      }
      notes {
        totalCount
      }
      actions {
        id
      }
      events {
        ... on SystemAction {
          systemMessage
          createdAt
        }
      }
    }
  }
`

/**
 * __useIncidentFeedItemsQuery__
 *
 * To run a query within a React component, call `useIncidentFeedItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIncidentFeedItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIncidentFeedItemsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIncidentFeedItemsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.IncidentFeedItemsQuery,
    Types.IncidentFeedItemsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.IncidentFeedItemsQuery,
    Types.IncidentFeedItemsQueryVariables
  >(IncidentFeedItemsDocument, options)
}
export function useIncidentFeedItemsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.IncidentFeedItemsQuery,
    Types.IncidentFeedItemsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.IncidentFeedItemsQuery,
    Types.IncidentFeedItemsQueryVariables
  >(IncidentFeedItemsDocument, options)
}
export type IncidentFeedItemsQueryHookResult = ReturnType<
  typeof useIncidentFeedItemsQuery
>
export type IncidentFeedItemsLazyQueryHookResult = ReturnType<
  typeof useIncidentFeedItemsLazyQuery
>
export type IncidentFeedItemsQueryResult = Apollo.QueryResult<
  Types.IncidentFeedItemsQuery,
  Types.IncidentFeedItemsQueryVariables
>
export const IncidentFiltersEnrichmentDocument = gql`
  query IncidentFiltersEnrichment(
    $includeArchived: Boolean!
    $deviceIdIn: [ID!]
    $floorIdIn: [ID!]
    $facilityIdIn: [ID!]
  ) {
    facilityNames: facilities(
      filter: { includeArchived: $includeArchived, idIn: $facilityIdIn }
      last: 100
      orderBy: [{ direction: ASC, field: NAME }]
    ) {
      edges {
        node {
          id
          name
          shortName
          archived
        }
      }
    }
    devices(filter: { idIn: $deviceIdIn }) {
      edges {
        node {
          id
          name
          facility {
            name
          }
        }
      }
    }
    floors(filter: { idIn: $floorIdIn }) {
      edges {
        node {
          id
          name
          facility {
            name
          }
        }
      }
    }
    manualIncidentCategories {
      edges {
        node {
          id
          name
          isQuickReportCategory
        }
      }
    }
  }
`

/**
 * __useIncidentFiltersEnrichmentQuery__
 *
 * To run a query within a React component, call `useIncidentFiltersEnrichmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useIncidentFiltersEnrichmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIncidentFiltersEnrichmentQuery({
 *   variables: {
 *      includeArchived: // value for 'includeArchived'
 *      deviceIdIn: // value for 'deviceIdIn'
 *      floorIdIn: // value for 'floorIdIn'
 *      facilityIdIn: // value for 'facilityIdIn'
 *   },
 * });
 */
export function useIncidentFiltersEnrichmentQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.IncidentFiltersEnrichmentQuery,
    Types.IncidentFiltersEnrichmentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.IncidentFiltersEnrichmentQuery,
    Types.IncidentFiltersEnrichmentQueryVariables
  >(IncidentFiltersEnrichmentDocument, options)
}
export function useIncidentFiltersEnrichmentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.IncidentFiltersEnrichmentQuery,
    Types.IncidentFiltersEnrichmentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.IncidentFiltersEnrichmentQuery,
    Types.IncidentFiltersEnrichmentQueryVariables
  >(IncidentFiltersEnrichmentDocument, options)
}
export type IncidentFiltersEnrichmentQueryHookResult = ReturnType<
  typeof useIncidentFiltersEnrichmentQuery
>
export type IncidentFiltersEnrichmentLazyQueryHookResult = ReturnType<
  typeof useIncidentFiltersEnrichmentLazyQuery
>
export type IncidentFiltersEnrichmentQueryResult = Apollo.QueryResult<
  Types.IncidentFiltersEnrichmentQuery,
  Types.IncidentFiltersEnrichmentQueryVariables
>
export const IncidentReasoningTrailDocument = gql`
  query IncidentReasoningTrail($id: ID!) {
    incident(id: $id) {
      id
      aiOperatorLatestFeedback {
        id
        isPositive
        message
        createdAt
      }
      aiOperatorReasoningTrail {
        steps {
          fieldId
          label
          sourceType
          result
          isDecisive
          description
          metadataCard {
            title
            rows {
              label
              value
            }
          }
          traceLogLink {
            deviceId
            highlightedEvent {
              detectedAt
              externalId
            }
          }
        }
        outcome {
          kind
          title
          description
        }
      }
    }
  }
`

/**
 * __useIncidentReasoningTrailQuery__
 *
 * To run a query within a React component, call `useIncidentReasoningTrailQuery` and pass it any options that fit your needs.
 * When your component renders, `useIncidentReasoningTrailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIncidentReasoningTrailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIncidentReasoningTrailQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.IncidentReasoningTrailQuery,
    Types.IncidentReasoningTrailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.IncidentReasoningTrailQuery,
    Types.IncidentReasoningTrailQueryVariables
  >(IncidentReasoningTrailDocument, options)
}
export function useIncidentReasoningTrailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.IncidentReasoningTrailQuery,
    Types.IncidentReasoningTrailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.IncidentReasoningTrailQuery,
    Types.IncidentReasoningTrailQueryVariables
  >(IncidentReasoningTrailDocument, options)
}
export type IncidentReasoningTrailQueryHookResult = ReturnType<
  typeof useIncidentReasoningTrailQuery
>
export type IncidentReasoningTrailLazyQueryHookResult = ReturnType<
  typeof useIncidentReasoningTrailLazyQuery
>
export type IncidentReasoningTrailQueryResult = Apollo.QueryResult<
  Types.IncidentReasoningTrailQuery,
  Types.IncidentReasoningTrailQueryVariables
>
export const IncidentVideoDocument = gql`
  query IncidentVideo($id: ID!) {
    incident(id: $id) {
      id
      video {
        url
        expiryTime
      }
      clips {
        edges {
          node {
            kind
            startTime
            endTime
            video {
              url
              expiryTime
            }
          }
        }
      }
    }
  }
`

/**
 * __useIncidentVideoQuery__
 *
 * To run a query within a React component, call `useIncidentVideoQuery` and pass it any options that fit your needs.
 * When your component renders, `useIncidentVideoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIncidentVideoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIncidentVideoQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.IncidentVideoQuery,
    Types.IncidentVideoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.IncidentVideoQuery,
    Types.IncidentVideoQueryVariables
  >(IncidentVideoDocument, options)
}
export function useIncidentVideoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.IncidentVideoQuery,
    Types.IncidentVideoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.IncidentVideoQuery,
    Types.IncidentVideoQueryVariables
  >(IncidentVideoDocument, options)
}
export type IncidentVideoQueryHookResult = ReturnType<
  typeof useIncidentVideoQuery
>
export type IncidentVideoLazyQueryHookResult = ReturnType<
  typeof useIncidentVideoLazyQuery
>
export type IncidentVideoQueryResult = Apollo.QueryResult<
  Types.IncidentVideoQuery,
  Types.IncidentVideoQueryVariables
>
export const IncidentWithDisplayIdDocument = gql`
  query IncidentWithDisplayId($displayId: String) {
    incidents(filter: { displayId: $displayId, mutedStatus: ALL }) {
      edges {
        node {
          id
        }
      }
    }
  }
`

/**
 * __useIncidentWithDisplayIdQuery__
 *
 * To run a query within a React component, call `useIncidentWithDisplayIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useIncidentWithDisplayIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIncidentWithDisplayIdQuery({
 *   variables: {
 *      displayId: // value for 'displayId'
 *   },
 * });
 */
export function useIncidentWithDisplayIdQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.IncidentWithDisplayIdQuery,
    Types.IncidentWithDisplayIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.IncidentWithDisplayIdQuery,
    Types.IncidentWithDisplayIdQueryVariables
  >(IncidentWithDisplayIdDocument, options)
}
export function useIncidentWithDisplayIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.IncidentWithDisplayIdQuery,
    Types.IncidentWithDisplayIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.IncidentWithDisplayIdQuery,
    Types.IncidentWithDisplayIdQueryVariables
  >(IncidentWithDisplayIdDocument, options)
}
export type IncidentWithDisplayIdQueryHookResult = ReturnType<
  typeof useIncidentWithDisplayIdQuery
>
export type IncidentWithDisplayIdLazyQueryHookResult = ReturnType<
  typeof useIncidentWithDisplayIdLazyQuery
>
export type IncidentWithDisplayIdQueryResult = Apollo.QueryResult<
  Types.IncidentWithDisplayIdQuery,
  Types.IncidentWithDisplayIdQueryVariables
>
export const IncidentWorkflowActionsDocument = gql`
  query IncidentWorkflowActions($incidentId: ID!) {
    incidentWorkflowActions(incidentId: $incidentId) {
      id
      incidentId
      sourceNodeId
      targetNodeId
      outcomeValue
      type
      actionTimestamp
      userId
    }
  }
`

/**
 * __useIncidentWorkflowActionsQuery__
 *
 * To run a query within a React component, call `useIncidentWorkflowActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIncidentWorkflowActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIncidentWorkflowActionsQuery({
 *   variables: {
 *      incidentId: // value for 'incidentId'
 *   },
 * });
 */
export function useIncidentWorkflowActionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.IncidentWorkflowActionsQuery,
    Types.IncidentWorkflowActionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.IncidentWorkflowActionsQuery,
    Types.IncidentWorkflowActionsQueryVariables
  >(IncidentWorkflowActionsDocument, options)
}
export function useIncidentWorkflowActionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.IncidentWorkflowActionsQuery,
    Types.IncidentWorkflowActionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.IncidentWorkflowActionsQuery,
    Types.IncidentWorkflowActionsQueryVariables
  >(IncidentWorkflowActionsDocument, options)
}
export type IncidentWorkflowActionsQueryHookResult = ReturnType<
  typeof useIncidentWorkflowActionsQuery
>
export type IncidentWorkflowActionsLazyQueryHookResult = ReturnType<
  typeof useIncidentWorkflowActionsLazyQuery
>
export type IncidentWorkflowActionsQueryResult = Apollo.QueryResult<
  Types.IncidentWorkflowActionsQuery,
  Types.IncidentWorkflowActionsQueryVariables
>
export const IncidentWorkflowByIdDocument = gql`
  query IncidentWorkflowById($versionId: ID!) {
    incidentWorkflow(versionId: $versionId) {
      versionId
      workflowId
      name
      startingStep
      state
      steps {
        id
        prompt
        stepType
        edges {
          label
          toStepId
        }
      }
    }
  }
`

/**
 * __useIncidentWorkflowByIdQuery__
 *
 * To run a query within a React component, call `useIncidentWorkflowByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useIncidentWorkflowByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIncidentWorkflowByIdQuery({
 *   variables: {
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useIncidentWorkflowByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.IncidentWorkflowByIdQuery,
    Types.IncidentWorkflowByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.IncidentWorkflowByIdQuery,
    Types.IncidentWorkflowByIdQueryVariables
  >(IncidentWorkflowByIdDocument, options)
}
export function useIncidentWorkflowByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.IncidentWorkflowByIdQuery,
    Types.IncidentWorkflowByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.IncidentWorkflowByIdQuery,
    Types.IncidentWorkflowByIdQueryVariables
  >(IncidentWorkflowByIdDocument, options)
}
export type IncidentWorkflowByIdQueryHookResult = ReturnType<
  typeof useIncidentWorkflowByIdQuery
>
export type IncidentWorkflowByIdLazyQueryHookResult = ReturnType<
  typeof useIncidentWorkflowByIdLazyQuery
>
export type IncidentWorkflowByIdQueryResult = Apollo.QueryResult<
  Types.IncidentWorkflowByIdQuery,
  Types.IncidentWorkflowByIdQueryVariables
>
export const IncidentWorkflowsDocument = gql`
  query IncidentWorkflows($filter: IncidentWorkflowFilterInput) {
    incidentWorkflows(filter: $filter) {
      versionId
      workflowId
      name
      createTime
      creatorId
      creator {
        id
        firstName
        lastName
      }
      state
    }
  }
`

/**
 * __useIncidentWorkflowsQuery__
 *
 * To run a query within a React component, call `useIncidentWorkflowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIncidentWorkflowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIncidentWorkflowsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useIncidentWorkflowsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.IncidentWorkflowsQuery,
    Types.IncidentWorkflowsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.IncidentWorkflowsQuery,
    Types.IncidentWorkflowsQueryVariables
  >(IncidentWorkflowsDocument, options)
}
export function useIncidentWorkflowsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.IncidentWorkflowsQuery,
    Types.IncidentWorkflowsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.IncidentWorkflowsQuery,
    Types.IncidentWorkflowsQueryVariables
  >(IncidentWorkflowsDocument, options)
}
export type IncidentWorkflowsQueryHookResult = ReturnType<
  typeof useIncidentWorkflowsQuery
>
export type IncidentWorkflowsLazyQueryHookResult = ReturnType<
  typeof useIncidentWorkflowsLazyQuery
>
export type IncidentWorkflowsQueryResult = Apollo.QueryResult<
  Types.IncidentWorkflowsQuery,
  Types.IncidentWorkflowsQueryVariables
>
export const IncidentsDocument = gql`
  query Incidents(
    $filter: IncidentFilterInput
    $first: Int
    $last: Int
    $orderBy: [IncidentOrderInput]
  ) {
    incidents(filter: $filter, first: $first, last: $last, orderBy: $orderBy) {
      edges {
        node {
          id
          name
          status
          real
          description
          type
          incidentType {
            displayName
            icon
            slug
          }
          createdAt
          source
          isFlagged
          hasVideoClip
          priority
          guard {
            id
            firstName
            lastName
            avatar {
              ... on UrlContent {
                minExpiryTime
                url
              }
            }
          }
          owner {
            id
            firstName
            lastName
            avatar {
              ... on UrlContent {
                minExpiryTime
                url
              }
            }
          }
          ownerId
          displayId
          dispatched
          devices {
            id
            name
            type
            facility {
              id
              name
              shortName
            }
            floor {
              id
              name
            }
          }
          externalDetail: externalIncidentAdditionalDetail {
            timeReported
          }
          facility {
            id
            name
            shortName
            archived
          }
          floor {
            id
            name
          }
          actions {
            type
          }
          audioMessages {
            totalCount
            edges {
              node {
                createdAt
              }
            }
          }
        }
      }
      totalCount
    }
  }
`

/**
 * __useIncidentsQuery__
 *
 * To run a query within a React component, call `useIncidentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIncidentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIncidentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useIncidentsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.IncidentsQuery,
    Types.IncidentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<Types.IncidentsQuery, Types.IncidentsQueryVariables>(
    IncidentsDocument,
    options
  )
}
export function useIncidentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.IncidentsQuery,
    Types.IncidentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.IncidentsQuery,
    Types.IncidentsQueryVariables
  >(IncidentsDocument, options)
}
export type IncidentsQueryHookResult = ReturnType<typeof useIncidentsQuery>
export type IncidentsLazyQueryHookResult = ReturnType<
  typeof useIncidentsLazyQuery
>
export type IncidentsQueryResult = Apollo.QueryResult<
  Types.IncidentsQuery,
  Types.IncidentsQueryVariables
>
export const IncidentsByMarketFacilityDocument = gql`
  query IncidentsByMarketFacility {
    incidents(
      filter: { facilityType: MARKET, statusIn: [IN_PROGRESS, ACTIVE] }
    ) {
      edges {
        node {
          id
          displayId
          name
          description
          latitude
          longitude
          address
          facility {
            name
          }
        }
      }
      totalCount
    }
  }
`

/**
 * __useIncidentsByMarketFacilityQuery__
 *
 * To run a query within a React component, call `useIncidentsByMarketFacilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useIncidentsByMarketFacilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIncidentsByMarketFacilityQuery({
 *   variables: {
 *   },
 * });
 */
export function useIncidentsByMarketFacilityQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.IncidentsByMarketFacilityQuery,
    Types.IncidentsByMarketFacilityQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.IncidentsByMarketFacilityQuery,
    Types.IncidentsByMarketFacilityQueryVariables
  >(IncidentsByMarketFacilityDocument, options)
}
export function useIncidentsByMarketFacilityLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.IncidentsByMarketFacilityQuery,
    Types.IncidentsByMarketFacilityQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.IncidentsByMarketFacilityQuery,
    Types.IncidentsByMarketFacilityQueryVariables
  >(IncidentsByMarketFacilityDocument, options)
}
export type IncidentsByMarketFacilityQueryHookResult = ReturnType<
  typeof useIncidentsByMarketFacilityQuery
>
export type IncidentsByMarketFacilityLazyQueryHookResult = ReturnType<
  typeof useIncidentsByMarketFacilityLazyQuery
>
export type IncidentsByMarketFacilityQueryResult = Apollo.QueryResult<
  Types.IncidentsByMarketFacilityQuery,
  Types.IncidentsByMarketFacilityQueryVariables
>
export const IncidentsForCaseDocument = gql`
  query IncidentsForCase($filter: IncidentFilterInput) {
    incidents(filter: $filter) {
      edges {
        node {
          createdAt
          displayId
          id
          name
          facility {
            id
            name
            shortName
          }
        }
      }
    }
  }
`

/**
 * __useIncidentsForCaseQuery__
 *
 * To run a query within a React component, call `useIncidentsForCaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useIncidentsForCaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIncidentsForCaseQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useIncidentsForCaseQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.IncidentsForCaseQuery,
    Types.IncidentsForCaseQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.IncidentsForCaseQuery,
    Types.IncidentsForCaseQueryVariables
  >(IncidentsForCaseDocument, options)
}
export function useIncidentsForCaseLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.IncidentsForCaseQuery,
    Types.IncidentsForCaseQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.IncidentsForCaseQuery,
    Types.IncidentsForCaseQueryVariables
  >(IncidentsForCaseDocument, options)
}
export type IncidentsForCaseQueryHookResult = ReturnType<
  typeof useIncidentsForCaseQuery
>
export type IncidentsForCaseLazyQueryHookResult = ReturnType<
  typeof useIncidentsForCaseLazyQuery
>
export type IncidentsForCaseQueryResult = Apollo.QueryResult<
  Types.IncidentsForCaseQuery,
  Types.IncidentsForCaseQueryVariables
>
export const IncidentsTotalCountDocument = gql`
  query IncidentsTotalCount($filter: IncidentFilterInput) {
    incidents(filter: $filter) {
      totalCount
    }
  }
`

/**
 * __useIncidentsTotalCountQuery__
 *
 * To run a query within a React component, call `useIncidentsTotalCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useIncidentsTotalCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIncidentsTotalCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useIncidentsTotalCountQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.IncidentsTotalCountQuery,
    Types.IncidentsTotalCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.IncidentsTotalCountQuery,
    Types.IncidentsTotalCountQueryVariables
  >(IncidentsTotalCountDocument, options)
}
export function useIncidentsTotalCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.IncidentsTotalCountQuery,
    Types.IncidentsTotalCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.IncidentsTotalCountQuery,
    Types.IncidentsTotalCountQueryVariables
  >(IncidentsTotalCountDocument, options)
}
export type IncidentsTotalCountQueryHookResult = ReturnType<
  typeof useIncidentsTotalCountQuery
>
export type IncidentsTotalCountLazyQueryHookResult = ReturnType<
  typeof useIncidentsTotalCountLazyQuery
>
export type IncidentsTotalCountQueryResult = Apollo.QueryResult<
  Types.IncidentsTotalCountQuery,
  Types.IncidentsTotalCountQueryVariables
>
export const LastDatabaseResetDocument = gql`
  query LastDatabaseReset {
    lastDatabaseReset {
      createdAt
      createdBy
    }
  }
`

/**
 * __useLastDatabaseResetQuery__
 *
 * To run a query within a React component, call `useLastDatabaseResetQuery` and pass it any options that fit your needs.
 * When your component renders, `useLastDatabaseResetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLastDatabaseResetQuery({
 *   variables: {
 *   },
 * });
 */
export function useLastDatabaseResetQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.LastDatabaseResetQuery,
    Types.LastDatabaseResetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.LastDatabaseResetQuery,
    Types.LastDatabaseResetQueryVariables
  >(LastDatabaseResetDocument, options)
}
export function useLastDatabaseResetLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.LastDatabaseResetQuery,
    Types.LastDatabaseResetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.LastDatabaseResetQuery,
    Types.LastDatabaseResetQueryVariables
  >(LastDatabaseResetDocument, options)
}
export type LastDatabaseResetQueryHookResult = ReturnType<
  typeof useLastDatabaseResetQuery
>
export type LastDatabaseResetLazyQueryHookResult = ReturnType<
  typeof useLastDatabaseResetLazyQuery
>
export type LastDatabaseResetQueryResult = Apollo.QueryResult<
  Types.LastDatabaseResetQuery,
  Types.LastDatabaseResetQueryVariables
>
export const LastIncidentWithClipByDeviceDocument = gql`
  query LastIncidentWithClipByDevice($deviceId: ID!) {
    incidents(
      filter: { deviceIdIn: [$deviceId], hasVideoClip: true }
      orderBy: [{ field: CREATED_AT, direction: DESC }]
      last: 1
    ) {
      edges {
        node {
          id
          hasVideoClip
          createdAt
          video {
            url
            expiryTime
          }
        }
      }
    }
  }
`

/**
 * __useLastIncidentWithClipByDeviceQuery__
 *
 * To run a query within a React component, call `useLastIncidentWithClipByDeviceQuery` and pass it any options that fit your needs.
 * When your component renders, `useLastIncidentWithClipByDeviceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLastIncidentWithClipByDeviceQuery({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *   },
 * });
 */
export function useLastIncidentWithClipByDeviceQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.LastIncidentWithClipByDeviceQuery,
    Types.LastIncidentWithClipByDeviceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.LastIncidentWithClipByDeviceQuery,
    Types.LastIncidentWithClipByDeviceQueryVariables
  >(LastIncidentWithClipByDeviceDocument, options)
}
export function useLastIncidentWithClipByDeviceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.LastIncidentWithClipByDeviceQuery,
    Types.LastIncidentWithClipByDeviceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.LastIncidentWithClipByDeviceQuery,
    Types.LastIncidentWithClipByDeviceQueryVariables
  >(LastIncidentWithClipByDeviceDocument, options)
}
export type LastIncidentWithClipByDeviceQueryHookResult = ReturnType<
  typeof useLastIncidentWithClipByDeviceQuery
>
export type LastIncidentWithClipByDeviceLazyQueryHookResult = ReturnType<
  typeof useLastIncidentWithClipByDeviceLazyQuery
>
export type LastIncidentWithClipByDeviceQueryResult = Apollo.QueryResult<
  Types.LastIncidentWithClipByDeviceQuery,
  Types.LastIncidentWithClipByDeviceQueryVariables
>
export const ListCustomerSecretProviderDocument = gql`
  query ListCustomerSecretProvider(
    $orderBy: [CustomerSecretProviderOrderInput!]
  ) {
    customerSecretProviders(orderBy: $orderBy) {
      edges {
        node {
          id
          providerAccountId
          providerName
          providerRegion
          providerType
          secretNamespace
          entities {
            edges {
              entityId
              entityType
              node {
                ... on Camera {
                  id
                  externalId
                  rtspIp
                }
                ... on PacsSourceInstance {
                  id
                  name
                }
                ... on ExternalAccountApiKey {
                  id
                  secretName
                  externalAccount {
                    accountName
                  }
                  permissionName
                }
              }
            }
          }
          kmsKeyId
          kmsRegion
          kmsAlias
          organizationId
          createdAt
          updatedAt
        }
      }
    }
  }
`

/**
 * __useListCustomerSecretProviderQuery__
 *
 * To run a query within a React component, call `useListCustomerSecretProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCustomerSecretProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCustomerSecretProviderQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useListCustomerSecretProviderQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.ListCustomerSecretProviderQuery,
    Types.ListCustomerSecretProviderQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.ListCustomerSecretProviderQuery,
    Types.ListCustomerSecretProviderQueryVariables
  >(ListCustomerSecretProviderDocument, options)
}
export function useListCustomerSecretProviderLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.ListCustomerSecretProviderQuery,
    Types.ListCustomerSecretProviderQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.ListCustomerSecretProviderQuery,
    Types.ListCustomerSecretProviderQueryVariables
  >(ListCustomerSecretProviderDocument, options)
}
export type ListCustomerSecretProviderQueryHookResult = ReturnType<
  typeof useListCustomerSecretProviderQuery
>
export type ListCustomerSecretProviderLazyQueryHookResult = ReturnType<
  typeof useListCustomerSecretProviderLazyQuery
>
export type ListCustomerSecretProviderQueryResult = Apollo.QueryResult<
  Types.ListCustomerSecretProviderQuery,
  Types.ListCustomerSecretProviderQueryVariables
>
export const ListIncidentTypesDocument = gql`
  query ListIncidentTypes($archived: Boolean, $manual: Boolean) {
    incidentTypes(archived: $archived, manual: $manual) {
      items {
        aioAllowedCriteria
        archived
        defaultPriority
        displayName
        icon
        id
        manual
        mutable
        quickReport
        slug
      }
    }
  }
`

/**
 * __useListIncidentTypesQuery__
 *
 * To run a query within a React component, call `useListIncidentTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListIncidentTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListIncidentTypesQuery({
 *   variables: {
 *      archived: // value for 'archived'
 *      manual: // value for 'manual'
 *   },
 * });
 */
export function useListIncidentTypesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.ListIncidentTypesQuery,
    Types.ListIncidentTypesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.ListIncidentTypesQuery,
    Types.ListIncidentTypesQueryVariables
  >(ListIncidentTypesDocument, options)
}
export function useListIncidentTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.ListIncidentTypesQuery,
    Types.ListIncidentTypesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.ListIncidentTypesQuery,
    Types.ListIncidentTypesQueryVariables
  >(ListIncidentTypesDocument, options)
}
export type ListIncidentTypesQueryHookResult = ReturnType<
  typeof useListIncidentTypesQuery
>
export type ListIncidentTypesLazyQueryHookResult = ReturnType<
  typeof useListIncidentTypesLazyQuery
>
export type ListIncidentTypesQueryResult = Apollo.QueryResult<
  Types.ListIncidentTypesQuery,
  Types.ListIncidentTypesQueryVariables
>
export const ManagedAccountsDocument = gql`
  query ManagedAccounts {
    managedAccounts: users(orderBy: [{ direction: ASC, field: LAST_NAME }]) {
      edges {
        node {
          id
          email
          lastName
          firstName
          roles
          roleName
          designatedFacility {
            id
            name
          }
        }
      }
    }
  }
`

/**
 * __useManagedAccountsQuery__
 *
 * To run a query within a React component, call `useManagedAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useManagedAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagedAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useManagedAccountsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.ManagedAccountsQuery,
    Types.ManagedAccountsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.ManagedAccountsQuery,
    Types.ManagedAccountsQueryVariables
  >(ManagedAccountsDocument, options)
}
export function useManagedAccountsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.ManagedAccountsQuery,
    Types.ManagedAccountsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.ManagedAccountsQuery,
    Types.ManagedAccountsQueryVariables
  >(ManagedAccountsDocument, options)
}
export type ManagedAccountsQueryHookResult = ReturnType<
  typeof useManagedAccountsQuery
>
export type ManagedAccountsLazyQueryHookResult = ReturnType<
  typeof useManagedAccountsLazyQuery
>
export type ManagedAccountsQueryResult = Apollo.QueryResult<
  Types.ManagedAccountsQuery,
  Types.ManagedAccountsQueryVariables
>
export const MeDocument = gql`
  query Me {
    me {
      id
      avatar {
        ... on UrlContent {
          minExpiryTime
          url
        }
      }
      email
      roles
      roleName
      firstName
      lastName
      username
    }
  }
`

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(
  baseOptions?: Apollo.QueryHookOptions<Types.MeQuery, Types.MeQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<Types.MeQuery, Types.MeQueryVariables>(
    MeDocument,
    options
  )
}
export function useMeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.MeQuery,
    Types.MeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<Types.MeQuery, Types.MeQueryVariables>(
    MeDocument,
    options
  )
}
export type MeQueryHookResult = ReturnType<typeof useMeQuery>
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>
export type MeQueryResult = Apollo.QueryResult<
  Types.MeQuery,
  Types.MeQueryVariables
>
export const MseStreamDocument = gql`
  query MSEStream($deviceId: ID!) {
    streamingUrlWrapper(deviceId: $deviceId) {
      url
      expiryTime
      headers {
        key
        value
      }
    }
  }
`

/**
 * __useMseStreamQuery__
 *
 * To run a query within a React component, call `useMseStreamQuery` and pass it any options that fit your needs.
 * When your component renders, `useMseStreamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMseStreamQuery({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *   },
 * });
 */
export function useMseStreamQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.MseStreamQuery,
    Types.MseStreamQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<Types.MseStreamQuery, Types.MseStreamQueryVariables>(
    MseStreamDocument,
    options
  )
}
export function useMseStreamLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.MseStreamQuery,
    Types.MseStreamQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.MseStreamQuery,
    Types.MseStreamQueryVariables
  >(MseStreamDocument, options)
}
export type MseStreamQueryHookResult = ReturnType<typeof useMseStreamQuery>
export type MseStreamLazyQueryHookResult = ReturnType<
  typeof useMseStreamLazyQuery
>
export type MseStreamQueryResult = Apollo.QueryResult<
  Types.MseStreamQuery,
  Types.MseStreamQueryVariables
>
export const MySettingDocument = gql`
  query MySetting {
    mySetting {
      audibleAlertsEnabled
      completedFtus
    }
  }
`

/**
 * __useMySettingQuery__
 *
 * To run a query within a React component, call `useMySettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useMySettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMySettingQuery({
 *   variables: {
 *   },
 * });
 */
export function useMySettingQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.MySettingQuery,
    Types.MySettingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<Types.MySettingQuery, Types.MySettingQueryVariables>(
    MySettingDocument,
    options
  )
}
export function useMySettingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.MySettingQuery,
    Types.MySettingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.MySettingQuery,
    Types.MySettingQueryVariables
  >(MySettingDocument, options)
}
export type MySettingQueryHookResult = ReturnType<typeof useMySettingQuery>
export type MySettingLazyQueryHookResult = ReturnType<
  typeof useMySettingLazyQuery
>
export type MySettingQueryResult = Apollo.QueryResult<
  Types.MySettingQuery,
  Types.MySettingQueryVariables
>
export const NextUpIncidentDocument = gql`
  query NextUpIncident(
    $filter: IncidentFilterInput
    $first: Int
    $last: Int
    $orderBy: [IncidentOrderInput]
  ) {
    incidents(filter: $filter, first: $first, last: $last, orderBy: $orderBy) {
      edges {
        node {
          id
          displayId
          priority
        }
      }
      totalCount
    }
  }
`

/**
 * __useNextUpIncidentQuery__
 *
 * To run a query within a React component, call `useNextUpIncidentQuery` and pass it any options that fit your needs.
 * When your component renders, `useNextUpIncidentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNextUpIncidentQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useNextUpIncidentQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.NextUpIncidentQuery,
    Types.NextUpIncidentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.NextUpIncidentQuery,
    Types.NextUpIncidentQueryVariables
  >(NextUpIncidentDocument, options)
}
export function useNextUpIncidentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.NextUpIncidentQuery,
    Types.NextUpIncidentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.NextUpIncidentQuery,
    Types.NextUpIncidentQueryVariables
  >(NextUpIncidentDocument, options)
}
export type NextUpIncidentQueryHookResult = ReturnType<
  typeof useNextUpIncidentQuery
>
export type NextUpIncidentLazyQueryHookResult = ReturnType<
  typeof useNextUpIncidentLazyQuery
>
export type NextUpIncidentQueryResult = Apollo.QueryResult<
  Types.NextUpIncidentQuery,
  Types.NextUpIncidentQueryVariables
>
export const OrganizationDocument = gql`
  query Organization {
    currentOrganization {
      name
    }
  }
`

/**
 * __useOrganizationQuery__
 *
 * To run a query within a React component, call `useOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.OrganizationQuery,
    Types.OrganizationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.OrganizationQuery,
    Types.OrganizationQueryVariables
  >(OrganizationDocument, options)
}
export function useOrganizationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.OrganizationQuery,
    Types.OrganizationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.OrganizationQuery,
    Types.OrganizationQueryVariables
  >(OrganizationDocument, options)
}
export type OrganizationQueryHookResult = ReturnType<
  typeof useOrganizationQuery
>
export type OrganizationLazyQueryHookResult = ReturnType<
  typeof useOrganizationLazyQuery
>
export type OrganizationQueryResult = Apollo.QueryResult<
  Types.OrganizationQuery,
  Types.OrganizationQueryVariables
>
export const OrganizationFacilitiesDocument = gql`
  query OrganizationFacilities($box: GeoFenceBoxInput) {
    facilities(filter: { box: $box, type: NORMAL }) {
      edges {
        node {
          id
          shortName
          defaultFloorId
          latitude
          longitude
          floors(filter: { archived: false }, first: 1) {
            edges {
              node {
                id
              }
            }
          }
        }
      }
    }
  }
`

/**
 * __useOrganizationFacilitiesQuery__
 *
 * To run a query within a React component, call `useOrganizationFacilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationFacilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationFacilitiesQuery({
 *   variables: {
 *      box: // value for 'box'
 *   },
 * });
 */
export function useOrganizationFacilitiesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.OrganizationFacilitiesQuery,
    Types.OrganizationFacilitiesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.OrganizationFacilitiesQuery,
    Types.OrganizationFacilitiesQueryVariables
  >(OrganizationFacilitiesDocument, options)
}
export function useOrganizationFacilitiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.OrganizationFacilitiesQuery,
    Types.OrganizationFacilitiesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.OrganizationFacilitiesQuery,
    Types.OrganizationFacilitiesQueryVariables
  >(OrganizationFacilitiesDocument, options)
}
export type OrganizationFacilitiesQueryHookResult = ReturnType<
  typeof useOrganizationFacilitiesQuery
>
export type OrganizationFacilitiesLazyQueryHookResult = ReturnType<
  typeof useOrganizationFacilitiesLazyQuery
>
export type OrganizationFacilitiesQueryResult = Apollo.QueryResult<
  Types.OrganizationFacilitiesQuery,
  Types.OrganizationFacilitiesQueryVariables
>
export const OrganizationFacilitiesIncidentCountDocument = gql`
  query OrganizationFacilitiesIncidentCount {
    activeIncidentCountsForAffectedFacilities {
      edges {
        node {
          id
          incidents {
            totalCount
          }
        }
      }
    }
  }
`

/**
 * __useOrganizationFacilitiesIncidentCountQuery__
 *
 * To run a query within a React component, call `useOrganizationFacilitiesIncidentCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationFacilitiesIncidentCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationFacilitiesIncidentCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationFacilitiesIncidentCountQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.OrganizationFacilitiesIncidentCountQuery,
    Types.OrganizationFacilitiesIncidentCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.OrganizationFacilitiesIncidentCountQuery,
    Types.OrganizationFacilitiesIncidentCountQueryVariables
  >(OrganizationFacilitiesIncidentCountDocument, options)
}
export function useOrganizationFacilitiesIncidentCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.OrganizationFacilitiesIncidentCountQuery,
    Types.OrganizationFacilitiesIncidentCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.OrganizationFacilitiesIncidentCountQuery,
    Types.OrganizationFacilitiesIncidentCountQueryVariables
  >(OrganizationFacilitiesIncidentCountDocument, options)
}
export type OrganizationFacilitiesIncidentCountQueryHookResult = ReturnType<
  typeof useOrganizationFacilitiesIncidentCountQuery
>
export type OrganizationFacilitiesIncidentCountLazyQueryHookResult = ReturnType<
  typeof useOrganizationFacilitiesIncidentCountLazyQuery
>
export type OrganizationFacilitiesIncidentCountQueryResult = Apollo.QueryResult<
  Types.OrganizationFacilitiesIncidentCountQuery,
  Types.OrganizationFacilitiesIncidentCountQueryVariables
>
export const OrganizationReportBrandingDocument = gql`
  query OrganizationReportBranding {
    currentOrganization {
      name
      logoUrl
    }
  }
`

/**
 * __useOrganizationReportBrandingQuery__
 *
 * To run a query within a React component, call `useOrganizationReportBrandingQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationReportBrandingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationReportBrandingQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationReportBrandingQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.OrganizationReportBrandingQuery,
    Types.OrganizationReportBrandingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.OrganizationReportBrandingQuery,
    Types.OrganizationReportBrandingQueryVariables
  >(OrganizationReportBrandingDocument, options)
}
export function useOrganizationReportBrandingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.OrganizationReportBrandingQuery,
    Types.OrganizationReportBrandingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.OrganizationReportBrandingQuery,
    Types.OrganizationReportBrandingQueryVariables
  >(OrganizationReportBrandingDocument, options)
}
export type OrganizationReportBrandingQueryHookResult = ReturnType<
  typeof useOrganizationReportBrandingQuery
>
export type OrganizationReportBrandingLazyQueryHookResult = ReturnType<
  typeof useOrganizationReportBrandingLazyQuery
>
export type OrganizationReportBrandingQueryResult = Apollo.QueryResult<
  Types.OrganizationReportBrandingQuery,
  Types.OrganizationReportBrandingQueryVariables
>
export const OrganizationSettingsDocument = gql`
  query OrganizationSettings {
    currentOrganization {
      organizationSettings {
        cameraOfflineDurationUnit
        minimumCameraOfflineDuration
        id
        emailSenderName
        emailReplyToAddress
        emailReplyToName
        inboundPhoneNumber
      }
      aiOperatorSettings {
        id
        monthlyIncidentLimit
        accessGrantedTimeThresholdDefault
        doorCloseTimeThresholdDefault
        doorForcedBounceTimeThresholdDefault
      }
    }
  }
`

/**
 * __useOrganizationSettingsQuery__
 *
 * To run a query within a React component, call `useOrganizationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationSettingsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.OrganizationSettingsQuery,
    Types.OrganizationSettingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.OrganizationSettingsQuery,
    Types.OrganizationSettingsQueryVariables
  >(OrganizationSettingsDocument, options)
}
export function useOrganizationSettingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.OrganizationSettingsQuery,
    Types.OrganizationSettingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.OrganizationSettingsQuery,
    Types.OrganizationSettingsQueryVariables
  >(OrganizationSettingsDocument, options)
}
export type OrganizationSettingsQueryHookResult = ReturnType<
  typeof useOrganizationSettingsQuery
>
export type OrganizationSettingsLazyQueryHookResult = ReturnType<
  typeof useOrganizationSettingsLazyQuery
>
export type OrganizationSettingsQueryResult = Apollo.QueryResult<
  Types.OrganizationSettingsQuery,
  Types.OrganizationSettingsQueryVariables
>
export const PacsSourcesDocument = gql`
  query PacsSources {
    pacsSources {
      edges {
        node {
          id
          name
          fields {
            id
            name
            secure
          }
        }
      }
    }
  }
`

/**
 * __usePacsSourcesQuery__
 *
 * To run a query within a React component, call `usePacsSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePacsSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePacsSourcesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePacsSourcesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.PacsSourcesQuery,
    Types.PacsSourcesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.PacsSourcesQuery,
    Types.PacsSourcesQueryVariables
  >(PacsSourcesDocument, options)
}
export function usePacsSourcesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.PacsSourcesQuery,
    Types.PacsSourcesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.PacsSourcesQuery,
    Types.PacsSourcesQueryVariables
  >(PacsSourcesDocument, options)
}
export type PacsSourcesQueryHookResult = ReturnType<typeof usePacsSourcesQuery>
export type PacsSourcesLazyQueryHookResult = ReturnType<
  typeof usePacsSourcesLazyQuery
>
export type PacsSourcesQueryResult = Apollo.QueryResult<
  Types.PacsSourcesQuery,
  Types.PacsSourcesQueryVariables
>
export const PacsSourceSecretsSettingsDocument = gql`
  query PacsSourceSecretsSettings {
    sources: pacsSources {
      edges {
        node {
          id
          name
        }
      }
    }
    instances: pacsSourceInstances {
      edges {
        node {
          id
          name
          customerSecretProvider {
            secretArn
            node {
              id
              providerName
            }
          }
          pacsSource {
            id
            name
          }
          fields {
            id
            value
            pacsSourceField {
              name
              secure
            }
          }
        }
      }
    }
  }
`

/**
 * __usePacsSourceSecretsSettingsQuery__
 *
 * To run a query within a React component, call `usePacsSourceSecretsSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePacsSourceSecretsSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePacsSourceSecretsSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePacsSourceSecretsSettingsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.PacsSourceSecretsSettingsQuery,
    Types.PacsSourceSecretsSettingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.PacsSourceSecretsSettingsQuery,
    Types.PacsSourceSecretsSettingsQueryVariables
  >(PacsSourceSecretsSettingsDocument, options)
}
export function usePacsSourceSecretsSettingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.PacsSourceSecretsSettingsQuery,
    Types.PacsSourceSecretsSettingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.PacsSourceSecretsSettingsQuery,
    Types.PacsSourceSecretsSettingsQueryVariables
  >(PacsSourceSecretsSettingsDocument, options)
}
export type PacsSourceSecretsSettingsQueryHookResult = ReturnType<
  typeof usePacsSourceSecretsSettingsQuery
>
export type PacsSourceSecretsSettingsLazyQueryHookResult = ReturnType<
  typeof usePacsSourceSecretsSettingsLazyQuery
>
export type PacsSourceSecretsSettingsQueryResult = Apollo.QueryResult<
  Types.PacsSourceSecretsSettingsQuery,
  Types.PacsSourceSecretsSettingsQueryVariables
>
export const PendingInvitesDocument = gql`
  query PendingInvites {
    pendingInvites {
      id
      email
      firstName
      lastName
      roles
      createdAt
      lastInviteSentAt
    }
  }
`

/**
 * __usePendingInvitesQuery__
 *
 * To run a query within a React component, call `usePendingInvitesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePendingInvitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePendingInvitesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePendingInvitesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.PendingInvitesQuery,
    Types.PendingInvitesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.PendingInvitesQuery,
    Types.PendingInvitesQueryVariables
  >(PendingInvitesDocument, options)
}
export function usePendingInvitesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.PendingInvitesQuery,
    Types.PendingInvitesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.PendingInvitesQuery,
    Types.PendingInvitesQueryVariables
  >(PendingInvitesDocument, options)
}
export type PendingInvitesQueryHookResult = ReturnType<
  typeof usePendingInvitesQuery
>
export type PendingInvitesLazyQueryHookResult = ReturnType<
  typeof usePendingInvitesLazyQuery
>
export type PendingInvitesQueryResult = Apollo.QueryResult<
  Types.PendingInvitesQuery,
  Types.PendingInvitesQueryVariables
>
export const PersonOfInterestDocument = gql`
  query PersonOfInterest($id: ID!) {
    personOfInterest(id: $id) {
      address
      cases {
        totalCount
        edges {
          node {
            caseRole
            customCaseRoleDescription
            case {
              createdAt
              createdBy
              description
              detailedReport
              displayId
              facilityIds
              id
              incidentIds
              name
              ownerId
              personsOfInterestIds
              status
              updatedAt
              updatedBy
            }
          }
        }
      }
      companyAffiliation
      createdAt
      customCompanyAffiliationDescription
      dateOfBirth
      email
      firstName
      id
      lastName
      phoneNumber
    }
  }
`

/**
 * __usePersonOfInterestQuery__
 *
 * To run a query within a React component, call `usePersonOfInterestQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonOfInterestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonOfInterestQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePersonOfInterestQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.PersonOfInterestQuery,
    Types.PersonOfInterestQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.PersonOfInterestQuery,
    Types.PersonOfInterestQueryVariables
  >(PersonOfInterestDocument, options)
}
export function usePersonOfInterestLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.PersonOfInterestQuery,
    Types.PersonOfInterestQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.PersonOfInterestQuery,
    Types.PersonOfInterestQueryVariables
  >(PersonOfInterestDocument, options)
}
export type PersonOfInterestQueryHookResult = ReturnType<
  typeof usePersonOfInterestQuery
>
export type PersonOfInterestLazyQueryHookResult = ReturnType<
  typeof usePersonOfInterestLazyQuery
>
export type PersonOfInterestQueryResult = Apollo.QueryResult<
  Types.PersonOfInterestQuery,
  Types.PersonOfInterestQueryVariables
>
export const PersonsOfInterestDocument = gql`
  query PersonsOfInterest($filter: PersonOfInterestFilterInput) {
    personsOfInterest(filter: $filter) {
      totalCount
      edges {
        node {
          id
          firstName
          lastName
          companyAffiliation
          cases {
            edges {
              node {
                caseRole
                customCaseRoleDescription
                case {
                  name
                  id
                }
              }
            }
          }
        }
      }
    }
  }
`

/**
 * __usePersonsOfInterestQuery__
 *
 * To run a query within a React component, call `usePersonsOfInterestQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonsOfInterestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonsOfInterestQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePersonsOfInterestQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.PersonsOfInterestQuery,
    Types.PersonsOfInterestQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.PersonsOfInterestQuery,
    Types.PersonsOfInterestQueryVariables
  >(PersonsOfInterestDocument, options)
}
export function usePersonsOfInterestLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.PersonsOfInterestQuery,
    Types.PersonsOfInterestQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.PersonsOfInterestQuery,
    Types.PersonsOfInterestQueryVariables
  >(PersonsOfInterestDocument, options)
}
export type PersonsOfInterestQueryHookResult = ReturnType<
  typeof usePersonsOfInterestQuery
>
export type PersonsOfInterestLazyQueryHookResult = ReturnType<
  typeof usePersonsOfInterestLazyQuery
>
export type PersonsOfInterestQueryResult = Apollo.QueryResult<
  Types.PersonsOfInterestQuery,
  Types.PersonsOfInterestQueryVariables
>
export const PreviewArchiveFloorDocument = gql`
  query PreviewArchiveFloor($id: ID!) {
    previewArchiveFloor(id: $id) {
      inProgressGuardTourCount
      tourPlansToArchiveCount
      tourPlansToUpdateCount
    }
  }
`

/**
 * __usePreviewArchiveFloorQuery__
 *
 * To run a query within a React component, call `usePreviewArchiveFloorQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewArchiveFloorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewArchiveFloorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePreviewArchiveFloorQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.PreviewArchiveFloorQuery,
    Types.PreviewArchiveFloorQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.PreviewArchiveFloorQuery,
    Types.PreviewArchiveFloorQueryVariables
  >(PreviewArchiveFloorDocument, options)
}
export function usePreviewArchiveFloorLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.PreviewArchiveFloorQuery,
    Types.PreviewArchiveFloorQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.PreviewArchiveFloorQuery,
    Types.PreviewArchiveFloorQueryVariables
  >(PreviewArchiveFloorDocument, options)
}
export type PreviewArchiveFloorQueryHookResult = ReturnType<
  typeof usePreviewArchiveFloorQuery
>
export type PreviewArchiveFloorLazyQueryHookResult = ReturnType<
  typeof usePreviewArchiveFloorLazyQuery
>
export type PreviewArchiveFloorQueryResult = Apollo.QueryResult<
  Types.PreviewArchiveFloorQuery,
  Types.PreviewArchiveFloorQueryVariables
>
export const ProductMessagesDocument = gql`
  query ProductMessages($last: Int, $filter: ProductMessageFilterInput) {
    productMessages(last: $last, filter: $filter) {
      id
      message
      messageType
      startDateTime
      endDateTime
    }
  }
`

/**
 * __useProductMessagesQuery__
 *
 * To run a query within a React component, call `useProductMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductMessagesQuery({
 *   variables: {
 *      last: // value for 'last'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useProductMessagesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.ProductMessagesQuery,
    Types.ProductMessagesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.ProductMessagesQuery,
    Types.ProductMessagesQueryVariables
  >(ProductMessagesDocument, options)
}
export function useProductMessagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.ProductMessagesQuery,
    Types.ProductMessagesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.ProductMessagesQuery,
    Types.ProductMessagesQueryVariables
  >(ProductMessagesDocument, options)
}
export type ProductMessagesQueryHookResult = ReturnType<
  typeof useProductMessagesQuery
>
export type ProductMessagesLazyQueryHookResult = ReturnType<
  typeof useProductMessagesLazyQuery
>
export type ProductMessagesQueryResult = Apollo.QueryResult<
  Types.ProductMessagesQuery,
  Types.ProductMessagesQueryVariables
>
export const ProgramRecommendationCountsDocument = gql`
  query ProgramRecommendationCounts {
    programRecommendationCounts {
      pending
      inProgress
      completed
      rejected
      archived
    }
  }
`

/**
 * __useProgramRecommendationCountsQuery__
 *
 * To run a query within a React component, call `useProgramRecommendationCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramRecommendationCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgramRecommendationCountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProgramRecommendationCountsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.ProgramRecommendationCountsQuery,
    Types.ProgramRecommendationCountsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.ProgramRecommendationCountsQuery,
    Types.ProgramRecommendationCountsQueryVariables
  >(ProgramRecommendationCountsDocument, options)
}
export function useProgramRecommendationCountsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.ProgramRecommendationCountsQuery,
    Types.ProgramRecommendationCountsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.ProgramRecommendationCountsQuery,
    Types.ProgramRecommendationCountsQueryVariables
  >(ProgramRecommendationCountsDocument, options)
}
export type ProgramRecommendationCountsQueryHookResult = ReturnType<
  typeof useProgramRecommendationCountsQuery
>
export type ProgramRecommendationCountsLazyQueryHookResult = ReturnType<
  typeof useProgramRecommendationCountsLazyQuery
>
export type ProgramRecommendationCountsQueryResult = Apollo.QueryResult<
  Types.ProgramRecommendationCountsQuery,
  Types.ProgramRecommendationCountsQueryVariables
>
export const ProgramRecommendationsDocument = gql`
  query ProgramRecommendations($filter: ProgramRecommendationFilterInput) {
    programRecommendations(filter: $filter) {
      edges {
        node {
          id
          title
          description
          category
          owner
          status
          createdAt
          estimatedImpact
          actualImpact
          internalNote
          actions {
            actionType
            performedAt
          }
          publishedBy {
            id
            firstName
            lastName
          }
          isArchived
        }
      }
    }
  }
`

/**
 * __useProgramRecommendationsQuery__
 *
 * To run a query within a React component, call `useProgramRecommendationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramRecommendationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgramRecommendationsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useProgramRecommendationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.ProgramRecommendationsQuery,
    Types.ProgramRecommendationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.ProgramRecommendationsQuery,
    Types.ProgramRecommendationsQueryVariables
  >(ProgramRecommendationsDocument, options)
}
export function useProgramRecommendationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.ProgramRecommendationsQuery,
    Types.ProgramRecommendationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.ProgramRecommendationsQuery,
    Types.ProgramRecommendationsQueryVariables
  >(ProgramRecommendationsDocument, options)
}
export type ProgramRecommendationsQueryHookResult = ReturnType<
  typeof useProgramRecommendationsQuery
>
export type ProgramRecommendationsLazyQueryHookResult = ReturnType<
  typeof useProgramRecommendationsLazyQuery
>
export type ProgramRecommendationsQueryResult = Apollo.QueryResult<
  Types.ProgramRecommendationsQuery,
  Types.ProgramRecommendationsQueryVariables
>
export const QuickReportDocument = gql`
  query QuickReport {
    quickReport {
      id
      createdAt
      formDescription
      formTitle
      logoAssetId
      logoUrl
      qrCodeUrl
      reportType
      updatedAt
    }
    manualIncidentCategories(input: { isQuickReportCategory: true }) {
      totalCount
      edges {
        node {
          creatorId
          id
          name
          isQuickReportCategory
          customForm {
            id
            name
            description
            status
            version
            publishedAt
            createdAt
            updatedAt
          }
        }
      }
    }
  }
`

/**
 * __useQuickReportQuery__
 *
 * To run a query within a React component, call `useQuickReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuickReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuickReportQuery({
 *   variables: {
 *   },
 * });
 */
export function useQuickReportQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.QuickReportQuery,
    Types.QuickReportQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.QuickReportQuery,
    Types.QuickReportQueryVariables
  >(QuickReportDocument, options)
}
export function useQuickReportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.QuickReportQuery,
    Types.QuickReportQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.QuickReportQuery,
    Types.QuickReportQueryVariables
  >(QuickReportDocument, options)
}
export type QuickReportQueryHookResult = ReturnType<typeof useQuickReportQuery>
export type QuickReportLazyQueryHookResult = ReturnType<
  typeof useQuickReportLazyQuery
>
export type QuickReportQueryResult = Apollo.QueryResult<
  Types.QuickReportQuery,
  Types.QuickReportQueryVariables
>
export const RecipientsByRuleDocument = gql`
  query RecipientsByRule($filter: EmailRecipientFilterInput) {
    recipients(filter: $filter) {
      edges {
        node {
          id
          email
        }
      }
    }
  }
`

/**
 * __useRecipientsByRuleQuery__
 *
 * To run a query within a React component, call `useRecipientsByRuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecipientsByRuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecipientsByRuleQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRecipientsByRuleQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.RecipientsByRuleQuery,
    Types.RecipientsByRuleQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.RecipientsByRuleQuery,
    Types.RecipientsByRuleQueryVariables
  >(RecipientsByRuleDocument, options)
}
export function useRecipientsByRuleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.RecipientsByRuleQuery,
    Types.RecipientsByRuleQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.RecipientsByRuleQuery,
    Types.RecipientsByRuleQueryVariables
  >(RecipientsByRuleDocument, options)
}
export type RecipientsByRuleQueryHookResult = ReturnType<
  typeof useRecipientsByRuleQuery
>
export type RecipientsByRuleLazyQueryHookResult = ReturnType<
  typeof useRecipientsByRuleLazyQuery
>
export type RecipientsByRuleQueryResult = Apollo.QueryResult<
  Types.RecipientsByRuleQuery,
  Types.RecipientsByRuleQueryVariables
>
export const RuleV2Document = gql`
  query RuleV2($id: ID!) {
    rule(id: $id) {
      id
      action
      createdAt
      creator {
        id
        firstName
        lastName
      }
      updatedAt
      updatedBy {
        id
        firstName
        lastName
      }
      incidentTypeDefinitions {
        id
      }
      lastMatched
      manualIncidentCategoryIds
      aiOperatorRuleDetails {
        isDryRun
      }
      aiOperatorResponseRules {
        action
        priority
        fieldId
        modelId
        field {
          id
          description
        }
        model {
          id
          canonicalName
          provider
        }
      }
      name
      ruleEventType
      triggerType
      ruleLogics {
        edges {
          node {
            id
            value
            entity
          }
        }
      }
      allDayOverride
      day
      endDate
      endTimeOfDay
      repeatInterval
      repeatIntervalNum
      startTime
      startTimeLocal
      endTimeLocal
      status
    }
  }
`

/**
 * __useRuleV2Query__
 *
 * To run a query within a React component, call `useRuleV2Query` and pass it any options that fit your needs.
 * When your component renders, `useRuleV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRuleV2Query({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRuleV2Query(
  baseOptions: Apollo.QueryHookOptions<
    Types.RuleV2Query,
    Types.RuleV2QueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<Types.RuleV2Query, Types.RuleV2QueryVariables>(
    RuleV2Document,
    options
  )
}
export function useRuleV2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.RuleV2Query,
    Types.RuleV2QueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<Types.RuleV2Query, Types.RuleV2QueryVariables>(
    RuleV2Document,
    options
  )
}
export type RuleV2QueryHookResult = ReturnType<typeof useRuleV2Query>
export type RuleV2LazyQueryHookResult = ReturnType<typeof useRuleV2LazyQuery>
export type RuleV2QueryResult = Apollo.QueryResult<
  Types.RuleV2Query,
  Types.RuleV2QueryVariables
>
export const RuleDocument = gql`
  query Rule($id: ID!) {
    rule(id: $id) {
      id
      allDayOverride
      action
      day
      endTimeOfDay
      endDate
      manualIncidentCategoryIds
      name
      repeatInterval
      repeatIntervalNum
      ruleEventType
      aiOperatorRuleDetails {
        isDryRun
      }
      aiOperatorResponseRules {
        action
        id
        priority
        updatedAt
        value
        fieldId
        model {
          id
          canonicalName
          provider
          createdAt
          default
          enabled
          identifier
          updatedAt
        }
        field {
          createdAt
          description
          enabled
          id
          referenceId
          sourceType
          type
          updatedAt
        }
        createdAt
        comparator
      }
      ruleLogics {
        edges {
          node {
            id
            value
          }
        }
      }
      startTime
      startTimeLocal
      endTimeLocal
      status
    }
  }
`

/**
 * __useRuleQuery__
 *
 * To run a query within a React component, call `useRuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useRuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRuleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRuleQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.RuleQuery,
    Types.RuleQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<Types.RuleQuery, Types.RuleQueryVariables>(
    RuleDocument,
    options
  )
}
export function useRuleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.RuleQuery,
    Types.RuleQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<Types.RuleQuery, Types.RuleQueryVariables>(
    RuleDocument,
    options
  )
}
export type RuleQueryHookResult = ReturnType<typeof useRuleQuery>
export type RuleLazyQueryHookResult = ReturnType<typeof useRuleLazyQuery>
export type RuleQueryResult = Apollo.QueryResult<
  Types.RuleQuery,
  Types.RuleQueryVariables
>
export const RuleDevicesDocument = gql`
  query RuleDevices($ids: [ID!]) {
    devices(filter: { idIn: $ids }) {
      edges {
        node {
          id
          name
          type
          floor {
            id
            name
          }
          facility {
            id
            name
            timeZone
          }
        }
      }
    }
  }
`

/**
 * __useRuleDevicesQuery__
 *
 * To run a query within a React component, call `useRuleDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRuleDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRuleDevicesQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useRuleDevicesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.RuleDevicesQuery,
    Types.RuleDevicesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.RuleDevicesQuery,
    Types.RuleDevicesQueryVariables
  >(RuleDevicesDocument, options)
}
export function useRuleDevicesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.RuleDevicesQuery,
    Types.RuleDevicesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.RuleDevicesQuery,
    Types.RuleDevicesQueryVariables
  >(RuleDevicesDocument, options)
}
export type RuleDevicesQueryHookResult = ReturnType<typeof useRuleDevicesQuery>
export type RuleDevicesLazyQueryHookResult = ReturnType<
  typeof useRuleDevicesLazyQuery
>
export type RuleDevicesQueryResult = Apollo.QueryResult<
  Types.RuleDevicesQuery,
  Types.RuleDevicesQueryVariables
>
export const RuleIsV2Document = gql`
  query RuleIsV2($id: ID!) {
    rule(id: $id) {
      id
      isV2
    }
  }
`

/**
 * __useRuleIsV2Query__
 *
 * To run a query within a React component, call `useRuleIsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useRuleIsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRuleIsV2Query({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRuleIsV2Query(
  baseOptions: Apollo.QueryHookOptions<
    Types.RuleIsV2Query,
    Types.RuleIsV2QueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<Types.RuleIsV2Query, Types.RuleIsV2QueryVariables>(
    RuleIsV2Document,
    options
  )
}
export function useRuleIsV2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.RuleIsV2Query,
    Types.RuleIsV2QueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<Types.RuleIsV2Query, Types.RuleIsV2QueryVariables>(
    RuleIsV2Document,
    options
  )
}
export type RuleIsV2QueryHookResult = ReturnType<typeof useRuleIsV2Query>
export type RuleIsV2LazyQueryHookResult = ReturnType<
  typeof useRuleIsV2LazyQuery
>
export type RuleIsV2QueryResult = Apollo.QueryResult<
  Types.RuleIsV2Query,
  Types.RuleIsV2QueryVariables
>
export const RuleRecipientsDocument = gql`
  query RuleRecipients {
    recipients {
      edges {
        node {
          id
          email
          userId
        }
      }
    }
    users {
      edges {
        node {
          id
          email
          firstName
          lastName
        }
      }
    }
  }
`

/**
 * __useRuleRecipientsQuery__
 *
 * To run a query within a React component, call `useRuleRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRuleRecipientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRuleRecipientsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRuleRecipientsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.RuleRecipientsQuery,
    Types.RuleRecipientsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.RuleRecipientsQuery,
    Types.RuleRecipientsQueryVariables
  >(RuleRecipientsDocument, options)
}
export function useRuleRecipientsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.RuleRecipientsQuery,
    Types.RuleRecipientsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.RuleRecipientsQuery,
    Types.RuleRecipientsQueryVariables
  >(RuleRecipientsDocument, options)
}
export type RuleRecipientsQueryHookResult = ReturnType<
  typeof useRuleRecipientsQuery
>
export type RuleRecipientsLazyQueryHookResult = ReturnType<
  typeof useRuleRecipientsLazyQuery
>
export type RuleRecipientsQueryResult = Apollo.QueryResult<
  Types.RuleRecipientsQuery,
  Types.RuleRecipientsQueryVariables
>
export const RulesDocument = gql`
  query Rules(
    $filter: RuleFilterInput
    $first: Int
    $last: Int
    $orderBy: [RuleOrderInput]
  ) {
    rules(filter: $filter, first: $first, last: $last, orderBy: $orderBy) {
      totalCount
      edges {
        node {
          id
          createdAt
          lastMatched
          name
          status
          action
          aiOperatorRuleDetails {
            isDryRun
          }
          isV2
          creator {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
`

/**
 * __useRulesQuery__
 *
 * To run a query within a React component, call `useRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRulesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useRulesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.RulesQuery,
    Types.RulesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<Types.RulesQuery, Types.RulesQueryVariables>(
    RulesDocument,
    options
  )
}
export function useRulesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.RulesQuery,
    Types.RulesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<Types.RulesQuery, Types.RulesQueryVariables>(
    RulesDocument,
    options
  )
}
export type RulesQueryHookResult = ReturnType<typeof useRulesQuery>
export type RulesLazyQueryHookResult = ReturnType<typeof useRulesLazyQuery>
export type RulesQueryResult = Apollo.QueryResult<
  Types.RulesQuery,
  Types.RulesQueryVariables
>
export const SavedIncidentsFilterDocument = gql`
  query SavedIncidentsFilter($id: ID!) {
    savedFilter(id: $id) {
      id
      isActive
      name
      filterCriteria {
        incident {
          aiOperatorStateIn
          createdAtGte
          createdAtGteInterval
          createdAtLte
          deviceIdIn
          facilityIdIn
          floorIdIn
          hasVideoClip
          mutedStatus
          priorityIn {
            value
          }
          statusIn
          OR {
            sourceIn
            deviceTypeIn
          }
          AND {
            OR {
              typeIn
              manualIncidentCategoryIdIn
            }
          }
        }
      }
    }
  }
`

/**
 * __useSavedIncidentsFilterQuery__
 *
 * To run a query within a React component, call `useSavedIncidentsFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useSavedIncidentsFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSavedIncidentsFilterQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSavedIncidentsFilterQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SavedIncidentsFilterQuery,
    Types.SavedIncidentsFilterQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.SavedIncidentsFilterQuery,
    Types.SavedIncidentsFilterQueryVariables
  >(SavedIncidentsFilterDocument, options)
}
export function useSavedIncidentsFilterLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SavedIncidentsFilterQuery,
    Types.SavedIncidentsFilterQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.SavedIncidentsFilterQuery,
    Types.SavedIncidentsFilterQueryVariables
  >(SavedIncidentsFilterDocument, options)
}
export type SavedIncidentsFilterQueryHookResult = ReturnType<
  typeof useSavedIncidentsFilterQuery
>
export type SavedIncidentsFilterLazyQueryHookResult = ReturnType<
  typeof useSavedIncidentsFilterLazyQuery
>
export type SavedIncidentsFilterQueryResult = Apollo.QueryResult<
  Types.SavedIncidentsFilterQuery,
  Types.SavedIncidentsFilterQueryVariables
>
export const SavedIncidentsFiltersDocument = gql`
  query SavedIncidentsFilters {
    savedFilters {
      edges {
        node {
          id
          name
          isActive
        }
      }
    }
  }
`

/**
 * __useSavedIncidentsFiltersQuery__
 *
 * To run a query within a React component, call `useSavedIncidentsFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSavedIncidentsFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSavedIncidentsFiltersQuery({
 *   variables: {
 *   },
 * });
 */
export function useSavedIncidentsFiltersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.SavedIncidentsFiltersQuery,
    Types.SavedIncidentsFiltersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.SavedIncidentsFiltersQuery,
    Types.SavedIncidentsFiltersQueryVariables
  >(SavedIncidentsFiltersDocument, options)
}
export function useSavedIncidentsFiltersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SavedIncidentsFiltersQuery,
    Types.SavedIncidentsFiltersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.SavedIncidentsFiltersQuery,
    Types.SavedIncidentsFiltersQueryVariables
  >(SavedIncidentsFiltersDocument, options)
}
export type SavedIncidentsFiltersQueryHookResult = ReturnType<
  typeof useSavedIncidentsFiltersQuery
>
export type SavedIncidentsFiltersLazyQueryHookResult = ReturnType<
  typeof useSavedIncidentsFiltersLazyQuery
>
export type SavedIncidentsFiltersQueryResult = Apollo.QueryResult<
  Types.SavedIncidentsFiltersQuery,
  Types.SavedIncidentsFiltersQueryVariables
>
export const ScopeDoorIdsDocument = gql`
  query ScopeDoorIds($filter: DeviceFilterInput, $first: Int, $last: Int) {
    devices(
      filter: $filter
      first: $first
      last: $last
      orderBy: [{ direction: ASC, field: ID }]
    ) {
      totalCount
      edges {
        node {
          id
        }
      }
    }
  }
`

/**
 * __useScopeDoorIdsQuery__
 *
 * To run a query within a React component, call `useScopeDoorIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useScopeDoorIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScopeDoorIdsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useScopeDoorIdsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.ScopeDoorIdsQuery,
    Types.ScopeDoorIdsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.ScopeDoorIdsQuery,
    Types.ScopeDoorIdsQueryVariables
  >(ScopeDoorIdsDocument, options)
}
export function useScopeDoorIdsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.ScopeDoorIdsQuery,
    Types.ScopeDoorIdsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.ScopeDoorIdsQuery,
    Types.ScopeDoorIdsQueryVariables
  >(ScopeDoorIdsDocument, options)
}
export type ScopeDoorIdsQueryHookResult = ReturnType<
  typeof useScopeDoorIdsQuery
>
export type ScopeDoorIdsLazyQueryHookResult = ReturnType<
  typeof useScopeDoorIdsLazyQuery
>
export type ScopeDoorIdsQueryResult = Apollo.QueryResult<
  Types.ScopeDoorIdsQuery,
  Types.ScopeDoorIdsQueryVariables
>
export const StaleIncidentGroupsDocument = gql`
  query StaleIncidentGroups(
    $actionUpdatedAtLte: String!
    $first: Int
    $last: Int
  ) {
    staleIncidentGroups(
      filter: {
        statusNotIn: RESOLVED
        actionTypeIn: [ACKNOWLEDGEMENT_BY_GUARD, ACKNOWLEDGEMENT_BY_OPERATOR]
        actionUpdatedAtLte: $actionUpdatedAtLte
      }
      first: $first
      last: $last
    ) {
      totalCount
      edges {
        node {
          userId
          incidentCount
          user {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
`

/**
 * __useStaleIncidentGroupsQuery__
 *
 * To run a query within a React component, call `useStaleIncidentGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStaleIncidentGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStaleIncidentGroupsQuery({
 *   variables: {
 *      actionUpdatedAtLte: // value for 'actionUpdatedAtLte'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useStaleIncidentGroupsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.StaleIncidentGroupsQuery,
    Types.StaleIncidentGroupsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.StaleIncidentGroupsQuery,
    Types.StaleIncidentGroupsQueryVariables
  >(StaleIncidentGroupsDocument, options)
}
export function useStaleIncidentGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.StaleIncidentGroupsQuery,
    Types.StaleIncidentGroupsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.StaleIncidentGroupsQuery,
    Types.StaleIncidentGroupsQueryVariables
  >(StaleIncidentGroupsDocument, options)
}
export type StaleIncidentGroupsQueryHookResult = ReturnType<
  typeof useStaleIncidentGroupsQuery
>
export type StaleIncidentGroupsLazyQueryHookResult = ReturnType<
  typeof useStaleIncidentGroupsLazyQuery
>
export type StaleIncidentGroupsQueryResult = Apollo.QueryResult<
  Types.StaleIncidentGroupsQuery,
  Types.StaleIncidentGroupsQueryVariables
>
export const StandardOperatingProcedureDocument = gql`
  query StandardOperatingProcedure($id: ID!) {
    standardOperatingProcedure(id: $id) {
      id
      name
      createdAt
      creator {
        firstName
        lastName
      }
      status
      url
    }
  }
`

/**
 * __useStandardOperatingProcedureQuery__
 *
 * To run a query within a React component, call `useStandardOperatingProcedureQuery` and pass it any options that fit your needs.
 * When your component renders, `useStandardOperatingProcedureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStandardOperatingProcedureQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStandardOperatingProcedureQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.StandardOperatingProcedureQuery,
    Types.StandardOperatingProcedureQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.StandardOperatingProcedureQuery,
    Types.StandardOperatingProcedureQueryVariables
  >(StandardOperatingProcedureDocument, options)
}
export function useStandardOperatingProcedureLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.StandardOperatingProcedureQuery,
    Types.StandardOperatingProcedureQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.StandardOperatingProcedureQuery,
    Types.StandardOperatingProcedureQueryVariables
  >(StandardOperatingProcedureDocument, options)
}
export type StandardOperatingProcedureQueryHookResult = ReturnType<
  typeof useStandardOperatingProcedureQuery
>
export type StandardOperatingProcedureLazyQueryHookResult = ReturnType<
  typeof useStandardOperatingProcedureLazyQuery
>
export type StandardOperatingProcedureQueryResult = Apollo.QueryResult<
  Types.StandardOperatingProcedureQuery,
  Types.StandardOperatingProcedureQueryVariables
>
export const StandardOperatingProcedureEditDocument = gql`
  query StandardOperatingProcedureEdit($id: ID!) {
    standardOperatingProcedure(id: $id) {
      id
      facilityIds
      type
    }
    facilityNames: facilities {
      edges {
        node {
          id
          name
          shortName
        }
      }
    }
  }
`

/**
 * __useStandardOperatingProcedureEditQuery__
 *
 * To run a query within a React component, call `useStandardOperatingProcedureEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useStandardOperatingProcedureEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStandardOperatingProcedureEditQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStandardOperatingProcedureEditQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.StandardOperatingProcedureEditQuery,
    Types.StandardOperatingProcedureEditQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.StandardOperatingProcedureEditQuery,
    Types.StandardOperatingProcedureEditQueryVariables
  >(StandardOperatingProcedureEditDocument, options)
}
export function useStandardOperatingProcedureEditLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.StandardOperatingProcedureEditQuery,
    Types.StandardOperatingProcedureEditQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.StandardOperatingProcedureEditQuery,
    Types.StandardOperatingProcedureEditQueryVariables
  >(StandardOperatingProcedureEditDocument, options)
}
export type StandardOperatingProcedureEditQueryHookResult = ReturnType<
  typeof useStandardOperatingProcedureEditQuery
>
export type StandardOperatingProcedureEditLazyQueryHookResult = ReturnType<
  typeof useStandardOperatingProcedureEditLazyQuery
>
export type StandardOperatingProcedureEditQueryResult = Apollo.QueryResult<
  Types.StandardOperatingProcedureEditQuery,
  Types.StandardOperatingProcedureEditQueryVariables
>
export const StandardOperatingProceduresDocument = gql`
  query StandardOperatingProcedures(
    $filter: StandardOperatingProcedureFilterInput
    $first: Int
    $last: Int
    $orderBy: [StandardOperatingProcedureOrderInput]
  ) {
    standardOperatingProcedures(
      filter: $filter
      first: $first
      last: $last
      orderBy: $orderBy
    ) {
      totalCount
      pageInfo {
        page
        pageSize
      }
      edges {
        node {
          id
          name
          createdAt
          creatorId
          creator {
            id
            firstName
            lastName
          }
          facilityIds
          facilities {
            edges {
              node {
                id
                name
                archived
              }
            }
          }
          externalId
          updatedAt
          type
          url
        }
      }
    }
  }
`

/**
 * __useStandardOperatingProceduresQuery__
 *
 * To run a query within a React component, call `useStandardOperatingProceduresQuery` and pass it any options that fit your needs.
 * When your component renders, `useStandardOperatingProceduresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStandardOperatingProceduresQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useStandardOperatingProceduresQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.StandardOperatingProceduresQuery,
    Types.StandardOperatingProceduresQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.StandardOperatingProceduresQuery,
    Types.StandardOperatingProceduresQueryVariables
  >(StandardOperatingProceduresDocument, options)
}
export function useStandardOperatingProceduresLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.StandardOperatingProceduresQuery,
    Types.StandardOperatingProceduresQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.StandardOperatingProceduresQuery,
    Types.StandardOperatingProceduresQueryVariables
  >(StandardOperatingProceduresDocument, options)
}
export type StandardOperatingProceduresQueryHookResult = ReturnType<
  typeof useStandardOperatingProceduresQuery
>
export type StandardOperatingProceduresLazyQueryHookResult = ReturnType<
  typeof useStandardOperatingProceduresLazyQuery
>
export type StandardOperatingProceduresQueryResult = Apollo.QueryResult<
  Types.StandardOperatingProceduresQuery,
  Types.StandardOperatingProceduresQueryVariables
>
export const StandardOperatingProceduresFilterDataDocument = gql`
  query StandardOperatingProceduresFilterData {
    standardOperatingProcedures {
      edges {
        node {
          creatorId
          creator {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
`

/**
 * __useStandardOperatingProceduresFilterDataQuery__
 *
 * To run a query within a React component, call `useStandardOperatingProceduresFilterDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useStandardOperatingProceduresFilterDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStandardOperatingProceduresFilterDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useStandardOperatingProceduresFilterDataQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.StandardOperatingProceduresFilterDataQuery,
    Types.StandardOperatingProceduresFilterDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.StandardOperatingProceduresFilterDataQuery,
    Types.StandardOperatingProceduresFilterDataQueryVariables
  >(StandardOperatingProceduresFilterDataDocument, options)
}
export function useStandardOperatingProceduresFilterDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.StandardOperatingProceduresFilterDataQuery,
    Types.StandardOperatingProceduresFilterDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.StandardOperatingProceduresFilterDataQuery,
    Types.StandardOperatingProceduresFilterDataQueryVariables
  >(StandardOperatingProceduresFilterDataDocument, options)
}
export type StandardOperatingProceduresFilterDataQueryHookResult = ReturnType<
  typeof useStandardOperatingProceduresFilterDataQuery
>
export type StandardOperatingProceduresFilterDataLazyQueryHookResult =
  ReturnType<typeof useStandardOperatingProceduresFilterDataLazyQuery>
export type StandardOperatingProceduresFilterDataQueryResult =
  Apollo.QueryResult<
    Types.StandardOperatingProceduresFilterDataQuery,
    Types.StandardOperatingProceduresFilterDataQueryVariables
  >
export const TagsDocument = gql`
  query Tags($filter: TagFilterInput, $limit: Int) {
    tags(filter: $filter, limit: $limit) {
      edges {
        node {
          id
          name
          enabled
          archived
          deviceCount
        }
      }
    }
  }
`

/**
 * __useTagsQuery__
 *
 * To run a query within a React component, call `useTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useTagsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.TagsQuery,
    Types.TagsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<Types.TagsQuery, Types.TagsQueryVariables>(
    TagsDocument,
    options
  )
}
export function useTagsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.TagsQuery,
    Types.TagsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<Types.TagsQuery, Types.TagsQueryVariables>(
    TagsDocument,
    options
  )
}
export type TagsQueryHookResult = ReturnType<typeof useTagsQuery>
export type TagsLazyQueryHookResult = ReturnType<typeof useTagsLazyQuery>
export type TagsQueryResult = Apollo.QueryResult<
  Types.TagsQuery,
  Types.TagsQueryVariables
>
export const TailgateGridDocument = gql`
  query TailgateGrid($cameraId: ID!, $doorId: ID!) {
    tailgateGrid(cameraId: $cameraId, doorId: $doorId) {
      inBox {
        topLeft {
          x
          y
        }
        topRight {
          x
          y
        }
        bottomRight {
          x
          y
        }
        bottomLeft {
          x
          y
        }
      }
      outBox {
        topLeft {
          x
          y
        }
        topRight {
          x
          y
        }
        bottomRight {
          x
          y
        }
        bottomLeft {
          x
          y
        }
      }
    }
  }
`

/**
 * __useTailgateGridQuery__
 *
 * To run a query within a React component, call `useTailgateGridQuery` and pass it any options that fit your needs.
 * When your component renders, `useTailgateGridQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTailgateGridQuery({
 *   variables: {
 *      cameraId: // value for 'cameraId'
 *      doorId: // value for 'doorId'
 *   },
 * });
 */
export function useTailgateGridQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.TailgateGridQuery,
    Types.TailgateGridQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.TailgateGridQuery,
    Types.TailgateGridQueryVariables
  >(TailgateGridDocument, options)
}
export function useTailgateGridLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.TailgateGridQuery,
    Types.TailgateGridQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.TailgateGridQuery,
    Types.TailgateGridQueryVariables
  >(TailgateGridDocument, options)
}
export type TailgateGridQueryHookResult = ReturnType<
  typeof useTailgateGridQuery
>
export type TailgateGridLazyQueryHookResult = ReturnType<
  typeof useTailgateGridLazyQuery
>
export type TailgateGridQueryResult = Apollo.QueryResult<
  Types.TailgateGridQuery,
  Types.TailgateGridQueryVariables
>
export const TeamStaleGroupIncidentsDocument = gql`
  query TeamStaleGroupIncidents(
    $actionUpdatedAtLte: String!
    $attributedToIdIn: [ID!]
    $attributedToIsNull: Boolean
    $first: Int
    $last: Int
  ) {
    outstandingIncidents(
      filter: {
        statusNotIn: RESOLVED
        actionTypeIn: [ACKNOWLEDGEMENT_BY_GUARD, ACKNOWLEDGEMENT_BY_OPERATOR]
        actionUpdatedAtLte: $actionUpdatedAtLte
        attributedToIdIn: $attributedToIdIn
        attributedToIsNull: $attributedToIsNull
      }
      first: $first
      last: $last
      orderBy: [{ direction: ASC, field: CREATED_AT }]
    ) {
      totalCount
      edges {
        node {
          id
          displayId
          name
          status
          priority
          actions {
            type
            createdAt
          }
          owner {
            id
            firstName
            lastName
          }
          guard {
            id
            firstName
            lastName
          }
          facility {
            id
            name
          }
          devices {
            id
            name
            type
          }
        }
      }
    }
  }
`

/**
 * __useTeamStaleGroupIncidentsQuery__
 *
 * To run a query within a React component, call `useTeamStaleGroupIncidentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamStaleGroupIncidentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamStaleGroupIncidentsQuery({
 *   variables: {
 *      actionUpdatedAtLte: // value for 'actionUpdatedAtLte'
 *      attributedToIdIn: // value for 'attributedToIdIn'
 *      attributedToIsNull: // value for 'attributedToIsNull'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useTeamStaleGroupIncidentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.TeamStaleGroupIncidentsQuery,
    Types.TeamStaleGroupIncidentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.TeamStaleGroupIncidentsQuery,
    Types.TeamStaleGroupIncidentsQueryVariables
  >(TeamStaleGroupIncidentsDocument, options)
}
export function useTeamStaleGroupIncidentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.TeamStaleGroupIncidentsQuery,
    Types.TeamStaleGroupIncidentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.TeamStaleGroupIncidentsQuery,
    Types.TeamStaleGroupIncidentsQueryVariables
  >(TeamStaleGroupIncidentsDocument, options)
}
export type TeamStaleGroupIncidentsQueryHookResult = ReturnType<
  typeof useTeamStaleGroupIncidentsQuery
>
export type TeamStaleGroupIncidentsLazyQueryHookResult = ReturnType<
  typeof useTeamStaleGroupIncidentsLazyQuery
>
export type TeamStaleGroupIncidentsQueryResult = Apollo.QueryResult<
  Types.TeamStaleGroupIncidentsQuery,
  Types.TeamStaleGroupIncidentsQueryVariables
>
export const TeamStaleIncidentIdsDocument = gql`
  query TeamStaleIncidentIds(
    $actionUpdatedAtLte: String!
    $first: Int
    $last: Int
  ) {
    outstandingIncidents(
      filter: {
        statusNotIn: RESOLVED
        actionTypeIn: [ACKNOWLEDGEMENT_BY_GUARD, ACKNOWLEDGEMENT_BY_OPERATOR]
        actionUpdatedAtLte: $actionUpdatedAtLte
      }
      first: $first
      last: $last
      orderBy: [{ direction: ASC, field: CREATED_AT }]
    ) {
      totalCount
      edges {
        node {
          id
        }
      }
    }
  }
`

/**
 * __useTeamStaleIncidentIdsQuery__
 *
 * To run a query within a React component, call `useTeamStaleIncidentIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamStaleIncidentIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamStaleIncidentIdsQuery({
 *   variables: {
 *      actionUpdatedAtLte: // value for 'actionUpdatedAtLte'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useTeamStaleIncidentIdsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.TeamStaleIncidentIdsQuery,
    Types.TeamStaleIncidentIdsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.TeamStaleIncidentIdsQuery,
    Types.TeamStaleIncidentIdsQueryVariables
  >(TeamStaleIncidentIdsDocument, options)
}
export function useTeamStaleIncidentIdsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.TeamStaleIncidentIdsQuery,
    Types.TeamStaleIncidentIdsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.TeamStaleIncidentIdsQuery,
    Types.TeamStaleIncidentIdsQueryVariables
  >(TeamStaleIncidentIdsDocument, options)
}
export type TeamStaleIncidentIdsQueryHookResult = ReturnType<
  typeof useTeamStaleIncidentIdsQuery
>
export type TeamStaleIncidentIdsLazyQueryHookResult = ReturnType<
  typeof useTeamStaleIncidentIdsLazyQuery
>
export type TeamStaleIncidentIdsQueryResult = Apollo.QueryResult<
  Types.TeamStaleIncidentIdsQuery,
  Types.TeamStaleIncidentIdsQueryVariables
>
export const TeamStaleIncidentsCountDocument = gql`
  query TeamStaleIncidentsCount($actionUpdatedAtLte: String!) {
    outstandingIncidents(
      filter: {
        statusNotIn: RESOLVED
        actionTypeIn: [ACKNOWLEDGEMENT_BY_GUARD, ACKNOWLEDGEMENT_BY_OPERATOR]
        actionUpdatedAtLte: $actionUpdatedAtLte
      }
      first: 0
      last: 1
    ) {
      totalCount
    }
  }
`

/**
 * __useTeamStaleIncidentsCountQuery__
 *
 * To run a query within a React component, call `useTeamStaleIncidentsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamStaleIncidentsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamStaleIncidentsCountQuery({
 *   variables: {
 *      actionUpdatedAtLte: // value for 'actionUpdatedAtLte'
 *   },
 * });
 */
export function useTeamStaleIncidentsCountQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.TeamStaleIncidentsCountQuery,
    Types.TeamStaleIncidentsCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.TeamStaleIncidentsCountQuery,
    Types.TeamStaleIncidentsCountQueryVariables
  >(TeamStaleIncidentsCountDocument, options)
}
export function useTeamStaleIncidentsCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.TeamStaleIncidentsCountQuery,
    Types.TeamStaleIncidentsCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.TeamStaleIncidentsCountQuery,
    Types.TeamStaleIncidentsCountQueryVariables
  >(TeamStaleIncidentsCountDocument, options)
}
export type TeamStaleIncidentsCountQueryHookResult = ReturnType<
  typeof useTeamStaleIncidentsCountQuery
>
export type TeamStaleIncidentsCountLazyQueryHookResult = ReturnType<
  typeof useTeamStaleIncidentsCountLazyQuery
>
export type TeamStaleIncidentsCountQueryResult = Apollo.QueryResult<
  Types.TeamStaleIncidentsCountQuery,
  Types.TeamStaleIncidentsCountQueryVariables
>
export const TechnicianDocument = gql`
  query Technician($id: ID!) {
    technician(id: $id) {
      id
      email
      firstName
      lastName
      facilities {
        archived
        id
        name
        shortName
      }
      deviceTypes
    }
  }
`

/**
 * __useTechnicianQuery__
 *
 * To run a query within a React component, call `useTechnicianQuery` and pass it any options that fit your needs.
 * When your component renders, `useTechnicianQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTechnicianQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTechnicianQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.TechnicianQuery,
    Types.TechnicianQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<Types.TechnicianQuery, Types.TechnicianQueryVariables>(
    TechnicianDocument,
    options
  )
}
export function useTechnicianLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.TechnicianQuery,
    Types.TechnicianQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.TechnicianQuery,
    Types.TechnicianQueryVariables
  >(TechnicianDocument, options)
}
export type TechnicianQueryHookResult = ReturnType<typeof useTechnicianQuery>
export type TechnicianLazyQueryHookResult = ReturnType<
  typeof useTechnicianLazyQuery
>
export type TechnicianQueryResult = Apollo.QueryResult<
  Types.TechnicianQuery,
  Types.TechnicianQueryVariables
>
export const TechniciansDocument = gql`
  query Technicians($filter: TechnicianFilterInput) {
    technicians(
      filter: $filter
      orderBy: [{ direction: ASC, field: LAST_NAME }]
    ) {
      totalCount
      edges {
        node {
          id
          email
          firstName
          lastName
          facilities {
            name
            archived
          }
          deviceTypes
        }
      }
    }
  }
`

/**
 * __useTechniciansQuery__
 *
 * To run a query within a React component, call `useTechniciansQuery` and pass it any options that fit your needs.
 * When your component renders, `useTechniciansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTechniciansQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTechniciansQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.TechniciansQuery,
    Types.TechniciansQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.TechniciansQuery,
    Types.TechniciansQueryVariables
  >(TechniciansDocument, options)
}
export function useTechniciansLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.TechniciansQuery,
    Types.TechniciansQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.TechniciansQuery,
    Types.TechniciansQueryVariables
  >(TechniciansDocument, options)
}
export type TechniciansQueryHookResult = ReturnType<typeof useTechniciansQuery>
export type TechniciansLazyQueryHookResult = ReturnType<
  typeof useTechniciansLazyQuery
>
export type TechniciansQueryResult = Apollo.QueryResult<
  Types.TechniciansQuery,
  Types.TechniciansQueryVariables
>
export const TestRulesDocument = gql`
  query TestRules($displayId: String, $incidentId: ID) {
    testRules(displayId: $displayId, incidentId: $incidentId) {
      id
      name
    }
  }
`

/**
 * __useTestRulesQuery__
 *
 * To run a query within a React component, call `useTestRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestRulesQuery({
 *   variables: {
 *      displayId: // value for 'displayId'
 *      incidentId: // value for 'incidentId'
 *   },
 * });
 */
export function useTestRulesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.TestRulesQuery,
    Types.TestRulesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<Types.TestRulesQuery, Types.TestRulesQueryVariables>(
    TestRulesDocument,
    options
  )
}
export function useTestRulesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.TestRulesQuery,
    Types.TestRulesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.TestRulesQuery,
    Types.TestRulesQueryVariables
  >(TestRulesDocument, options)
}
export type TestRulesQueryHookResult = ReturnType<typeof useTestRulesQuery>
export type TestRulesLazyQueryHookResult = ReturnType<
  typeof useTestRulesLazyQuery
>
export type TestRulesQueryResult = Apollo.QueryResult<
  Types.TestRulesQuery,
  Types.TestRulesQueryVariables
>
export const UserDocument = gql`
  query User($id: ID!) {
    user(id: $id) {
      id
      email
      roles
      roleName
      firstName
      lastName
      designatedFacilityId
      designatedFacility {
        archived
        id
        name
        shortName
      }
    }
  }
`

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.UserQuery,
    Types.UserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<Types.UserQuery, Types.UserQueryVariables>(
    UserDocument,
    options
  )
}
export function useUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.UserQuery,
    Types.UserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<Types.UserQuery, Types.UserQueryVariables>(
    UserDocument,
    options
  )
}
export type UserQueryHookResult = ReturnType<typeof useUserQuery>
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>
export type UserQueryResult = Apollo.QueryResult<
  Types.UserQuery,
  Types.UserQueryVariables
>
export const UsersDocument = gql`
  query Users($filter: UserFilterInput) {
    users(filter: $filter) {
      edges {
        node {
          id
          email
          firstName
          lastName
          roleName
        }
      }
    }
  }
`

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useUsersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.UsersQuery,
    Types.UsersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<Types.UsersQuery, Types.UsersQueryVariables>(
    UsersDocument,
    options
  )
}
export function useUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.UsersQuery,
    Types.UsersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<Types.UsersQuery, Types.UsersQueryVariables>(
    UsersDocument,
    options
  )
}
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>
export type UsersQueryResult = Apollo.QueryResult<
  Types.UsersQuery,
  Types.UsersQueryVariables
>
export const NotificationAudioMessagesDocument = gql`
  query notificationAudioMessages($id: ID!) {
    audioMessages(filter: { id: $id }) {
      edges {
        node {
          id
          audioClip {
            url
          }
        }
      }
    }
  }
`

/**
 * __useNotificationAudioMessagesQuery__
 *
 * To run a query within a React component, call `useNotificationAudioMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationAudioMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationAudioMessagesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNotificationAudioMessagesQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.NotificationAudioMessagesQuery,
    Types.NotificationAudioMessagesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.NotificationAudioMessagesQuery,
    Types.NotificationAudioMessagesQueryVariables
  >(NotificationAudioMessagesDocument, options)
}
export function useNotificationAudioMessagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.NotificationAudioMessagesQuery,
    Types.NotificationAudioMessagesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.NotificationAudioMessagesQuery,
    Types.NotificationAudioMessagesQueryVariables
  >(NotificationAudioMessagesDocument, options)
}
export type NotificationAudioMessagesQueryHookResult = ReturnType<
  typeof useNotificationAudioMessagesQuery
>
export type NotificationAudioMessagesLazyQueryHookResult = ReturnType<
  typeof useNotificationAudioMessagesLazyQuery
>
export type NotificationAudioMessagesQueryResult = Apollo.QueryResult<
  Types.NotificationAudioMessagesQuery,
  Types.NotificationAudioMessagesQueryVariables
>
export const WhitelistedUsersForIncidentCategoryDocument = gql`
  query WhitelistedUsersForIncidentCategory($incidentCategoryId: ID!) {
    whitelistedUsersForIncidentCategory(
      incidentCategoryId: $incidentCategoryId
    ) {
      edges {
        node {
          id
          email
          firstName
          lastName
        }
      }
    }
  }
`

/**
 * __useWhitelistedUsersForIncidentCategoryQuery__
 *
 * To run a query within a React component, call `useWhitelistedUsersForIncidentCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useWhitelistedUsersForIncidentCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWhitelistedUsersForIncidentCategoryQuery({
 *   variables: {
 *      incidentCategoryId: // value for 'incidentCategoryId'
 *   },
 * });
 */
export function useWhitelistedUsersForIncidentCategoryQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.WhitelistedUsersForIncidentCategoryQuery,
    Types.WhitelistedUsersForIncidentCategoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    Types.WhitelistedUsersForIncidentCategoryQuery,
    Types.WhitelistedUsersForIncidentCategoryQueryVariables
  >(WhitelistedUsersForIncidentCategoryDocument, options)
}
export function useWhitelistedUsersForIncidentCategoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.WhitelistedUsersForIncidentCategoryQuery,
    Types.WhitelistedUsersForIncidentCategoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    Types.WhitelistedUsersForIncidentCategoryQuery,
    Types.WhitelistedUsersForIncidentCategoryQueryVariables
  >(WhitelistedUsersForIncidentCategoryDocument, options)
}
export type WhitelistedUsersForIncidentCategoryQueryHookResult = ReturnType<
  typeof useWhitelistedUsersForIncidentCategoryQuery
>
export type WhitelistedUsersForIncidentCategoryLazyQueryHookResult = ReturnType<
  typeof useWhitelistedUsersForIncidentCategoryLazyQuery
>
export type WhitelistedUsersForIncidentCategoryQueryResult = Apollo.QueryResult<
  Types.WhitelistedUsersForIncidentCategoryQuery,
  Types.WhitelistedUsersForIncidentCategoryQueryVariables
>
